(function () {
  window.__fishystuffGeneratedI18n = Object.freeze({
  "config": {
    "defaultContentLang": "en-US",
    "defaultLocale": "en-US",
    "defaultServerDataspace": "eu",
    "defaultApiLang": "en",
    "contentLanguages": [
      {
        "code": "en-US",
        "pathPrefix": "/",
        "dataLanguage": "en"
      },
      {
        "code": "de-DE",
        "pathPrefix": "/de-DE/",
        "dataLanguage": "de"
      }
    ],
    "localeLanguages": [
      "en-US",
      "de-DE",
      "ko-KR"
    ],
    "serverDataspaces": [
      {
        "code": "na",
        "sourceServiceRegion": "naeu",
        "dataLanguages": [
          "en",
          "de",
          "fr",
          "sp"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "eu",
        "sourceServiceRegion": "naeu",
        "dataLanguages": [
          "en",
          "de",
          "fr",
          "sp"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "mena",
        "sourceServiceRegion": "tr",
        "dataLanguages": [
          "tr",
          "tr_en",
          "en"
        ],
        "defaultApiLang": "tr"
      },
      {
        "code": "ru",
        "sourceServiceRegion": "nez",
        "dataLanguages": [
          "ru",
          "en"
        ],
        "defaultApiLang": "ru"
      },
      {
        "code": "asia",
        "sourceServiceRegion": "asia",
        "dataLanguages": [
          "en",
          "id",
          "th"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "jp",
        "sourceServiceRegion": "jp",
        "dataLanguages": [
          "jp"
        ],
        "defaultApiLang": "jp"
      },
      {
        "code": "sa",
        "sourceServiceRegion": "sa",
        "dataLanguages": [
          "es",
          "pt"
        ],
        "defaultApiLang": "es"
      },
      {
        "code": "kr",
        "sourceServiceRegion": "kr",
        "dataLanguages": [
          "kr"
        ],
        "defaultApiLang": "kr"
      },
      {
        "code": "tw",
        "sourceServiceRegion": "tw",
        "dataLanguages": [
          "tw"
        ],
        "defaultApiLang": "tw"
      },
      {
        "code": "gt",
        "sourceServiceRegion": "global-lab",
        "dataLanguages": [
          "en"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "ceu",
        "sourceServiceRegion": "ceu",
        "dataLanguages": [
          "en",
          "de",
          "fr",
          "sp"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "cna",
        "sourceServiceRegion": "cna",
        "dataLanguages": [
          "en",
          "de",
          "fr",
          "sp"
        ],
        "defaultApiLang": "en"
      },
      {
        "code": "cas",
        "sourceServiceRegion": "cas",
        "dataLanguages": [
          "en",
          "id",
          "th"
        ],
        "defaultApiLang": "en"
      }
    ],
    "apiLanguages": [
      "en",
      "de",
      "es",
      "fr",
      "id",
      "jp",
      "pt",
      "ru",
      "sp",
      "th",
      "tr",
      "tr_en",
      "tw"
    ],
    "dataLanguageHtmlLangs": {
      "en": "en",
      "de": "de",
      "es": "es",
      "fr": "fr",
      "id": "id",
      "jp": "ja",
      "pt": "pt",
      "ru": "ru",
      "sp": "es",
      "th": "th",
      "tr": "tr",
      "tr_en": "en",
      "tw": "zh-Hant",
      "kr": "ko"
    }
  },
  "presentation": {
    "itemGradeTones": {
      "Prize": "red",
      "Rare": "yellow",
      "HighQuality": "blue",
      "General": "green",
      "Trash": "white"
    }
  },
  "catalogs": {
    "en-US": {
      "calculator.loading": "Loading calculator...",
      "calculator.recovery.title": "Calculator data needs attention",
      "calculator.recovery.description": "The calculator could not apply this work to the current game data. It may reference an option that changed or was removed.",
      "calculator.recovery.dismiss": "Dismiss",
      "calculator.recovery.retry": "Try again",
      "calculator.recovery.defaults": "Reset Current to defaults",
      "calculator.recovery.preservation": "This resets only Current calculator work. Saved presets and layouts are not changed.",
      "calculator.recovery.save_failed": "The calculator reopened, but Current work could not be updated. Try again before reloading.",
      "calculator.timespan.unit.minute.one": "minute",
      "calculator.timespan.unit.minute.other": "minutes",
      "calculator.timespan.unit.hour.one": "hour",
      "calculator.timespan.unit.hour.other": "hours",
      "calculator.timespan.unit.day.one": "day",
      "calculator.timespan.unit.day.other": "days",
      "calculator.timespan.unit.week.one": "week",
      "calculator.timespan.unit.week.other": "weeks",
      "calculator.resource.exhausted": "Exhausted",
      "calculator.resource.low": "Low",
      "calculator.resource.average": "Average",
      "calculator.resource.abundant": "Abundant",
      "calculator.timeline.bite_time": "Bite Time",
      "calculator.timeline.auto_fishing_time": "Auto-Fishing Time",
      "calculator.timeline.catch_time": "Catch Time",
      "calculator.timeline.time_saved": "Time Saved",
      "calculator.share.active_lead": "Active | ",
      "calculator.share.afr_lead": "{$afr} AFR | ",
      "calculator.share.link": "[FishyStuff Calculator Preset | {$lead}{$item_drr} Item DRR | {$zone}]({$url})",
      "calculator.toast.preset_url_copied": "Preset URL copied.",
      "calculator.toast.share_copied": "Share text copied.",
      "calculator.title.casts_average": "Average Casts ({$timespan})",
      "calculator.title.durability_loss_average": "Average Durability Loss ({$timespan})",
      "calculator.title.expected_catches": "Expected Catches ({$timespan})",
      "calculator.title.expected_profit": "Expected Profit ({$timespan})",
      "calculator.title.bite_time": "Bite Time: {$seconds}s ({$percent}%)",
      "calculator.title.auto_fishing_time": "Auto-Fishing Time: {$seconds}s ({$percent}%)",
      "calculator.title.catch_time": "Catch Time: {$seconds}s ({$percent}%)",
      "calculator.title.unoptimized_time": "Average Unoptimized Time: {$seconds}s ({$percent}%)",
      "calculator.server.option.none": "None",
      "calculator.server.option.custom_trade_distance": "Custom distance",
      "calculator.server.option.custom_pet": "Custom pet",
      "calculator.server.result.no_matching_options": "No matching options",
      "calculator.server.result.no_matching_zones": "No matching zones",
      "calculator.server.result.no_matching_hotspots": "No matching hotspots",
      "calculator.server.result.selected": "Selected",
      "calculator.server.result.added": "Added",
      "calculator.server.result.available_for_pet": "Available for this pet",
      "calculator.server.result.group.active_zones": "Active zones",
      "calculator.server.result.group.inactive_zones": "Inactive zones",
      "calculator.server.result.group.available_pet_perks": "Available for this pet",
      "calculator.server.result.group.other_pet_perks": "Other known perks",
      "calculator.server.result.group.compatible_pet_appearances": "Pet appearances supporting the selected perks",
      "calculator.server.result.group.other_pet_appearances": "Other pet appearances",
      "calculator.server.action.remove": "Remove {$label}",
      "calculator.server.action.copy_url": "Copy URL",
      "calculator.server.action.copy_share": "Copy Share",
      "calculator.server.action.remove_custom_card": "Remove {$label} from Custom",
      "calculator.server.action.drag_section": "Drag {$label}",
      "calculator.server.action.drag_section_generic": "Drag section",
      "calculator.server.toggle.active_fishing": "Active Fishing",
      "calculator.server.toggle.debug": "Debug",
      "calculator.server.toggle.show_inactive_zones": "Show inactive zones",
      "calculator.server.workspace.basics": "Basics",
      "calculator.server.workspace.loadout": "Loadout",
      "calculator.server.workspace.loot": "Loot",
      "calculator.server.workspace.trade": "Trade",
      "calculator.server.workspace.data": "Data",
      "calculator.server.workspace.advanced": "Advanced",
      "calculator.server.workspace.custom": "Custom",
      "calculator.server.search.zones": "Search zones",
      "calculator.server.search.hotspots": "Search by fish or hotspot ID",
      "calculator.server.search.fishing_levels": "Search fishing levels",
      "calculator.server.search.session_units": "Search session units",
      "calculator.server.search.lifeskill_levels": "Search lifeskill levels",
      "calculator.server.search.rods": "Search rods",
      "calculator.server.search.floats": "Search floats",
      "calculator.server.search.chairs": "Search chairs",
      "calculator.server.search.lightstone_sets": "Search lightstone sets",
      "calculator.server.search.backpacks": "Search backpacks",
      "calculator.server.search.foods": "Search foods by name or effect",
      "calculator.server.search.buffs": "Search buffs by name or effect",
      "calculator.server.search.trade_levels": "Search trade levels",
      "calculator.server.search.trade_origins": "Search trade origins",
      "calculator.server.search.trade_destinations": "NPC, region, or distance %",
      "calculator.server.search.loot_rows": "Search loot rows at this spot",
      "calculator.server.search.pet_tiers": "Search pet tiers",
      "calculator.server.search.pet_specials": "Search pet specials",
      "calculator.server.search.pet_talents": "Search pet talents",
      "calculator.server.search.pet_skills": "Search pet skills",
      "calculator.server.search.pets": "Search pets",
      "calculator.server.section.mode": "Mode",
      "calculator.server.section.source": "Fishing source",
      "calculator.server.section.bite_time": "Bite Time",
      "calculator.server.section.catch_time": "Catch Time",
      "calculator.server.section.session": "Session",
      "calculator.server.section.gear": "Loadout",
      "calculator.server.section.pets": "Pets",
      "calculator.server.section.distribution": "Distribution",
      "calculator.server.section.loot": "Loot",
      "calculator.server.section.trade": "Trade",
      "calculator.server.section.data_editor": "Loot Data Editor",
      "calculator.server.field.fishing_level": "Fishing Level",
      "calculator.server.field.fishing_resources": "Fishing Resources",
      "calculator.server.field.fishing_mode": "Fishing Mode",
      "calculator.server.field.rod_zone": "Rod fishing zone",
      "calculator.server.field.harpoon_zone": "Harpooning zone",
      "calculator.server.field.hotspot": "Hotspot",
      "calculator.server.field.fishing_method": "Method",
      "calculator.server.field.active": "Active",
      "calculator.server.field.afk": "AFK",
      "calculator.server.field.amount": "Amount",
      "calculator.server.field.unit": "Unit",
      "calculator.server.field.lifeskill_level": "Lifeskill Level",
      "calculator.server.field.fishing_rod": "Fishing Rod",
      "calculator.server.field.brand": "Brand",
      "calculator.server.field.float": "Float",
      "calculator.server.field.chair": "Chair",
      "calculator.server.field.lightstone_set": "Lightstone Set",
      "calculator.server.field.backpack": "Backpack",
      "calculator.server.field.outfit": "Outfit",
      "calculator.server.field.food": "Food",
      "calculator.server.field.buffs": "Buffs",
      "calculator.server.field.pet": "Pet",
      "calculator.server.field.tier": "Tier",
      "calculator.server.field.special": "Special",
      "calculator.server.field.talent": "Talent",
      "calculator.server.field.skills": "Skills",
      "calculator.server.field.pack_leader": "Pack leader",
      "calculator.server.field.mastery": "Mastery",
      "calculator.server.field.target_fish": "Target Fish / Loot Item",
      "calculator.server.field.target_amount": "Target Amount",
      "calculator.server.field.pmf_max_count": "PMF Max Count",
      "calculator.server.field.trade_level": "Trade Level",
      "calculator.server.field.trade_origin": "Trade Origin",
      "calculator.server.field.trade_destination": "Destination Trader",
      "calculator.server.field.distance_bonus": "Distance Bonus",
      "calculator.server.field.trade_price_curve": "Trade Price Curve",
      "calculator.server.field.imperial_fishing_delivery": "Imperial Fishing Delivery",
      "calculator.server.field.distance_bonus_exp_only": "Distance Bonus (Trade EXP only)",
      "calculator.server.field.discard_grade": "Discard fish up to grade",
      "calculator.server.mode.rod": "Rod",
      "calculator.server.mode.hotspot": "Hotspot",
      "calculator.server.mode.harpoon_forces_active": "Harpoon temporarily forces Active.",
      "calculator.server.stat.seconds": "seconds",
      "calculator.server.stat.average_total_fishing_time": "Average Total Fishing Time",
      "calculator.server.stat.average_bite_time": "Average Bite Time",
      "calculator.server.stat.min": "Min",
      "calculator.server.stat.average": "Average",
      "calculator.server.stat.max": "Max",
      "calculator.server.stat.effective_min": "Effective Min",
      "calculator.server.stat.effective_average": "Effective Average",
      "calculator.server.stat.effective_max": "Effective Max",
      "calculator.server.stat.auto_fishing_time_aft": "Auto-Fishing Time (AFT)",
      "calculator.server.stat.auto_fishing_time_reduction_afr": "Auto-Fishing Time Reduction (AFR)",
      "calculator.server.stat.item_drr": "Item DRR",
      "calculator.server.stat.chance_to_consume_durability": "Chance to Consume Durability",
      "calculator.server.stat.raw_prize_catch_rate": "Raw Prize Catch Rate",
      "calculator.server.stat.expected_catches": "Expected Catches",
      "calculator.server.stat.expected_catches_per_hour": "Expected Catches / Hour",
      "calculator.server.stat.expected_profit": "Expected Profit",
      "calculator.server.stat.profit_per_hour": "Profit / Hour",
      "calculator.server.stat.expected_exp": "Expected EXP",
      "calculator.server.stat.exp_per_hour": "EXP / Hour",
      "calculator.server.stat.expected_totem_exp": "Expected Totem EXP",
      "calculator.server.stat.totem_exp_per_hour": "Totem EXP / Hour",
      "calculator.server.stat.bargain_bonus": "Bargain Bonus",
      "calculator.server.stat.sale_multiplier": "Final Sale Multiplier",
      "calculator.server.stat.fixed_fish_sale_value": "Fixed Fish Sale Value",
      "calculator.server.helper.mastery": "Enter your consolidated fishing mastery directly.",
      "calculator.server.helper.mastery_formula_prefix": "Mastery",
      "calculator.server.helper.mastery_formula_suffix": "drives the direct prize-rate formula before normalization.",
      "calculator.server.helper.before_zone_group_normalization": "before zone-group normalization",
      "calculator.server.helper.target_amount": "Expected time to reach this amount.",
      "calculator.server.helper.within_current_session_duration": "within the current session duration",
      "calculator.server.helper.select_target_fish": "Select a target fish.",
      "calculator.server.helper.target_status_per_day": "{$label} · {$per_day}/day",
      "calculator.server.helper.target_pmf_count": "Shows the discrete outcome distribution up to this catch count; the final bucket rolls up every higher result.",
      "calculator.server.helper.target_pmf_auto_short": "0 = auto",
      "calculator.server.helper.target_select_zone_item": "Select a target fish or loot item from this zone.",
      "calculator.server.helper.target_per_day_at_spot": "{$per_day} / day at the current spot and setup.",
      "calculator.server.helper.target_missing_at_spot": "This target does not currently appear at this spot.",
      "calculator.server.helper.target_pmf_auto": "0 = auto. Current final PMF bucket is ≥{$count} (0.5% tail cutoff).",
      "calculator.server.helper.target_pmf_fixed": "Final PMF bucket is ≥{$count}.",
      "calculator.server.helper.custom_trade_distance": "Manual distance bonus",
      "calculator.server.helper.trade_price_curve": "manual % curve, commonly around 105–130%",
      "calculator.server.helper.apply_trade_settings": "Apply Trade Settings",
      "calculator.server.helper.imperial_fishing_sale_policy": "Fish sale value is always 250%. Distance Bonus is retained for Trade EXP only; Trade Price Curve and Bargain Bonus do not apply.",
      "calculator.server.helper.food_family": "Only one food family applies at a time. Higher-tier foods replace lower-tier ones in the same family.",
      "calculator.server.helper.buff_group": "Selecting another buff in the same buff group replaces the previous one.",
      "calculator.server.helper.fish_only_notice": "Fish only. Non-fish loot stays. Red fish are always kept.",
      "calculator.server.helper.using": "using",
      "calculator.server.helper.per_cast": "per cast",
      "calculator.server.helper.sale": "sale",
      "calculator.server.helper.pet_skills.one": "Choose 1 skill.",
      "calculator.server.helper.pet_skills.many": "Choose 1 to {$count} skills.",
      "calculator.server.tab.groups": "Groups",
      "calculator.server.tab.value_split": "Value Split",
      "calculator.server.tab.silver": "Silver",
      "calculator.server.tab.exp": "EXP",
      "calculator.server.tab.totem_exp": "Totem EXP",
      "calculator.server.tab.normalized": "Normalized",
      "calculator.server.tab.denormalized": "Denormalized",
      "calculator.server.tab.raw_weight": "Raw Weight",
      "calculator.server.tab.loot_flow": "Loot Flow",
      "calculator.server.tab.exp_flow": "EXP Flow",
      "calculator.server.tab.totem_exp_flow": "Totem EXP Flow",
      "calculator.server.tab.target_fish": "Target Fish",
      "calculator.server.tab.overview": "Overview",
      "calculator.server.tab.inputs": "Inputs",
      "calculator.server.discard.none": "Do not discard",
      "calculator.server.target.expected": "Expected ({$timespan})",
      "calculator.server.target.time_to_target": "Time to Target",
      "calculator.server.target.chance_at_least": "Chance to Get at Least {$amount}",
      "calculator.server.target.no_rows": "No loot rows are currently available for target analysis at this spot.",
      "calculator.server.target.session_distribution_title": "Session Count Distribution",
      "calculator.server.target.session_distribution_description": "Discrete session outcome distribution for this target within the current session duration.",
      "calculator.server.target.count_bucket_probability": "count bucket probability",
      "calculator.server.chart.no_loot_rows": "No source-backed loot rows are available for this zone yet.",
      "calculator.server.chart.no_exp_rows": "No source-backed fish EXP rows are available for this zone yet.",
      "calculator.server.chart.no_totem_exp_rows": "No retained fish rows with source-backed or grade-rule-imputed Totem EXP are contributing for this zone yet.",
      "calculator.server.chart.loot_flow_title": "Loot Flow",
      "calculator.server.chart.loot_flow_description": "Each flow starts at a fish group, passes through source-backed species rows, then recombines into silver-weighted group totals. Left-side metrics show each item's within-group rate; right-side metrics show silver contribution.",
      "calculator.server.chart.exp_flow_title": "EXP Flow",
      "calculator.server.chart.exp_flow_description": "Each flow starts at a fish group, passes through source-backed species rows, then recombines into EXP-weighted group totals. Left-side metrics show each item's within-group rate; right-side metrics show EXP contribution.",
      "calculator.server.chart.totem_exp_flow_title": "Totem EXP Flow",
      "calculator.server.chart.totem_exp_flow_description": "Each flow starts at a fish group, passes through retained fish rows, then recombines into Totem EXP-weighted group totals; the provenance rail marks source-backed and grade-rule-imputed values.",
      "calculator.server.chart.sort_by": "Sort by",
      "calculator.server.chart.sort_by.price": "Price",
      "calculator.server.chart.sort_by.grade": "Grade",
      "calculator.server.chart.sort_by.droprate": "Within-group rate",
      "calculator.server.chart.sort_by.expected_value": "Expected value",
      "calculator.server.chart.sort_by.exp": "EXP",
      "calculator.server.chart.sort_by.totem_exp": "Totem EXP",
      "calculator.server.chart.sort_by.alphabetical": "Alphabetical",
      "calculator.server.chart.sort_by.item_id": "Item ID",
      "calculator.server.chart.sort_by.database": "Database",
      "calculator.server.chart.sort_by.evidence": "Strongest Evidence",
      "calculator.server.chart.sort_order": "Sort order",
      "calculator.server.chart.sort_order.desc": "Descending",
      "calculator.server.chart.sort_order.asc": "Ascending",
      "calculator.server.chart.group_distribution_title": "Group Selection Distribution",
      "calculator.server.chart.group_distribution_description.normalized": "Current fish-group share after prize, rare, and high-quality weighting.",
      "calculator.server.chart.group_distribution_description.raw": "Raw fish-group weights after Prize mastery and active group modifiers, before normalization.",
      "calculator.server.chart.group_silver_distribution_title": "Group Silver Distribution",
      "calculator.server.chart.group_silver_distribution_description": "Expected silver share by fish group after trade and pricing settings.",
      "calculator.server.chart.group_exp_distribution_title": "Group EXP Distribution",
      "calculator.server.chart.group_exp_distribution_description": "Expected EXP share by fish group after source-backed fish EXP values and active EXP modifiers.",
      "calculator.server.chart.group_totem_exp_distribution_title": "Group Totem EXP Distribution",
      "calculator.server.chart.group_totem_exp_distribution_description": "Expected Totem EXP share by fish group from retained source-backed or grade-rule-imputed fish catches.",
      "calculator.server.chart.aria.group_distribution": "Group Selection Distribution",
      "calculator.server.chart.aria.group_silver_distribution": "Group Silver Distribution",
      "calculator.server.chart.aria.group_exp_distribution": "Group EXP Distribution",
      "calculator.server.chart.aria.group_totem_exp_distribution": "Group Totem EXP Distribution",
      "calculator.server.chart.aria.loot_flow": "Expected loot flow from groups to loot rows",
      "calculator.server.chart.aria.exp_flow": "Expected EXP flow from groups to loot rows",
      "calculator.server.chart.aria.totem_exp_flow": "Expected Totem EXP flow from groups to loot rows",
      "calculator.server.chart.aria.target_distribution": "Target Fish Session Distribution",
      "calculator.server.chart.aria.timeline": "Fishing cycle timeline",
      "calculator.server.chart.aria.distribution_tabs": "Distribution tabs",
      "calculator.server.chart.aria.value_split_metric_switch": "Value Split metric",
      "calculator.server.chart.aria.loot_flow_metric_switch": "Loot Flow metric",
      "calculator.server.chart.aria.loot_rate_display_mode": "Loot rate display",
      "calculator.server.chart.aria.workspace_tabs": "Calculator sections",
      "calculator.server.chart.aria.custom_tabs": "Custom workspace cards",
      "calculator.server.badge.aft": "-{$percent}% AFT",
      "calculator.server.badge.rare": "+{$percent}% Rare",
      "calculator.server.badge.hq": "+{$percent}% HQ",
      "calculator.server.badge.item_drr": "+{$percent}% Item DRR",
      "calculator.server.badge.fish_multiplier": "Fish ×{$multiplier}",
      "calculator.server.badge.fish_exp": "+{$percent}% Fish EXP",
      "calculator.server.badge.life_exp": "+{$percent}% Life EXP",
      "calculator.server.badge.set_effect": "Set effect",
      "calculator.server.badge.level_drr": "+{$percent}% Lv DRR",
      "calculator.server.badge.zone_origin": "Zone origin",
      "calculator.server.loot.breakdown.label.base_price": "Base price",
      "calculator.server.value.unavailable": "Unavailable",
      "calculator.server.disclaimer.title": "Data Quality Warning",
      "calculator.server.disclaimer.p1": "The data we currently have is INCOMPLETE and some data may be MISSING entirely.",
      "calculator.server.disclaimer.p2": "Info about group-rates is based on older data and is OUTDATED.",
      "calculator.server.disclaimer.p3": "In particular: Prize Fish info is based purely on community estimates and may be totally off. True rates are UNKNOWN.",
      "calculator.server.disclaimer.p4": "So while this aims to be as accurate as we can be, for now please do not take any of this at face value.",
      "calculator.server.disclaimer.p5": "Going forward, we will try to crowdsource data and appreciate any future contributions.",
      "calculator.data.title": "Zone data",
      "calculator.data.description": "Edit the effective loot table visually, then inspect its exact source candidates when needed.",
      "calculator.data.empty": "The calculator model, projection, and finalized user layer are required.",
      "calculator.data.none": "None",
      "calculator.data.selected_item": "Selected item",
      "calculator.data.item_id": "Item {$id}",
      "calculator.data.candidate": "Candidate {$number}",
      "calculator.data.editor.title": "Loot table editor",
      "calculator.data.editor.description": "Select an item, then use a group arrow to assign it. Group activation is independent from its saved entries and rate.",
      "calculator.data.catalog.title": "Catalog",
      "calculator.data.catalog.add_item": "Add catalog item",
      "calculator.data.catalog.section.custom": "Custom",
      "calculator.data.catalog.section.assigned": "Assigned",
      "calculator.data.catalog.section.available": "Available",
      "calculator.data.catalog.section.in_zone": "In-zone presence",
      "calculator.data.catalog.section.zone_edge": "Zone-edge presence",
      "calculator.data.catalog.section.no_ranking_presence": "No ranking presence evidence",
      "calculator.data.available.item_count.one": "{$count} item",
      "calculator.data.available.item_count.other": "{$count} items",
      "calculator.data.available.showing": "· showing {$count}",
      "calculator.data.available.none": "No items are available for this fishing source.",
      "calculator.data.action.add_item": "Add {$item}",
      "calculator.data.action.add_item_to_group": "Add {$item} to {$group}",
      "calculator.data.action.add_to_group": "Add to group",
      "calculator.data.action.activate_group": "Activate",
      "calculator.data.action.activate_group_label": "Activate {$group} with its saved entries",
      "calculator.data.action.apply": "Apply",
      "calculator.data.action.apply_membership": "Apply group membership",
      "calculator.data.action.apply_presence": "Apply presence",
      "calculator.data.action.apply_price": "Apply price",
      "calculator.data.action.cancel": "Cancel",
      "calculator.data.action.deactivate_group": "Deactivate",
      "calculator.data.action.deactivate_group_label": "Deactivate {$group} without deleting its entries",
      "calculator.data.action.item_already_in_group": "{$item} is already in {$group}",
      "calculator.data.action.refute": "Refute with user layer",
      "calculator.data.action.remove": "Remove",
      "calculator.data.action.remove_item_from_group": "Remove {$item} from {$group}",
      "calculator.data.action.inspect_group": "Inspect fishing group {$group}",
      "calculator.data.action.select_item": "Select {$item}",
      "calculator.data.action.remove_custom_item": "Remove {$item} from Custom",
      "calculator.data.action.inspect_item_assignment": "Inspect {$item} assignment in {$group}",
      "calculator.data.action.revert": "Revert",
      "calculator.data.action.revert_label": "Revert {$operation}",
      "calculator.data.action.revert_user_operation": "Revert user operation",
      "calculator.data.action.review_item": "Review item",
      "calculator.data.action.search": "Search",
      "calculator.data.action.select_item_for_group": "Select an item to add to {$group}",
      "calculator.data.action.select_reason": "Select a reason",
      "calculator.data.action.use_id": "Use ID",
      "calculator.data.field.catalog": "Catalog",
      "calculator.data.field.detail_code_optional": "Detail code (optional)",
      "calculator.data.field.filter": "Filter",
      "calculator.data.field.item_id": "Item ID",
      "calculator.data.field.membership_group": "Membership group",
      "calculator.data.field.membership_state": "Membership state",
      "calculator.data.field.confidence": "Confidence",
      "calculator.data.field.operation_comment": "Operation comment",
      "calculator.data.field.operation_context": "Confidence & note",
      "calculator.data.field.presence": "Presence",
      "calculator.data.field.price_silver": "Price (silver)",
      "calculator.data.field.price_state": "Price state",
      "calculator.data.field.rate_basis": "Input basis",
      "calculator.data.field.rate_value": "Value",
      "calculator.data.field.rate_value_accessible": "Rate value. Normalized fixed rates must be between 0 and 100 percent; denormalized and raw weights must be finite non-negative values. Weight inputs retain their full precision.",
      "calculator.data.field.refutation_reason": "Refutation reason code",
      "calculator.data.field.state": "State",
      "calculator.data.field.unavailable_reason": "Unavailable reason",
      "calculator.data.placeholder.reason_code": "Enter a reason code",
      "calculator.data.placeholder.operation_comment": "Why this override exists, what evidence supports it, or what still needs review",
      "calculator.data.search.catalog_placeholder": "Search full catalog",
      "calculator.data.search.filter_placeholder": "Item, ID, group, layer, or status",
      "calculator.data.state.absent": "Absent",
      "calculator.data.confidence.guessed": "Guessed",
      "calculator.data.state.known": "Known",
      "calculator.data.state.not_loaded": "Not loaded",
      "calculator.data.state.present": "Present",
      "calculator.data.state.unavailable": "Unavailable",
      "calculator.data.state.unknown": "Unknown",
      "calculator.data.status.condition_inactive": "Condition inactive",
      "calculator.data.condition.none_active": "No active condition",
      "calculator.data.condition.automatic": "Use automatic condition",
      "calculator.data.condition.auto_short": "Auto",
      "calculator.data.status.effective": "Effective",
      "calculator.data.status.overridden": "Overridden",
      "calculator.data.status.refuted": "Refuted",
      "calculator.data.membership.member": "Included in group",
      "calculator.data.membership.not_member": "Excluded from group",
      "calculator.data.membership.unknown": "Membership unknown",
      "calculator.data.rate_basis.per_catch": "Per catch",
      "calculator.data.rate_basis.fixed_share_percent": "Fixed share (%)",
      "calculator.data.rate_basis.normalized_percent": "Normalized",
      "calculator.data.rate_basis.denormalized_weight": "Denormalized",
      "calculator.data.rate_basis.percent": "Percent",
      "calculator.data.rate_basis.ratio": "Ratio",
      "calculator.data.rate_basis.raw_weight": "Raw weight",
      "calculator.data.rate.weight": "{$value} weight",
      "calculator.data.rate.projected_edit_base": "Projected {$rate}; edit {$label}",
      "calculator.data.rate.projected_total_edit_base": "Projected total {$rate}; edit {$label}",
      "calculator.data.rate.state_label": "{$state} rate",
      "calculator.data.rate.unavailable": "Unavailable rate",
      "calculator.data.rate.unknown": "Unknown rate",
      "calculator.data.rate.unquantified_group": "{$group} · unquantified",
      "calculator.data.rate_editor.edit": "Edit {$label}",
      "calculator.data.rate_editor.group_rate": "group rate input",
      "calculator.data.rate_editor.item_base": "item base input",
      "calculator.data.rate_editor.user_group_override": "user group override",
      "calculator.data.rate_editor.shadowed_bonus": "This fixed normalized rate does not apply its raw-weight bonuses; edit the rate in Denormalized or Raw Weight to apply them.",
      "calculator.data.unavailable.incomplete_provenance": "Incomplete provenance",
      "calculator.data.unavailable.missing_source": "Missing source fact",
      "calculator.data.unavailable.model_selection": "Choose condition",
      "calculator.data.unavailable.no_equivalent_raw_weight": "No equivalent raw weight",
      "calculator.data.unavailable.not_applicable": "Not applicable",
      "calculator.data.unavailable.unsupported_source": "Unsupported source variant",
      "calculator.data.group.label": "{$group} group",
      "calculator.data.group.main_group_id": "Main group ID: {$value}",
      "calculator.data.group.no_memberships": "No effective item memberships.",
      "calculator.data.group.none_available": "No groups are available for this selection.",
      "calculator.data.assignment.independent_fact": "Independent group fact from {$layer}",
      "calculator.data.assignment.no_memberships": "No effective group memberships",
      "calculator.data.assignment.review_label": "Review {$group} assignment for {$item}",
      "calculator.data.assignment.unassigned": "Unassigned",
      "calculator.data.assignment.via_layer": "via {$layer}",
      "calculator.data.catalog.section.assigned_absent": "Assigned · absent",
      "calculator.data.badge.catalog_result": "Catalog result",
      "calculator.data.badge.exact_id": "Exact ID",
      "calculator.data.badge.user_layer": "User layer",
      "calculator.data.presence.label": "Presence: {$state}",
      "calculator.data.provenance.membership": "Membership",
      "calculator.data.provenance.no_effective_rate": "No effective rate fact",
      "calculator.data.provenance.presence": "Presence",
      "calculator.data.provenance.rate": "Rate",
      "calculator.data.provenance.unknown_layer": "Unknown layer",
      "calculator.data.provenance.audit_details": "Audit details",
      "calculator.data.provenance.final": "Final",
      "calculator.data.provenance.actions": "Actions",
      "calculator.data.provenance.supporting": "Supporting",
      "calculator.data.provenance_graph.item_presence": "Item presence",
      "calculator.data.provenance_graph.group_identity": "Group identity · {$group}",
      "calculator.data.provenance_graph.group_presence": "Group presence · {$group}",
      "calculator.data.provenance_graph.group_membership": "Group membership · {$group}",
      "calculator.data.provenance_graph.group_rate": "Group rate · {$group}",
      "calculator.data.provenance_graph.item_rate": "Item rate · {$group}",
      "calculator.data.provenance_graph.item_quantity": "Item quantity · {$group}",
      "calculator.data.provenance_graph.item_quantity_default": "Default item quantity",
      "calculator.data.provenance_graph.active_condition": "Active condition",
      "calculator.data.provenance_graph.presence": "Presence",
      "calculator.data.provenance_graph.presence_description": "Direct presence facts for the selected fishing group or loot row.",
      "calculator.data.provenance_graph.rate": "Rate",
      "calculator.data.provenance_graph.rate_description": "Direct rate facts for the selected fishing group or loot row, plus quantity facts for a selected loot row.",
      "calculator.data.provenance_graph.result": "Result",
      "calculator.data.provenance_graph.no_effective": "No effective fact",
      "calculator.data.provenance_graph.select_subject": "Select a fishing group or loot row to inspect its provenance.",
      "calculator.data.provenance_graph.details_unavailable": "Provenance details are unavailable for this fact.",
      "calculator.data.provenance_graph.no_facts": "No provenance facts are loaded for this channel.",
      "calculator.data.provenance_graph.scroll_label": "{$channel} provenance graph",
      "calculator.data.provenance_graph.subject": "Provenance for {$subject}",
      "calculator.data.provenance_graph.heading": "Loot provenance",
      "calculator.data.provenance_graph.description": "Each lane starts with its final value. Moving right shows candidates from highest to lowest precedence.",
      "calculator.data.metadata.content_hash": "Content hash",
      "calculator.data.metadata.comment": "Comment",
      "calculator.data.metadata.confidence": "Confidence",
      "calculator.data.metadata.author": "Author",
      "calculator.data.metadata.author_handle": "Author handle",
      "calculator.data.metadata.author_id": "Author ID",
      "calculator.data.metadata.created": "Created",
      "calculator.data.metadata.claim_date": "Claim date",
      "calculator.data.metadata.claim_date_approximate_value": "Approx. {$range}",
      "calculator.data.metadata.deactivated_by": "Deactivated by",
      "calculator.data.metadata.evidence_class": "Evidence class",
      "calculator.data.metadata.fact_id": "Fact ID",
      "calculator.data.metadata.imported": "Imported",
      "calculator.data.metadata.layer": "Layer",
      "calculator.data.metadata.observation_count": "Observation count",
      "calculator.data.metadata.observation_scope": "Observation scope",
      "calculator.data.metadata.observed": "Observed",
      "calculator.data.metadata.operation": "Operation",
      "calculator.data.metadata.operation_id": "Operation ID",
      "calculator.data.metadata.refutation_comment": "Refutation comment",
      "calculator.data.metadata.refutation_confidence": "Refutation confidence",
      "calculator.data.metadata.refutation_author": "Refutation author",
      "calculator.data.metadata.refutation_author_handle": "Refutation author handle",
      "calculator.data.metadata.refutation_author_id": "Refutation author ID",
      "calculator.data.metadata.refutation_created": "Refutation created",
      "calculator.data.metadata.refutation_claim_date": "Refutation claim date",
      "calculator.data.metadata.refutation_reason": "Refutation reason",
      "calculator.data.metadata.refuted_by": "Refuted by",
      "calculator.data.metadata.row": "Row",
      "calculator.data.metadata.sheet": "Sheet",
      "calculator.data.metadata.source_id": "Source ID",
      "calculator.data.metadata.source_revision": "Source revision",
      "calculator.data.metadata.table": "Table",
      "calculator.data.metadata.value": "Value",
      "calculator.data.metadata.conditions": "Conditions",
      "calculator.data.metadata.branch_id": "Branch ID",
      "calculator.data.metadata.alternative": "Alternative",
      "calculator.data.evidence.catalog_result": "Current catalog search result",
      "calculator.data.evidence.description": "Spatial ranking observations support item presence in the selected zone. Group assignments are separate facts and may include several groups.",
      "calculator.data.evidence.details_heading": "Ranking evidence details",
      "calculator.data.evidence.exact_identity": "Exact numeric item identity",
      "calculator.data.evidence.no_matches": "No ranking evidence matches this filter.",
      "calculator.data.evidence.observed_at": "Observed {$time}",
      "calculator.data.evidence.presence_not_loaded": "Presence fact not loaded",
      "calculator.data.evidence.rate_warning": "Observation counts are evidence of zone presence, never drop-rate estimates.",
      "calculator.data.evidence.scope.fully_contained": "Fully contained ranking rings",
      "calculator.data.evidence.scope.partial_intersection": "Boundary-intersecting ranking rings",
      "calculator.data.evidence.review_item_label": "Review {$item} evidence and assignments",
      "calculator.data.evidence.showing_limit": "Showing the first {$visible} of {$total} matches. Refine the filter to inspect the rest.",
      "calculator.data.evidence.table_caption": "Ranking presence observations and the independent effective group assignments for each item",
      "calculator.data.evidence.title": "Ranking evidence & group assignments",
      "calculator.data.evidence.unassigned_help": "Ranking supports zone presence only; choose one or more groups.",
      "calculator.data.evidence.unquantified_in": "Unquantified in {$group}",
      "calculator.data.evidence.user_layer_reference": "Referenced by the user layer",
      "calculator.data.evidence.candidate_count.one": "{$count} candidate fact",
      "calculator.data.evidence.candidate_count.other": "{$count} candidate facts",
      "calculator.data.evidence.zone_count.one": "{$count} ranking-supported item for this zone.",
      "calculator.data.evidence.zone_count.other": "{$count} ranking-supported items for this zone.",
      "calculator.data.table.actions": "Actions",
      "calculator.data.table.group_facts": "Effective group facts",
      "calculator.data.table.item": "Item",
      "calculator.data.table.zone_presence": "Zone presence evidence",
      "calculator.data.advanced.editing_item": "Editing {$item}. Presence and each group membership are independent typed facts.",
      "calculator.data.advanced.heading": "Advanced typed fact editor",
      "calculator.data.advanced.user_layer_edit": "User-layer edit",
      "calculator.data.layer.current_source": "Current fishing-source layers",
      "calculator.data.layer.description": "Resolution runs from immutable base facts through ordered sources, then your layer last.",
      "calculator.data.layer.effective_for_fact": "Effective for selected fact",
      "calculator.data.layer.loaded_sources.one": "{$count} loaded effective source",
      "calculator.data.layer.loaded_sources.other": "{$count} loaded effective sources",
      "calculator.data.layer.no_model": "No model is loaded.",
      "calculator.data.layer.order": "Order {$order}",
      "calculator.data.layer.read_only": "Read-only",
      "calculator.data.layer.user_editable": "User-editable",
      "calculator.data.fact_count.one": "{$count} fact operation",
      "calculator.data.fact_count.other": "{$count} fact operations",
      "calculator.data.operation_count.one": "{$count} operation",
      "calculator.data.operation_count.other": "{$count} operations",
      "calculator.data.operations.description": "Only this layer is editable. Showing operations scoped to {$source}; reverting reveals the next effective candidate.",
      "calculator.data.operations.global_count": "Global operations · {$count}",
      "calculator.data.operations.hidden_source_count.one": "{$count} operation for another fishing source hidden.",
      "calculator.data.operations.hidden_source_count.other": "{$count} operations for other fishing sources hidden.",
      "calculator.data.operations.none_global": "No global personal operations.",
      "calculator.data.operations.none_source": "No personal operations for this fishing source yet. Review evidence or add a catalog item to begin.",
      "calculator.data.operations.title": "Personal overlay operations",
      "calculator.data.operations.source_count.one": "{$count} source operation",
      "calculator.data.operations.source_count.other": "{$count} source operations",
      "calculator.data.trace.effective_fact_id": "Effective fact ID",
      "calculator.data.trace.effective_layer": "Effective layer",
      "calculator.data.trace.heading": "Selected fact provenance",
      "calculator.data.trace.none": "No provenance traces are available.",
      "calculator.data.trace.selected_fact": "Selected fact",
      "calculator.data.fact.branch": "branch {$id}",
      "calculator.data.fact.fact": "fact {$id}",
      "calculator.data.fact.group": "group {$id}",
      "calculator.data.fact.zone": "zone {$id}",
      "calculator.data.boundary.initialization": "initialization",
      "calculator.data.boundary.storage": "storage",
      "calculator.data.status.active_local": "The active user layer is evaluated locally.",
      "calculator.data.status.invalid_saved_document": "The saved v4 document was ignored because it is invalid: {$error} The active model layer was still validated; storage was not changed.",
      "calculator.data.status.model_refresh_failed": "Calculator model refresh failed.",
      "calculator.data.status.saved_removed": "The stored v4 overlay was removed elsewhere; the active local overlay remains in use.",
      "calculator.data.status.server_confirmed": "The server confirmed this user layer.",
      "calculator.data.status.storage_unavailable": "Local overlay storage is unavailable.",
      "calculator.data.status.storage_write_failed": "The overlay is active, but it could not be stored locally: {$error}",
      "calculator.data.status.stored_locally": "The active v4 overlay is stored locally.",
      "calculator.data.status.validation_superseded": "Newer local input superseded this validation response.",
      "calculator.data.status.stored_invalid": "Stored v4 layer is invalid.",
      "calculator.data.status.validating_boundary": "Validating user layer at the {$boundary} boundary.",
      "calculator.data.status.validating_result": "Validating the calculator result with the server.",
      "calculator.data.status.waiting_for_model": "Waiting for the calculator model.",
      "calculator.data.error.wait_for_model": "Wait for the selected model facts to finish loading before editing the user layer.",
      "calculator.data.error.wait_for_author": "Wait for the current authored edit to finish before editing again.",
      "calculator.data.announcement.custom_item_added": "{$item} added to Custom.",
      "calculator.data.announcement.custom_item_removed": "{$item} removed from Custom.",
      "calculator.data.announcement.filter_applied": "Ranking evidence filter applied.",
      "calculator.data.announcement.loading_before_add": "Loading this item's facts. Add it to a group after loading finishes.",
      "calculator.data.announcement.loading_before_assign": "Loading this item's facts before it can be assigned.",
      "calculator.data.announcement.loading_item": "Loading facts for Item {$id}.",
      "calculator.data.announcement.user_layer_updated": "User layer updated.",
      "calculator.data.quantity.accessible_exact": "Quantity {$quantity}",
      "calculator.data.quantity.accessible_range": "Quantity {$minimum} to {$maximum}",
      "calculator.data.quantity.accessible_expected": "Expected quantity {$quantity}",
      "calculator.data.quantity.expected_short": "EV",
      "calculator.data.quantity.editor_title": "Drop quantity",
      "calculator.data.quantity.minimum": "Minimum",
      "calculator.data.quantity.maximum": "Maximum",
      "calculator.data.action.revert_quantity": "Revert",
      "calculator.data.action.edit_item_facts_for": "Edit facts for {$item}",
      "calculator.data.action.close_item_facts_for": "Close facts for {$item}",
      "calculator.data.item_facts.title": "Item facts",
      "calculator.data.item_facts.description": "These values apply to this item globally.",
      "calculator.data.item_facts.price_unknown": "Unknown",
      "calculator.data.item_facts.revert_price": "Revert price",
      "calculator.data.item_facts.quantity_default": "Default quantity range",
      "calculator.data.item_facts.revert_quantity_default": "Revert default",
      "calculator.server.recovery.unavailable": "The selected configuration could not be calculated. Your settings and saved history are still available.",
      "calculator.server.recovery.instructions": "No results are available for this configuration. Adjust the source or pet settings below, or use preset history to undo a change or choose another preset, then try again. Current work is not reset.",
      "calculator.server.recovery.retry": "Try again with these settings",
      "calculator.server.recovery.request": "Request details",
      "nav.get_started": "Get Started",
      "nav.guides": "Guides",
      "nav.map": "Map",
      "nav.dex": "Dex",
      "nav.calculator": "Calculator",
      "nav.community": "Community",
      "nav.glossary": "Glossary",
      "nav.log": "Log",
      "nav.devlog": "Development Log",
      "nav.menu.open": "Open navigation menu",
      "nav.scroll_to_top": "Scroll to top",
      "admin.contest_moderator": "Contest moderator",
      "admin.no_contest_moderator": "No contest moderator role",
      "admin.grant_contest_moderator": "Grant contest moderator",
      "admin.revoke_contest_moderator": "Revoke contest moderator",
      "admin.contest_moderator_help": "Contest moderators can confirm suggested fish. This role grants no account administration or Fishing Logger beta access. Administrators can also confirm fish without this separate role.",
      "footer.about": "About",
      "footer.feedback": "Feedback",
      "footer.legal": "Legal",
      "footer.provider_terms": "Provider & Terms of Service",
      "footer.privacy_policy": "Privacy Policy",
      "footer.crio_terms": "Crio Terms of Service",
      "footer.crio_privacy": "Crio Privacy Policy",
      "footer.pearl_abyss_disclaimer": "FishyStuff is a community hobby project and is not affiliated with Pearl Abyss. This is unofficial content which contains copyrighted materials and IP from Pearl Abyss, and is not official or endorsed by Pearl Abyss.",
      "common.action.save": "Save",
      "common.action.discard": "Discard",
      "common.action.rename": "Rename",
      "common.action.delete": "Delete",
      "common.action.export": "Export",
      "common.action.import": "Import",
      "common.action.cancel": "Cancel",
      "common.action.copy": "Copy",
      "common.action.clone": "Clone",
      "common.action.search": "Search",
      "common.action.close": "Close",
      "common.action.undo": "Undo",
      "common.action.redo": "Redo",
      "common.action.clear_selection": "Clear",
      "common.action.clear_selection_count": "Clear ({$count})",
      "common.status.current": "Current",
      "common.status.saved": "Saved",
      "common.status.modified": "Modified",
      "common.status.default": "Default",
      "common.status.applied": "Applied",
      "common.status.original": "Original",
      "common.status.active": "Active",
      "common.status.selected": "Selected",
      "common.status.not_selected": "Not selected",
      "common.field.title": "Title",
      "profile.menu.open": "Open account menu",
      "profile.menu.account": "Account",
      "profile.menu.loading": "Checking account…",
      "profile.menu.sign_in": "Sign in",
      "profile.menu.discord": "Sign in with Discord",
      "profile.menu.sign_out": "Sign out",
      "profile.menu.unavailable": "Account temporarily unavailable",
      "profile.menu.action_failed": "That account action could not be completed. Try again.",
      "profile.menu.theme": "Theme",
      "profile.menu.presets": "Presets",
      "account.state.loading": "Checking whether you’re signed in…",
      "account.state.signed_out": "Not signed in",
      "account.state.signed_out_detail": "Sign in or create a FishyStuff account to use synchronized settings and saved data on this device.",
      "account.state.signed_in": "Signed in",
      "account.state.no_recovery_email": "No recovery email is set. Email recovery is unavailable.",
      "account.login.title": "Sign in to FishyStuff",
      "account.registration.title": "Create your FishyStuff account",
      "account.registration.email_recovery_notice": "Recovery email is optional; without one, email recovery is unavailable until you add one in account settings.",
      "account.registration.discord_handle_help": "Leave blank to use your Discord username.",
      "account.registration.legal_title": "Terms and privacy information",
      "account.registration.terms_prefix": "I confirm that I am at least 18 years old and accept the",
      "account.registration.terms_link": "Terms of Service",
      "account.registration.privacy_link": "Privacy Policy",
      "account.registration.privacy_notice": "How FishyStuff processes account data is explained in the",
      "account.legal.required_title": "Review updated Terms",
      "account.legal.required_detail": "FishyStuff has no acceptance of this exact Terms version for this account. The Terms may have been updated.",
      "account.legal.notice_title": "Updated Terms require your attention",
      "account.legal.notice_detail": "Some API functionality may no longer work until you accept the updated Terms. Review and accept them on the Terms page, or delete your account.",
      "account.legal.review_action": "Review and accept Terms",
      "account.legal.delete_action": "Delete account",
      "account.legal.version": "Version",
      "account.legal.effective": "Effective",
      "account.legal.terms_prefix": "I confirm that I am at least 18 years old and accept the",
      "account.legal.privacy_notice": "is provided for your information and explains how FishyStuff processes account data.",
      "account.legal.submit": "Accept and continue",
      "account.legal.status_unavailable": "Terms acceptance status is unavailable.",
      "account.legal.recording": "Recording Terms acceptance…",
      "account.legal.failed": "Terms acceptance could not be recorded. Try again.",
      "account.discord_handle_conflict.title": "Discord handle unavailable",
      "account.discord_handle_conflict.detail": "That Discord handle is unavailable. Sign in to link Discord to your account, or register manually with a different handle.",
      "account.error.discord": "Discord sign-in could not be completed. Try again.",
      "account.error.discord_session": "Discord sign-in finished, but your FishyStuff account could not be loaded. Reload this page.",
      "account.discord_linked": "Discord is now linked to your account.",
      "account.settings.title": "Account settings",
      "account.settings.detail": "Update your account settings.",
      "account.settings.group.account": "Account",
      "account.settings.group.sign_in": "Sign-in methods",
      "account.settings.group.two_step": "Two-step verification",
      "account.settings.group.sessions": "Sessions",
      "account.settings.group.danger": "Danger zone",
      "account.settings.navigation.profile": "Profile",
      "account.settings.navigation.password": "Password",
      "account.settings.navigation.oidc": "Social sign-in",
      "account.settings.navigation.passkey": "Passkeys",
      "account.settings.navigation.webauthn": "Security keys",
      "account.settings.navigation.totp": "Authenticator app",
      "account.settings.navigation.lookup_secret": "Backup codes",
      "account.settings.profile.title": "Profile settings",
      "account.settings.profile.detail": "Update your profile information.",
      "account.settings.password.title": "Change password",
      "account.settings.password.detail": "Change or remove password sign-in.",
      "account.settings.first_factor_removal_blocked": "This is your only sign-in method. Add another one before removing it.",
      "account.settings.oidc.title": "Connected accounts",
      "account.settings.oidc.detail": "Connect or disconnect Discord sign-in.",
      "account.settings.passkey.title": "Manage passkeys",
      "account.settings.passkey.detail": "Add or remove passkeys for this account.",
      "account.settings.webauthn.title": "Security keys",
      "account.settings.webauthn.detail": "Manage device biometrics and hardware security keys for two-step verification.",
      "account.settings.totp.title": "Authenticator app",
      "account.settings.totp.detail": "Manage two-step verification with an authenticator app.",
      "account.settings.lookup_secret.title": "Backup recovery codes",
      "account.settings.lookup_secret.detail": "Manage recovery codes for two-step verification.",
      "account.recovery.title": "Recover your account",
      "account.recovery.detail": "We’ll send a short-lived code to the recovery email on your account.",
      "account.verification.title": "Verify your recovery email",
      "account.verification.detail": "Verify your recovery email so it can be trusted for account recovery.",
      "account.verification.complete_title": "Recovery email verified",
      "account.verification.complete_detail": "Your recovery email is verified and can now be used to recover your account.",
      "account.step_up.title": "Complete two-step verification",
      "account.step_up.detail": "Use a security key, your authenticator app, or a backup code to continue securely.",
      "account.reauthenticate.title": "Confirm it’s you",
      "account.reauthenticate.detail": "Sign in again before changing sensitive account details.",
      "account.identity_owned": "Profile, sign-in, and security changes are handled directly by FishyStuff’s account service, separately from synchronized settings and local browser data.",
      "account.field.identifier": "Account handle or recovery email",
      "account.field.identifier_optional": "Account handle or recovery email (optional)",
      "account.field.handle": "Account handle",
      "account.field.handle_optional": "Account handle (optional)",
      "account.field.display_name": "Display name",
      "account.field.display_name_optional": "Display name (optional)",
      "account.field.display_name_help": "When blank, FishyStuff shows your account handle instead.",
      "account.field.password": "Password",
      "account.field.recovery_email": "Recovery email",
      "account.field.recovery_email_help": "Keep at least one verified address so you can recover your account by email.",
      "account.field.email_code": "Email code",
      "account.field.authenticator_code": "Authenticator code",
      "account.field.backup_code": "Backup code",
      "account.field.security_key_name": "Security key name",
      "account.method.password": "Account handle and password",
      "account.method.regular_sign_in": "Regular sign in",
      "account.method.password_change": "Password",
      "account.method.discord": "Discord",
      "account.method.passkey": "Passkeys",
      "account.method.passkey_sign_in": "Passkey",
      "account.method.security_key": "Security key",
      "account.method.profile": "Profile details",
      "account.avatar.title": "Profile picture",
      "account.avatar.detail": "Choose your Discord picture or a FishyStuff avatar. It is saved with your profile.",
      "account.avatar.discord": "Discord",
      "account.avatar.search": "Search avatars",
      "account.avatar.fishystuff": "FishyStuff avatars",
      "account.avatar.choose_fishystuff": "Choose a FishyStuff avatar",
      "account.avatar.color": "Avatar color",
      "account.avatar.color.base": "Theme",
      "account.avatar.color.primary": "Primary",
      "account.avatar.color.secondary": "Secondary",
      "account.avatar.color.accent": "Accent",
      "account.avatar.fish": "Fish",
      "account.avatar.cat": "Cat",
      "account.avatar.dog": "Dog",
      "account.avatar.rabbit": "Rabbit",
      "account.avatar.bear": "Bear",
      "account.avatar.deer": "Deer",
      "account.avatar.bird": "Bird",
      "account.avatar.butterfly": "Butterfly",
      "account.avatar.flower": "Flower",
      "account.avatar.leaf": "Leaf",
      "account.avatar.tree": "Tree",
      "account.avatar.wave": "Wave",
      "account.avatar.paw": "Paw",
      "account.avatar.birthday-2": "Birthday cake",
      "account.avatar.bone": "Bone",
      "account.avatar.bottle-glass": "Glass bottle",
      "account.avatar.bowl-2": "Bowl 2",
      "account.avatar.bowl": "Bowl",
      "account.avatar.bread": "Bread",
      "account.avatar.cake": "Cake",
      "account.avatar.candy-2": "Candy 2",
      "account.avatar.candy": "Candy",
      "account.avatar.carrot": "Carrot",
      "account.avatar.champagne": "Champagne",
      "account.avatar.chicken": "Chicken",
      "account.avatar.chopsticks": "Chopsticks",
      "account.avatar.cookie": "Cookie",
      "account.avatar.cookie-man": "Gingerbread person",
      "account.avatar.cupcake": "Cupcake",
      "account.avatar.dinner": "Dinner",
      "account.avatar.dish-cover": "Serving dish",
      "account.avatar.donut": "Donut",
      "account.avatar.drink": "Drink",
      "account.avatar.egg-crack": "Cracked egg",
      "account.avatar.egg": "Egg",
      "account.avatar.electric-cooker": "Rice cooker",
      "account.avatar.feeder": "Feeder",
      "account.avatar.fork": "Fork",
      "account.avatar.fork-knife": "Fork and knife",
      "account.avatar.fork-spoon": "Fork and spoon",
      "account.avatar.fried-egg": "Fried egg",
      "account.avatar.fries": "Fries",
      "account.avatar.glass-cup": "Glass cup",
      "account.avatar.hamburger": "Hamburger",
      "account.avatar.ice-cream-2": "Ice cream 2",
      "account.avatar.ice-cream": "Ice cream",
      "account.avatar.lollipop": "Lollipop",
      "account.avatar.pizza": "Pizza",
      "account.avatar.soup-pot-2": "Soup pot 2",
      "account.avatar.soup-pot": "Soup pot",
      "account.avatar.spatula": "Spatula",
      "account.avatar.spoon": "Spoon",
      "account.avatar.sugar-coated-haws": "Candied haws",
      "account.avatar.teacup": "Teacup",
      "account.avatar.wine": "Wine",
      "account.avatar.wineglass-2": "Wine glass 2",
      "account.avatar.wineglass": "Wine glass",
      "account.avatar.none": "No picture",
      "account.method.authenticator": "Authenticator app",
      "account.method.backup_codes": "Backup codes",
      "account.method.email_code": "Email code",
      "account.action.sign_in": "Sign in",
      "account.action.submit": "Sign in",
      "account.action.create": "Create account",
      "account.action.register": "Create account",
      "account.action.sign_in_discord": "Sign in with Discord",
      "account.action.register_discord": "Register with Discord",
      "account.action.link_discord": "Link Discord",
      "account.action.unlink_discord": "Unlink Discord",
      "account.action.remove_password": "Remove password",
      "account.action.sign_in_passkey": "Sign in with a passkey",
      "account.login.or": "or",
      "account.action.register_passkey": "Register with a passkey",
      "account.action.add_passkey": "Add a passkey",
      "account.action.remove_passkey": "Remove passkey",
      "account.action.add_security_key": "Add security key",
      "account.action.use_security_key": "Use security key",
      "account.action.remove_security_key": "Remove security key",
      "account.action.rename_passkey": "Rename",
      "account.passkey.default_name": "Passkey",
      "account.passkey.rename_prompt": "Enter a new name for this passkey (1–80 characters).",
      "account.passkey.name_invalid": "Use 1–80 characters without spaces at the beginning or end.",
      "account.passkey.name_saved": "Passkey name saved.",
      "account.passkey.name_failed": "Passkey name could not be saved.",
      "account.passkey.name_conflict": "This passkey name changed elsewhere. The latest name is shown.",
      "account.passkey.identifier_help": "Usually you can choose the account in your device’s passkey prompt.",
      "account.action.save_profile": "Save account details",
      "account.action.change_password": "Change password",
      "account.action.continue": "Continue",
      "account.action.need_account": "Need an account? Register",
      "account.action.register_manually": "Create account manually",
      "account.action.have_account": "Already registered? Sign in",
      "account.action.sign_out": "Sign out",
      "account.action.sign_in_again": "Sign in again",
      "account.action.cancel": "Cancel",
      "account.action.back": "Back to account",
      "account.action.back_to_sign_in": "Back to sign in",
      "account.action.forgot_password": "Forgot your password?",
      "account.action.recover": "Recover account",
      "account.action.verify": "Verify",
      "account.action.verify_email": "Verify recovery email",
      "account.action.send_code": "Send code",
      "account.action.resend_code": "Send a new code",
      "account.action.send_recovery_code": "Send recovery code",
      "account.action.send_verification_code": "Send verification code",
      "account.action.enable_authenticator": "Verify and enable",
      "account.action.remove_authenticator": "Remove authenticator app",
      "account.action.show_backup_codes": "Show backup codes",
      "account.action.regenerate_backup_codes": "Generate new backup codes",
      "account.action.remove_backup_codes": "Remove backup codes",
      "account.action.confirm_backup_codes": "I’ve saved these codes",
      "account.confirm.remove_passkey": "Remove this passkey?",
      "account.confirm.remove_password": "Remove password sign-in from this account?",
      "account.confirm.unlink_discord": "Disconnect Discord sign-in from this account?",
      "account.confirm.remove_security_key": "Remove this security key from your two-step verification methods?",
      "account.confirm.remove_authenticator": "Remove your authenticator app from this account?",
      "account.confirm.regenerate_backup_codes": "Generate new backup codes? Your current backup codes will stop working.",
      "account.confirm.remove_backup_codes": "Remove all backup codes from this account?",
      "account.confirm.revoke_sessions": "Sign out every other active session?",
      "account.error.title": "Account access problem",
      "account.error.connection_title": "Account connection needs attention",
      "account.error.connection_conflict": "That sign-in method is already connected to another account. Sign in to that account first if you want to change its connections.",
      "account.error.login_expired": "Your login expired. Sign in again to continue.",
      "account.error.flow_expired": "That security form expired. Review the fresh form and submit it again.",
      "account.error.sign_out": "Sign out could not be completed.",
      "account.reauthentication.complete": "Login renewed and your change was completed.",
      "account.error.unsupported": "This sign-in page includes controls this FishyStuff version cannot safely display.",
      "account.message.continue": "Continue to finish this account step.",
      "account.message.request_failed": "We couldn’t complete that request. Check the details and try again.",
      "account.error.last_sign_in_method": "This is your only sign-in method. Add another one before removing it.",
      "account.passkey.loading": "Loading passkey support…",
      "account.passkey.cancelled": "The passkey request did not complete.",
      "account.passkey.unavailable": "Passkey support is unavailable.",
      "account.passkey.device_unavailable": "This device can’t create a FishyStuff passkey. Try a device with a supported password manager and screen lock.",
      "account.webauthn.default_name": "Security key",
      "account.webauthn.loading": "Loading security-key support…",
      "account.webauthn.cancelled": "The security-key request did not complete.",
      "account.webauthn.unavailable": "Security-key support is unavailable.",
      "account.webauthn.device_unavailable": "This device can’t create a FishyStuff security key. Try another browser, device biometric, or hardware security key.",
      "account.navigation": "Account access",
      "account.totp.qr_alt": "Authenticator setup QR code",
      "account.totp.qr_help": "Scan this code with your authenticator app, then enter the generated code below.",
      "account.totp.manual_help": "Can’t scan the QR code? Enter this setup key manually:",
      "account.backup_codes.save_notice": "Save these codes somewhere safe. Each available code can be used once if you lose your authenticator.",
      "account.backup_codes.used": "Used code",
      "account.email.title": "Email addresses",
      "account.email.address": "Email address",
      "account.email.verified": "Verified",
      "account.email.unverified": "Not verified",
      "account.action.add_display_name": "Add display name",
      "account.action.remove_display_name": "Remove display name",
      "account.action.add_email": "Add email",
      "account.action.remove_email": "Remove email",
      "account.session.standard": "This session used standard sign-in.",
      "account.session.two_step": "This session completed two-step verification.",
      "account.sessions.title": "Other signed-in sessions",
      "account.sessions.tab": "Sessions",
      "account.sessions.none": "No other active sessions.",
      "account.sessions.unavailable": "Your other sessions are unavailable right now. Profile and sign-out controls still work.",
      "account.sessions.unsupported": "Your other sessions cannot be displayed safely in this version.",
      "account.sessions.item": "Signed-in session",
      "account.sessions.signed_in": "Signed in",
      "account.sessions.expires": "expires",
      "account.sessions.revoke": "Sign out session",
      "account.sessions.revoke_all": "Sign out all other sessions",
      "account.sessions.revoking": "Signing out the selected session…",
      "account.sessions.revoking_all": "Signing out all other sessions…",
      "account.sessions.revoke_failed": "That session could not be signed out. Try again.",
      "account.deletion.title": "Delete account",
      "account.deletion.warning": "Deleting your account cannot be undone. It removes your FishyStuff account and account-accessible synchronized private history, and signs you out on every device.",
      "account.deletion.retention": "Server-side account data and synchronized private history are deleted. Minimal-context fishing statistics merged during deletion remain without a fixed deletion date and may be shared or published as explained in the Privacy Policy. FishyStuff does not keep an account-to-contribution link, but outside information may still allow association. Data stored on your devices is not deleted. Backups, temporary deletion records, security logs, and legal records follow the retention periods in the Privacy Policy.",
      "account.deletion.confirm_prompt": "Type this handle exactly to confirm:",
      "account.deletion.action": "Delete account",
      "account.deletion.pending": "Deleting your account…",
      "account.deletion.accepted_title": "Account deletion started",
      "account.deletion.accepted_detail": "Your account data is locked and cleanup is continuing. You will be signed out on every device when deletion finishes.",
      "account.deletion.retryable": "Account deletion could not be completed. Try again.",
      "account.deletion.identity_changed": "We checked your account again. Confirm the current handle before deleting it.",
      "account.deletion.reauthenticate": "For your security, sign in again before deleting your account.",
      "account.deletion.reauthenticate_action": "Sign in again",
      "account.deletion.complete_title": "Account deleted",
      "account.deletion.complete_detail": "Your FishyStuff account and account-accessible synchronized private history were deleted. You have been signed out on every device.",
      "account.deletion.complete_local": "Browser-local and offline data on this or other devices was not erased.",
      "account.privacy.title": "Privacy & data",
      "account.privacy.detail": "Review optional diagnostic sharing and Discord profile images.",
      "desktop.privacy.title": "Desktop / Dataset Contribution privacy notice",
      "desktop.privacy.detail": "Read this separate notice before downloading Desktop or connecting synchronization. It explains local capture, private synchronization, and dataset contribution. This is information, not consent; opening or saving it does not activate contribution.",
      "desktop.privacy.access": "The complete English and German notice is available online to signed-in, eligible account holders before participation. Current Terms acceptance is not required to read or download it.",
      "desktop.privacy.contact": "Former participants, closed accounts, or no access: request this information or exercise privacy rights by email. No sign-up, payment, or Terms acceptance is required:",
      "desktop.privacy.before_download": "Before installing: read the Desktop / Dataset Contribution privacy notice (information, not consent).",
      "account.privacy.no_active_consent": "No active consent",
      "account.privacy.clear_declined": "Clear declined choice",
      "account.browser.title": "This browser",
      "account.browser.detail": "Manage data kept only on this device. These actions do not delete synchronized account data.",
      "account.browser.local_detail": "Clear the signed-out authorship record, local appearance and language choices, or shared browser interface preferences.",
      "account.browser.clear_profile": "Clear local profile",
      "account.browser.reset_appearance": "Reset local appearance",
      "account.browser.reset_interface": "Reset browser interface",
      "account.browser.cache_detail": "Clear rebuildable FishyStuff map runtime files without removing bookmarks, map settings, or other saved data.",
      "account.browser.clear_cache": "Clear runtime cache",
      "account.browser.delete_detail": "Delete all saved user state from this browser. Synchronized account data and open map-tab session state are not deleted.",
      "account.browser.delete_all": "Delete browser data",
      "appearance.domain_colors.title": "Palette sources",
      "appearance.domain_colors.detail": "Choose whether source-backed labels use game colors or the active theme.",
      "appearance.domain_colors.game.label": "Use game colors",
      "appearance.domain_colors.game.detail": "Grades, ranks, and common status colors use the game palette.",
      "appearance.domain_colors.game_grades.label": "Use game colors for grades and ranks",
      "appearance.domain_colors.game_grades.detail": "Status colors follow the theme; item grades and lifeskill ranks keep their game colors.",
      "appearance.domain_colors.theme.label": "Use theme colors",
      "appearance.domain_colors.theme.detail": "Item grades and lifeskill ranks both follow the active theme.",
      "profile.role.profile": "Profile",
      "profile.role.member": "Member",
      "profile.provider.account": "Account",
      "profile.actor.guest_name": "Angler {$id}",
      "profile.actor.provider_profile": "{$provider} profile",
      "profile.actor.provider_user": "{$provider} user",
      "profile.local_profile.label": "Browser {$id}",
      "profile.session.label": "Session {$id}",
      "profile.telemetry.status.on": "On",
      "profile.telemetry.status.off": "Off",
      "profile.telemetry.preference.requested_on": "Requested on",
      "profile.telemetry.preference.stored_off": "Stored off",
      "profile.telemetry.preference.unavailable": "Unavailable",
      "profile.telemetry.preference.always_on": "Always on",
      "profile.telemetry.preference.always_off": "Always off",
      "profile.telemetry.preference.using_default": "Using default",
      "profile.telemetry.detail.unavailable": "Telemetry is unavailable.",
      "profile.telemetry.detail.enabled": "Telemetry is enabled.",
      "profile.telemetry.detail.disabled": "Telemetry is disabled.",
      "profile.telemetry.detail.off": "Telemetry is off.",
      "profile.diagnostic_reports.status.manual": "Manual",
      "profile.diagnostic_reports.detail.manual": "Reports are shared manually.",
      "profile.data_scope.profile_data": "Profile data",
      "profile.data_scope.profile_ui": "Profile UI",
      "profile.data_scope.browser_data": "Browser data",
      "profile.data_scope.browser_ui": "Browser UI",
      "profile.data_scope.map_data": "Map data",
      "profile.data_scope.map_ui": "Map UI",
      "profile.data_scope.dex_data": "Dex data",
      "profile.data_scope.dex_ui": "Dex UI",
      "profile.data_scope.calculator_data": "Calculator data",
      "profile.data_scope.calculator_ui": "Calculator UI",
      "profile.data_scope.presets_data": "Saved presets",
      "profile.data_scope.overrides_data": "Overrides data",
      "profile.data_scope.tutorial_progress": "Tutorial progress",
      "profile.data_scope.all": "All local data",
      "health.menu.open": "Open status menu",
      "health.menu.title": "Page status",
      "health.menu.send_report": "Send report",
      "health.menu.dismiss_all": "Dismiss all",
      "health.menu.show_status": "Show status menu",
      "health.menu.show_warnings": "Show status warnings",
      "health.menu.visible_when_warnings": "Visible when warnings are active",
      "health.menu.visible_for_errors": "Visible while errors are active",
      "health.menu.hidden_in_settings": "Hidden in settings",
      "health.telemetry.detail.export_failed": "The last manual report could not be delivered.",
      "health.telemetry.detail.ready": "Manual report delivery is available.",
      "health.telemetry.detail.missing_logs_exporter": "Manual report delivery is not configured.",
      "health.telemetry.detail.logs_unavailable": "Manual report delivery is unavailable right now.",
      "health.telemetry.detail.disabled_by_runtime_policy": "Manual reports are disabled by the runtime policy.",
      "health.telemetry.detail.uninitialized": "Manual report delivery has not initialized for this page.",
      "health.issue.default_page_title": "Page issue",
      "health.issue.active_warning.one": "1 active warning",
      "health.issue.active_warning.many": "{$count} active warnings",
      "health.issue.severity.error": "error",
      "health.issue.severity.warning": "warning",
      "health.issue.severity.info": "info",
      "health.issue.dismiss": "Dismiss",
      "health.issue.copy_details": "Copy details",
      "health.issue.copy_success": "Error details copied.",
      "health.issue.copy_failure": "Clipboard access is unavailable in this browser.",
      "health.console_error.title": "Console error",
      "health.resource_error.title": "Resource load error",
      "health.runtime_error.title": "Page script error",
      "health.unhandled_rejection.title": "Unhandled page error",
      "health.report.summary.warnings": "{$count} page health warnings",
      "health.report.failure.delivery": "The manual report could not be delivered.",
      "health.report.failure.telemetry_off": "Manual report delivery is unavailable for this page.",
      "health.report.failure.logs_unavailable": "Manual report delivery is unavailable right now.",
      "health.report.failure.telemetry_unavailable": "Manual report delivery is unavailable right now.",
      "health.report.success.sent": "Diagnostic report sent.",
      "health.report.send_title": "Preview selected issues and description",
      "health.report.preview_title": "Review this diagnostic report",
      "health.report.preview_notice": "Only the exact JSON below is sent when you choose “Send this report”.",
      "health.report.preview_cancel": "Cancel",
      "health.report.preview_confirm": "Send this report",
      "common.provenance.label.default": "Provenance",
      "common.provenance.channel.presence": "Presence",
      "common.provenance.channel.rate": "Rate",
      "common.provenance.source.database": "Database",
      "common.provenance.source.ranking": "Ranking",
      "common.provenance.source.ranking_ring": "Ranking ring",
      "common.provenance.source.community": "Community",
      "common.provenance.source.community_guess": "Community guess",
      "common.provenance.source.community_support": "Community support",
      "common.provenance.source.derived": "Derived",
      "common.provenance.source.overlay": "Personal overlay",
      "common.provenance.source.overlay_short": "Overlay",
      "common.provenance.source.mixed_support": "Mixed support",
      "common.provenance.source.mixed_sources": "Mixed sources",
      "common.provenance.source.full_ring": "Full ring",
      "common.provenance.source.partial_ring": "Partial ring",
      "common.provenance.source.unspecified": "Unspecified",
      "common.provenance.source.detail": "Detail",
      "common.provenance.detail.database_rate": "Database-backed rate.",
      "common.provenance.detail.database_rate_value": "Database-backed rate. Current value: {$value}.",
      "common.provenance.detail.database_presence": "Database-backed presence.",
      "common.provenance.detail.ranking_presence": "Ranking ring overlap support from observed player positions.",
      "common.provenance.detail.ranking_rate": "Ranking-derived provenance.",
      "common.provenance.detail.community_rate": "Community-maintained guessed rate.",
      "common.provenance.detail.community_presence": "Community-maintained presence support.",
      "common.provenance.detail.derived_rate": "Derived rate.",
      "common.provenance.detail.derived_rate_value": "Derived rate. Current value: {$value}.",
      "common.provenance.detail.derived_presence": "Derived presence support.",
      "common.provenance.detail.overlay": "Personal overlay proposal.",
      "common.provenance.detail.overlay_rate_value": "Personal overlay proposal. Current value: {$value}.",
      "common.provenance.detail.mixed_presence": "Multiple presence provenance sources support this row.",
      "common.provenance.detail.mixed": "Multiple provenance sources support this row.",
      "common.provenance.detail.missing": "No {$channel} provenance recorded yet.",
      "domain.entity.fish": "Fish",
      "domain.entity.fish_id": "Fish {$id}",
      "domain.entity.item": "Item",
      "domain.entity.item_id": "Item {$id}",
      "domain.entity.zone": "Zone",
      "domain.entity.map": "Map",
      "domain.taxonomy.grade": "Grade",
      "domain.taxonomy.method": "Method",
      "domain.method.rod": "Rod",
      "domain.method.hotspot": "Hotspot",
      "domain.method.harpoon": "Harpoon",
      "domain.method.fishing": "Fishing",
      "domain.source.zone": "Zone",
      "domain.source.hotspot": "Hotspot",
      "domain.source.ice_fishing": "Ice Fishing",
      "domain.grade.prize": "Prize",
      "domain.grade.red": "Red",
      "domain.grade.yellow": "Yellow",
      "domain.grade.blue": "Blue",
      "domain.grade.green": "Green",
      "domain.grade.white": "White",
      "domain.grade.unknown": "Unknown",
      "domain.loot_group.prize": "Prize",
      "domain.loot_group.rare": "Rare",
      "domain.loot_group.high_quality": "High-Quality",
      "domain.loot_group.general": "General",
      "domain.loot_group.trash": "Trash",
      "domain.loot_group.unassigned": "Unassigned",
      "common.rate_basis.normalized.description": "Final allocated percentage after fixed shares and weights are resolved.",
      "common.rate_basis.denormalized.description": "The same raw weight divided by 10,000 and displayed with %.",
      "common.rate_basis.raw_weight.description": "A non-negative relative input used to divide the probability left after fixed shares.",
      "by": "By",
      "by_lower": "by",
      "last_updated": "Last updated",
      "originally_posted": "Originally posted",
      "updated": "Updated",
      "minutes_read_suffix": "min read",
      "minutes_read_abbrev": "min",
      "language.menu.label": "Language",
      "language.menu.content": "Content language",
      "language.menu.locale": "UI language",
      "language.menu.api": "Data language",
      "language.menu.service_region": "Game service region",
      "language.menu.content_help": "Changes page content such as guides when a translation is available.",
      "language.menu.locale_help": "Changes interface labels such as menus, buttons, and controls.",
      "language.menu.api_help": "Changes game data texts such as item, region and node names.",
      "language.menu.service_region_help": "Sets your game service region for region-specific data and defaults.",
      "language.option.auto.locale": "Follow content language",
      "language.option.follow_content.api": "Follow content language",
      "language.option.region_default.api": "Use region default data language",
      "language.option.content.en-US": "English",
      "language.option.content.de-DE": "Deutsch",
      "language.option.locale.en-US": "English (en-US)",
      "language.option.locale.de-DE": "Deutsch (de-DE)",
      "language.option.locale.ko-KR": "한국어 (ko-KR)",
      "language.option.api.en": "English (en)",
      "language.option.api.de": "Deutsch (de)",
      "language.option.api.es": "Español (es)",
      "language.option.api.fr": "Français (fr)",
      "language.option.api.id": "Bahasa Indonesia (id)",
      "language.option.api.jp": "日本語 (jp)",
      "language.option.api.kr": "한국어 (kr)",
      "language.option.api.pt": "Português (pt)",
      "language.option.api.ru": "Русский (ru)",
      "language.option.api.sp": "Español (sp)",
      "language.option.api.th": "ไทย (th)",
      "language.option.api.tr": "Türkçe (tr)",
      "language.option.api.tr_en": "English (tr_en)",
      "language.option.api.tw": "繁體中文 (tw)",
      "language.option.service_region.na": "North America (NA)",
      "language.option.service_region.eu": "Europe (EU)",
      "language.option.service_region.mena": "Middle East/North Africa (MENA)",
      "language.option.service_region.ru": "Russia (RU)",
      "language.option.service_region.asia": "Asia (TH/SEA) (ASIA)",
      "language.option.service_region.jp": "Japan (JP)",
      "language.option.service_region.sa": "South America (SA)",
      "language.option.service_region.kr": "Korea (KR)",
      "language.option.service_region.tw": "Taiwan (TW)",
      "language.option.service_region.gt": "Global Lab (GT)",
      "language.option.service_region.ceu": "Console Europe (CEU)",
      "language.option.service_region.cna": "Console North America (CNA)",
      "language.option.service_region.cas": "Console Asia (CAS)",
      "translation_notice.title": "Translation help wanted",
      "translation_notice.body": "This page has not been translated yet. You are currently viewing the English source content.",
      "translation_notice.help": "Want to help?",
      "translation_notice.community_link": "Community page",
      "translation_notice.target_path_label": "Target file:",
      "account.privacy.optional_features": "External feature consent",
      "account.privacy.optional_features_detail": "External features remain off unless you allow their exact purpose. You can withdraw permission at any time.",
      "account.privacy.telemetry_consent": "Optional telemetry",
      "account.privacy.telemetry_consent_detail": "Send bounded technical errors, traces, and performance measurements to FishyStuff.",
      "account.privacy.telemetry_account_only": "Optional telemetry settings are available only while signed in.",
      "account.privacy.discord_images": "Discord profile images",
      "account.privacy.discord_images_detail": "Load your selected profile image directly from Discord's CDN. Discord receives your IP address and request metadata.",
      "account.privacy.settings": "Privacy settings",
      "account.privacy.settings_detail": "Preferences are separate from consent. A feature cannot send data unless its required consent is active.",
      "consent.title": "Optional features",
      "consent.detail": "FishyStuff works without these. Choose which external features may run.",
      "consent.dismiss": "Decide later",
      "consent.open": "Privacy choices",
      "consent.telemetry.title": "Optional telemetry",
      "consent.telemetry.detail": "Send bounded technical errors, traces, and performance measurements to FishyStuff.",
      "consent.telemetry.granted": "Allowed under the current telemetry notice.",
      "consent.telemetry.denied": "Not allowed.",
      "consent.telemetry.unset": "No decision yet; telemetry remains off.",
      "consent.telemetry.selection_approved": "Approved for sending",
      "consent.telemetry.selection_not_approved": "Not approved for sending",
      "consent.discord_images.title": "Discord profile images",
      "consent.discord_images.detail": "Load a selected profile image directly from Discord's CDN.",
      "consent.discord_images.granted": "Discord-hosted profile images may load.",
      "consent.discord_images.denied": "Discord-hosted images stay blocked.",
      "consent.discord_images.unset": "No decision yet; Discord-hosted images stay blocked.",
      "consent.settings": "Privacy settings",
      "consent.keep_off": "Keep optional features off",
      "consent.save": "Allow selected",
      "consent.save_failed": "Your privacy choices could not be saved. Try again.",
      "participation.title": "Participation",
      "participation.activity": "Activity",
      "participation.download": "Get Desktop",
      "participation.refresh": "Refresh status",
      "participation.review": "Review participation",
      "participation.signed_out": "Sign in to manage your installations. Local tracking does not require participation.",
      "participation.loading": "Loading participation status…",
      "participation.unavailable": "Participation status is unavailable. No change has been confirmed.",
      "participation.intro": "Manage each installation separately. Stopping contribution stops future delivery; it does not erase existing data or replace a privacy-rights request.",
      "participation.no_installations": "No installations are registered for this account. In Desktop, choose “Review synchronization and contribution” to review retained history and future uploads. Visiting this page enables nothing.",
      "participation.active": "Authorized",
      "participation.disabled": "Stopped",
      "participation.review_required": "Review required",
      "participation.revocation_pending": "New authorization is disabled. Broker revocation is still pending; do not assume existing connections have stopped.",
      "participation.revocation_complete": "Broker revocation confirmed.",
      "participation.prepare_again": "Prepare a fresh review in this Desktop installation before enabling contribution.",
      "participation.retry_stop": "Retry broker revocation",
      "participation.stop": "Stop contributing",
      "participation.account": "Account",
      "participation.installation": "Installation",
      "participation.retained_history": "Retained history prepared by this installation",
      "participation.fact_count": "Pending facts",
      "participation.fact_kinds": "Fact kinds",
      "participation.source_range": "Available source timestamp range (nanoseconds)",
      "participation.names": "Identity names in retained facts",
      "participation.gaps": "Recorded history gaps",
      "participation.yes": "Yes",
      "participation.no": "No",
      "participation.none": "None",
      "participation.unknown": "Unavailable",
      "participation.full_notice": "Read the complete Desktop and Dataset Contribution Privacy Notice",
      "participation.keep_local": "Keep data local",
      "participation.enable": "Enable synchronization and contribute",
      "participation.saving": "Applying participation change…",
      "participation.uncertain": "Could not confirm this change. Refresh status before trying again; do not assume contribution has stopped.",
      "participation.enable_unavailable": "Enabling requires current Terms acceptance and Desktop eligibility. You can still stop an existing registration here.",
      "participation.no_installations_unavailable": "No installations are registered for this account. Enabling participation requires current Terms acceptance and Desktop eligibility.",
      "desktop.privacy.reader.open": "Read privacy notice",
      "desktop.privacy.reader.title": "Desktop and Dataset Contribution Privacy Notice",
      "desktop.privacy.reader.loading": "Loading the privacy notice…",
      "desktop.privacy.reader.ready": "Privacy notice loaded.",
      "desktop.privacy.reader.signed_out": "Sign in with an eligible account to read this notice here, or request a copy by email below.",
      "desktop.privacy.reader.denied": "This account cannot read the notice online. You can request the relevant notice by email below.",
      "desktop.privacy.reader.error": "The privacy notice could not be loaded. Try again, or request a copy by email below.",
      "desktop.privacy.reader.sign_in": "Sign in",
      "desktop.privacy.reader.retry": "Try again",
      "desktop.privacy.reader.javascript": "Enable JavaScript to read the notice here, or request a copy by email below.",
      "desktop.privacy.reader.downloads": "Privacy notice downloads",
      "page_outline.open": "Open table of contents",
      "page_outline.title": "On this page",
      "page_outline.close": "Close table of contents",
      "desktop.privacy.reader.rss": "RSS updates",
      "desktop.privacy.reader.text": "Download .txt",
      "desktop.privacy.reader.request_title": "Need a copy without account access?",
      "desktop.privacy.reader.request_detail": "Former participants and anyone whose data may be affected can request the relevant current notice and information about earlier processing. No registration, renewed eligibility, payment, or acceptance of new Terms is required.",
      "contest.title": "This week's contest",
      "contest.query_title": "Weekly Contest",
      "contest.explanation": "Help the community identify this week's contest fish for your selected region: suggest fish, upvote one per category, and optionally downvote other suggestions. Click an active thumb to withdraw it. Votes are grouped by account when signed in, or by IP address when signed out; people sharing an IP share votes.",
      "contest.loading": "Loading this week's community reports…",
      "contest.unavailable": "Contest reports are unavailable.",
      "contest.period": "Week: { $start } to { $end } · 00:00 UTC",
      "contest.prize": "Prize",
      "contest.rare": "Rare",
      "contest.highQuality": "High Quality",
      "contest.no_leader": "No unique leader",
      "contest.contribute": "Community reports and contributions",
      "contest.voting": "Voting",
      "contest.vote": "Vote",
      "contest.view_results_vote": "View results and vote",
      "contest.close": "Close",
      "contest.slot_loading": "Loading…",
      "contest.slot_unavailable": "Unavailable",
      "contest.no_candidates": "No fish have been suggested in this category yet.",
      "contest.leader": "Provisional vote leader",
      "contest.vote_name": "Upvote { $name } · { $count } upvotes",
      "contest.retract_name": "Withdraw your upvote for { $name } · { $count } upvotes",
      "contest.downvote_name": "Downvote { $name } · { $count } downvotes",
      "contest.retract_downvote_name": "Withdraw your downvote for { $name } · { $count } downvotes",
      "contest.net_support": "Net: { $count }",
      "contest.net_support_help": "Net support is upvotes minus downvotes.",
      "contest.vote_retracted": "Your upvote was withdrawn.",
      "contest.downvote_retracted": "Your downvote was withdrawn.",
      "contest.choose": "Choose a fish",
      "contest.add_candidate": "Suggest a fish and upvote it",
      "contest.search": "Search fish",
      "contest.saving": "Sending your contribution…",
      "contest.voted": "Your upvote was recorded.",
      "contest.downvoted": "Your downvote was recorded.",
      "contest.conflict": "Participation, confirmation or the week changed. Your contribution was not sent again.",
      "contest.forbidden": "This contribution was not allowed. Account votes require current Terms acceptance; confirmations also require current moderator permission. Nothing was sent again.",
      "contest.uncertain": "This contribution could not be confirmed. It was not sent again.",
      "contest.week_changed": "A new contest week has begun. The previous week's fish have been cleared.",
      "contest.moderator_confirmed": "Confirmed",
      "contest.confirm_fish": "Confirm fish",
      "contest.confirm_fish_name": "Review confirmation of { $name }",
      "contest.replace_confirmation": "Replace confirmation",
      "contest.replace_confirmation_name": "Review replacing the confirmation with { $name }",
      "contest.review_confirmation": "Review moderator confirmation",
      "contest.review_replacement": "Review confirmation replacement",
      "contest.confirmation_help": "Confirm one suggested fish for this category, region and week. This choice replaces any current confirmation and is used by the contest filter even if another fish has higher net support. It does not change votes or certify an official target.",
      "contest.previous_confirmation": "Currently confirmed: { $name }",
      "contest.cancel_confirmation": "Cancel",
      "contest.save_confirmation": "Confirm for this week",
      "contest.save_replacement": "Replace confirmed fish",
      "contest.confirmation_saved": "The moderator-confirmed fish was updated.",
      "fishydex.progress.panel": "Progress",
      "fishydex.progress.aria.catalog": "Catalog completion: {$caught} of {$total} fish caught ({$percent}%)",
      "fishydex.progress.aria.grade": "{$grade} completion: {$caught} of {$total} fish caught ({$percent}%)",
      "fishydex.progress.kicker": "Overall",
      "fishydex.progress.title": "Catalog Completion",
      "fishydex.progress.remaining": "{$count} remaining",
      "fishydex.progress.empty": "No catalog entries yet",
      "fishydex.progress.empty_grade": "No catalog fish",
      "fishydex.presets.preview.caught": "{$count} caught",
      "fishydex.presets.preview.favourite": "{$count} favourite",
      "fishydex.presets.preview.tracked": "{$count} tracked",
      "fishydex.presets.change.dried_visibility": "Dried fish visibility",
      "fishydex.presets.change.caught_fish": "Caught fish",
      "fishydex.presets.change.favourite_fish": "Favourite fish",
      "fishydex.presets.change.not_favourite": "Not favourite",
      "fishydex.presets.change.shown": "Shown",
      "fishydex.presets.change.hidden": "Hidden",
      "fishydex.presets.change.enabled": "Enabled",
      "fishydex.presets.change.disabled": "Disabled",
      "fishydex.presets.change.none": "None",
      "fishydex.presets.change.fish_guide": "Fish Guide",
      "fishydex.filter.panel": "Filter",
      "fishydex.filter.expand": "Expand filter panel",
      "fishydex.filter.collapse": "Collapse filter panel",
      "fishydex.filter.search.sr": "Search fish",
      "fishydex.filter.search.placeholder": "Search by fish name or ID",
      "fishydex.filter.status.legend": "Status",
      "fishydex.filter.status.group": "Status filters",
      "fishydex.filter.status.all": "All",
      "fishydex.filter.status.caught": "Caught",
      "fishydex.filter.status.missing": "Missing",
      "fishydex.filter.status.favourite": "Favourite",
      "fishydex.filter.grade.group": "Grade color filters",
      "fishydex.filter.grade.red_help": "Red grade — typically found in the Prize group",
      "fishydex.filter.grade.yellow_help": "Yellow grade — typically found in the Rare group",
      "fishydex.filter.grade.blue_help": "Blue grade — typically found in the High-Quality group",
      "fishydex.filter.grade.green_help": "Green grade — typically found in the General group",
      "fishydex.filter.grade.white_help": "White grade — no typical fishing-group association is documented",
      "fishydex.filter.method.group": "Catch method filters and dried fish visibility",
      "fishydex.filter.method.show_dried": "Include dried fish",
      "fishydex.filter.matches": "Showing {$visible}/{$total} matches",
      "fishydex.filter.clear": "Clear filters",
      "fishydex.filter.status_label": "Status:",
      "fishydex.catalog.panel": "Catalog",
      "fishydex.catalog.controls": "Catalog controls",
      "fishydex.catalog.view": "Catalog view",
      "fishydex.catalog.view.guide": "Fish Guide",
      "fishydex.catalog.sort": "Catalog sort controls",
      "fishydex.catalog.sort.price": "Price",
      "fishydex.catalog.sort.name": "Name",
      "fishydex.catalog.sort.current": "Toggle {$field} sort direction. Current: {$direction}.",
      "fishydex.catalog.sort.default": "Sort catalog by {$field} ascending.",
      "fishydex.catalog.sort.direction.asc": "ascending",
      "fishydex.catalog.sort.direction.desc": "descending",
      "fishydex.details.open": "Open details for {$name}",
      "fishydex.details.favourite_toggle": "Mark fish as favourite",
      "fishydex.details.caught_toggle": "Mark fish as caught",
      "fishydex.details.favourite": "Favourite",
      "fishydex.details.caught": "Caught",
      "fishydex.details.not_caught": "Not Caught",
      "fishydex.details.unknown": "Unknown",
      "fishydex.details.dried": "Dried",
      "fishydex.details.close": "Close fish details",
      "fishydex.details.item_key": "Item Key",
      "fishydex.details.vendor_price": "Vendor Price",
      "fishydex.details.catch_count": "Capture count",
      "fishydex.details.tabs.label": "Fish details",
      "fishydex.details.tabs.info": "Info",
      "fishydex.details.tabs.zones": "Zones",
      "fishydex.details.tabs.titles": "Titles",
      "fishydex.details.view_on_map": "View on map: {$name}",
      "fishydex.details.description_unavailable": "No official description is available in the selected data language.",
      "fishydex.details.zones.heading": "Fishing Zones",
      "fishydex.page.context": "{$name} is a {$grade}-grade Black Desert fish worth {$price}. {$locations}.",
      "fishydex.page.silver": "Silver",
      "fishydex.page.locations.first_group": "It belongs to the {$groups} group in {$zones}",
      "fishydex.page.locations.additional_group": "the {$groups} group in {$zones}",
      "fishydex.page.locations.first_groups": "It belongs to the {$groups} groups in {$zones}",
      "fishydex.page.locations.additional_groups": "the {$groups} groups in {$zones}",
      "fishydex.page.locations.first_unknown": "It appears in {$zones}",
      "fishydex.page.locations.additional_unknown": "also appears in {$zones}",
      "fishydex.page.locations.none": "No known fishing zone is currently listed",
      "fishydex.page.locations.known_one": "1 additional known zone",
      "fishydex.page.locations.known_many": "{$count} additional known zones",
      "fishydex.page.locations.potential_one": "1 additional potential zone",
      "fishydex.page.locations.potential_many": "{$count} additional potential zones",
      "fishydex.page.locations.explore": "See {$locations} on FishyStuff",
      "fishydex.index.title": "Fish Location Index",
      "fishydex.index.description": "Browse individual fish pages with in-game descriptions and known or potential fishing zones.",
      "fishydex.index.summary": "Browse {$count} fish",
      "fishydex.details.zones.loading": "Loading fishing zones…",
      "fishydex.details.zones.error": "Fishing zones could not be loaded.",
      "fishydex.details.zones.empty": "No known or potential fishing zones are currently listed for this fish.",
      "fishydex.details.zones.tab_known": "Known Fishing Zones",
      "fishydex.details.zones.tab_potential": "Potential Fishing Zones",
      "fishydex.details.zones.known_intro": "Known fishing zones are established by reviewed baseline data or maintained community assignments.",
      "fishydex.details.zones.potential_intro": "Potential fishing zones are suggested automatically from real-player ranking observations and still need review.",
      "fishydex.details.zones.explainer_summary": "How ranking evidence is attributed",
      "fishydex.details.zones.ranking_context": "Ranking observations record a fish, timestamp, and player position—not the fish’s exact catch location. FishyStuff attributes a 500-game-unit uncertainty ring around that position to the current fishing-zone map.",
      "fishydex.details.zones.fully_contained_label": "Fully contained",
      "fishydex.details.zones.fully_contained_explanation": "The entire uncertainty ring falls inside one fishing zone in the current map. This is stronger spatial support, but it is not promoted automatically: ranking evidence does not establish a fishing group, and zone boundaries may still need review.",
      "fishydex.details.zones.partial_overlap_label": "Partial overlap",
      "fishydex.details.zones.partial_overlap_explanation": "The ring crosses a zone border and touches more than one fishing zone. Every touched zone receives weaker positive support because the exact zone attribution is unclear.",
      "fishydex.details.zones.ranking_limit": "These counts indicate presence support, not catch rates or drop rates.",
      "fishydex.details.zones.unknown_zone": "Unknown zone",
      "fishydex.details.zones.ranking_fully_contained": "Fully contained ranking rings ×{$count}",
      "fishydex.details.zones.ranking_partial_overlap": "Partially overlapping ranking rings ×{$count}",
      "fishydex.details.zones.baseline_group": "Baseline {$group}",
      "fishydex.details.zones.maintained_group": "Maintained {$group}",
      "fishydex.empty.title": "No fish match this filter.",
      "fishydex.empty.filtered": "Try a broader search or clear some filters.",
      "fishydex.empty.unfiltered": "The fish catalog is empty.",
      "fishydex.group.count": "{$count} entries",
      "fishydex.group.guide.freshwater": "Freshwater Fish",
      "fishydex.group.guide.saltwater": "Saltwater Fish",
      "fishydex.group.guide.crustacean": "Crustacean",
      "fishydex.group.guide.other": "Other",
      "fishydex.group.guide.unknown": "Unmapped",
      "fishydex.details.icon_alt": "{$name} icon",
      "fishydex.details.guide_alt": "{$name} guide image",
      "fishydex.guide.catch_count": "Catches: {$count}",
      "fishydex.guide.catch_count_short": "{$count}x",
      "fishydex.state.unavailable": "Unavailable",
      "fishydex.state.not_applicable": "Not applicable",
      "fishydex.state.local_storage_unavailable": "localStorage is unavailable; progress is not persisted.",
      "fishydex.state.corrupt_filters": "Reset corrupted local fishydex filters.",
      "fishydex.state.corrupt_progress": "Reset corrupted local fishydex progress.",
      "fishydex.state.corrupt_favourites": "Reset corrupted local fishydex favourites.",
      "fishydex.state.corrupt_fish_guide": "Reset corrupted local Fish Guide progress.",
      "fishydex.action.favourite.add": "Add {$name} to favourites",
      "fishydex.action.favourite.remove": "Remove {$name} from favourites",
      "fishydex.action.caught.mark": "Set {$name} to 1 catch",
      "fishydex.action.caught.unmark": "Reset {$name} to 0 catches",
      "fishydex.api.zone_evidence_error": "Fishing-zone evidence could not be loaded ({$message}).",
      "fishydex.api.contract_error": "Fish API returned an unsupported catalog contract ({$detail}).",
      "fishydex.api.fish_error": "Fish API request failed.",
      "fishydex.api.fish_error_status": "Fish API request failed (HTTP {$status}).",
      "fishydex.api.retrying": "Fish API request is retrying.",
      "fishydex.api.cors_hint": "If this page is on a different origin than the API, confirm the API CORS allowlist includes this site.",
      "fishydex.api.retry_hint": "The request could not be completed cleanly.",
      "fishydex.titles.include_contest": "Include contest titles",
      "fishydex.titles.include_unobtainable": "Include unobtainable titles",
      "fishydex.titles.unobtainable": "Unobtainable",
      "fishydex.titles.catch": "Catch titles",
      "fishydex.titles.contest": "Contest titles",
      "fishydex.titles.quest": "Quest titles",
      "fishydex.titles.exchange": "Exchange titles",
      "fishydex.titles.other": "Other fishing titles",
      "fishydex.titles.unknown": "Unknown",
      "fishydex.titles.name_unknown": "Title {$id}: name unavailable",
      "fishydex.titles.description_unknown": "Original description unavailable in this data language.",
      "fishydex.titles.owned": "Title obtained",
      "fishydex.titles.not_owned": "Title not obtained",
      "fishydex.titles.owned_total": "Titles obtained: {$owned}/{$total}",
      "fishydex.titles.image_progress": "Title progress around fish image",
      "fishydex.titles.current_count": "Recorded catches: {$count}",
      "fishydex.titles.reference_count": "Community reference: {$count} catches",
      "fishydex.titles.community_count": "Community estimate: {$count} catches",
      "fishydex.titles.requirement_unknown": "Numeric requirement unknown",
      "fishydex.titles.reference_source": "Community reference source",
      "fishydex.titles.manual_count": "Catch count",
      "fishydex.titles.save_error": "Progress could not be saved. Your acknowledged progress is shown; try again.",
      "fishydex.titles.state_unavailable": "Progress is not writable right now. Resolve the Current progress status before editing.",
      "fishydex.titles.loading": "Loading fishing titles…",
      "fishydex.titles.catalog_error": "Fishing titles could not be loaded in this data language. Reload to try again; your saved progress is unchanged.",
      "fishydex.titles.no_titles": "No fishing titles are currently associated with this fish.",
      "fishydex.titles.reports": "Community acquisition reports: {$count}; average {$average} catches. This is not an exact requirement.",
      "fishydex.titles.no_reports": "No acquisition reports yet.",
      "fishydex.titles.report_heading": "Contribute an acquisition report",
      "fishydex.titles.report_help": "Signed-in contribution: report the count when you obtained a title. Only the number of reports and average are public. One report per account and title; submitting again replaces yours. Saving personal progress never sends a report.",
      "fishydex.titles.report_count": "Catch count when obtained",
      "fishydex.titles.report_date": "Date obtained (optional)",
      "fishydex.titles.report_submit": "Submit acquisition report",
      "fishydex.titles.report_sending": "Sending report…",
      "fishydex.titles.report_saved": "Your acquisition report was saved. Public averages update when the catalog is next loaded.",
      "fishydex.titles.report_sign_in": "Sign in to submit an acquisition report. Your personal progress is unchanged.",
      "fishydex.titles.report_error": "The acquisition report could not be saved. Please try again.",
      "fishydex.titles.provenance": "Evidence",
      "fishydex.titles.used_requirement": "Current requirement (catches)",
      "fishydex.titles.community_evidence": "Community reports",
      "fishydex.titles.estimate_difference": "Average minus current requirement",
      "fishydex.titles.difference_value": "{$count} catches",
      "fishydex.titles.estimate_used": "No reference requirement is available; the rounded community average is used.",
      "fishydex.titles.evidence_limits": "Evidence limits",
      "fishydex.titles.no_distribution": "Only the report count and average are available. The spread and uncertainty cannot be determined.",
      "fishydex.titles.required_catches": "{$count} catches",
      "fishydex.titles.estimated_catches": "≈ {$count} catches",
      "fishydex.titles.table_caption": "Fishing titles",
      "fishydex.titles.title_column": "Title",
      "fishydex.titles.requirement_column": "Requirement",
      "fishydex.titles.mark_obtained": "Mark obtained",
      "fishydex.titles.description_column": "Description",
      "fishydex.titles.condition_unknown": "Condition unavailable",
      "fishydex.titles.tab_memory_error": "The selected tab could not be remembered for this browser session.",
      "fishydex.titles.mark_not_obtained": "Mark not obtained",
      "fishydex.query.label": "Filter fish",
      "fishydex.query.placeholder": "Search fish, titles… or zone:\"Velia\" AND missing",
      "fishydex.query.unavailable": "Search data is unavailable or belongs to a different source revision. Reload after the catalog is updated.",
      "fishydex.query.loading": "Loading search data…",
      "fishydex.query.term.missing-titles": "Missing titles",
      "fishydex.query.term.caught": "Caught",
      "fishydex.query.term.missing": "Not caught",
      "fishydex.query.term.favourite": "Favourite",
      "fishydex.query.term.red": "Red grade",
      "fishydex.query.term.yellow": "Yellow grade",
      "fishydex.query.term.blue": "Blue grade",
      "fishydex.query.term.green": "Green grade",
      "fishydex.query.term.white": "White grade",
      "fishydex.query.term.rod": "Rod",
      "fishydex.query.term.hotspot": "Hotspot",
      "fishydex.query.term.harpoon": "Harpoon",
      "fishydex.query.term.dried": "Dried fish",
      "fishydex.query.field.fish": "Fish name",
      "fishydex.query.field.title": "Title name",
      "fishydex.query.field.zone": "Known fishing zone",
      "fishydex.query.field.potential-zone": "Potential fishing zone",
      "fishydex.query.state.empty": "No query is applied.",
      "fishydex.query.state.applied": "Current text is applied.",
      "fishydex.query.state.partial": "Only the valid prefix is applied; remaining text is not.",
      "fishydex.query.state.invalid": "No query is applied. Check the filter name, quotes and parentheses.",
      "fishydex.query.updating": "Updating the query…",
      "fishydex.query.composing": "Finish composition to update the query.",
      "fishydex.query.field.status": "Status",
      "fishydex.query.field.grade": "Grade",
      "fishydex.query.field.method": "Fishing method",
      "fishydex.query.field.dried": "Dried fish",
      "fishydex.titles.completion": "Title Completion",
      "fishydex.titles.empty_grade": "No titles",
      "fishydex.details.navigation.label": "Browse fish",
      "fishydex.details.navigation.previous": "Previous fish",
      "fishydex.details.navigation.next": "Next fish",
      "fishydex.filter.include_non_fish": "Include non-fish items",
      "fishydex.catalog.kind.item": "Non-fish item",
      "fishydex.page.context_item": "{$name} is a {$grade}-grade Black Desert item worth {$price}. {$locations}.",
      "fishydex.catalog.display_options": "Display options",
      "fishydex.catalog.sort.label": "Sort by",
      "fishydex.catalog.view.simple": "Simple",
      "fishydex.group.all": "All items",
      "frontpage.hero.title": "Everything you need to get fishing",
      "frontpage.guides.title": "Guides",
      "frontpage.guides.body": "Community-contributed guides to help you learn fishing.",
      "frontpage.guides.cta": "Open Guides",
      "frontpage.map.title": "Map",
      "frontpage.map.body": "Explore zones, loot tables, hotspots, and recorded catches to find where to fish.",
      "frontpage.map.cta": "Open Map",
      "frontpage.dex.title": "Dex",
      "frontpage.dex.body_intro": "Gotta Catch 'Em All",
      "frontpage.dex.body_detail": "Browse fish and track your progress.",
      "frontpage.dex.cta": "Browse Dex",
      "map.toolbar.map_windows": "Map windows",
      "map.toolbar.bookmarks": "Bookmarks",
      "map.toolbar.settings": "Settings",
      "map.toolbar.info": "Info",
      "map.toolbar.layers": "Layers",
      "map.tutorial.window_title": "Help & Tutorials",
      "map.tutorial.about_title": "Interactive Fishing Map for Black Desert",
      "map.tutorial.about_body": "Explore FishyStuff’s interactive BDO fishing map to find fish, inspect fishing zones and loot tables, compare hotspots, and examine recorded catch evidence.",
      "map.tutorial.provenance_body": "FishyStuff is a community-maintained Black Desert Online project. Map facts keep their source and evidence context so unavailable or uncertain information stays visible instead of being presented as confirmed.",
      "map.tutorial.catalog_title": "Interactive tutorials",
      "map.tutorial.group.beginner": "Beginner",
      "map.tutorial.group.beginner_summary": "Learn the map’s essential query, window, and layer controls.",
      "map.tutorial.group.intermediate": "Intermediate",
      "map.tutorial.group.intermediate_summary": "Save locations and shape a reusable map workspace.",
      "map.tutorial.group.advanced": "Advanced",
      "map.tutorial.group.advanced_summary": "Inspect evidence and combine geographic layers, clipping relationships, and structured queries.",
      "map.tutorial.start": "Start",
      "map.tutorial.continue": "Continue",
      "map.tutorial.exit": "Exit tutorial",
      "map.tutorial.complete": "Complete",
      "map.tutorial.hide": "Hide tutorial",
      "map.tutorial.proceed": "Proceed",
      "map.tutorial.task_completed": "Completed",
      "map.tutorial.unavailable_title": "Tutorial unavailable",
      "map.tutorial.unavailable_body": "This tutorial is not part of the current map guide.",
      "map.tutorial.query_basics.title": "Use the query system",
      "map.tutorial.query_basics.summary": "Find Pink Dolphin and Sea Bunny, then read a catch group, fish price, and within-group rate.",
      "map.tutorial.query_basics.step1.title": "Find Pink Dolphin",
      "map.tutorial.query_basics.step1.body": "Type “Pink” in { $query }. Stop when it resolves to { $pink_dolphin } before you finish the name.",
      "map.tutorial.query_basics.step2.title": "Confirm Pink Dolphin",
      "map.tutorial.query_basics.step2.body": "The highlighted query term is { $pink_dolphin }. Finishing the full name also continues automatically.",
      "map.tutorial.query_basics.step3.title": "Clear the query",
      "map.tutorial.query_basics.step3.body": "Clear { $pink_dolphin } with the clear button, or erase the text in { $query }.",
      "map.tutorial.query_basics.step4.title": "Find Sea Bunny",
      "map.tutorial.query_basics.step4.body": "Search for { $sea_bunny } and apply the matching result. The map now shows its fishing evidence.",
      "map.tutorial.query_basics.step5.title": "Bring the results into view",
      "map.tutorial.query_basics.step5.body": "Optionally pan or zoom away from the results. Use { $focus_query } in Query to bring the Sea Bunny matches back into view.",
      "map.tutorial.query_basics.step6.title": "Load a catch profile",
      "map.tutorial.query_basics.step6.body": "Click open water in any fishing zone. Wait for { $details } to show its Catch Profile; the zone does not need Sea Bunny.",
      "map.tutorial.query_basics.step7.title": "Catch groups",
      "map.tutorial.query_basics.step7.body": "Select { $zone_tab } in { $details } if needed. Catch groups collect fish from the same loot category, such as Prize or Rare. { $group_share } is this group’s portion of the whole profile.",
      "map.tutorial.query_basics.step8.title": "Fish and base price",
      "map.tutorial.query_basics.step8.body": "The grade-colored icon and name identify the fish; { $base_price } is its vendor base price.",
      "map.tutorial.query_basics.step9.title": "Within-group rate",
      "map.tutorial.query_basics.step9.body": "{ $within_group_rate } is the fish’s share within this group, not the whole profile, and may display as a percentage or weight.",
      "map.tutorial.window_basics.title": "Use the window system",
      "map.tutorial.window_basics.summary": "Hide and recover a tutorial, open and close windows, collapse them, and move them.",
      "map.tutorial.window_basics.step1.title": "Hide and recover this tutorial",
      "map.tutorial.window_basics.step1.body": "Choose “Hide tutorial” below. Reopen Help & Tutorials with the question-mark button, then choose Continue here.",
      "map.tutorial.window_basics.step2.title": "Close and reopen Query",
      "map.tutorial.window_basics.step2.body": "Use the toolbar’s { $query } button to close the Query window, then use the same button to open it again.",
      "map.tutorial.window_basics.step2.open_first": "{ $query } is already closed. Open it first; then close and reopen it to complete the full cycle.",
      "map.tutorial.window_basics.step2.reopen": "{ $query } is closed. Use the same toolbar button to reopen it.",
      "map.tutorial.window_basics.step3.title": "Collapse and expand Layers",
      "map.tutorial.window_basics.step3.body": "Click the { $layers } title bar to collapse the window, then click the title bar again to expand it.",
      "map.tutorial.window_basics.step3.expand_first": "{ $layers } is already collapsed. Expand it first; then collapse and expand it once more.",
      "map.tutorial.window_basics.step3.expand": "{ $layers } is collapsed. Click its title bar again to expand it.",
      "map.tutorial.window_basics.step4.title": "Move a window",
      "map.tutorial.window_basics.step4.body": "Drag the { $layers } title bar to move the window.",
      "map.tutorial.layer_basics.title": "Use the layer system",
      "map.tutorial.layer_basics.summary": "Show Hotspots, inspect one and its dedicated Details tab, then hide the crowded layer again.",
      "map.tutorial.layer_basics.step1.title": "Show Hotspots",
      "map.tutorial.layer_basics.step1.body": "Open { $layers } if needed, then turn on { $hotspots }.",
      "map.tutorial.layer_basics.step1.resume": "{ $hotspots } are hidden. Turn the layer back on to finish the comparison.",
      "map.tutorial.layer_basics.step1.query_filtered": "{ $hotspots } is on, but the current { $query } hides every hotspot. Clear the query to show them.",
      "map.tutorial.layer_basics.step2.title": "Inspect a hotspot",
      "map.tutorial.layer_basics.step2.body": "Select any visible { $hotspots } marker on the map. Details should identify the selected landmark as a hotspot.",
      "map.tutorial.layer_basics.step2.not_hotspot": "That is a different landmark. Select a visible { $hotspots } marker instead.",
      "map.tutorial.layer_basics.step3.title": "Open the Hotspot details",
      "map.tutorial.layer_basics.step3.body": "Choose { $hotspot_tab } in { $details }. Review its catch counts, bite timing, lifetime, loot, and model previews.",
      "map.tutorial.layer_basics.step4.title": "Hide Hotspots again",
      "map.tutorial.layer_basics.step4.body": "Turn { $hotspots } off after reviewing { $hotspot_tab }. The layer is useful on demand but visually crowded.",
      "map.tutorial.catch_profile_provenance.title": "Understand catch-profile provenance",
      "map.tutorial.catch_profile_provenance.summary": "Compare the separate evidence behind a fish’s presence and rate.",
      "map.tutorial.catch_profile_provenance.step1.title": "Load a catch profile",
      "map.tutorial.catch_profile_provenance.step1.body": "Click open water in any fishing zone. In { $details }, use the first fish row to compare Presence and Rate evidence.",
      "map.tutorial.catch_profile_provenance.step2.title": "Inspect Presence evidence",
      "map.tutorial.catch_profile_provenance.step2.body": "Open the first fish’s { $presence_provenance } mark. It explains why the fish belongs here, not how often it is caught. Check source, status, conditions, date, and observation count; color summarizes the evidence type.",
      "map.tutorial.catch_profile_provenance.step3.title": "Inspect Rate evidence",
      "map.tutorial.catch_profile_provenance.step3.body": "Open the same fish’s { $rate_provenance } mark. It supports Rate separately from Presence. Check value (% or weight), conditions, status, and source. Green means known, blue database-backed, and yellow uncertain.",
      "map.tutorial.bookmarks.title": "Save and exchange bookmarks",
      "map.tutorial.bookmarks.summary": "Place and inspect bookmarks, then exchange WorldmapBookMark XML with GameVariables.xml.",
      "map.tutorial.bookmarks.step1.title": "Place a bookmark",
      "map.tutorial.bookmarks.step1.body": "Open Bookmarks, choose New bookmark, then select the fishing location you want to keep.",
      "map.tutorial.bookmarks.step2.title": "Return to a bookmark",
      "map.tutorial.bookmarks.step2.body": "Activate the bookmark you just created to return to its world point and inspect the same Details facts.",
      "map.tutorial.bookmarks.step3.title": "Copy coordinates from Details",
      "map.tutorial.bookmarks.step3.body": "Select { $territory_tab } in { $details } to see the current landmark’s world coordinates. Then click the landmark-type button in the Details title bar (for example, Bookmark) to copy those coordinates as bookmark XML.",
      "map.tutorial.bookmarks.step4.title": "Copy or export bookmark XML",
      "map.tutorial.bookmarks.step4.body": "Select a bookmark, then use Copy or Export. To add it to Black Desert, close the game, back up { $game_variables }, replace its { $worldmap_bookmark } block with the exported XML, and restart.",
      "map.tutorial.bookmarks.step5.title": "Import bookmarks from the game",
      "map.tutorial.bookmarks.step5.body": "To bring local game bookmarks to the site, copy the { $worldmap_bookmark } block from { $game_variables } and choose Paste, or save that block as XML and choose Import.",
      "map.tutorial.layer_settings.title": "Use layer settings",
      "map.tutorial.layer_settings.summary": "Expand Fish Evidence settings, change opacity, and close the settings cleanly.",
      "map.tutorial.layer_settings.step1.title": "Open Fish Evidence settings",
      "map.tutorial.layer_settings.step1.body": "In { $layers }, click the { $fish_evidence } row to expand its settings. If it started expanded, close and reopen it once.",
      "map.tutorial.layer_settings.step1.resume": "{ $fish_evidence } settings are closed. Open the row again to finish the cycle.",
      "map.tutorial.layer_settings.step2.title": "Change layer opacity",
      "map.tutorial.layer_settings.step2.body": "Move the { $fish_evidence } opacity slider and watch the evidence overlay change without hiding the layer.",
      "map.tutorial.layer_settings.step3.title": "Close the settings",
      "map.tutorial.layer_settings.step3.body": "Click the { $fish_evidence } row again to collapse its settings when you are finished.",
      "map.tutorial.map_presets.title": "Create a map preset",
      "map.tutorial.map_presets.summary": "Clone the current map setup and give the saved preset a useful name.",
      "map.tutorial.map_presets.step1.title": "Open Map Presets",
      "map.tutorial.map_presets.step1.body": "Open Settings, then choose Map Presets. Presets keep a reusable copy of your map layers, query, view, and window arrangement.",
      "map.tutorial.map_presets.step2.title": "Clone the current setup",
      "map.tutorial.map_presets.step2.body": "Choose Clone to create your own saved preset from the currently selected setup.",
      "map.tutorial.map_presets.step3.title": "Give the preset a useful name",
      "map.tutorial.map_presets.step3.body": "Replace the cloned preset’s title with a name you will recognize, then press Enter or leave the title field to save it.",
      "map.tutorial.regions.title": "Use Region hover facts",
      "map.tutorial.regions.summary": "Enable Origin and Resources hover facts, then hover a field to compare them without showing either layer.",
      "map.tutorial.regions.step1.title": "Enable Origin",
      "map.tutorial.regions.step1.body": "Open { $regions } settings, choose Hover, and turn on { $origin }. If it is already on, turn it off and on once. The fact remains available while the layer is hidden.",
      "map.tutorial.regions.step2.title": "Enable Resources",
      "map.tutorial.regions.step2.body": "Open { $region_groups } settings, choose Hover, and turn on { $resources }. If it is already on, turn it off and on once. The fact remains available while the layer is hidden.",
      "map.tutorial.regions.step3.title": "Hover a field",
      "map.tutorial.regions.step3.body": "Hover a field on the map until { $origin } and { $resources } appear together. Neither the Regions nor Region Groups layer needs to be visible.",
      "map.tutorial.clipping.title": "Clip one layer through another",
      "map.tutorial.clipping.summary": "Detach Regions from Zone Mask, then attach it again through the layer drop target.",
      "map.tutorial.clipping.step1.title": "Detach Regions from the Zone Mask",
      "map.tutorial.clipping.step1.body": "In { $layers }, drag the { $regions } row to an edge of another row until an insertion line appears, then drop it. This removes its current { $zone_mask } clipping relationship.",
      "map.tutorial.clipping.step1.detached": "{ $regions } is already detached. First drop it onto the center of { $zone_mask }; then drag it to a row edge and drop it again so you perform the detach operation yourself.",
      "map.tutorial.clipping.step2.title": "Attach Regions to the Zone Mask",
      "map.tutorial.clipping.step2.body": "Drag { $regions } onto the center of { $zone_mask } until the row shows the attach target, then drop it. Regions becomes indented beneath its clipping mask.",
      "map.tutorial.advanced_queries.title": "Use container queries",
      "map.tutorial.advanced_queries.summary": "Compare a single matching fish with separate fish witnesses inside the same zone or hotspot.",
      "map.tutorial.advanced_queries.step1.title": "Require one fish to match both",
      "map.tutorial.advanced_queries.step1.body": "Enter { $same_fish_query }. Grade and collection status share one fish container—the same as { $explicit_same_fish_query }. A zone or hotspot matches only when one fish is both red and missing from your FishyDex.",
      "map.tutorial.advanced_queries.step2.title": "Frame the same-fish matches",
      "map.tutorial.advanced_queries.step2.body": "Use the target button beside Query to frame the matches. Notice which zones remain when one fish must satisfy both conditions.",
      "map.tutorial.advanced_queries.step3.title": "Allow two different fish to match",
      "map.tutorial.advanced_queries.step3.body": "Replace it with { $separate_fish_query }. Each bracket creates its own fish container, so one contained fish may be red while another is missing. Both must still occur in the same zone or hotspot.",
      "map.tutorial.advanced_queries.step4.title": "Frame the separate-fish matches",
      "map.tutorial.advanced_queries.step4.body": "Use the target button again. Compare this view with the previous one: these containers may satisfy red and missing with two different fish.",
      "map.tutorial.advanced_queries.step5.title": "Inspect one shared container",
      "map.tutorial.advanced_queries.step5.body": "Select open water in a remaining zone and inspect its Catch Profile. Find the red fish and missing fish that made the zone match; they may be different fish.",
      "map.tutorial.selection.landmark_rejected": "That is a landmark, sample, NPC, or hotspot. Click open water in a fishing zone instead.",
      "map.tutorial.scroll_down": "Scroll down inside Layers to reach the highlighted control.",
      "map.tutorial.scroll_up": "Scroll up inside Layers to reach the highlighted control.",
      "map.query.title": "Query",
      "map.query.input_label": "Map query",
      "map.query.clear": "Clear query",
      "map.query.focus_current": "Focus current query",
      "map.query.status_indicator.none": "Off",
      "map.query.status_indicator.applied": "Applied",
      "map.query.status_indicator.updating": "Updating",
      "map.query.status_indicator.partial": "Partial",
      "map.query.status_indicator.invalid": "Invalid",
      "map.query.status_indicator.failed": "Failed",
      "map.query.status.empty": "No query is applied.",
      "map.query.status.applied": "Current text is applied.",
      "map.query.status.evaluating.active": "Checking current text; the map still uses “{$source}”…",
      "map.query.status.evaluating.empty": "Nothing is applied while checking current text…",
      "map.query.status.applying.active": "Applying current text; the map still uses “{$source}”…",
      "map.query.status.applying.empty": "Nothing is applied until current text is confirmed…",
      "map.query.status.clearing.active": "Clearing “{$source}”…",
      "map.query.status.clearing.empty": "Confirming that no query is applied…",
      "map.query.status.composing.active": "The map still uses “{$source}”; finish composition to update.",
      "map.query.status.composing.empty": "Nothing is applied; finish composition to update.",
      "map.query.status.partial": "Only units paired with the valid prefix are applied; remaining text is not.",
      "map.query.status.partial_applying.active": "Applying the valid prefix; the map still uses “{$source}”…",
      "map.query.status.partial_applying.empty": "Nothing is applied while the valid prefix is confirmed…",
      "map.query.status.invalid_clearing.active": "Current text is invalid; clearing “{$source}”…",
      "map.query.status.invalid_clearing.empty": "Current text is invalid; confirming that no query is applied…",
      "map.query.status.invalid.active": "Current text is invalid; the map still uses “{$source}”.",
      "map.query.status.invalid.empty": "Current text is invalid; no query is applied.",
      "map.query.status.failed.active": "Current text could not be applied; the map still uses “{$source}”. Press Enter to retry.",
      "map.query.status.failed.empty": "Current text could not be applied; no query is confirmed. Press Enter to retry.",
      "map.query.status.failed_prefix.active": "The valid prefix could not be applied; the map still uses “{$source}”. Press Enter to retry.",
      "map.query.status.failed_prefix.empty": "The valid prefix could not be applied; no query is confirmed. Press Enter to retry.",
      "map.query.status.failed_clearing.active": "“{$source}” could not be cleared. Press Enter to retry.",
      "map.query.status.failed_clearing.empty": "The clear could not be confirmed; no query was previously confirmed. Press Enter to retry.",
      "map.query.status.failed_evaluating.active": "Current text could not be interpreted; the map still uses “{$source}”. Press Enter to retry.",
      "map.query.status.failed_evaluating.empty": "Current text could not be interpreted; no query is confirmed. Press Enter to retry.",
      "map.query.status.failed_preparing.active": "Search data could not be prepared; the map still uses “{$source}”. It will recover when new map data arrives.",
      "map.query.status.failed_preparing.empty": "Search data could not be prepared, so no query is confirmed. It will recover when new map data arrives.",
      "map.search.placeholder": "Search fish, zone, filter, or patch",
      "map.search.meaning.applied_query": "Applied query meaning",
      "map.search.meaning.applied_term": "Applied term",
      "map.search.meaning.exclude": "Exclude",
      "map.search.meaning.match_all": "Match all",
      "map.search.meaning.match_any": "Match any",
      "map.search.meaning.container_containing": "Container containing",
      "map.search.meaning.conjunction.and": "AND",
      "map.search.meaning.conjunction.or": "OR",
      "map.search.bound.before": "Before",
      "map.search.bound.after": "After",
      "map.search.patch.choose_date": "Choose date",
      "map.search.kind.filter": "Filter",
      "map.search.kind.date": "Date",
      "map.search.kind.status": "Status",
      "map.search.kind.layer": "Layer",
      "map.search.kind.layer_filter": "Layer filter",
      "map.search.kind.layer_fact": "Layer fact",
      "map.search.semantic.field": "Field {$id}",
      "map.search.zone.fallback": "Zone {$zone}",
      "map.search.stinky_fish": "Stinky Fish",
      "map.search.triple_float_fishing_rod": "Triple-Float Fishing Rod",
      "map.search.quest.fish_for_villagers": "Fish for Villagers",
      "map.search.quest.special_fishing_rod": "A Special Fishing Rod",
      "map.search.item_group.any": "{$label} (any)",
      "map.search.item_group.items.one": "1 item",
      "map.search.item_group.items.other": "{$count} items",
      "map.search.layer_filter.label": "{$layer} filter",
      "map.search.layer_group.high_quality": "High Quality",
      "map.search.layer_group.prize": "Prize",
      "map.search.filter.favourite.label": "Favourite",
      "map.search.filter.favourite.description": "Fish marked with a heart in Fishydex.",
      "map.search.filter.missing.label": "Missing",
      "map.search.filter.missing.description": "Fish not marked caught in Fishydex.",
      "map.search.filter.red.description": "Prize or red-grade fish and loot.",
      "map.search.filter.yellow.description": "Rare or yellow-grade fish and loot.",
      "map.search.filter.blue.description": "High-quality or blue-grade fish and loot.",
      "map.search.filter.green.description": "General or green-grade fish and loot.",
      "map.search.filter.white.description": "Trash or white-grade fish and loot.",
      "map.search.patch.prompt.after": "After",
      "map.search.patch.prompt.before": "Before",
      "map.search.patch.prompt.description": "Pick a patch or date to limit samples.",
      "map.overview.zone": "Zone",
      "map.overview.rgb": "RGB",
      "map.overview.bite_time": "Bite Time",
      "map.overview.resources": "Resources",
      "map.overview.origin": "Origin",
      "map.info.window_title": "Details",
      "map.info.status.bookmark": "Bookmark",
      "map.info.status.waypoint": "Waypoint",
      "map.info.status.clicked": "Clicked point",
      "map.info.status.no_selection": "no selection",
      "map.info.provenance": "Fact provenance",
      "map.info.tabs": "Point layer tabs",
      "map.info.empty_group": "No rows are assigned to this group in the current overlay yet.",
      "map.info.empty_zone": "No fish rows are available for this zone yet.",
      "map.info.empty_about_title": "Black Desert Fishing Map",
      "map.info.empty_about": "Explore fishing zones, loot tables, hotspots, region groups, fish locations, and recorded catches.",
      "map.info.empty_selection": "Click the map, use a waypoint target, or select a bookmark to inspect facts at a world point.",
      "map.info.fish.unknown": "Unknown fish",
      "map.info.pane.zone": "Zone",
      "map.info.pane.landmark": "Landmark",
      "map.info.pane.territory": "Territory",
      "map.info.pane.trade": "Trade",
      "map.info.pane.lineage": "Lineage",
      "map.info.section.zone": "Zone",
      "map.info.section.landmark": "Landmark",
      "map.info.section.territory": "Territory",
      "map.info.section.trade": "Trade",
      "map.info.section.fish": "Fish",
      "map.info.location.title": "Location",
      "map.info.location.world_coordinates": "World coordinates",
      "map.info.location.unavailable": "unavailable",
      "map.info.location.copy_bookmark": "Copy bookmark",
      "map.info.location.create_bookmark": "Turn into bookmark",
      "map.info.location.bookmark_unavailable": "Height is unavailable, so this point cannot be used as a bookmark.",
      "map.info.lineage.coordinate": "Mask pixel {$x}, {$y}",
      "map.info.lineage.current_rgb": "Current RGB {$rgb}",
      "map.info.lineage.result_rgb": "Result RGB {$rgb}",
      "map.info.lineage.known": "Known",
      "map.info.lineage.guess": "Guess",
      "map.info.lineage.leak": "Leak",
      "map.info.lineage.evidence": "Evidence",
      "map.info.lineage.timestamp_source": "Time source",
      "map.info.lineage.source_revision": "Source revision {$revision}",
      "map.info.history.title": "History",
      "map.info.history.back": "Back to previous selection",
      "map.info.history.go": "Return to {$name}",
      "map.info.history.previous": "Previous selection: {$name}",
      "map.info.history.next": "Next selection: {$name}",
      "map.info.history.unknown": "Selection",
      "map.info.trade.managers": "Trade Managers",
      "map.info.trade.manager_count": "{$count} destination traders",
      "map.info.trade.filter_label": "Trader type",
      "map.info.trade.filter_all": "All",
      "map.info.trade.filter_standard": "Trade Managers",
      "map.info.trade.filter_imperial": "Imperial",
      "map.info.trade.filter_empty": "No traders match this filter.",
      "map.info.trade.multiplier_final": "{$multiplier} sale",
      "map.info.trade.multiplier_fixed": "{$multiplier} sale",
      "map.info.trade.multiplier_final_help": "Final sale multiplier from the regular calculator defaults.",
      "map.info.trade.multiplier_fixed_help": "Fixed fish sale multiplier.",
      "map.info.trade.maximum_bonus_group": "Maximum distance bonus (150%+)",
      "map.info.trade.below_maximum_bonus_group": "Below maximum distance bonus (<150%)",
      "map.info.trade.loading": "loading",
      "map.info.trade.unavailable": "unavailable",
      "map.info.trade.request_failed": "trade manager request failed ({$status})",
      "map.info.trade.focus_target": "Focus {$name}",
      "map.info.trade.focus_target_generic": "Focus target",
      "map.info.notice.title": "Notice",
      "map.info.zone_loot.title": "Catch Profile",
      "map.info.zone_loot.summary.default": "Calculator defaults",
      "map.info.zone_loot.notice.status_title": "Catch Profile Status",
      "map.info.zone_loot.profile_tabs": "Loot tables",
      "map.info.zone_loot.status.idle": "zone loot: idle",
      "map.info.zone_loot.status.loading": "zone loot: loading",
      "map.info.zone_loot.status.loaded": "zone loot: loaded",
      "map.info.zone_loot.status.error": "zone loot: error",
      "map.info.zone_loot.status.other": "zone loot: {$status}",
      "map.info.zone_loot.unavailable": "Zone loot summary is unavailable.",
      "map.info.zone_loot.condition.previous": "Previous condition",
      "map.info.zone_loot.condition.next": "Next condition",
      "map.bookmarks.window_title": "Bookmarks",
      "map.bookmarks.new": "New bookmark",
      "map.bookmarks.click_to_place": "Click map to place",
      "map.bookmarks.select_all": "Select all",
      "map.bookmarks.paste": "Paste",
      "map.bookmarks.empty": "No bookmarks yet.",
      "map.bookmarks.fallback": "Bookmark {$index}",
      "map.bookmarks.row_label": "Bookmark",
      "map.bookmarks.action.drag": "Drag {$label}",
      "map.bookmarks.action.select": "Select {$label}",
      "map.bookmarks.action.rename": "Rename bookmark",
      "map.bookmarks.action.inspect": "Inspect bookmark",
      "map.bookmarks.action.copy_xml": "Copy bookmark XML",
      "map.bookmarks.action.delete": "Delete bookmark",
      "map.bookmarks.confirm.delete_selected.one": "Delete {$count} selected bookmark?",
      "map.bookmarks.confirm.delete_selected.other": "Delete {$count} selected bookmarks?",
      "map.bookmarks.confirm.delete_single": "Delete bookmark \"{$label}\"?",
      "map.bookmarks.prompt.rename": "Rename bookmark",
      "map.bookmarks.toast.select_to_copy": "Select one or more bookmarks to copy.",
      "map.bookmarks.toast.clipboard_unavailable": "Clipboard access is unavailable in this browser.",
      "map.bookmarks.toast.no_export": "There are no bookmarks to export yet.",
      "map.bookmarks.toast.export_unavailable": "Bookmark export is unavailable in this browser.",
      "map.bookmarks.toast.import_unavailable": "Bookmark import is unavailable in this browser.",
      "map.bookmarks.toast.import_no_xml": "The imported text did not contain any bookmark XML.",
      "map.bookmarks.toast.import_failed": "Bookmark import failed. Use valid WorldmapBookMark XML.",
      "map.bookmarks.toast.copied_single": "Copied bookmark XML.",
      "map.bookmarks.toast.created_single": "Added bookmark.",
      "map.bookmarks.toast.copy_selection.one": "Copied XML for {$count} bookmark.",
      "map.bookmarks.toast.copy_selection.other": "Copied XML for {$count} bookmarks.",
      "map.bookmarks.toast.export_selected.one": "Exported {$count} selected bookmark.",
      "map.bookmarks.toast.export_selected.other": "Exported {$count} selected bookmarks.",
      "map.bookmarks.toast.export_all.one": "Exported {$count} bookmark.",
      "map.bookmarks.toast.export_all.other": "Exported {$count} bookmarks.",
      "map.bookmarks.toast.import_none": "No new bookmarks were imported.",
      "map.bookmarks.toast.imported.one": "Imported {$count} bookmark.",
      "map.bookmarks.toast.imported.other": "Imported {$count} bookmarks.",
      "map.bookmarks.toast.skipped_duplicates.one": "Skipped {$count} duplicate.",
      "map.bookmarks.toast.skipped_duplicates.other": "Skipped {$count} duplicates.",
      "map.layers.window_title": "Layers",
      "map.layers.unavailable": "Unavailable",
      "map.layers.loading_registry": "Layer registry is loading...",
      "map.layers.show": "Show",
      "map.layers.hide": "Hide",
      "map.layers.live_events_unavailable": "Live Events requires a signed-in account, the Fishing Logger enabled, and live character data.",
      "map.layers.drag_pinned": "{$name} is pinned to the ground layer",
      "map.layers.drag": "Drag {$name}",
      "map.layers.settings_show": "Show settings for {$name}",
      "map.layers.settings_hide": "Hide settings for {$name}",
      "map.layers.opacity": "Opacity",
      "map.layers.opacity_for": "Opacity for {$name}",
      "map.layers.confidence": "Confidence",
      "map.layers.confidence_showcase": "Showcase confidence",
      "map.layers.lineage_panel": "Show lineage panel",
      "map.layers.tab.appearance": "Appearance",
      "map.layers.tab.hover": "Hover",
      "map.layers.tab.highlight": "Highlight",
      "map.layers.tab.waypoints": "Waypoints",
      "map.layers.highlight.enabled": "Enabled",
      "map.layers.highlight.opacity": "Opacity",
      "map.layers.highlight.opacity_for": "Highlight opacity for {$name}",
      "map.layers.highlight.color": "Color",
      "map.layers.highlight.color_for": "Highlight color for {$name}",
      "map.layers.connections": "Connections",
      "map.layers.names": "Names",
      "map.layers.categories": "Categories",
      "map.layers.icons": "Icons",
      "map.layers.sample_hover": "Sample hover",
      "map.layers.hover_facts": "Hover facts",
      "map.layers.table.icon": "Icon",
      "map.layers.table.name": "Name",
      "map.layers.table.fact": "Fact",
      "map.layers.table.show": "Show",
      "map.layers.hover_show": "Show {$fact} while hovering {$layer}",
      "map.layers.fish_evidence": "Fish Evidence",
      "map.layers.fish_icon_size": "Fish icon size",
      "map.layers.fish_icon_size_for": "Fish icon size for {$name}",
      "map.layers.clustering": "Clustering",
      "map.layers.search_kind.zones": "Zones",
      "map.hover.extents_confidence": "Extents confidence",
      "map.hover.lineage": "Lineage",
      "map.hover.confidence.known": "Known",
      "map.hover.confidence.guess": "Guess",
      "map.hover.zone_name": "Zone Name",
      "map.hover.zone": "Zone",
      "map.hover.rgb": "RGB",
      "map.hover.world_coordinate_xz": "XZ Coordinate",
      "map.hover.world_coordinate": "World Coordinate",
      "map.hover.resources": "Resources",
      "map.hover.origin": "Origin",
      "map.hover.affiliated_node": "Affiliated Node",
      "map.hover.details": "Details",
      "map.settings.window_title": "Settings",
      "map.settings.ready": "Ready",
      "map.settings.loading": "Loading",
      "map.settings.actions": "Actions",
      "map.settings.reset_view": "Reset view",
      "map.settings.reset_ui": "Reset UI",
      "map.settings.display": "Display",
      "map.settings.auto_adjust_view": "Auto-adjust view",
      "map.settings.three_d_enabled": "Enable 3D",
      "map.settings.loot_rate_display_mode": "Loot rate display",
      "map.settings.loot_rate_display_mode.normalized": "Normalized",
      "map.settings.loot_rate_display_mode.denormalized": "Denormalized",
      "map.settings.loot_rate_display_mode.raw_weight": "Raw Weight",
      "map.settings.sample_from_filtered_elements": "Sample from filtered elements",
      "map.settings.effects_enabled": "Animations/effects",
      "map.settings.focus_waves_enabled": "Continuous focus waves",
      "map.settings.filtering": "Filtering",
      "map.settings.filter_active_condition_groups": "Filter only active condition groups",
      "map.settings.sorting": "Sorting",
      "map.settings.sort_by": "Sort by",
      "map.settings.sort_by.calculator": "Map default (price)",
      "map.settings.sort_by.price": "Price",
      "map.settings.sort_by.grade": "Grade",
      "map.settings.sort_by.droprate": "Within-group rate",
      "map.settings.sort_by.expected_value": "Expected value",
      "map.settings.sort_by.exp": "EXP",
      "map.settings.sort_by.totem_exp": "Totem EXP",
      "map.settings.sort_by.alphabetical": "Alphabetical",
      "map.settings.sort_by.item_id": "Item ID",
      "map.settings.sort_by.database": "Database",
      "map.settings.sort_by.evidence": "Strongest Evidence",
      "map.settings.sort_order": "Sort order",
      "map.settings.sort_order.calculator": "Map default (descending)",
      "map.settings.sort_order.desc": "Descending",
      "map.settings.sort_order.asc": "Ascending",
      "map.loading.title": "Black Desert Fishing Map",
      "map.loading.starting": "Preparing map...",
      "map.loading.initial_detail": "This can take a moment on the first visit.",
      "map.loading.manifest": "Finding map runtime...",
      "map.loading.module_import": "Loading map code...",
      "map.loading.wasm_fetch": "Downloading map runtime...",
      "map.loading.wasm_compile": "Compiling map runtime...",
      "map.loading.renderer_start": "Starting renderer...",
      "map.loading.runtime_bootstrap": "Loading map data...",
      "map.loading.first_paint": "Drawing first frame...",
      "map.loading.ready": "Map ready",
      "map.loading.fetch_bytes": "{$loaded} of {$total}",
      "map.loading.fetch_bytes_unknown": "{$loaded} downloaded",
      "map.error.renderer_unavailable": "Map renderer unavailable",
      "map.error.badge": "Error",
      "map.error.renderer_start_failed": "The webpage loaded, but the Bevy/WebGL renderer could not start.",
      "map.zone_loot.error.invalid_zone_rgb": "zone loot summary requires a valid zone rgb",
      "map.zone_loot.error.missing_endpoint": "Zone loot summary endpoint is unavailable on the current API build.",
      "map.zone_loot.error.request_failed": "zone loot summary request failed: {$status}",
      "map.search.title.description": "Fishing title by ID or name",
      "map.search.filter.missing_titles.description": "Fish with unearned titles, using your Fishydex title inclusion preferences.",
      "presets.select.label": "Saved presets",
      "presets.select.hint": "Select a preset to inspect or rename it. Use Apply to activate it.",
      "presets.button.open_manager": "Preset Manager",
      "presets.manager.description": "Save, rename, import, export, and switch between saved presets without rebuilding them from scratch.",
      "presets.manager.open": "Open preset manager",
      "presets.manager.close": "Close preset manager",
      "presets.collection.title": "{$name} presets",
      "presets.collection.open": "{$name} Presets",
      "presets.collection.default_name": "{$name} {$index}",
      "presets.collection.workspace": "Workspace",
      "presets.collection.calculator": "Calculator",
      "presets.collection.overlay": "Overlay",
      "presets.collection.map": "Map",
      "presets.collection.dex": "Dex",
      "presets.grid.title": "Presets",
      "presets.grid.description": "Selecting a card only opens it for management. Use it to replace Current work.",
      "presets.grid.count": "{$count} saved",
      "presets.grid.empty": "No presets are available.",
      "presets.grid.no_matches": "No presets match this filter.",
      "presets.grid.local_empty_account": "No local presets found. While logged in, presets are saved under your account.",
      "presets.current.modified": "Modified current preset",
      "presets.current.modified_from": "Modified: {$name}",
      "presets.current.untitled": "Current work",
      "presets.current.unnamed": "Unnamed preset",
      "presets.current.not_in_preset": "Changes not in preset",
      "presets.current.based_on_preset": "Based on preset “{$name}”",
      "presets.current.based_on_fixed": "Based on built-in “{$name}”",
      "presets.current.no_base": "No named preset yet",
      "presets.current.revision": "Version {$revision}",
      "presets.current.revision_pending": "Version pending",
      "presets.current.status_unavailable": "Status unavailable",
      "presets.autosave.saving": "Saving locally…",
      "presets.autosave.error": "Local save needs attention",
      "presets.section.active.title": "Active preset",
      "presets.section.active.description": "The page currently uses this preset. Save or discard its active working changes here.",
      "presets.section.selected.title": "Selected preset",
      "presets.section.selected.description.fixed": "Use this built-in preset without changing its definition.",
      "presets.section.selected.description.current": "This is the live unsaved preset. Clone keeps a persisted copy.",
      "presets.section.selected.description.saved": "Rename or manage this preset without changing Current work.",
      "presets.section.selected.description.empty": "Choose a preset to inspect it.",
      "presets.section.transfer.title": "Transfer",
      "presets.section.transfer.description": "Export the selected preset as JSON or import one that another player shared with you.",
      "presets.section.delete.title": "Remove selected preset",
      "presets.section.delete.description": "Delete the selected saved preset. Your currently visible state stays as-is until you switch again.",
      "presets.section.delete.description.saved": "Delete the selected saved preset. The current live state stays untouched.",
      "presets.section.delete.description.readonly": "Default and Current are not removable. Use Clone if you want an editable saved copy first.",
      "presets.dialog.name_label": "Preset name",
      "presets.name.hint": "Use this name for creating a new preset or renaming the selected one.",
      "presets.name.required": "Enter a preset name.",
      "presets.field.selected_title.hint.saved": "Typing here updates the selected saved preset title.",
      "presets.field.selected_title.hint.readonly": "This title is fixed. Use Clone to create an editable saved copy.",
      "presets.dialog.rename.title": "Rename preset",
      "presets.action.apply_selected": "Apply selected",
      "presets.action.import_file": "Import presets",
      "presets.action.use_item": "Use this {$item}",
      "presets.action.set_active": "Activate preset",
      "presets.action.set_active_named": "Activate “{$name}”",
      "presets.action.update": "Update “{$name}”",
      "presets.action.update_unavailable": "Update preset",
      "presets.action.save_as": "Save as new {$item}…",
      "presets.action.reset_to": "Reset to “{$name}”",
      "presets.action.reset": "Reset current work",
      "presets.selected.heading": "Selected {$item}",
      "presets.selected.name_label": "{$item} name",
      "presets.status.base": "Base preset",
      "presets.status.active_named": "“{$name}” is the active preset",
      "presets.copy_name": "{$name} copy",
      "presets.default_name": "Preset {$index}",
      "presets.save_as.name_label": "New preset name",
      "presets.save_as.reference_hint": "Creates a named reference to this exact version.",
      "presets.tab.presets": "Presets",
      "presets.tab.changes": "Unsaved changes",
      "presets.tab.history": "History",
      "presets.library.title": "Preset library",
      "presets.library.filter": "Filter presets",
      "presets.library.search": "Search presets",
      "presets.selected.version": "Version",
      "presets.status.applying": "Applying…",
      "presets.status.built_in": "Built in",
      "presets.confirm.delete": "Delete \"{$name}\"?",
      "presets.toast.created": "Saved new preset \"{$name}\".",
      "presets.toast.copied": "Cloned \"{$name}\".",
      "presets.toast.saved": "Saved \"{$name}\".",
      "presets.toast.discarded": "Current work reset to its base preset.",
      "presets.toast.renamed": "Renamed to \"{$name}\".",
      "presets.toast.deleted": "Deleted \"{$name}\".",
      "presets.toast.exported": "Preset exported.",
      "presets.toast.imported": "Preset imported.",
      "presets.toast.applied": "Applied \"{$name}\".",
      "presets.error.import": "Preset import failed.",
      "presets.error.apply": "Preset apply failed.",
      "presets.error.save": "Preset save failed.",
      "presets.error.discard": "Preset discard failed.",
      "presets.error.capture": "Current preset state is unavailable.",
      "presets.error.command": "The preset action could not be completed.",
      "presets.state.loading": "Loading preset workspace…",
      "presets.state.conflict": "This preset changed in another tab. Review the latest version before trying again.",
      "presets.state.invalid": "Stored preset data is invalid. It has been preserved for recovery.",
      "presets.state.unsupported": "These presets were created by a newer version of FishyStuff.",
      "presets.state.unavailable": "Preset storage is currently unavailable.",
      "presets.history.change": "Preset changed",
      "presets.history.current": "Current",
      "presets.history.shared_base": "Shared base",
      "presets.history.show_alternates": "Show alternate branches",
      "presets.history.old": "old:",
      "presets.history.new": "new:",
      "presets.history.compacted": "Older changes compacted",
      "presets.history.branches": "{$count} branches",
      "presets.history.previewing": "Previewing {$summary}",
      "presets.history.undone": "Moved to the previous version.",
      "presets.history.redone": "Moved to the next version.",
      "presets.history.version_applied": "Current work now uses the selected version.",
      "presets.history.title": "Current work history",
      "presets.history.description": "Previewing a version does not apply it. New edits after Undo keep the other branch.",
      "presets.history.preview_not_applied": "Nothing has been applied yet.",
      "presets.history.empty": "No content changes yet.",
      "presets.history.empty_selected": "No recorded changes for this preset.",
      "presets.details.label": "Preset details",
      "presets.changes.kind": "Change",
      "presets.changes.setting": "Setting",
      "presets.changes.old": "Old",
      "presets.changes.new": "New",
      "presets.changes.path": "Path",
      "presets.changes.saved": "Saved",
      "presets.changes.working": "Working",
      "presets.changes.added": "Added",
      "presets.changes.removed": "Removed",
      "presets.changes.changed": "Changed",
      "presets.changes.summary": "{$count} changes compared with the saved preset.",
      "presets.changes.summary_truncated": "Showing the first {$count} changes.",
      "presets.changes.empty": "No differences from this preset.",
      "presets.changes.inactive": "Set this preset active to inspect its changes.",
      "presets.quick_switch.empty": "No presets available.",
      "presets.quick_switch.search": "Search presets...",
      "presets.quick_switch.current": "Current",
      "presets.quick_switch.current_modified": "Current work · {$name}"
    },
    "ko-KR": {
      "calculator.loading": "계산기 불러오는 중...",
      "calculator.recovery.title": "계산기 데이터를 확인해야 합니다",
      "calculator.recovery.description": "이 작업을 현재 게임 데이터에 적용할 수 없습니다. 변경되었거나 삭제된 옵션을 참조하고 있을 수 있습니다.",
      "calculator.recovery.dismiss": "닫기",
      "calculator.recovery.retry": "다시 시도",
      "calculator.recovery.defaults": "현재 작업을 기본값으로 재설정",
      "calculator.recovery.preservation": "현재 계산기 작업만 재설정합니다. 저장된 프리셋과 레이아웃은 변경되지 않습니다.",
      "calculator.recovery.save_failed": "계산기는 다시 열렸지만 현재 작업을 업데이트하지 못했습니다. 새로고침하기 전에 다시 시도해 주세요.",
      "calculator.timespan.unit.minute.one": "분",
      "calculator.timespan.unit.minute.other": "분",
      "calculator.timespan.unit.hour.one": "시간",
      "calculator.timespan.unit.hour.other": "시간",
      "calculator.timespan.unit.day.one": "일",
      "calculator.timespan.unit.day.other": "일",
      "calculator.timespan.unit.week.one": "주",
      "calculator.timespan.unit.week.other": "주",
      "calculator.resource.exhausted": "고갈",
      "calculator.resource.low": "낮음",
      "calculator.resource.average": "보통",
      "calculator.resource.abundant": "풍부",
      "calculator.timeline.bite_time": "입질 시간",
      "calculator.timeline.auto_fishing_time": "자동 낚시 시간",
      "calculator.timeline.catch_time": "낚아올리기 시간",
      "calculator.timeline.time_saved": "절약 시간",
      "calculator.share.active_lead": "Active | ",
      "calculator.share.afr_lead": "{$afr} AFR | ",
      "calculator.share.link": "[FishyStuff Calculator Preset | {$lead}{$item_drr} Item DRR | {$zone}]({$url})",
      "calculator.toast.preset_url_copied": "Preset URL copied.",
      "calculator.toast.share_copied": "Share text copied.",
      "calculator.title.casts_average": "평균 낚시 횟수 ({$timespan})",
      "calculator.title.durability_loss_average": "평균 내구도 소모 ({$timespan})",
      "calculator.title.expected_catches": "예상 횟수 ({$timespan})",
      "calculator.title.expected_profit": "예상 수익 ({$timespan})",
      "calculator.title.bite_time": "입질 시간: {$seconds}초 ({$percent}%)",
      "calculator.title.auto_fishing_time": "자동 낚시 시간: {$seconds}초 ({$percent}%)",
      "calculator.title.catch_time": "낚아올리기 시간: {$seconds}초 ({$percent}%)",
      "calculator.title.unoptimized_time": "평균 비최적화 시간: {$seconds}초 ({$percent}%)",
      "calculator.server.option.none": "없음",
      "calculator.server.option.custom_trade_distance": "사용자 지정 거리 보너스",
      "calculator.server.option.custom_pet": "사용자 지정 반려동물",
      "calculator.server.result.no_matching_options": "일치하는 항목 없음",
      "calculator.server.result.no_matching_zones": "일치하는 지역 없음",
      "calculator.server.result.no_matching_hotspots": "일치하는 핫스팟 없음",
      "calculator.server.result.selected": "선택됨",
      "calculator.server.result.added": "추가됨",
      "calculator.server.result.available_for_pet": "이 반려동물에서 사용 가능",
      "calculator.server.result.group.active_zones": "활성 지역",
      "calculator.server.result.group.inactive_zones": "비활성 지역",
      "calculator.server.result.group.available_pet_perks": "이 반려동물에서 사용 가능",
      "calculator.server.result.group.other_pet_perks": "기타 알려진 특성",
      "calculator.server.result.group.compatible_pet_appearances": "선택한 특성을 지원하는 반려동물 외형",
      "calculator.server.result.group.other_pet_appearances": "기타 반려동물 외형",
      "calculator.server.action.remove": "{$label} 제거",
      "calculator.server.action.copy_url": "URL 복사",
      "calculator.server.action.copy_share": "공유 텍스트 복사",
      "calculator.server.action.remove_custom_card": "Custom에서 {$label} 제거",
      "calculator.server.action.drag_section": "{$label} 드래그",
      "calculator.server.action.drag_section_generic": "섹션 드래그",
      "calculator.server.toggle.active_fishing": "수동 낚시",
      "calculator.server.toggle.debug": "디버그",
      "calculator.server.toggle.show_inactive_zones": "비활성 지역 표시",
      "calculator.server.workspace.basics": "기본",
      "calculator.server.workspace.loadout": "장비 구성",
      "calculator.server.workspace.loot": "전리품",
      "calculator.server.workspace.trade": "무역",
      "calculator.server.workspace.data": "데이터",
      "calculator.server.workspace.advanced": "고급",
      "calculator.server.workspace.custom": "사용자 지정",
      "calculator.server.search.zones": "지역 검색",
      "calculator.server.search.hotspots": "물고기 또는 핫스팟 ID 검색",
      "calculator.server.search.fishing_levels": "낚시 레벨 검색",
      "calculator.server.search.session_units": "세션 단위 검색",
      "calculator.server.search.lifeskill_levels": "생활 레벨 검색",
      "calculator.server.search.rods": "낚싯대 검색",
      "calculator.server.search.floats": "찌 검색",
      "calculator.server.search.chairs": "의자 검색",
      "calculator.server.search.lightstone_sets": "광명석 조합 검색",
      "calculator.server.search.backpacks": "가방 검색",
      "calculator.server.search.foods": "음식 이름 또는 효과 검색",
      "calculator.server.search.buffs": "버프 이름 또는 효과 검색",
      "calculator.server.search.trade_levels": "무역 레벨 검색",
      "calculator.server.search.trade_origins": "무역 원산지 검색",
      "calculator.server.search.trade_destinations": "NPC, 지역 또는 거리 %",
      "calculator.server.search.loot_rows": "이 지역의 전리품 항목 검색",
      "calculator.server.search.pet_tiers": "펫 세대 검색",
      "calculator.server.search.pet_specials": "펫 특기 검색",
      "calculator.server.search.pet_talents": "펫 재능 검색",
      "calculator.server.search.pet_skills": "펫 기술 검색",
      "calculator.server.search.pets": "펫 검색",
      "calculator.server.section.mode": "모드",
      "calculator.server.section.source": "낚시 소스",
      "calculator.server.section.bite_time": "입질 시간",
      "calculator.server.section.catch_time": "낚아올리기 시간",
      "calculator.server.section.session": "세션",
      "calculator.server.section.gear": "장비 구성",
      "calculator.server.section.pets": "펫",
      "calculator.server.section.distribution": "분포",
      "calculator.server.section.loot": "전리품",
      "calculator.server.section.trade": "무역",
      "calculator.server.section.data_editor": "전리품 데이터 편집기",
      "calculator.server.field.fishing_level": "낚시 레벨",
      "calculator.server.field.fishing_resources": "낚시 자원",
      "calculator.server.field.fishing_mode": "낚시 모드",
      "calculator.server.field.rod_zone": "낚싯대 낚시 지역",
      "calculator.server.field.harpoon_zone": "작살 낚시 지역",
      "calculator.server.field.hotspot": "핫스팟",
      "calculator.server.field.fishing_method": "방식",
      "calculator.server.field.active": "수동",
      "calculator.server.field.afk": "잠수",
      "calculator.server.field.amount": "수량",
      "calculator.server.field.unit": "단위",
      "calculator.server.field.lifeskill_level": "생활 레벨",
      "calculator.server.field.fishing_rod": "낚싯대",
      "calculator.server.field.brand": "브랜드",
      "calculator.server.field.float": "찌",
      "calculator.server.field.chair": "의자",
      "calculator.server.field.lightstone_set": "광명석 조합",
      "calculator.server.field.backpack": "가방",
      "calculator.server.field.outfit": "의상",
      "calculator.server.field.food": "음식",
      "calculator.server.field.buffs": "버프",
      "calculator.server.field.pet": "펫",
      "calculator.server.field.tier": "세대",
      "calculator.server.field.special": "특기",
      "calculator.server.field.talent": "재능",
      "calculator.server.field.skills": "기술",
      "calculator.server.field.pack_leader": "우두머리",
      "calculator.server.field.mastery": "숙련도",
      "calculator.server.field.target_fish": "대상 물고기 / 전리품",
      "calculator.server.field.target_amount": "목표 수량",
      "calculator.server.field.pmf_max_count": "PMF 최대 횟수",
      "calculator.server.field.trade_level": "무역 레벨",
      "calculator.server.field.trade_origin": "무역 원산지",
      "calculator.server.field.trade_destination": "판매 무역상",
      "calculator.server.field.distance_bonus": "거리 보너스",
      "calculator.server.field.trade_price_curve": "무역 가격 곡선",
      "calculator.server.field.imperial_fishing_delivery": "황실낚시 납품",
      "calculator.server.field.distance_bonus_exp_only": "거리 보너스 (무역 경험치 전용)",
      "calculator.server.field.discard_grade": "이 등급까지 물고기 버리기",
      "calculator.server.mode.rod": "낚싯대",
      "calculator.server.mode.hotspot": "핫스팟",
      "calculator.server.mode.harpoon_forces_active": "작살은 일시적으로 수동만 허용합니다.",
      "calculator.server.stat.seconds": "초",
      "calculator.server.stat.average_total_fishing_time": "평균 총 낚시 시간",
      "calculator.server.stat.average_bite_time": "평균 입질 시간",
      "calculator.server.stat.min": "최소",
      "calculator.server.stat.average": "평균",
      "calculator.server.stat.max": "최대",
      "calculator.server.stat.effective_min": "적용 최소",
      "calculator.server.stat.effective_average": "적용 평균",
      "calculator.server.stat.effective_max": "적용 최대",
      "calculator.server.stat.auto_fishing_time_aft": "자동 낚시 시간 (AFT)",
      "calculator.server.stat.auto_fishing_time_reduction_afr": "자동 낚시 시간 감소 (AFR)",
      "calculator.server.stat.item_drr": "아이템 DRR",
      "calculator.server.stat.chance_to_consume_durability": "내구도 소모 확률",
      "calculator.server.stat.raw_prize_catch_rate": "원시 상위 어종 획득률",
      "calculator.server.stat.expected_catches": "예상 횟수",
      "calculator.server.stat.expected_catches_per_hour": "시간당 예상 횟수",
      "calculator.server.stat.expected_profit": "예상 수익",
      "calculator.server.stat.profit_per_hour": "시간당 수익",
      "calculator.server.stat.expected_exp": "예상 경험치",
      "calculator.server.stat.exp_per_hour": "시간당 경험치",
      "calculator.server.stat.expected_totem_exp": "예상 토템 경험치",
      "calculator.server.stat.totem_exp_per_hour": "시간당 토템 경험치",
      "calculator.server.stat.bargain_bonus": "흥정 보너스",
      "calculator.server.stat.sale_multiplier": "최종 판매 배수",
      "calculator.server.stat.fixed_fish_sale_value": "물고기 고정 판매가",
      "calculator.server.helper.mastery": "통합 낚시 숙련도를 직접 입력하세요.",
      "calculator.server.helper.mastery_formula_prefix": "숙련도",
      "calculator.server.helper.mastery_formula_suffix": "값이 정규화 전 직접 Prize Fish 확률 공식에 적용됩니다.",
      "calculator.server.helper.before_zone_group_normalization": "지역 그룹 정규화 전",
      "calculator.server.helper.target_amount": "이 수량에 도달하는 예상 시간입니다.",
      "calculator.server.helper.within_current_session_duration": "현재 세션 시간 기준",
      "calculator.server.helper.select_target_fish": "대상 물고기를 선택하세요.",
      "calculator.server.helper.target_status_per_day": "{$label} · 하루 {$per_day}개",
      "calculator.server.helper.target_pmf_count": "이 횟수까지의 이산 결과 분포를 표시하며, 마지막 버킷에는 그보다 큰 모든 결과가 합쳐집니다.",
      "calculator.server.helper.target_pmf_auto_short": "0 = 자동",
      "calculator.server.helper.target_select_zone_item": "이 지역의 대상 물고기 또는 전리품을 선택하세요.",
      "calculator.server.helper.target_per_day_at_spot": "현재 지역과 설정 기준 하루 {$per_day}개 예상됩니다.",
      "calculator.server.helper.target_missing_at_spot": "이 대상은 현재 이 지역에 나오지 않습니다.",
      "calculator.server.helper.target_pmf_auto": "0 = 자동. 현재 마지막 PMF 버킷은 ≥{$count}입니다. (꼬리 확률 0.5% 기준)",
      "calculator.server.helper.target_pmf_fixed": "마지막 PMF 버킷은 ≥{$count}입니다.",
      "calculator.server.helper.custom_trade_distance": "수동 거리 보너스",
      "calculator.server.helper.trade_price_curve": "수동 % 곡선, 보통 105–130%",
      "calculator.server.helper.apply_trade_settings": "무역 설정 적용",
      "calculator.server.helper.imperial_fishing_sale_policy": "물고기 판매가는 항상 250%입니다. 거리 보너스는 무역 경험치에만 적용되며, 무역 가격 곡선과 흥정 보너스는 적용되지 않습니다.",
      "calculator.server.helper.food_family": "한 번에 하나의 음식 계열만 적용됩니다. 같은 계열의 상위 음식은 하위 음식을 대체합니다.",
      "calculator.server.helper.buff_group": "같은 버프 그룹의 다른 버프를 선택하면 이전 버프를 대체합니다.",
      "calculator.server.helper.fish_only_notice": "물고기에만 적용됩니다. 물고기가 아닌 전리품은 유지됩니다. 빨간 물고기는 항상 유지됩니다.",
      "calculator.server.helper.using": "사용",
      "calculator.server.helper.per_cast": "회당",
      "calculator.server.helper.sale": "판매",
      "calculator.server.helper.pet_skills.one": "기술은 1개 선택합니다.",
      "calculator.server.helper.pet_skills.many": "기술은 1개부터 {$count}개까지 선택합니다.",
      "calculator.server.tab.groups": "그룹",
      "calculator.server.tab.value_split": "가치 분할",
      "calculator.server.tab.silver": "은화",
      "calculator.server.tab.exp": "경험치",
      "calculator.server.tab.totem_exp": "토템 경험치",
      "calculator.server.tab.normalized": "정규화",
      "calculator.server.tab.denormalized": "역정규화",
      "calculator.server.tab.raw_weight": "원시 가중치",
      "calculator.server.tab.loot_flow": "전리품 흐름",
      "calculator.server.tab.exp_flow": "경험치 흐름",
      "calculator.server.tab.totem_exp_flow": "토템 경험치 흐름",
      "calculator.server.tab.target_fish": "대상 물고기",
      "calculator.server.tab.overview": "개요",
      "calculator.server.tab.inputs": "입력값",
      "calculator.server.discard.none": "버리지 않음",
      "calculator.server.target.expected": "예상값 ({$timespan})",
      "calculator.server.target.time_to_target": "목표 도달 시간",
      "calculator.server.target.chance_at_least": "{$amount}개 이상 획득 확률",
      "calculator.server.target.no_rows": "이 지역에는 현재 대상 분석에 사용할 전리품 행이 없습니다.",
      "calculator.server.target.session_distribution_title": "세션 횟수 분포",
      "calculator.server.target.session_distribution_description": "현재 세션 시간 기준 이 대상의 이산 결과 분포입니다.",
      "calculator.server.target.count_bucket_probability": "횟수 버킷 확률",
      "calculator.server.chart.no_loot_rows": "이 지역에는 아직 소스 기반 전리품 행이 없습니다.",
      "calculator.server.chart.no_exp_rows": "이 지역에는 아직 소스 기반 물고기 경험치 행이 없습니다.",
      "calculator.server.chart.no_totem_exp_rows": "이 지역에는 현재 소스 기반 또는 등급 규칙 추정 토템 경험치로 기여하는 유지된 물고기 행이 없습니다.",
      "calculator.server.chart.loot_flow_title": "전리품 흐름",
      "calculator.server.chart.loot_flow_description": "각 흐름은 물고기 그룹에서 시작해 소스 기반 종 행을 거친 뒤 은화 가중 그룹 합계로 다시 합쳐집니다. 왼쪽 지표는 각 아이템의 그룹 내 비율을, 오른쪽 지표는 은화 기여도를 보여줍니다.",
      "calculator.server.chart.exp_flow_title": "경험치 흐름",
      "calculator.server.chart.exp_flow_description": "각 흐름은 물고기 그룹에서 시작해 소스 기반 종 행을 거친 뒤 경험치 가중 그룹 합계로 다시 합쳐집니다. 왼쪽 지표는 각 아이템의 그룹 내 비율을, 오른쪽 지표는 경험치 기여도를 보여줍니다.",
      "calculator.server.chart.totem_exp_flow_title": "토템 경험치 흐름",
      "calculator.server.chart.totem_exp_flow_description": "각 흐름은 물고기 그룹에서 시작해 유지되는 물고기 행을 거친 뒤 토템 경험치 가중 그룹 합계로 다시 합쳐집니다. 출처 막대는 소스 기반 값과 등급 규칙 추정 값을 표시합니다.",
      "calculator.server.chart.sort_by": "정렬 기준",
      "calculator.server.chart.sort_by.price": "가격",
      "calculator.server.chart.sort_by.grade": "등급",
      "calculator.server.chart.sort_by.droprate": "그룹 내 비율",
      "calculator.server.chart.sort_by.expected_value": "기대값",
      "calculator.server.chart.sort_by.exp": "경험치",
      "calculator.server.chart.sort_by.totem_exp": "토템 경험치",
      "calculator.server.chart.sort_by.alphabetical": "가나다순",
      "calculator.server.chart.sort_by.item_id": "아이템 ID",
      "calculator.server.chart.sort_by.database": "데이터베이스",
      "calculator.server.chart.sort_by.evidence": "가장 강한 근거",
      "calculator.server.chart.sort_order": "정렬 순서",
      "calculator.server.chart.sort_order.desc": "내림차순",
      "calculator.server.chart.sort_order.asc": "오름차순",
      "calculator.server.chart.group_distribution_title": "그룹 선택 확률 분포",
      "calculator.server.chart.group_distribution_description.normalized": "Prize, 희귀, 고품질 가중치를 적용한 현재 물고기 그룹 비중입니다.",
      "calculator.server.chart.group_distribution_description.raw": "정규화 전, 보물 물고기 숙련도와 활성 그룹 보정이 적용된 물고기 그룹 원시 가중치입니다.",
      "calculator.server.chart.group_silver_distribution_title": "그룹 은화 분포",
      "calculator.server.chart.group_silver_distribution_description": "무역 및 가격 설정 적용 후 물고기 그룹별 예상 은화 비중입니다.",
      "calculator.server.chart.group_exp_distribution_title": "그룹 경험치 분포",
      "calculator.server.chart.group_exp_distribution_description": "소스 기반 물고기 경험치 값과 활성 경험치 보정을 적용한 물고기 그룹별 예상 경험치 비중입니다.",
      "calculator.server.chart.group_totem_exp_distribution_title": "그룹 토템 경험치 분포",
      "calculator.server.chart.group_totem_exp_distribution_description": "유지되는 소스 기반 또는 등급 규칙 추정 물고기 획득에서 얻는 물고기 그룹별 예상 토템 경험치 비중입니다.",
      "calculator.server.chart.aria.group_distribution": "그룹 선택 확률 분포",
      "calculator.server.chart.aria.group_silver_distribution": "그룹 은화 분포",
      "calculator.server.chart.aria.group_exp_distribution": "그룹 경험치 분포",
      "calculator.server.chart.aria.group_totem_exp_distribution": "그룹 토템 경험치 분포",
      "calculator.server.chart.aria.loot_flow": "그룹에서 전리품 행으로 이어지는 예상 전리품 흐름",
      "calculator.server.chart.aria.exp_flow": "그룹에서 전리품 행으로 이어지는 예상 경험치 흐름",
      "calculator.server.chart.aria.totem_exp_flow": "그룹에서 전리품 행으로 이어지는 예상 토템 경험치 흐름",
      "calculator.server.chart.aria.target_distribution": "대상 물고기 세션 분포",
      "calculator.server.chart.aria.timeline": "낚시 사이클 타임라인",
      "calculator.server.chart.aria.distribution_tabs": "분포 탭",
      "calculator.server.chart.aria.value_split_metric_switch": "가치 분할 지표",
      "calculator.server.chart.aria.loot_flow_metric_switch": "전리품 흐름 지표",
      "calculator.server.chart.aria.loot_rate_display_mode": "전리품 확률 표시",
      "calculator.server.chart.aria.workspace_tabs": "계산기 섹션",
      "calculator.server.chart.aria.custom_tabs": "Custom 작업공간 카드",
      "calculator.server.badge.aft": "-{$percent}% AFT",
      "calculator.server.badge.rare": "+{$percent}% Rare",
      "calculator.server.badge.hq": "+{$percent}% HQ",
      "calculator.server.badge.item_drr": "+{$percent}% Item DRR",
      "calculator.server.badge.fish_multiplier": "Fish ×{$multiplier}",
      "calculator.server.badge.fish_exp": "+{$percent}% Fish EXP",
      "calculator.server.badge.life_exp": "+{$percent}% Life EXP",
      "calculator.server.badge.set_effect": "Set effect",
      "calculator.server.badge.level_drr": "+{$percent}% Lv DRR",
      "calculator.server.badge.zone_origin": "지역 원산지",
      "calculator.server.loot.breakdown.label.base_price": "기본 가격",
      "calculator.server.value.unavailable": "이용 불가",
      "calculator.server.disclaimer.title": "데이터 품질 경고",
      "calculator.server.disclaimer.p1": "현재 보유한 데이터는 불완전하며 일부 데이터는 완전히 누락되었을 수 있습니다.",
      "calculator.server.disclaimer.p2": "그룹 비율 정보는 오래된 데이터를 기반으로 하므로 최신이 아닙니다.",
      "calculator.server.disclaimer.p3": "특히 Prize Fish 정보는 전적으로 커뮤니티 추정치 기반이므로 크게 빗나갈 수 있습니다. 실제 확률은 알 수 없습니다.",
      "calculator.server.disclaimer.p4": "최대한 정확하게 맞추려 하고 있지만, 지금은 이 결과를 그대로 사실로 받아들이지 마세요.",
      "calculator.server.disclaimer.p5": "앞으로는 데이터를 크라우드소싱할 예정이며, 향후 기여를 환영합니다.",
      "calculator.data.title": "지역 데이터",
      "calculator.data.description": "적용 중인 전리품 표를 시각적으로 편집하고 필요할 때 정확한 소스 후보를 확인합니다.",
      "calculator.data.empty": "계산기 모델, 결과, 확정된 사용자 레이어가 필요합니다.",
      "calculator.data.none": "없음",
      "calculator.data.selected_item": "선택한 아이템",
      "calculator.data.item_id": "아이템 {$id}",
      "calculator.data.candidate": "후보 {$number}",
      "calculator.data.editor.title": "전리품 표 편집기",
      "calculator.data.editor.description": "아이템을 선택한 다음 그룹 화살표로 할당하세요. 그룹 활성화 상태는 저장된 항목 및 확률과 별개입니다.",
      "calculator.data.catalog.title": "카탈로그",
      "calculator.data.catalog.add_item": "카탈로그 아이템 추가",
      "calculator.data.catalog.section.custom": "사용자 지정",
      "calculator.data.catalog.section.assigned": "할당됨",
      "calculator.data.catalog.section.available": "사용 가능",
      "calculator.data.catalog.section.in_zone": "구역 내부 출현",
      "calculator.data.catalog.section.zone_edge": "구역 경계 출현",
      "calculator.data.catalog.section.no_ranking_presence": "랭킹 출현 근거 없음",
      "calculator.data.available.item_count.one": "아이템 {$count}개",
      "calculator.data.available.item_count.other": "아이템 {$count}개",
      "calculator.data.available.showing": "· {$count}개 표시",
      "calculator.data.available.none": "이 낚시 소스에 사용할 수 있는 아이템이 없습니다.",
      "calculator.data.action.add_item": "{$item} 추가",
      "calculator.data.action.add_item_to_group": "{$item}을(를) {$group}에 추가",
      "calculator.data.action.add_to_group": "그룹에 추가",
      "calculator.data.action.activate_group": "활성화",
      "calculator.data.action.activate_group_label": "저장된 항목과 함께 {$group} 활성화",
      "calculator.data.action.apply": "적용",
      "calculator.data.action.apply_membership": "그룹 소속 적용",
      "calculator.data.action.apply_presence": "존재 상태 적용",
      "calculator.data.action.apply_price": "가격 적용",
      "calculator.data.action.cancel": "취소",
      "calculator.data.action.deactivate_group": "비활성화",
      "calculator.data.action.deactivate_group_label": "항목을 삭제하지 않고 {$group} 비활성화",
      "calculator.data.action.item_already_in_group": "{$item}은(는) 이미 {$group}에 있습니다",
      "calculator.data.action.refute": "사용자 레이어로 반박",
      "calculator.data.action.remove": "제거",
      "calculator.data.action.remove_item_from_group": "{$group}에서 {$item} 제거",
      "calculator.data.action.inspect_group": "낚시 그룹 {$group} 확인",
      "calculator.data.action.select_item": "{$item} 선택",
      "calculator.data.action.remove_custom_item": "사용자 지정에서 {$item} 제거",
      "calculator.data.action.inspect_item_assignment": "{$group}의 {$item} 할당 확인",
      "calculator.data.action.revert": "되돌리기",
      "calculator.data.action.revert_label": "{$operation} 되돌리기",
      "calculator.data.action.revert_user_operation": "사용자 작업 되돌리기",
      "calculator.data.action.review_item": "아이템 검토",
      "calculator.data.action.search": "검색",
      "calculator.data.action.select_item_for_group": "{$group}에 추가할 아이템 선택",
      "calculator.data.action.select_reason": "사유 선택",
      "calculator.data.action.use_id": "ID 사용",
      "calculator.data.field.catalog": "카탈로그",
      "calculator.data.field.detail_code_optional": "상세 코드(선택 사항)",
      "calculator.data.field.filter": "필터",
      "calculator.data.field.item_id": "아이템 ID",
      "calculator.data.field.membership_group": "소속 그룹",
      "calculator.data.field.membership_state": "소속 상태",
      "calculator.data.field.confidence": "신뢰도",
      "calculator.data.field.operation_comment": "작업 메모",
      "calculator.data.field.operation_context": "신뢰도 및 메모",
      "calculator.data.field.presence": "존재 상태",
      "calculator.data.field.price_silver": "가격(은화)",
      "calculator.data.field.price_state": "가격 상태",
      "calculator.data.field.rate_basis": "입력 기준",
      "calculator.data.field.rate_value": "값",
      "calculator.data.field.rate_value_accessible": "확률 값. 정규화 고정 확률은 0~100%여야 하며, 역정규화 및 원시 가중치는 유한한 0 이상의 값이어야 합니다. 가중치 입력은 전체 정밀도를 유지합니다.",
      "calculator.data.field.refutation_reason": "반박 사유 코드",
      "calculator.data.field.state": "상태",
      "calculator.data.field.unavailable_reason": "사용할 수 없는 사유",
      "calculator.data.placeholder.reason_code": "사유 코드 입력",
      "calculator.data.placeholder.operation_comment": "이 덮어쓰기의 이유, 근거 또는 추가 검토가 필요한 내용을 입력하세요",
      "calculator.data.search.catalog_placeholder": "전체 카탈로그 검색",
      "calculator.data.search.filter_placeholder": "아이템, ID, 그룹, 레이어 또는 상태",
      "calculator.data.state.absent": "없음",
      "calculator.data.confidence.guessed": "추정",
      "calculator.data.state.known": "알려짐",
      "calculator.data.state.not_loaded": "불러오지 않음",
      "calculator.data.state.present": "있음",
      "calculator.data.state.unavailable": "사용할 수 없음",
      "calculator.data.state.unknown": "알 수 없음",
      "calculator.data.status.condition_inactive": "조건 비활성",
      "calculator.data.condition.none_active": "활성 조건 없음",
      "calculator.data.condition.automatic": "자동 조건 사용",
      "calculator.data.condition.auto_short": "자동",
      "calculator.data.status.effective": "적용 중",
      "calculator.data.status.overridden": "덮어씀",
      "calculator.data.status.refuted": "반박됨",
      "calculator.data.membership.member": "그룹에 포함",
      "calculator.data.membership.not_member": "그룹에서 제외",
      "calculator.data.membership.unknown": "소속 알 수 없음",
      "calculator.data.rate_basis.per_catch": "획득당",
      "calculator.data.rate_basis.fixed_share_percent": "고정 비율 (%)",
      "calculator.data.rate_basis.normalized_percent": "정규화",
      "calculator.data.rate_basis.denormalized_weight": "역정규화",
      "calculator.data.rate_basis.percent": "백분율",
      "calculator.data.rate_basis.ratio": "비율",
      "calculator.data.rate_basis.raw_weight": "원시 가중치",
      "calculator.data.rate.weight": "가중치 {$value}",
      "calculator.data.rate.projected_edit_base": "계산 결과 {$rate}; {$label} 편집",
      "calculator.data.rate.projected_total_edit_base": "예상 합계 {$rate}; {$label} 편집",
      "calculator.data.rate.state_label": "{$state} 확률",
      "calculator.data.rate.unavailable": "확률 사용 불가",
      "calculator.data.rate.unknown": "확률 알 수 없음",
      "calculator.data.rate.unquantified_group": "{$group} · 수치화되지 않음",
      "calculator.data.rate_editor.edit": "{$label} 편집",
      "calculator.data.rate_editor.group_rate": "그룹 확률 입력",
      "calculator.data.rate_editor.item_base": "아이템 기본 입력",
      "calculator.data.rate_editor.user_group_override": "사용자 그룹 덮어쓰기",
      "calculator.data.rate_editor.shadowed_bonus": "이 고정 정규화 확률에는 원시 가중치 보너스가 적용되지 않습니다. 보너스를 적용하려면 비정규화 또는 원시 가중치에서 확률을 편집하세요.",
      "calculator.data.unavailable.incomplete_provenance": "출처 이력 불완전",
      "calculator.data.unavailable.missing_source": "소스 팩트 누락",
      "calculator.data.unavailable.model_selection": "조건 선택",
      "calculator.data.unavailable.no_equivalent_raw_weight": "동등한 원시 가중치 없음",
      "calculator.data.unavailable.not_applicable": "해당 없음",
      "calculator.data.unavailable.unsupported_source": "지원하지 않는 소스 형식",
      "calculator.data.group.label": "{$group} 그룹",
      "calculator.data.group.main_group_id": "메인 그룹 ID: {$value}",
      "calculator.data.group.no_memberships": "적용 중인 아이템 소속이 없습니다.",
      "calculator.data.group.none_available": "이 선택에 사용할 수 있는 그룹이 없습니다.",
      "calculator.data.assignment.independent_fact": "{$layer}의 독립 그룹 팩트",
      "calculator.data.assignment.no_memberships": "적용 중인 그룹 소속 없음",
      "calculator.data.assignment.review_label": "{$item}의 {$group} 배정 검토",
      "calculator.data.assignment.unassigned": "미배정",
      "calculator.data.assignment.via_layer": "{$layer} 경유",
      "calculator.data.catalog.section.assigned_absent": "배정됨 · 없음",
      "calculator.data.badge.catalog_result": "카탈로그 결과",
      "calculator.data.badge.exact_id": "정확한 ID",
      "calculator.data.badge.user_layer": "사용자 레이어",
      "calculator.data.presence.label": "존재 상태: {$state}",
      "calculator.data.provenance.membership": "소속",
      "calculator.data.provenance.no_effective_rate": "적용 중인 확률 팩트 없음",
      "calculator.data.provenance.presence": "존재 상태",
      "calculator.data.provenance.rate": "확률",
      "calculator.data.provenance.unknown_layer": "알 수 없는 레이어",
      "calculator.data.provenance.audit_details": "감사 세부 정보",
      "calculator.data.provenance.final": "최종 결과",
      "calculator.data.provenance.actions": "작업",
      "calculator.data.provenance.supporting": "보조 근거",
      "calculator.data.provenance_graph.item_presence": "아이템 존재 상태",
      "calculator.data.provenance_graph.group_identity": "그룹 정체성 · {$group}",
      "calculator.data.provenance_graph.group_presence": "그룹 존재 상태 · {$group}",
      "calculator.data.provenance_graph.group_membership": "그룹 소속 · {$group}",
      "calculator.data.provenance_graph.group_rate": "그룹 확률 · {$group}",
      "calculator.data.provenance_graph.item_rate": "아이템 확률 · {$group}",
      "calculator.data.provenance_graph.item_quantity": "아이템 수량 · {$group}",
      "calculator.data.provenance_graph.item_quantity_default": "아이템 기본 수량",
      "calculator.data.provenance_graph.active_condition": "활성 조건",
      "calculator.data.provenance_graph.presence": "존재 상태",
      "calculator.data.provenance_graph.presence_description": "선택한 낚시 그룹 또는 전리품 행의 직접적인 존재 상태 팩트입니다.",
      "calculator.data.provenance_graph.rate": "확률",
      "calculator.data.provenance_graph.rate_description": "선택한 낚시 그룹 또는 전리품 행의 직접적인 확률 팩트와 선택한 전리품 행의 수량 팩트입니다.",
      "calculator.data.provenance_graph.result": "결과",
      "calculator.data.provenance_graph.no_effective": "적용 중인 팩트 없음",
      "calculator.data.provenance_graph.select_subject": "출처 이력을 보려면 낚시 그룹이나 전리품 행을 선택하세요.",
      "calculator.data.provenance_graph.details_unavailable": "이 팩트의 출처 세부 정보를 사용할 수 없습니다.",
      "calculator.data.provenance_graph.no_facts": "이 채널에 불러온 출처 팩트가 없습니다.",
      "calculator.data.provenance_graph.scroll_label": "{$channel} 출처 이력 그래프",
      "calculator.data.provenance_graph.subject": "{$subject} 출처 이력",
      "calculator.data.provenance_graph.heading": "전리품 출처 이력",
      "calculator.data.provenance_graph.description": "각 경로는 최종 값으로 시작합니다. 오른쪽으로 갈수록 후보가 높은 우선순위에서 낮은 우선순위 순으로 표시됩니다.",
      "calculator.data.metadata.content_hash": "콘텐츠 해시",
      "calculator.data.metadata.comment": "메모",
      "calculator.data.metadata.confidence": "신뢰도",
      "calculator.data.metadata.author": "작성자",
      "calculator.data.metadata.author_handle": "작성자 핸들",
      "calculator.data.metadata.author_id": "작성자 ID",
      "calculator.data.metadata.created": "작성 시각",
      "calculator.data.metadata.claim_date": "주장 일자",
      "calculator.data.metadata.claim_date_approximate_value": "약 {$range}",
      "calculator.data.metadata.deactivated_by": "비활성화한 작업",
      "calculator.data.metadata.evidence_class": "근거 분류",
      "calculator.data.metadata.fact_id": "팩트 ID",
      "calculator.data.metadata.imported": "가져온 시각",
      "calculator.data.metadata.layer": "레이어",
      "calculator.data.metadata.observation_count": "관측 횟수",
      "calculator.data.metadata.observation_scope": "관측 범위",
      "calculator.data.metadata.observed": "관측 시각",
      "calculator.data.metadata.operation": "작업",
      "calculator.data.metadata.operation_id": "작업 ID",
      "calculator.data.metadata.refutation_comment": "반박 메모",
      "calculator.data.metadata.refutation_confidence": "반박 신뢰도",
      "calculator.data.metadata.refutation_author": "반박 작성자",
      "calculator.data.metadata.refutation_author_handle": "반박 작성자 핸들",
      "calculator.data.metadata.refutation_author_id": "반박 작성자 ID",
      "calculator.data.metadata.refutation_created": "반박 작성 시각",
      "calculator.data.metadata.refutation_claim_date": "반박 주장 일자",
      "calculator.data.metadata.refutation_reason": "반박 사유",
      "calculator.data.metadata.refuted_by": "반박한 작업",
      "calculator.data.metadata.row": "행",
      "calculator.data.metadata.sheet": "시트",
      "calculator.data.metadata.source_id": "소스 ID",
      "calculator.data.metadata.source_revision": "소스 리비전",
      "calculator.data.metadata.table": "테이블",
      "calculator.data.metadata.value": "값",
      "calculator.data.metadata.conditions": "조건",
      "calculator.data.metadata.branch_id": "분기 ID",
      "calculator.data.metadata.alternative": "대안",
      "calculator.data.evidence.catalog_result": "현재 카탈로그 검색 결과",
      "calculator.data.evidence.description": "공간 랭킹 관측은 선택한 지역에 아이템이 존재한다는 근거입니다. 그룹 배정은 별도의 팩트이며 여러 그룹을 포함할 수 있습니다.",
      "calculator.data.evidence.details_heading": "랭킹 근거 상세 정보",
      "calculator.data.evidence.exact_identity": "정확한 숫자 아이템 식별자",
      "calculator.data.evidence.no_matches": "이 필터와 일치하는 랭킹 근거가 없습니다.",
      "calculator.data.evidence.observed_at": "관측 시각 {$time}",
      "calculator.data.evidence.presence_not_loaded": "존재 팩트를 불러오지 않음",
      "calculator.data.evidence.rate_warning": "관측 횟수는 지역 내 존재 근거이며 드롭 확률 추정치가 아닙니다.",
      "calculator.data.evidence.scope.fully_contained": "완전히 포함된 랭킹 고리",
      "calculator.data.evidence.scope.partial_intersection": "경계와 교차하는 랭킹 고리",
      "calculator.data.evidence.review_item_label": "{$item}의 근거와 배정 검토",
      "calculator.data.evidence.showing_limit": "{$total}개 결과 중 처음 {$visible}개를 표시합니다. 나머지를 보려면 필터를 구체화하세요.",
      "calculator.data.evidence.table_caption": "각 아이템의 랭킹 존재 관측과 독립적으로 적용되는 그룹 배정",
      "calculator.data.evidence.title": "랭킹 근거 및 그룹 배정",
      "calculator.data.evidence.unassigned_help": "랭킹은 지역 내 존재만 뒷받침합니다. 하나 이상의 그룹을 선택하세요.",
      "calculator.data.evidence.unquantified_in": "{$group}에서 수치화되지 않음",
      "calculator.data.evidence.user_layer_reference": "사용자 레이어에서 참조함",
      "calculator.data.evidence.candidate_count.one": "후보 팩트 {$count}개",
      "calculator.data.evidence.candidate_count.other": "후보 팩트 {$count}개",
      "calculator.data.evidence.zone_count.one": "이 지역의 랭킹 근거 아이템 {$count}개.",
      "calculator.data.evidence.zone_count.other": "이 지역의 랭킹 근거 아이템 {$count}개.",
      "calculator.data.table.actions": "작업",
      "calculator.data.table.group_facts": "적용 중인 그룹 팩트",
      "calculator.data.table.item": "아이템",
      "calculator.data.table.zone_presence": "지역 존재 근거",
      "calculator.data.advanced.editing_item": "{$item} 편집 중. 존재 상태와 각 그룹 소속은 서로 독립된 형식화 팩트입니다.",
      "calculator.data.advanced.heading": "고급 형식화 팩트 편집기",
      "calculator.data.advanced.user_layer_edit": "사용자 레이어 편집",
      "calculator.data.layer.current_source": "현재 낚시 소스 레이어",
      "calculator.data.layer.description": "변경할 수 없는 기본 팩트부터 순서가 지정된 소스를 거쳐 마지막으로 개인 레이어를 적용합니다.",
      "calculator.data.layer.effective_for_fact": "선택한 팩트에 적용 중",
      "calculator.data.layer.loaded_sources.one": "불러온 적용 소스 {$count}개",
      "calculator.data.layer.loaded_sources.other": "불러온 적용 소스 {$count}개",
      "calculator.data.layer.no_model": "불러온 모델이 없습니다.",
      "calculator.data.layer.order": "순서 {$order}",
      "calculator.data.layer.read_only": "읽기 전용",
      "calculator.data.layer.user_editable": "사용자 편집 가능",
      "calculator.data.fact_count.one": "팩트 작업 {$count}개",
      "calculator.data.fact_count.other": "팩트 작업 {$count}개",
      "calculator.data.operation_count.one": "작업 {$count}개",
      "calculator.data.operation_count.other": "작업 {$count}개",
      "calculator.data.operations.description": "이 레이어만 편집할 수 있습니다. {$source} 범위의 작업을 표시하며, 되돌리면 다음 후보가 적용됩니다.",
      "calculator.data.operations.global_count": "전역 작업 · {$count}",
      "calculator.data.operations.hidden_source_count.one": "다른 낚시 소스의 작업 {$count}개를 숨겼습니다.",
      "calculator.data.operations.hidden_source_count.other": "다른 낚시 소스의 작업 {$count}개를 숨겼습니다.",
      "calculator.data.operations.none_global": "전역 개인 작업이 없습니다.",
      "calculator.data.operations.none_source": "이 낚시 소스의 개인 작업이 아직 없습니다. 근거를 검토하거나 카탈로그 아이템을 추가하세요.",
      "calculator.data.operations.title": "개인 오버레이 작업",
      "calculator.data.operations.source_count.one": "소스 작업 {$count}개",
      "calculator.data.operations.source_count.other": "소스 작업 {$count}개",
      "calculator.data.trace.effective_fact_id": "적용 중인 팩트 ID",
      "calculator.data.trace.effective_layer": "적용 중인 레이어",
      "calculator.data.trace.heading": "선택한 팩트 출처 이력",
      "calculator.data.trace.none": "사용할 수 있는 출처 추적 정보가 없습니다.",
      "calculator.data.trace.selected_fact": "선택한 팩트",
      "calculator.data.fact.branch": "분기 {$id}",
      "calculator.data.fact.fact": "팩트 {$id}",
      "calculator.data.fact.group": "그룹 {$id}",
      "calculator.data.fact.zone": "지역 {$id}",
      "calculator.data.boundary.initialization": "초기화",
      "calculator.data.boundary.storage": "저장소",
      "calculator.data.status.active_local": "활성 사용자 레이어를 로컬에서 계산합니다.",
      "calculator.data.status.invalid_saved_document": "저장된 v4 문서가 올바르지 않아 무시했습니다: {$error} 활성 모델 레이어는 계속 검증했으며 저장소는 변경하지 않았습니다.",
      "calculator.data.status.model_refresh_failed": "계산기 모델 새로 고침에 실패했습니다.",
      "calculator.data.status.saved_removed": "저장된 v4 오버레이가 다른 곳에서 제거되었지만 활성 로컬 오버레이는 계속 사용됩니다.",
      "calculator.data.status.server_confirmed": "서버에서 이 사용자 레이어를 확인했습니다.",
      "calculator.data.status.storage_unavailable": "로컬 오버레이 저장소를 사용할 수 없습니다.",
      "calculator.data.status.storage_write_failed": "오버레이는 적용되었지만 로컬에 저장하지 못했습니다: {$error}",
      "calculator.data.status.stored_locally": "활성 v4 오버레이를 로컬에 저장했습니다.",
      "calculator.data.status.validation_superseded": "더 최신의 로컬 입력으로 인해 이 검증 응답이 더 이상 유효하지 않습니다.",
      "calculator.data.status.stored_invalid": "저장된 v4 레이어가 올바르지 않습니다.",
      "calculator.data.status.validating_boundary": "{$boundary} 경계에서 사용자 레이어를 검증하는 중입니다.",
      "calculator.data.status.validating_result": "서버에서 계산 결과를 검증하는 중입니다.",
      "calculator.data.status.waiting_for_model": "계산기 모델을 기다리는 중입니다.",
      "calculator.data.error.wait_for_model": "선택한 모델 팩트를 모두 불러온 뒤 사용자 레이어를 편집하세요.",
      "calculator.data.error.wait_for_author": "현재 작성자 정보가 포함된 편집이 완료될 때까지 기다린 후 다시 편집하세요.",
      "calculator.data.announcement.custom_item_added": "{$item}을(를) 사용자 지정에 추가했습니다.",
      "calculator.data.announcement.custom_item_removed": "{$item}을(를) 사용자 지정에서 제거했습니다.",
      "calculator.data.announcement.filter_applied": "랭킹 근거 필터를 적용했습니다.",
      "calculator.data.announcement.loading_before_add": "이 아이템의 팩트를 불러오는 중입니다. 완료된 뒤 그룹에 추가하세요.",
      "calculator.data.announcement.loading_before_assign": "배정하기 전에 이 아이템의 팩트를 불러오는 중입니다.",
      "calculator.data.announcement.loading_item": "아이템 {$id}의 팩트를 불러오는 중입니다.",
      "calculator.data.announcement.user_layer_updated": "사용자 레이어를 업데이트했습니다.",
      "calculator.data.quantity.accessible_exact": "수량 {$quantity}",
      "calculator.data.quantity.accessible_range": "수량 {$minimum}~{$maximum}",
      "calculator.data.quantity.accessible_expected": "예상 수량 {$quantity}",
      "calculator.data.quantity.expected_short": "기댓값",
      "calculator.data.quantity.editor_title": "획득 수량",
      "calculator.data.quantity.minimum": "최소",
      "calculator.data.quantity.maximum": "최대",
      "calculator.data.action.revert_quantity": "되돌리기",
      "calculator.data.action.edit_item_facts_for": "{$item} 정보 편집",
      "calculator.data.action.close_item_facts_for": "{$item} 정보 닫기",
      "calculator.data.item_facts.title": "아이템 정보",
      "calculator.data.item_facts.description": "이 값은 이 아이템에 전역으로 적용됩니다.",
      "calculator.data.item_facts.price_unknown": "알 수 없음",
      "calculator.data.item_facts.revert_price": "가격 되돌리기",
      "calculator.data.item_facts.quantity_default": "기본 수량 범위",
      "calculator.data.item_facts.revert_quantity_default": "기본값 되돌리기",
      "calculator.server.recovery.unavailable": "선택한 설정으로 계산할 수 없습니다. 설정과 저장된 기록은 계속 사용할 수 있습니다.",
      "calculator.server.recovery.instructions": "이 설정에 대한 결과가 없습니다. 아래에서 낚시 대상이나 반려동물 설정을 조정하거나 프리셋 기록에서 변경을 취소하거나 다른 프리셋을 선택한 후 다시 시도하세요. 현재 작업은 초기화되지 않습니다.",
      "calculator.server.recovery.retry": "이 설정으로 다시 시도",
      "calculator.server.recovery.request": "요청 정보",
      "nav.get_started": "시작하기",
      "nav.guides": "가이드",
      "nav.map": "지도",
      "nav.dex": "도감",
      "nav.calculator": "계산기",
      "nav.community": "커뮤니티",
      "nav.glossary": "용어집",
      "nav.log": "기록",
      "nav.devlog": "개발 기록",
      "nav.menu.open": "내비게이션 메뉴 열기",
      "nav.scroll_to_top": "맨 위로 이동",
      "admin.contest_moderator": "대회 관리자",
      "admin.no_contest_moderator": "대회 관리자 역할 없음",
      "admin.grant_contest_moderator": "대회 관리자 권한 부여",
      "admin.revoke_contest_moderator": "대회 관리자 권한 해제",
      "admin.contest_moderator_help": "대회 관리자는 제안된 물고기를 확정할 수 있습니다. 이 역할은 계정 관리나 Fishing Logger 베타 접근 권한을 부여하지 않습니다. 사이트 관리자는 이 별도 역할 없이도 물고기를 확정할 수 있습니다.",
      "footer.about": "정보",
      "footer.feedback": "피드백",
      "footer.legal": "법적 고지",
      "footer.provider_terms": "제공자 및 서비스 이용약관",
      "footer.privacy_policy": "개인정보 처리방침",
      "footer.crio_terms": "Crio 서비스 이용약관",
      "footer.crio_privacy": "Crio 개인정보 처리방침",
      "footer.pearl_abyss_disclaimer": "FishyStuff는 커뮤니티 취미 프로젝트이며 펄어비스와 제휴하지 않습니다. 이는 펄어비스의 저작권 보호 자료와 지식 재산을 포함하는 비공식 콘텐츠이며, 펄어비스의 공식 콘텐츠 또는 승인된 콘텐츠가 아닙니다.",
      "common.action.save": "저장",
      "common.action.discard": "폐기",
      "common.action.rename": "이름 변경",
      "common.action.delete": "삭제",
      "common.action.export": "내보내기",
      "common.action.import": "가져오기",
      "common.action.cancel": "취소",
      "common.action.copy": "복사",
      "common.action.clone": "복제",
      "common.action.search": "검색",
      "common.action.close": "닫기",
      "common.action.undo": "실행 취소",
      "common.action.redo": "다시 실행",
      "common.action.clear_selection": "선택 해제",
      "common.action.clear_selection_count": "선택 해제 ({$count})",
      "common.status.current": "현재",
      "common.status.saved": "저장됨",
      "common.status.modified": "수정됨",
      "common.status.default": "기본값",
      "common.status.applied": "적용됨",
      "common.status.original": "원본",
      "common.status.active": "활성",
      "common.status.selected": "선택됨",
      "common.status.not_selected": "선택되지 않음",
      "common.field.title": "제목",
      "profile.menu.open": "계정 메뉴 열기",
      "profile.menu.account": "계정",
      "profile.menu.loading": "계정 확인 중…",
      "profile.menu.sign_in": "로그인",
      "profile.menu.discord": "Discord로 로그인",
      "profile.menu.sign_out": "로그아웃",
      "profile.menu.unavailable": "계정을 일시적으로 사용할 수 없습니다",
      "profile.menu.action_failed": "계정 작업을 완료할 수 없습니다. 다시 시도하세요.",
      "profile.menu.theme": "테마",
      "profile.menu.presets": "프리셋",
      "account.state.loading": "로그인 상태 확인 중…",
      "account.state.signed_out": "로그인하지 않음",
      "account.state.signed_out_detail": "로그인하거나 FishyStuff 계정을 만들어 이 기기에서 동기화된 설정과 저장 데이터를 사용하세요.",
      "account.state.signed_in": "로그인됨",
      "account.state.no_recovery_email": "복구 이메일이 설정되어 있지 않아 이메일 복구를 사용할 수 없습니다.",
      "account.login.title": "FishyStuff 로그인",
      "account.registration.title": "FishyStuff 계정 만들기",
      "account.registration.email_recovery_notice": "복구 이메일은 선택 사항이며, 계정 설정에서 추가하기 전에는 이메일 복구를 사용할 수 없습니다.",
      "account.registration.discord_handle_help": "비워 두면 Discord 사용자 이름을 사용합니다.",
      "account.registration.legal_title": "이용 약관 및 개인정보 안내",
      "account.registration.terms_prefix": "다음 문서에 동의합니다:",
      "account.registration.terms_link": "이용 약관",
      "account.registration.privacy_link": "개인정보 처리방침",
      "account.registration.privacy_notice": "FishyStuff의 계정 데이터 처리 방식은 다음 문서에서 확인할 수 있습니다:",
      "account.legal.required_title": "업데이트된 이용 약관 검토",
      "account.legal.required_detail": "이 계정에는 현재 이용 약관 버전에 대한 동의 기록이 없습니다. 약관이 업데이트되었을 수 있습니다.",
      "account.legal.notice_title": "업데이트된 이용 약관을 확인해 주세요",
      "account.legal.notice_detail": "업데이트된 이용 약관에 동의할 때까지 일부 API 기능이 더 이상 작동하지 않을 수 있습니다. 이용 약관 페이지에서 검토하고 동의하거나 계정을 삭제할 수 있습니다.",
      "account.legal.review_action": "약관 검토 및 동의",
      "account.legal.delete_action": "계정 삭제",
      "account.legal.version": "버전",
      "account.legal.effective": "시행일",
      "account.legal.terms_prefix": "다음 문서에 동의합니다:",
      "account.legal.privacy_notice": "은 참고용으로 제공되며 FishyStuff의 계정 데이터 처리 방식을 설명합니다.",
      "account.legal.submit": "동의하고 계속",
      "account.legal.status_unavailable": "이용 약관 동의 상태를 확인할 수 없습니다.",
      "account.legal.recording": "이용 약관 동의를 저장하는 중…",
      "account.legal.failed": "이용 약관 동의를 저장하지 못했습니다. 다시 시도하세요.",
      "account.discord_handle_conflict.title": "Discord 핸들을 사용할 수 없음",
      "account.discord_handle_conflict.detail": "이 Discord 핸들은 사용할 수 없습니다. 로그인하여 Discord를 계정에 연결하거나 다른 핸들로 직접 가입하세요.",
      "account.error.discord": "Discord 로그인을 완료하지 못했습니다. 다시 시도하세요.",
      "account.error.discord_session": "Discord 로그인은 완료되었지만 FishyStuff 계정을 불러오지 못했습니다. 이 페이지를 새로고침하세요.",
      "account.discord_linked": "Discord가 계정에 연결되었습니다.",
      "account.settings.title": "계정 설정",
      "account.settings.detail": "계정 설정을 업데이트하세요.",
      "account.settings.group.account": "계정",
      "account.settings.group.sign_in": "로그인 방법",
      "account.settings.group.two_step": "2단계 인증",
      "account.settings.group.sessions": "세션",
      "account.settings.group.danger": "위험 구역",
      "account.settings.navigation.profile": "프로필",
      "account.settings.navigation.password": "비밀번호",
      "account.settings.navigation.oidc": "소셜 로그인",
      "account.settings.navigation.passkey": "패스키",
      "account.settings.navigation.webauthn": "보안 키",
      "account.settings.navigation.totp": "인증 앱",
      "account.settings.navigation.lookup_secret": "백업 코드",
      "account.settings.profile.title": "프로필 설정",
      "account.settings.profile.detail": "프로필 정보를 업데이트하세요.",
      "account.settings.password.title": "비밀번호 변경",
      "account.settings.password.detail": "비밀번호 로그인을 변경하거나 제거하세요.",
      "account.settings.first_factor_removal_blocked": "현재 유일한 로그인 방법입니다. 제거하기 전에 다른 로그인 방법을 추가하세요.",
      "account.settings.oidc.title": "연결된 계정",
      "account.settings.oidc.detail": "Discord 로그인을 연결하거나 해제하세요.",
      "account.settings.passkey.title": "패스키 관리",
      "account.settings.passkey.detail": "이 계정의 패스키를 추가하거나 제거하세요.",
      "account.settings.webauthn.title": "보안 키",
      "account.settings.webauthn.detail": "2단계 인증에 사용할 기기 생체 인증 및 하드웨어 보안 키를 관리하세요.",
      "account.settings.totp.title": "인증 앱",
      "account.settings.totp.detail": "인증 앱을 통한 2단계 인증을 관리하세요.",
      "account.settings.lookup_secret.title": "백업 복구 코드",
      "account.settings.lookup_secret.detail": "2단계 인증 복구 코드를 관리하세요.",
      "account.recovery.title": "계정 복구",
      "account.recovery.detail": "계정에 등록된 복구 이메일로 잠시 동안만 유효한 코드를 보내드립니다.",
      "account.verification.title": "복구 이메일 인증",
      "account.verification.detail": "계정 복구에 사용할 수 있도록 복구 이메일을 인증하세요.",
      "account.verification.complete_title": "복구 이메일 인증 완료",
      "account.verification.complete_detail": "복구 이메일 인증이 완료되어 이제 계정 복구에 사용할 수 있습니다.",
      "account.step_up.title": "2단계 인증을 완료하세요",
      "account.step_up.detail": "안전하게 계속하려면 보안 키, 인증 앱 또는 백업 코드를 사용하세요.",
      "account.reauthenticate.title": "본인 확인",
      "account.reauthenticate.detail": "민감한 계정 정보를 변경하기 전에 다시 로그인하세요.",
      "account.identity_owned": "프로필, 로그인 및 보안 변경 사항은 동기화된 설정 및 로컬 브라우저 데이터와 별도로 FishyStuff 계정 서비스에서 직접 처리합니다.",
      "account.field.identifier": "계정 핸들 또는 복구 이메일",
      "account.field.identifier_optional": "계정 핸들 또는 복구 이메일(선택 사항)",
      "account.field.handle": "계정 핸들",
      "account.field.handle_optional": "계정 핸들(선택 사항)",
      "account.field.display_name": "표시 이름",
      "account.field.display_name_optional": "표시 이름(선택 사항)",
      "account.field.display_name_help": "비워 두면 FishyStuff에서 계정 핸들을 대신 표시합니다.",
      "account.field.password": "비밀번호",
      "account.field.recovery_email": "복구 이메일",
      "account.field.recovery_email_help": "이메일로 계정을 복구할 수 있도록 인증된 주소를 하나 이상 유지하세요.",
      "account.field.email_code": "이메일 코드",
      "account.field.authenticator_code": "인증 앱 코드",
      "account.field.backup_code": "백업 코드",
      "account.field.security_key_name": "보안 키 이름",
      "account.method.password": "계정 핸들 및 비밀번호",
      "account.method.regular_sign_in": "일반 로그인",
      "account.method.password_change": "비밀번호",
      "account.method.discord": "Discord",
      "account.method.passkey": "패스키",
      "account.method.passkey_sign_in": "패스키",
      "account.method.security_key": "보안 키",
      "account.method.profile": "프로필 정보",
      "account.avatar.title": "프로필 사진",
      "account.avatar.detail": "Discord 사진 또는 FishyStuff 아바타를 선택하세요. 프로필과 함께 저장됩니다.",
      "account.avatar.discord": "Discord",
      "account.avatar.search": "아바타 검색",
      "account.avatar.fishystuff": "FishyStuff 아바타",
      "account.avatar.choose_fishystuff": "FishyStuff 아바타 선택",
      "account.avatar.color": "아바타 색상",
      "account.avatar.color.base": "테마",
      "account.avatar.color.primary": "기본",
      "account.avatar.color.secondary": "보조",
      "account.avatar.color.accent": "강조",
      "account.avatar.fish": "물고기",
      "account.avatar.cat": "고양이",
      "account.avatar.dog": "강아지",
      "account.avatar.rabbit": "토끼",
      "account.avatar.bear": "곰",
      "account.avatar.deer": "사슴",
      "account.avatar.bird": "새",
      "account.avatar.butterfly": "나비",
      "account.avatar.flower": "꽃",
      "account.avatar.leaf": "잎",
      "account.avatar.tree": "나무",
      "account.avatar.wave": "파도",
      "account.avatar.paw": "발바닥",
      "account.avatar.birthday-2": "생일 케이크",
      "account.avatar.bone": "뼈",
      "account.avatar.bottle-glass": "유리병",
      "account.avatar.bowl-2": "그릇 2",
      "account.avatar.bowl": "그릇",
      "account.avatar.bread": "빵",
      "account.avatar.cake": "케이크",
      "account.avatar.candy-2": "사탕 2",
      "account.avatar.candy": "사탕",
      "account.avatar.carrot": "당근",
      "account.avatar.champagne": "샴페인",
      "account.avatar.chicken": "닭",
      "account.avatar.chopsticks": "젓가락",
      "account.avatar.cookie": "쿠키",
      "account.avatar.cookie-man": "진저브레드맨",
      "account.avatar.cupcake": "컵케이크",
      "account.avatar.dinner": "저녁 식사",
      "account.avatar.dish-cover": "음식 덮개",
      "account.avatar.donut": "도넛",
      "account.avatar.drink": "음료",
      "account.avatar.egg-crack": "깨진 달걀",
      "account.avatar.egg": "달걀",
      "account.avatar.electric-cooker": "전기밥솥",
      "account.avatar.feeder": "먹이통",
      "account.avatar.fork": "포크",
      "account.avatar.fork-knife": "포크와 나이프",
      "account.avatar.fork-spoon": "포크와 숟가락",
      "account.avatar.fried-egg": "달걀 프라이",
      "account.avatar.fries": "감자튀김",
      "account.avatar.glass-cup": "유리컵",
      "account.avatar.hamburger": "햄버거",
      "account.avatar.ice-cream-2": "아이스크림 2",
      "account.avatar.ice-cream": "아이스크림",
      "account.avatar.lollipop": "막대사탕",
      "account.avatar.pizza": "피자",
      "account.avatar.soup-pot-2": "수프 냄비 2",
      "account.avatar.soup-pot": "수프 냄비",
      "account.avatar.spatula": "뒤집개",
      "account.avatar.spoon": "숟가락",
      "account.avatar.sugar-coated-haws": "탕후루",
      "account.avatar.teacup": "찻잔",
      "account.avatar.wine": "와인",
      "account.avatar.wineglass-2": "와인잔 2",
      "account.avatar.wineglass": "와인잔",
      "account.avatar.none": "사진 없음",
      "account.method.authenticator": "인증 앱",
      "account.method.backup_codes": "백업 코드",
      "account.method.email_code": "이메일 코드",
      "account.action.sign_in": "로그인",
      "account.action.submit": "로그인",
      "account.action.create": "계정 만들기",
      "account.action.register": "계정 만들기",
      "account.action.sign_in_discord": "Discord로 로그인",
      "account.action.register_discord": "Discord로 가입",
      "account.action.link_discord": "Discord 연결",
      "account.action.unlink_discord": "Discord 연결 해제",
      "account.action.remove_password": "비밀번호 제거",
      "account.action.sign_in_passkey": "패스키로 로그인",
      "account.login.or": "또는",
      "account.action.register_passkey": "패스키로 가입",
      "account.action.add_passkey": "패스키 추가",
      "account.action.remove_passkey": "패스키 제거",
      "account.action.add_security_key": "보안 키 추가",
      "account.action.use_security_key": "보안 키 사용",
      "account.action.remove_security_key": "보안 키 제거",
      "account.action.rename_passkey": "이름 변경",
      "account.passkey.default_name": "패스키",
      "account.passkey.rename_prompt": "이 패스키의 새 이름을 입력하세요(1~80자).",
      "account.passkey.name_invalid": "처음과 끝에 공백 없이 1~80자를 사용하세요.",
      "account.passkey.name_saved": "패스키 이름을 저장했습니다.",
      "account.passkey.name_failed": "패스키 이름을 저장할 수 없습니다.",
      "account.passkey.name_conflict": "이 패스키 이름이 다른 곳에서 변경되었습니다. 최신 이름을 표시합니다.",
      "account.passkey.identifier_help": "일반적으로 기기의 패스키 안내에서 계정을 선택할 수 있습니다.",
      "account.action.save_profile": "계정 정보 저장",
      "account.action.change_password": "비밀번호 변경",
      "account.action.continue": "계속",
      "account.action.need_account": "계정이 없나요? 가입하기",
      "account.action.register_manually": "직접 계정 만들기",
      "account.action.have_account": "이미 가입했나요? 로그인",
      "account.action.sign_out": "로그아웃",
      "account.action.sign_in_again": "다시 로그인",
      "account.action.cancel": "취소",
      "account.action.back": "계정으로 돌아가기",
      "account.action.back_to_sign_in": "로그인으로 돌아가기",
      "account.action.forgot_password": "비밀번호를 잊으셨나요?",
      "account.action.recover": "계정 복구",
      "account.action.verify": "인증",
      "account.action.verify_email": "복구 이메일 인증",
      "account.action.send_code": "코드 보내기",
      "account.action.resend_code": "새 코드 보내기",
      "account.action.send_recovery_code": "복구 코드 보내기",
      "account.action.send_verification_code": "인증 코드 보내기",
      "account.action.enable_authenticator": "인증 후 활성화",
      "account.action.remove_authenticator": "인증 앱 제거",
      "account.action.show_backup_codes": "백업 코드 보기",
      "account.action.regenerate_backup_codes": "새 백업 코드 생성",
      "account.action.remove_backup_codes": "백업 코드 제거",
      "account.action.confirm_backup_codes": "이 코드를 저장했습니다",
      "account.confirm.remove_passkey": "이 패스키를 제거할까요?",
      "account.confirm.remove_password": "이 계정에서 비밀번호 로그인을 제거할까요?",
      "account.confirm.unlink_discord": "이 계정에서 Discord 로그인의 연결을 해제할까요?",
      "account.confirm.remove_security_key": "2단계 인증 방법에서 이 보안 키를 제거할까요?",
      "account.confirm.remove_authenticator": "이 계정에서 인증 앱을 제거할까요?",
      "account.confirm.regenerate_backup_codes": "새 백업 코드를 생성할까요? 현재 백업 코드는 더 이상 사용할 수 없습니다.",
      "account.confirm.remove_backup_codes": "이 계정의 모든 백업 코드를 제거할까요?",
      "account.confirm.revoke_sessions": "다른 모든 활성 세션에서 로그아웃할까요?",
      "account.error.title": "계정 접근 문제",
      "account.error.connection_title": "계정 연결 확인 필요",
      "account.error.connection_conflict": "이 로그인 방법은 이미 다른 계정에 연결되어 있습니다. 연결을 변경하려면 먼저 해당 계정으로 로그인하세요.",
      "account.error.login_expired": "로그인이 만료되었습니다. 계속하려면 다시 로그인하세요.",
      "account.error.flow_expired": "보안 양식이 만료되었습니다. 새 양식을 확인한 후 다시 제출하세요.",
      "account.error.sign_out": "로그아웃을 완료하지 못했습니다.",
      "account.reauthentication.complete": "로그인이 갱신되었고 변경 사항이 완료되었습니다.",
      "account.error.unsupported": "이 로그인 페이지에는 현재 FishyStuff 버전이 안전하게 표시할 수 없는 컨트롤이 포함되어 있습니다.",
      "account.message.continue": "이 계정 단계를 마치려면 계속하세요.",
      "account.message.request_failed": "요청을 완료하지 못했습니다. 입력 내용을 확인한 후 다시 시도하세요.",
      "account.error.last_sign_in_method": "현재 유일한 로그인 방법입니다. 제거하기 전에 다른 로그인 방법을 추가하세요.",
      "account.passkey.loading": "패스키 지원 불러오는 중…",
      "account.passkey.cancelled": "패스키 요청이 완료되지 않았습니다.",
      "account.passkey.unavailable": "패스키 지원을 사용할 수 없습니다.",
      "account.passkey.device_unavailable": "이 기기에서는 FishyStuff 패스키를 만들 수 없습니다. 지원되는 비밀번호 관리자와 화면 잠금이 설정된 기기에서 다시 시도하세요.",
      "account.webauthn.default_name": "보안 키",
      "account.webauthn.loading": "보안 키 지원 불러오는 중…",
      "account.webauthn.cancelled": "보안 키 요청이 완료되지 않았습니다.",
      "account.webauthn.unavailable": "보안 키 지원을 사용할 수 없습니다.",
      "account.webauthn.device_unavailable": "이 기기에서는 FishyStuff 보안 키를 만들 수 없습니다. 다른 브라우저, 기기 생체 인증 또는 하드웨어 보안 키로 다시 시도하세요.",
      "account.navigation": "계정 접근",
      "account.totp.qr_alt": "인증 앱 설정 QR 코드",
      "account.totp.qr_help": "인증 앱으로 이 코드를 스캔한 후 아래에 생성된 코드를 입력하세요.",
      "account.totp.manual_help": "QR 코드를 스캔할 수 없나요? 이 설정 키를 직접 입력하세요:",
      "account.backup_codes.save_notice": "이 코드를 안전한 곳에 보관하세요. 인증 앱을 사용할 수 없을 때 아직 사용하지 않은 코드를 각각 한 번씩 사용할 수 있습니다.",
      "account.backup_codes.used": "사용한 코드",
      "account.email.title": "이메일 주소",
      "account.email.address": "이메일 주소",
      "account.email.verified": "인증됨",
      "account.email.unverified": "인증되지 않음",
      "account.action.add_display_name": "표시 이름 추가",
      "account.action.remove_display_name": "표시 이름 삭제",
      "account.action.add_email": "이메일 추가",
      "account.action.remove_email": "이메일 삭제",
      "account.session.standard": "이 세션은 일반 로그인을 사용했습니다.",
      "account.session.two_step": "이 세션은 2단계 인증을 완료했습니다.",
      "account.sessions.title": "로그인된 다른 세션",
      "account.sessions.tab": "세션",
      "account.sessions.none": "다른 활성 세션이 없습니다.",
      "account.sessions.unavailable": "지금은 다른 세션을 불러올 수 없습니다. 프로필 및 로그아웃 기능은 계속 사용할 수 있습니다.",
      "account.sessions.unsupported": "이 버전에서는 다른 세션을 안전하게 표시할 수 없습니다.",
      "account.sessions.item": "로그인된 세션",
      "account.sessions.signed_in": "로그인",
      "account.sessions.expires": "만료",
      "account.sessions.revoke": "세션에서 로그아웃",
      "account.sessions.revoke_all": "다른 모든 세션에서 로그아웃",
      "account.sessions.revoking": "선택한 세션에서 로그아웃하는 중…",
      "account.sessions.revoking_all": "다른 모든 세션에서 로그아웃하는 중…",
      "account.sessions.revoke_failed": "해당 세션에서 로그아웃하지 못했습니다. 다시 시도하세요.",
      "account.deletion.title": "계정 삭제",
      "account.deletion.warning": "계정 삭제는 취소할 수 없습니다. FishyStuff 계정과 계정에서 접근할 수 있는 동기화된 비공개 기록이 삭제되고 모든 기기에서 로그아웃됩니다.",
      "account.deletion.retention": "서버의 계정 데이터와 동기화된 비공개 기록은 삭제됩니다. 삭제 과정에서 병합된 최소 컨텍스트 낚시 통계는 정해진 삭제 기한 없이 유지되며 개인정보 처리방침에 설명된 대로 공유되거나 공개될 수 있습니다. FishyStuff는 계정과 기여를 연결하는 정보를 보관하지 않지만, 외부 정보와 결합하면 연관성이 드러날 수 있습니다. 기기에 저장된 데이터는 삭제되지 않습니다. 백업, 임시 삭제 기록, 보안 로그 및 법적 기록은 개인정보 처리방침에 명시된 보관 기간을 따릅니다.",
      "account.deletion.confirm_prompt": "확인하려면 이 핸들을 정확히 입력하세요:",
      "account.deletion.action": "계정 삭제",
      "account.deletion.pending": "계정을 삭제하는 중…",
      "account.deletion.accepted_title": "계정 삭제가 시작되었습니다",
      "account.deletion.accepted_detail": "계정 데이터가 잠겼으며 정리가 계속 진행 중입니다. 삭제가 완료되면 모든 기기에서 로그아웃됩니다.",
      "account.deletion.retryable": "계정 삭제를 완료하지 못했습니다. 다시 시도하세요.",
      "account.deletion.identity_changed": "계정을 다시 확인했습니다. 삭제하기 전에 현재 핸들을 확인하세요.",
      "account.deletion.reauthenticate": "보안을 위해 계정을 삭제하기 전에 다시 로그인하세요.",
      "account.deletion.reauthenticate_action": "다시 로그인",
      "account.deletion.complete_title": "계정이 삭제되었습니다",
      "account.deletion.complete_detail": "FishyStuff 계정과 계정에서 접근할 수 있는 동기화된 비공개 기록이 삭제되었습니다. 모든 기기에서 로그아웃되었습니다.",
      "account.deletion.complete_local": "이 브라우저나 다른 기기의 브라우저 로컬 및 오프라인 데이터는 삭제되지 않았습니다.",
      "account.privacy.title": "개인정보 및 데이터",
      "account.privacy.detail": "선택적 진단 정보 공유와 Discord 프로필 이미지를 검토하세요.",
      "desktop.privacy.title": "Desktop / Dataset Contribution privacy notice",
      "desktop.privacy.detail": "Read this separate notice before downloading Desktop or connecting synchronization. It explains local capture, private synchronization, and dataset contribution. This is information, not consent; opening or saving it does not activate contribution.",
      "desktop.privacy.access": "The complete English and German notice is available online to signed-in, eligible account holders before participation. Current Terms acceptance is not required to read or download it.",
      "desktop.privacy.contact": "Former participants, closed accounts, or no access: request this information or exercise privacy rights by email. No sign-up, payment, or Terms acceptance is required:",
      "desktop.privacy.before_download": "Before installing: read the Desktop / Dataset Contribution privacy notice (information, not consent).",
      "account.privacy.no_active_consent": "활성 동의 없음",
      "account.privacy.clear_declined": "거부한 선택 지우기",
      "account.browser.title": "이 브라우저",
      "account.browser.detail": "이 기기에만 저장된 데이터를 관리합니다. 이 작업은 동기화된 계정 데이터를 삭제하지 않습니다.",
      "account.browser.local_detail": "로그아웃 상태의 작성자 프로필, 로컬 화면 및 언어 선택, 공유 브라우저 인터페이스 설정을 지웁니다.",
      "account.browser.clear_profile": "로컬 프로필 지우기",
      "account.browser.reset_appearance": "로컬 화면 설정 초기화",
      "account.browser.reset_interface": "브라우저 인터페이스 초기화",
      "account.browser.cache_detail": "북마크, 지도 설정 또는 기타 저장 데이터를 제거하지 않고 다시 만들 수 있는 FishyStuff 지도 런타임 파일을 지웁니다.",
      "account.browser.clear_cache": "런타임 캐시 지우기",
      "account.browser.delete_detail": "이 브라우저에서 저장된 모든 사용자 상태를 삭제합니다. 동기화된 계정 데이터와 열린 지도 탭의 세션 상태는 삭제되지 않습니다.",
      "account.browser.delete_all": "브라우저 데이터 삭제",
      "appearance.domain_colors.title": "팔레트 출처",
      "appearance.domain_colors.detail": "출처 기반 레이블에 게임 색상 또는 현재 테마 색상을 사용할지 선택합니다.",
      "appearance.domain_colors.game.label": "게임 색상 사용",
      "appearance.domain_colors.game.detail": "아이템 등급, 생활 기술 등급, 일반 상태 색상에 게임 팔레트를 사용합니다.",
      "appearance.domain_colors.game_grades.label": "테마 색상을 사용하되 등급은 게임 색상 사용",
      "appearance.domain_colors.game_grades.detail": "상태 색상은 테마를 따르고 아이템 및 생활 기술 등급은 게임 색상을 유지합니다.",
      "appearance.domain_colors.theme.label": "테마 색상 사용",
      "appearance.domain_colors.theme.detail": "아이템 등급과 생활 기술 등급 모두 현재 테마를 따릅니다.",
      "profile.role.profile": "프로필",
      "profile.role.member": "회원",
      "profile.provider.account": "계정",
      "profile.actor.guest_name": "낚시꾼 {$id}",
      "profile.actor.provider_profile": "{$provider} 프로필",
      "profile.actor.provider_user": "{$provider} 사용자",
      "profile.local_profile.label": "브라우저 {$id}",
      "profile.session.label": "세션 {$id}",
      "profile.telemetry.status.on": "켜짐",
      "profile.telemetry.status.off": "꺼짐",
      "profile.telemetry.preference.requested_on": "켜기 요청됨",
      "profile.telemetry.preference.stored_off": "꺼짐 저장됨",
      "profile.telemetry.preference.unavailable": "사용할 수 없음",
      "profile.telemetry.preference.always_on": "항상 켜짐",
      "profile.telemetry.preference.always_off": "항상 꺼짐",
      "profile.telemetry.preference.using_default": "기본값 사용",
      "profile.telemetry.detail.unavailable": "텔레메트리를 사용할 수 없습니다.",
      "profile.telemetry.detail.enabled": "텔레메트리가 켜져 있습니다.",
      "profile.telemetry.detail.disabled": "텔레메트리가 꺼져 있습니다.",
      "profile.telemetry.detail.off": "텔레메트리가 꺼져 있습니다.",
      "profile.diagnostic_reports.status.manual": "수동",
      "profile.diagnostic_reports.detail.manual": "보고서는 수동으로 공유됩니다.",
      "profile.data_scope.profile_data": "프로필 데이터",
      "profile.data_scope.profile_ui": "프로필 UI",
      "profile.data_scope.browser_data": "브라우저 데이터",
      "profile.data_scope.browser_ui": "브라우저 UI",
      "profile.data_scope.map_data": "지도 데이터",
      "profile.data_scope.map_ui": "지도 UI",
      "profile.data_scope.dex_data": "도감 데이터",
      "profile.data_scope.dex_ui": "도감 UI",
      "profile.data_scope.calculator_data": "계산기 데이터",
      "profile.data_scope.calculator_ui": "계산기 UI",
      "profile.data_scope.presets_data": "저장된 프리셋",
      "profile.data_scope.overrides_data": "오버라이드 데이터",
      "profile.data_scope.tutorial_progress": "튜토리얼 진행 상황",
      "profile.data_scope.all": "모든 로컬 데이터",
      "health.menu.open": "상태 메뉴 열기",
      "health.menu.title": "페이지 상태",
      "health.menu.send_report": "보고서 보내기",
      "health.menu.dismiss_all": "모두 숨기기",
      "health.menu.show_status": "상태 메뉴 표시",
      "health.menu.show_warnings": "상태 경고 표시",
      "health.menu.visible_when_warnings": "경고가 있을 때 표시됩니다",
      "health.menu.visible_for_errors": "오류가 활성화된 동안 표시됩니다",
      "health.menu.hidden_in_settings": "설정에서 숨김",
      "health.telemetry.detail.export_failed": "마지막 수동 보고서를 전송할 수 없습니다.",
      "health.telemetry.detail.ready": "수동 보고서를 전송할 수 있습니다.",
      "health.telemetry.detail.missing_logs_exporter": "수동 보고서 전송이 설정되지 않았습니다.",
      "health.telemetry.detail.logs_unavailable": "지금은 수동 보고서를 전송할 수 없습니다.",
      "health.telemetry.detail.disabled_by_runtime_policy": "런타임 정책으로 수동 보고서가 비활성화되어 있습니다.",
      "health.telemetry.detail.uninitialized": "이 페이지에서 수동 보고서 전송이 아직 초기화되지 않았습니다.",
      "health.issue.default_page_title": "페이지 문제",
      "health.issue.active_warning.one": "활성 경고 1개",
      "health.issue.active_warning.many": "활성 경고 {$count}개",
      "health.issue.severity.error": "오류",
      "health.issue.severity.warning": "경고",
      "health.issue.severity.info": "정보",
      "health.issue.dismiss": "숨기기",
      "health.issue.copy_details": "세부 정보 복사",
      "health.issue.copy_success": "오류 세부 정보를 복사했습니다.",
      "health.issue.copy_failure": "이 브라우저에서는 클립보드를 사용할 수 없습니다.",
      "health.console_error.title": "콘솔 오류",
      "health.resource_error.title": "리소스 로드 오류",
      "health.runtime_error.title": "페이지 스크립트 오류",
      "health.unhandled_rejection.title": "처리되지 않은 페이지 오류",
      "health.report.summary.warnings": "페이지 상태 경고 {$count}개",
      "health.report.failure.delivery": "수동 보고서를 전송할 수 없습니다.",
      "health.report.failure.telemetry_off": "이 페이지에서는 수동 보고서를 전송할 수 없습니다.",
      "health.report.failure.logs_unavailable": "지금은 수동 보고서를 전송할 수 없습니다.",
      "health.report.failure.telemetry_unavailable": "지금은 수동 보고서를 전송할 수 없습니다.",
      "health.report.success.sent": "진단 보고서를 보냈습니다.",
      "health.report.send_title": "선택한 문제와 설명 미리 보기",
      "health.report.preview_title": "이 진단 보고서 검토",
      "health.report.preview_notice": "“이 보고서 보내기”를 선택하면 아래에 정확히 표시된 JSON만 전송됩니다.",
      "health.report.preview_cancel": "취소",
      "health.report.preview_confirm": "이 보고서 보내기",
      "common.provenance.label.default": "출처",
      "common.provenance.channel.presence": "존재",
      "common.provenance.channel.rate": "확률",
      "common.provenance.source.database": "데이터베이스",
      "common.provenance.source.ranking": "랭킹",
      "common.provenance.source.ranking_ring": "랭킹 링",
      "common.provenance.source.community": "커뮤니티",
      "common.provenance.source.community_guess": "커뮤니티 추정",
      "common.provenance.source.community_support": "커뮤니티 지원",
      "common.provenance.source.derived": "계산됨",
      "common.provenance.source.overlay": "개인 오버레이",
      "common.provenance.source.overlay_short": "오버레이",
      "common.provenance.source.mixed_support": "혼합 지원",
      "common.provenance.source.mixed_sources": "혼합 소스",
      "common.provenance.source.full_ring": "전체 링",
      "common.provenance.source.partial_ring": "부분 링",
      "common.provenance.source.unspecified": "지정되지 않음",
      "common.provenance.source.detail": "세부 정보",
      "common.provenance.detail.database_rate": "데이터베이스 기반 확률입니다.",
      "common.provenance.detail.database_rate_value": "데이터베이스 기반 확률입니다. 현재 값: {$value}.",
      "common.provenance.detail.database_presence": "데이터베이스 기반 존재 정보입니다.",
      "common.provenance.detail.ranking_presence": "관측된 플레이어 위치의 랭킹 링 중첩 지원입니다.",
      "common.provenance.detail.ranking_rate": "랭킹에서 파생된 출처입니다.",
      "common.provenance.detail.community_rate": "커뮤니티가 관리하는 추정 확률입니다.",
      "common.provenance.detail.community_presence": "커뮤니티가 관리하는 존재 지원입니다.",
      "common.provenance.detail.derived_rate": "계산된 확률입니다.",
      "common.provenance.detail.derived_rate_value": "계산된 확률입니다. 현재 값: {$value}.",
      "common.provenance.detail.derived_presence": "계산된 존재 지원입니다.",
      "common.provenance.detail.overlay": "개인 오버레이 제안입니다.",
      "common.provenance.detail.overlay_rate_value": "개인 오버레이 제안입니다. 현재 값: {$value}.",
      "common.provenance.detail.mixed_presence": "여러 존재 출처가 이 행을 지원합니다.",
      "common.provenance.detail.mixed": "여러 출처가 이 행을 지원합니다.",
      "common.provenance.detail.missing": "{$channel} 출처가 아직 기록되지 않았습니다.",
      "domain.entity.fish": "물고기",
      "domain.entity.fish_id": "물고기 {$id}",
      "domain.entity.item": "아이템",
      "domain.entity.item_id": "아이템 {$id}",
      "domain.entity.zone": "지역",
      "domain.entity.map": "지도",
      "domain.taxonomy.grade": "등급",
      "domain.taxonomy.method": "방법",
      "domain.method.rod": "낚싯대",
      "domain.method.hotspot": "핫스팟",
      "domain.method.harpoon": "작살",
      "domain.method.fishing": "낚시",
      "domain.source.zone": "구역",
      "domain.source.hotspot": "핫스팟",
      "domain.source.ice_fishing": "얼음 낚시",
      "domain.grade.prize": "보물",
      "domain.grade.red": "빨간색",
      "domain.grade.yellow": "노란색",
      "domain.grade.blue": "파란색",
      "domain.grade.green": "녹색",
      "domain.grade.white": "흰색",
      "domain.grade.unknown": "알 수 없음",
      "domain.loot_group.prize": "Prize",
      "domain.loot_group.rare": "Rare",
      "domain.loot_group.high_quality": "High-Quality",
      "domain.loot_group.general": "General",
      "domain.loot_group.trash": "Trash",
      "domain.loot_group.unassigned": "Unassigned",
      "common.rate_basis.normalized.description": "고정 지분과 가중치를 계산한 뒤 최종 배정된 백분율입니다.",
      "common.rate_basis.denormalized.description": "동일한 원시 가중치를 10,000으로 나누어 %로 표시한 값입니다.",
      "common.rate_basis.raw_weight.description": "고정 지분 이후 남은 확률을 나누는 0 이상의 상대 입력값입니다.",
      "by": "By",
      "by_lower": "by",
      "last_updated": "Last updated",
      "originally_posted": "Originally posted",
      "updated": "Updated",
      "minutes_read_suffix": "min read",
      "minutes_read_abbrev": "min",
      "language.menu.label": "언어",
      "language.menu.content": "콘텐츠 언어",
      "language.menu.locale": "UI 언어",
      "language.menu.api": "데이터 언어",
      "language.menu.service_region": "게임 서비스 지역",
      "language.menu.content_help": "번역이 있으면 가이드 같은 페이지 콘텐츠를 바꿉니다.",
      "language.menu.locale_help": "메뉴, 버튼, 컨트롤 같은 UI 라벨을 바꿉니다.",
      "language.menu.api_help": "아이템, 지역, 노드 이름 같은 게임 데이터 텍스트를 바꿉니다.",
      "language.menu.service_region_help": "지역별 데이터와 기본값에 사용할 게임 서비스 지역을 정합니다.",
      "language.option.auto.locale": "콘텐츠 언어 따르기",
      "language.option.follow_content.api": "콘텐츠 언어 따르기",
      "language.option.region_default.api": "지역 기본 데이터 언어 사용",
      "language.option.content.en-US": "English",
      "language.option.content.de-DE": "Deutsch",
      "language.option.locale.en-US": "English (en-US)",
      "language.option.locale.de-DE": "Deutsch (de-DE)",
      "language.option.locale.ko-KR": "한국어 (ko-KR)",
      "language.option.api.en": "English (en)",
      "language.option.api.de": "Deutsch (de)",
      "language.option.api.es": "Español (es)",
      "language.option.api.fr": "Français (fr)",
      "language.option.api.id": "Bahasa Indonesia (id)",
      "language.option.api.jp": "日本語 (jp)",
      "language.option.api.kr": "한국어 (kr)",
      "language.option.api.pt": "Português (pt)",
      "language.option.api.ru": "Русский (ru)",
      "language.option.api.sp": "Español (sp)",
      "language.option.api.th": "ไทย (th)",
      "language.option.api.tr": "Türkçe (tr)",
      "language.option.api.tr_en": "English (tr_en)",
      "language.option.api.tw": "繁體中文 (tw)",
      "language.option.service_region.na": "북미 (NA)",
      "language.option.service_region.eu": "유럽 (EU)",
      "language.option.service_region.mena": "중동/북아프리카 (MENA)",
      "language.option.service_region.ru": "러시아 (RU)",
      "language.option.service_region.asia": "아시아 (TH/SEA) (ASIA)",
      "language.option.service_region.jp": "일본 (JP)",
      "language.option.service_region.sa": "남미 (SA)",
      "language.option.service_region.kr": "한국 (KR)",
      "language.option.service_region.tw": "대만 (TW)",
      "language.option.service_region.gt": "Global Lab (GT)",
      "language.option.service_region.ceu": "콘솔 유럽 (CEU)",
      "language.option.service_region.cna": "콘솔 북미 (CNA)",
      "language.option.service_region.cas": "콘솔 아시아 (CAS)",
      "translation_notice.title": "Translation help wanted",
      "translation_notice.body": "This page has not been translated yet. You are currently viewing the English source content.",
      "translation_notice.help": "Want to help?",
      "translation_notice.community_link": "Community page",
      "translation_notice.target_path_label": "Target file:",
      "account.privacy.optional_features": "외부 기능 동의",
      "account.privacy.optional_features_detail": "외부 기능은 각 목적을 허용하기 전까지 꺼져 있습니다. 언제든지 동의를 철회할 수 있습니다.",
      "account.privacy.telemetry_consent": "선택적 원격 분석",
      "account.privacy.telemetry_consent_detail": "제한된 기술 오류, 추적 및 성능 측정값을 FishyStuff에 전송합니다.",
      "account.privacy.telemetry_account_only": "선택적 원격 분석 설정은 로그인한 동안에만 사용할 수 있습니다.",
      "account.privacy.discord_images": "Discord 프로필 이미지",
      "account.privacy.discord_images_detail": "선택한 프로필 이미지를 Discord CDN에서 직접 불러옵니다. Discord에 IP 주소와 요청 정보가 전달됩니다.",
      "account.privacy.settings": "개인정보 설정",
      "account.privacy.settings_detail": "설정과 동의는 별개입니다. 필요한 동의가 활성화되지 않으면 데이터가 전송되지 않습니다.",
      "consent.title": "선택 기능",
      "consent.detail": "이 기능 없이도 FishyStuff를 사용할 수 있습니다. 허용할 외부 기능을 선택하세요.",
      "consent.dismiss": "나중에 결정",
      "consent.open": "Privacy choices",
      "consent.telemetry.title": "선택적 원격 분석",
      "consent.telemetry.detail": "제한된 기술 오류, 추적 및 성능 측정값을 FishyStuff에 전송합니다.",
      "consent.telemetry.granted": "현재 원격 분석 안내에 따라 허용되었습니다.",
      "consent.telemetry.denied": "허용되지 않았습니다.",
      "consent.telemetry.unset": "아직 결정하지 않았습니다. 원격 분석은 꺼진 상태입니다.",
      "consent.telemetry.selection_approved": "전송 승인됨",
      "consent.telemetry.selection_not_approved": "전송 승인 안 됨",
      "consent.discord_images.title": "Discord 프로필 이미지",
      "consent.discord_images.detail": "선택한 프로필 이미지를 Discord CDN에서 직접 불러옵니다.",
      "consent.discord_images.granted": "Discord에서 호스팅하는 프로필 이미지를 불러올 수 있습니다.",
      "consent.discord_images.denied": "Discord에서 호스팅하는 이미지는 차단됩니다.",
      "consent.discord_images.unset": "아직 결정하지 않았습니다. Discord 이미지는 차단됩니다.",
      "consent.settings": "개인정보 설정",
      "consent.keep_off": "선택 기능 끄기",
      "consent.save": "선택 항목 허용",
      "consent.save_failed": "개인정보 선택을 저장할 수 없습니다. 다시 시도하세요.",
      "participation.title": "Participation",
      "participation.activity": "Activity",
      "participation.download": "Get Desktop",
      "participation.refresh": "Refresh status",
      "participation.review": "Review participation",
      "participation.signed_out": "Sign in to manage your installations. Local tracking does not require participation.",
      "participation.loading": "Loading participation status…",
      "participation.unavailable": "Participation status is unavailable. No change has been confirmed.",
      "participation.intro": "Manage each installation separately. Stopping contribution stops future delivery; it does not erase existing data or replace a privacy-rights request.",
      "participation.no_installations": "No installations are registered for this account. In Desktop, choose “Review synchronization and contribution” to review retained history and future uploads. Visiting this page enables nothing.",
      "participation.active": "Authorized",
      "participation.disabled": "Stopped",
      "participation.review_required": "Review required",
      "participation.revocation_pending": "New authorization is disabled. Broker revocation is still pending; do not assume existing connections have stopped.",
      "participation.revocation_complete": "Broker revocation confirmed.",
      "participation.prepare_again": "Prepare a fresh review in this Desktop installation before enabling contribution.",
      "participation.retry_stop": "Retry broker revocation",
      "participation.stop": "Stop contributing",
      "participation.account": "Account",
      "participation.installation": "Installation",
      "participation.retained_history": "Retained history prepared by this installation",
      "participation.fact_count": "Pending facts",
      "participation.fact_kinds": "Fact kinds",
      "participation.source_range": "Available source timestamp range (nanoseconds)",
      "participation.names": "Identity names in retained facts",
      "participation.gaps": "Recorded history gaps",
      "participation.yes": "Yes",
      "participation.no": "No",
      "participation.none": "None",
      "participation.unknown": "Unavailable",
      "participation.full_notice": "Read the complete Desktop and Dataset Contribution Privacy Notice",
      "participation.keep_local": "Keep data local",
      "participation.enable": "Enable synchronization and contribute",
      "participation.saving": "Applying participation change…",
      "participation.uncertain": "Could not confirm this change. Refresh status before trying again; do not assume contribution has stopped.",
      "participation.enable_unavailable": "Enabling requires current Terms acceptance and Desktop eligibility. You can still stop an existing registration here.",
      "participation.no_installations_unavailable": "No installations are registered for this account. Enabling participation requires current Terms acceptance and Desktop eligibility.",
      "desktop.privacy.reader.open": "Read privacy notice",
      "desktop.privacy.reader.title": "Desktop and Dataset Contribution Privacy Notice",
      "desktop.privacy.reader.loading": "Loading the privacy notice…",
      "desktop.privacy.reader.ready": "Privacy notice loaded.",
      "desktop.privacy.reader.signed_out": "Sign in with an eligible account to read this notice here, or request a copy by email below.",
      "desktop.privacy.reader.denied": "This account cannot read the notice online. You can request the relevant notice by email below.",
      "desktop.privacy.reader.error": "The privacy notice could not be loaded. Try again, or request a copy by email below.",
      "desktop.privacy.reader.sign_in": "Sign in",
      "desktop.privacy.reader.retry": "Try again",
      "desktop.privacy.reader.javascript": "Enable JavaScript to read the notice here, or request a copy by email below.",
      "desktop.privacy.reader.downloads": "Privacy notice downloads",
      "page_outline.open": "Open table of contents",
      "page_outline.title": "On this page",
      "page_outline.close": "Close table of contents",
      "desktop.privacy.reader.rss": "RSS updates",
      "desktop.privacy.reader.text": "Download .txt",
      "desktop.privacy.reader.request_title": "Need a copy without account access?",
      "desktop.privacy.reader.request_detail": "Former participants and anyone whose data may be affected can request the relevant current notice and information about earlier processing. No registration, renewed eligibility, payment, or acceptance of new Terms is required.",
      "contest.title": "이번 주 낚시 대회",
      "contest.query_title": "주간 낚시 대회",
      "contest.explanation": "선택한 지역의 이번 주 대회 물고기를 커뮤니티와 함께 찾아보세요. 물고기를 제안하고 등급마다 한 종류에 찬성표를 주거나, 원한다면 다른 제안에 반대표를 줄 수 있습니다. 활성화된 엄지 버튼을 다시 누르면 해당 표를 철회합니다. 로그인 상태에서는 계정별로, 로그아웃 상태에서는 IP 주소별로 집계되므로 같은 IP를 쓰는 사람들은 표를 공유합니다.",
      "contest.loading": "이번 주 커뮤니티 제보를 불러오는 중…",
      "contest.unavailable": "대회 제보를 불러올 수 없습니다.",
      "contest.period": "기간: { $start } ~ { $end } · 00:00 UTC",
      "contest.prize": "보물",
      "contest.rare": "희귀",
      "contest.highQuality": "높은 품질",
      "contest.no_leader": "단독 선두 없음",
      "contest.contribute": "커뮤니티 제보 및 참여",
      "contest.voting": "투표",
      "contest.vote": "투표",
      "contest.view_results_vote": "결과 보기 및 투표",
      "contest.close": "닫기",
      "contest.slot_loading": "불러오는 중…",
      "contest.slot_unavailable": "이용 불가",
      "contest.no_candidates": "아직 이 등급에 제안된 물고기가 없습니다.",
      "contest.leader": "잠정 득표 선두",
      "contest.vote_name": "{ $name }에 찬성 · 찬성 { $count }표",
      "contest.retract_name": "{ $name }에 대한 내 찬성표 철회 · 찬성 { $count }표",
      "contest.downvote_name": "{ $name }에 반대 · 반대 { $count }표",
      "contest.retract_downvote_name": "{ $name }에 대한 내 반대표 철회 · 반대 { $count }표",
      "contest.net_support": "순지지: { $count }",
      "contest.net_support_help": "순지지는 찬성표에서 반대표를 뺀 값입니다.",
      "contest.vote_retracted": "찬성표가 철회되었습니다.",
      "contest.downvote_retracted": "반대표가 철회되었습니다.",
      "contest.choose": "물고기 선택",
      "contest.add_candidate": "물고기 제안 및 찬성",
      "contest.search": "물고기 검색",
      "contest.saving": "참여 내용을 보내는 중…",
      "contest.voted": "찬성표가 기록되었습니다.",
      "contest.downvoted": "반대표가 기록되었습니다.",
      "contest.conflict": "참여 상태, 확인 내용 또는 주가 변경되었습니다. 참여 내용을 재전송하지 않았습니다.",
      "contest.forbidden": "이 참여는 허용되지 않았습니다. 계정 투표에는 최신 이용약관 동의가 필요하며, 확인에는 현재 운영진 권한도 필요합니다. 재전송하지 않았습니다.",
      "contest.uncertain": "참여 결과를 확인할 수 없습니다. 참여 내용을 재전송하지 않았습니다.",
      "contest.week_changed": "새로운 대회 주가 시작되었습니다. 지난주 물고기를 지웠습니다.",
      "contest.moderator_confirmed": "확인됨",
      "contest.confirm_fish": "물고기 확인",
      "contest.confirm_fish_name": "{ $name } 확인 검토",
      "contest.replace_confirmation": "확인 대상 교체",
      "contest.replace_confirmation_name": "확인 대상을 { $name }(으)로 교체할지 검토",
      "contest.review_confirmation": "운영진 확인 검토",
      "contest.review_replacement": "확인 대상 교체 검토",
      "contest.confirmation_help": "이 등급·지역·주에 제안된 물고기 한 종류를 확인합니다. 기존 확인 대상을 교체하며 다른 물고기의 순지지가 더 높아도 대회 필터에 적용됩니다. 투표는 변경하지 않으며 공식 대상을 인증하는 것은 아닙니다.",
      "contest.previous_confirmation": "현재 확인된 물고기: { $name }",
      "contest.cancel_confirmation": "취소",
      "contest.save_confirmation": "이번 주 대상으로 확인",
      "contest.save_replacement": "확인된 물고기 교체",
      "contest.confirmation_saved": "운영진이 확인한 물고기가 변경되었습니다.",
      "fishydex.progress.panel": "Progress",
      "fishydex.progress.aria.catalog": "Catalog completion: {$caught} of {$total} fish caught ({$percent}%)",
      "fishydex.progress.aria.grade": "{$grade} completion: {$caught} of {$total} fish caught ({$percent}%)",
      "fishydex.progress.kicker": "Overall",
      "fishydex.progress.title": "Catalog Completion",
      "fishydex.progress.remaining": "{$count} remaining",
      "fishydex.progress.empty": "No catalog entries yet",
      "fishydex.progress.empty_grade": "No catalog fish",
      "fishydex.presets.preview.caught": "잡은 물고기 {$count}",
      "fishydex.presets.preview.favourite": "즐겨찾기 {$count}",
      "fishydex.presets.preview.tracked": "기록 {$count}",
      "fishydex.presets.change.dried_visibility": "건조 어류 표시",
      "fishydex.presets.change.caught_fish": "잡은 물고기",
      "fishydex.presets.change.favourite_fish": "즐겨찾기 물고기",
      "fishydex.presets.change.not_favourite": "즐겨찾기 아님",
      "fishydex.presets.change.shown": "표시",
      "fishydex.presets.change.hidden": "숨김",
      "fishydex.presets.change.enabled": "활성화",
      "fishydex.presets.change.disabled": "비활성화",
      "fishydex.presets.change.none": "없음",
      "fishydex.presets.change.fish_guide": "물고기 도감",
      "fishydex.filter.panel": "Filter",
      "fishydex.filter.expand": "Expand filter panel",
      "fishydex.filter.collapse": "Collapse filter panel",
      "fishydex.filter.search.sr": "Search fish",
      "fishydex.filter.search.placeholder": "Search by fish name or ID",
      "fishydex.filter.status.legend": "Status",
      "fishydex.filter.status.group": "Status filters",
      "fishydex.filter.status.all": "All",
      "fishydex.filter.status.caught": "Caught",
      "fishydex.filter.status.missing": "Missing",
      "fishydex.filter.status.favourite": "Favourite",
      "fishydex.filter.grade.group": "Grade color filters",
      "fishydex.filter.grade.red_help": "빨간색 등급 — 일반적으로 Prize 그룹에서 발견됩니다",
      "fishydex.filter.grade.yellow_help": "노란색 등급 — 일반적으로 Rare 그룹에서 발견됩니다",
      "fishydex.filter.grade.blue_help": "파란색 등급 — 일반적으로 High-Quality 그룹에서 발견됩니다",
      "fishydex.filter.grade.green_help": "녹색 등급 — 일반적으로 General 그룹에서 발견됩니다",
      "fishydex.filter.grade.white_help": "흰색 등급 — 일반적인 낚시 그룹 연관성이 문서화되어 있지 않습니다",
      "fishydex.filter.method.group": "낚시 방식 필터 및 건조 어류 표시",
      "fishydex.filter.method.show_dried": "말린 물고기 포함",
      "fishydex.filter.matches": "Showing {$visible}/{$total} matches",
      "fishydex.filter.clear": "Clear filters",
      "fishydex.filter.status_label": "Status:",
      "fishydex.catalog.panel": "Catalog",
      "fishydex.catalog.controls": "Catalog controls",
      "fishydex.catalog.view": "Catalog view",
      "fishydex.catalog.view.guide": "Fish Guide",
      "fishydex.catalog.sort": "Catalog sort controls",
      "fishydex.catalog.sort.price": "Price",
      "fishydex.catalog.sort.name": "Name",
      "fishydex.catalog.sort.current": "Toggle {$field} sort direction. Current: {$direction}.",
      "fishydex.catalog.sort.default": "Sort catalog by {$field} ascending.",
      "fishydex.catalog.sort.direction.asc": "ascending",
      "fishydex.catalog.sort.direction.desc": "descending",
      "fishydex.details.open": "Open details for {$name}",
      "fishydex.details.favourite_toggle": "Mark fish as favourite",
      "fishydex.details.caught_toggle": "Mark fish as caught",
      "fishydex.details.favourite": "Favourite",
      "fishydex.details.caught": "Caught",
      "fishydex.details.not_caught": "Not Caught",
      "fishydex.details.unknown": "Unknown",
      "fishydex.details.dried": "Dried",
      "fishydex.details.close": "Close fish details",
      "fishydex.details.item_key": "Item Key",
      "fishydex.details.vendor_price": "Vendor Price",
      "fishydex.details.catch_count": "포획 횟수",
      "fishydex.details.tabs.label": "물고기 상세 정보",
      "fishydex.details.tabs.info": "정보",
      "fishydex.details.tabs.zones": "구역",
      "fishydex.details.tabs.titles": "칭호",
      "fishydex.details.view_on_map": "지도에서 보기: {$name}",
      "fishydex.details.description_unavailable": "선택한 데이터 언어로 제공되는 공식 설명이 없습니다.",
      "fishydex.details.zones.heading": "낚시 구역",
      "fishydex.page.context": "{$name} is a {$grade}-grade Black Desert fish worth {$price}. {$locations}.",
      "fishydex.page.silver": "Silver",
      "fishydex.page.locations.first_group": "It belongs to the {$groups} group in {$zones}",
      "fishydex.page.locations.additional_group": "the {$groups} group in {$zones}",
      "fishydex.page.locations.first_groups": "It belongs to the {$groups} groups in {$zones}",
      "fishydex.page.locations.additional_groups": "the {$groups} groups in {$zones}",
      "fishydex.page.locations.first_unknown": "It appears in {$zones}",
      "fishydex.page.locations.additional_unknown": "also appears in {$zones}",
      "fishydex.page.locations.none": "No known fishing zone is currently listed",
      "fishydex.page.locations.known_one": "1 additional known zone",
      "fishydex.page.locations.known_many": "{$count} additional known zones",
      "fishydex.page.locations.potential_one": "1 additional potential zone",
      "fishydex.page.locations.potential_many": "{$count} additional potential zones",
      "fishydex.page.locations.explore": "See {$locations} on FishyStuff",
      "fishydex.index.title": "Fish Location Index",
      "fishydex.index.description": "Browse individual fish pages with in-game descriptions and known or potential fishing zones.",
      "fishydex.index.summary": "Browse {$count} fish",
      "fishydex.details.zones.loading": "낚시 구역을 불러오는 중…",
      "fishydex.details.zones.error": "낚시 구역을 불러올 수 없습니다.",
      "fishydex.details.zones.empty": "현재 이 물고기의 알려진 또는 가능한 낚시 구역이 없습니다.",
      "fishydex.details.zones.tab_known": "알려진 낚시 구역",
      "fishydex.details.zones.tab_potential": "가능한 낚시 구역",
      "fishydex.details.zones.known_intro": "알려진 낚시 구역은 검토된 기준 데이터 또는 유지 관리되는 커뮤니티 지정을 바탕으로 합니다.",
      "fishydex.details.zones.potential_intro": "가능한 낚시 구역은 기록된 플레이어 랭킹 관측을 바탕으로 자동 제안되며 추가 검토가 필요합니다.",
      "fishydex.details.zones.explainer_summary": "랭킹 근거의 공간 귀속 방식",
      "fishydex.details.zones.ranking_context": "랭킹 관측에는 물고기, 시각, 플레이어 위치가 기록되며 물고기의 정확한 포획 위치는 기록되지 않습니다. FishyStuff는 해당 위치를 중심으로 반경 500 게임 단위의 불확실성 링을 현재 낚시 구역 지도와 대조합니다.",
      "fishydex.details.zones.fully_contained_label": "완전히 포함됨",
      "fishydex.details.zones.fully_contained_explanation": "현재 지도에서 불확실성 링 전체가 하나의 낚시 구역 안에 있습니다. 더 강한 공간적 근거이지만 자동으로 알려진 구역으로 확정되지는 않습니다. 랭킹 근거만으로는 낚시 그룹을 확인할 수 없고 구역 경계도 검토가 필요할 수 있습니다.",
      "fishydex.details.zones.partial_overlap_label": "일부 겹침",
      "fishydex.details.zones.partial_overlap_explanation": "링이 구역 경계를 넘어 두 개 이상의 낚시 구역에 닿습니다. 정확한 구역 귀속이 불명확하므로 닿은 각 구역에는 더 약한 존재 근거가 부여됩니다.",
      "fishydex.details.zones.ranking_limit": "이 수치는 포획률이나 드롭률이 아니라 존재 근거를 나타냅니다.",
      "fishydex.details.zones.unknown_zone": "알 수 없는 구역",
      "fishydex.details.zones.ranking_fully_contained": "완전히 포함된 랭킹 링 ×{$count}",
      "fishydex.details.zones.ranking_partial_overlap": "일부 겹치는 랭킹 링 ×{$count}",
      "fishydex.details.zones.baseline_group": "기준 데이터 {$group}",
      "fishydex.details.zones.maintained_group": "관리 데이터 {$group}",
      "fishydex.empty.title": "No fish match this filter.",
      "fishydex.empty.filtered": "Try a broader search or clear some filters.",
      "fishydex.empty.unfiltered": "The fish catalog is empty.",
      "fishydex.group.count": "{$count} entries",
      "fishydex.group.guide.freshwater": "Freshwater Fish",
      "fishydex.group.guide.saltwater": "Saltwater Fish",
      "fishydex.group.guide.crustacean": "Crustacean",
      "fishydex.group.guide.other": "Other",
      "fishydex.group.guide.unknown": "Unmapped",
      "fishydex.details.icon_alt": "{$name} icon",
      "fishydex.details.guide_alt": "{$name} guide image",
      "fishydex.guide.catch_count": "낚은 횟수: {$count}",
      "fishydex.guide.catch_count_short": "{$count}x",
      "fishydex.state.unavailable": "Unavailable",
      "fishydex.state.not_applicable": "해당 없음",
      "fishydex.state.local_storage_unavailable": "localStorage is unavailable; progress is not persisted.",
      "fishydex.state.corrupt_filters": "Reset corrupted local fishydex filters.",
      "fishydex.state.corrupt_progress": "Reset corrupted local fishydex progress.",
      "fishydex.state.corrupt_favourites": "Reset corrupted local fishydex favourites.",
      "fishydex.state.corrupt_fish_guide": "손상된 로컬 물고기 도감 진행도를 초기화했습니다.",
      "fishydex.action.favourite.add": "Add {$name} to favourites",
      "fishydex.action.favourite.remove": "Remove {$name} from favourites",
      "fishydex.action.caught.mark": "{$name} 포획 횟수를 1회로 설정",
      "fishydex.action.caught.unmark": "{$name} 포획 횟수를 0회로 초기화",
      "fishydex.api.zone_evidence_error": "낚시 구역 근거를 불러올 수 없습니다({$message}).",
      "fishydex.api.contract_error": "물고기 API가 지원되지 않는 도감 계약을 반환했습니다({$detail}).",
      "fishydex.api.fish_error": "Fish API request failed.",
      "fishydex.api.fish_error_status": "Fish API request failed (HTTP {$status}).",
      "fishydex.api.retrying": "Fish API request is retrying.",
      "fishydex.api.cors_hint": "If this page is on a different origin than the API, confirm the API CORS allowlist includes this site.",
      "fishydex.api.retry_hint": "The request could not be completed cleanly.",
      "fishydex.titles.include_contest": "대회 칭호 포함",
      "fishydex.titles.include_unobtainable": "획득 불가능한 칭호 포함",
      "fishydex.titles.unobtainable": "획득 불가능",
      "fishydex.titles.catch": "포획 칭호",
      "fishydex.titles.contest": "대회 칭호",
      "fishydex.titles.quest": "의뢰 칭호",
      "fishydex.titles.exchange": "교환 칭호",
      "fishydex.titles.other": "기타 낚시 칭호",
      "fishydex.titles.unknown": "알 수 없음",
      "fishydex.titles.name_unknown": "칭호 {$id}: 이름을 사용할 수 없음",
      "fishydex.titles.description_unknown": "이 데이터 언어의 원문 설명을 사용할 수 없습니다.",
      "fishydex.titles.owned": "칭호 획득",
      "fishydex.titles.not_owned": "칭호 미획득",
      "fishydex.titles.owned_total": "획득한 칭호: {$owned}/{$total}",
      "fishydex.titles.image_progress": "물고기 이미지 테두리의 칭호 진행도",
      "fishydex.titles.current_count": "기록된 포획 횟수: {$count}",
      "fishydex.titles.reference_count": "커뮤니티 참고: {$count}회",
      "fishydex.titles.community_count": "커뮤니티 추정: {$count}회",
      "fishydex.titles.requirement_unknown": "필요한 포획 횟수 알 수 없음",
      "fishydex.titles.reference_source": "커뮤니티 참고 출처",
      "fishydex.titles.manual_count": "포획 횟수",
      "fishydex.titles.save_error": "진행도를 저장하지 못했습니다. 확인된 진행도가 표시됩니다. 다시 시도하세요.",
      "fishydex.titles.state_unavailable": "지금은 진행도를 수정할 수 없습니다. 현재 진행도 상태를 먼저 확인하세요.",
      "fishydex.titles.loading": "낚시 칭호 불러오는 중…",
      "fishydex.titles.catalog_error": "이 데이터 언어로 낚시 칭호를 불러오지 못했습니다. 새로고침해 다시 시도하세요. 저장된 진행도는 바뀌지 않습니다.",
      "fishydex.titles.no_titles": "현재 이 물고기와 연결된 낚시 칭호가 없습니다.",
      "fishydex.titles.reports": "커뮤니티 획득 보고 {$count}건, 평균 {$average}회. 정확한 획득 조건을 뜻하지 않습니다.",
      "fishydex.titles.no_reports": "아직 획득 보고가 없습니다.",
      "fishydex.titles.report_heading": "획득 보고 기여하기",
      "fishydex.titles.report_help": "로그인 후 칭호 획득 당시의 포획 횟수를 보고하세요. 보고 수와 평균만 공개됩니다. 계정과 칭호당 한 건이며 다시 제출하면 기존 보고를 대체합니다. 개인 진행도 저장으로 보고가 자동 제출되지는 않습니다.",
      "fishydex.titles.report_count": "획득 당시 포획 횟수",
      "fishydex.titles.report_date": "획득 날짜 (선택 사항)",
      "fishydex.titles.report_submit": "획득 보고 제출",
      "fishydex.titles.report_sending": "보고 전송 중…",
      "fishydex.titles.report_saved": "획득 보고가 저장되었습니다. 공개 평균은 다음 카탈로그 로드 시 갱신됩니다.",
      "fishydex.titles.report_sign_in": "획득 보고를 제출하려면 로그인하세요. 개인 진행도는 바뀌지 않습니다.",
      "fishydex.titles.report_error": "획득 보고를 저장하지 못했습니다. 다시 시도하세요.",
      "fishydex.titles.provenance": "근거",
      "fishydex.titles.used_requirement": "현재 요구 횟수",
      "fishydex.titles.community_evidence": "커뮤니티 제보",
      "fishydex.titles.estimate_difference": "평균과 현재 요구 횟수의 차이",
      "fishydex.titles.difference_value": "{$count}회",
      "fishydex.titles.estimate_used": "참조 요구 횟수가 없어 반올림한 커뮤니티 평균을 사용합니다.",
      "fishydex.titles.evidence_limits": "근거의 한계",
      "fishydex.titles.no_distribution": "제보 수와 평균만 제공됩니다. 분포와 불확실성은 판단할 수 없습니다.",
      "fishydex.titles.required_catches": "{$count} 회",
      "fishydex.titles.estimated_catches": "≈ {$count} 회",
      "fishydex.titles.table_caption": "낚시 칭호",
      "fishydex.titles.title_column": "칭호",
      "fishydex.titles.requirement_column": "요구 조건",
      "fishydex.titles.mark_obtained": "획득으로 표시",
      "fishydex.titles.description_column": "설명",
      "fishydex.titles.condition_unknown": "조건 정보 없음",
      "fishydex.titles.tab_memory_error": "이 브라우저 세션에 선택한 탭을 저장할 수 없습니다.",
      "fishydex.titles.mark_not_obtained": "미획득으로 표시",
      "fishydex.query.label": "Filter fish",
      "fishydex.query.placeholder": "Search fish, titles… or zone:\"Velia\" AND missing",
      "fishydex.query.unavailable": "Search data is unavailable or belongs to a different source revision. Reload after the catalog is updated.",
      "fishydex.query.loading": "Loading search data…",
      "fishydex.query.term.missing-titles": "Missing titles",
      "fishydex.query.term.caught": "Caught",
      "fishydex.query.term.missing": "Not caught",
      "fishydex.query.term.favourite": "Favourite",
      "fishydex.query.term.red": "Red grade",
      "fishydex.query.term.yellow": "Yellow grade",
      "fishydex.query.term.blue": "Blue grade",
      "fishydex.query.term.green": "Green grade",
      "fishydex.query.term.white": "White grade",
      "fishydex.query.term.rod": "Rod",
      "fishydex.query.term.hotspot": "Hotspot",
      "fishydex.query.term.harpoon": "Harpoon",
      "fishydex.query.term.dried": "Dried fish",
      "fishydex.query.field.fish": "Fish name",
      "fishydex.query.field.title": "Title name",
      "fishydex.query.field.zone": "Known fishing zone",
      "fishydex.query.field.potential-zone": "Potential fishing zone",
      "fishydex.query.state.empty": "No query is applied.",
      "fishydex.query.state.applied": "Current text is applied.",
      "fishydex.query.state.partial": "Only the valid prefix is applied; remaining text is not.",
      "fishydex.query.state.invalid": "No query is applied. Check the filter name, quotes and parentheses.",
      "fishydex.query.updating": "Updating the query…",
      "fishydex.query.composing": "Finish composition to update the query.",
      "fishydex.query.field.status": "Status",
      "fishydex.query.field.grade": "Grade",
      "fishydex.query.field.method": "Fishing method",
      "fishydex.query.field.dried": "Dried fish",
      "fishydex.titles.completion": "칭호 완성도",
      "fishydex.titles.empty_grade": "칭호 없음",
      "fishydex.details.navigation.label": "물고기 탐색",
      "fishydex.details.navigation.previous": "이전 물고기",
      "fishydex.details.navigation.next": "다음 물고기",
      "fishydex.filter.include_non_fish": "물고기가 아닌 아이템 포함",
      "fishydex.catalog.kind.item": "물고기가 아닌 아이템",
      "fishydex.page.context_item": "{$name} is a {$grade}-grade Black Desert item worth {$price}. {$locations}.",
      "fishydex.catalog.display_options": "표시 옵션",
      "fishydex.catalog.sort.label": "정렬 기준",
      "fishydex.catalog.view.simple": "간단히",
      "fishydex.group.all": "모든 아이템",
      "frontpage.hero.title": "낚시를 시작하는 데 필요한 모든 것",
      "frontpage.guides.title": "가이드",
      "frontpage.guides.body": "낚시를 배우는 데 도움이 되는 커뮤니티 작성 가이드입니다.",
      "frontpage.guides.cta": "가이드 열기",
      "frontpage.map.title": "지도",
      "frontpage.map.body": "낚시 구역, 전리품 표, 핫스팟과 기록된 어획을 살펴보고 낚시할 곳을 찾아보세요.",
      "frontpage.map.cta": "지도 열기",
      "frontpage.dex.title": "도감",
      "frontpage.dex.body_intro": "모두 잡아보세요",
      "frontpage.dex.body_detail": "물고기를 살펴보고 수집 진행 상황을 추적하세요.",
      "frontpage.dex.cta": "도감 보기",
      "map.toolbar.map_windows": "지도 창",
      "map.toolbar.bookmarks": "북마크",
      "map.toolbar.settings": "설정",
      "map.toolbar.info": "정보",
      "map.toolbar.layers": "레이어",
      "map.tutorial.window_title": "도움말 및 튜토리얼",
      "map.tutorial.about_title": "Black Desert 인터랙티브 낚시 지도",
      "map.tutorial.about_body": "FishyStuff의 대화형 BDO 낚시 지도에서 물고기를 찾고, 낚시 지역과 전리품 표를 확인하고, 핫스팟을 비교하고, 기록된 포획 근거를 살펴보세요.",
      "map.tutorial.provenance_body": "FishyStuff는 커뮤니티가 관리하는 Black Desert Online 프로젝트입니다. 지도 정보에는 출처와 근거 맥락이 유지되므로 확인할 수 없거나 불확실한 정보가 확정된 사실처럼 표시되지 않습니다.",
      "map.tutorial.catalog_title": "대화형 튜토리얼",
      "map.tutorial.group.beginner": "초급",
      "map.tutorial.group.beginner_summary": "지도의 필수 쿼리, 창, 레이어 조작법을 배웁니다.",
      "map.tutorial.group.intermediate": "중급",
      "map.tutorial.group.intermediate_summary": "위치를 저장하고 재사용할 수 있는 지도 작업 공간을 구성합니다.",
      "map.tutorial.group.advanced": "고급",
      "map.tutorial.group.advanced_summary": "근거를 확인하고 지리 레이어, 클리핑 관계, 구조화된 쿼리를 함께 사용합니다.",
      "map.tutorial.start": "시작",
      "map.tutorial.continue": "계속",
      "map.tutorial.exit": "튜토리얼 종료",
      "map.tutorial.complete": "완료",
      "map.tutorial.hide": "튜토리얼 숨기기",
      "map.tutorial.proceed": "계속",
      "map.tutorial.task_completed": "완료",
      "map.tutorial.unavailable_title": "튜토리얼을 사용할 수 없음",
      "map.tutorial.unavailable_body": "이 튜토리얼은 현재 지도 안내에 포함되어 있지 않습니다.",
      "map.tutorial.query_basics.title": "쿼리 시스템 사용하기",
      "map.tutorial.query_basics.summary": "Pink Dolphin과 Sea Bunny를 찾은 다음 포획 그룹, 물고기 가격, 그룹 내 확률을 읽어 봅니다.",
      "map.tutorial.query_basics.step1.title": "Pink Dolphin 찾기",
      "map.tutorial.query_basics.step1.body": "{ $query }에 “Pink”를 입력하세요. 이름을 모두 입력하기 전에 { $pink_dolphin }으로 해석되면 멈추세요.",
      "map.tutorial.query_basics.step2.title": "Pink Dolphin 확인하기",
      "map.tutorial.query_basics.step2.body": "강조된 쿼리 항목은 { $pink_dolphin }입니다. 전체 이름을 입력해도 자동으로 계속됩니다.",
      "map.tutorial.query_basics.step3.title": "쿼리 지우기",
      "map.tutorial.query_basics.step3.body": "지우기 버튼으로 { $pink_dolphin }을 지우거나 { $query }의 텍스트를 삭제하세요.",
      "map.tutorial.query_basics.step4.title": "Sea Bunny 찾기",
      "map.tutorial.query_basics.step4.body": "{ $sea_bunny }를 검색하고 일치하는 결과를 적용하세요. 이제 지도에 이 물고기의 낚시 근거가 표시됩니다.",
      "map.tutorial.query_basics.step5.title": "결과를 다시 화면에 표시하기",
      "map.tutorial.query_basics.step5.body": "원한다면 결과에서 멀어지도록 지도를 이동하거나 확대·축소하세요. 쿼리의 { $focus_query }으로 Sea Bunny 결과를 다시 화면에 표시하세요.",
      "map.tutorial.query_basics.step6.title": "포획 프로필 불러오기",
      "map.tutorial.query_basics.step6.body": "아무 낚시 지역의 열린 물을 클릭하세요. { $details }에 포획 프로필이 나타날 때까지 기다리세요. Sea Bunny가 없는 지역도 괜찮습니다.",
      "map.tutorial.query_basics.step7.title": "포획 그룹",
      "map.tutorial.query_basics.step7.body": "필요한 경우 { $details }에서 { $zone_tab } 탭을 선택하세요. 포획 그룹은 Prize나 Rare처럼 같은 전리품 범주의 물고기를 모읍니다. { $group_share }은 전체 프로필 중 이 그룹의 비율입니다.",
      "map.tutorial.query_basics.step8.title": "물고기와 기본 가격",
      "map.tutorial.query_basics.step8.body": "등급 색상의 아이콘과 이름으로 물고기를 식별하며, { $base_price }은 상점 기본 가격입니다.",
      "map.tutorial.query_basics.step9.title": "그룹 내 확률",
      "map.tutorial.query_basics.step9.body": "{ $within_group_rate }은 전체 프로필이 아니라 이 그룹 안에서 물고기가 차지하는 비율이며 백분율 또는 가중치로 표시될 수 있습니다.",
      "map.tutorial.window_basics.title": "창 시스템 사용하기",
      "map.tutorial.window_basics.summary": "튜토리얼을 숨겼다가 다시 열고, 창을 열고 닫고 접고 이동합니다.",
      "map.tutorial.window_basics.step1.title": "이 튜토리얼 숨기고 다시 찾기",
      "map.tutorial.window_basics.step1.body": "아래의 “튜토리얼 숨기기”를 선택하세요. 물음표 버튼으로 도움말 및 튜토리얼을 다시 열고 여기에서 계속을 선택하세요.",
      "map.tutorial.window_basics.step2.title": "쿼리 닫고 다시 열기",
      "map.tutorial.window_basics.step2.body": "도구 모음의 { $query } 버튼으로 쿼리 창을 닫은 다음 같은 버튼으로 다시 여세요.",
      "map.tutorial.window_basics.step2.open_first": "{ $query }가 이미 닫혀 있습니다. 먼저 연 뒤, 닫고 다시 열어 전체 과정을 완료하세요.",
      "map.tutorial.window_basics.step2.reopen": "{ $query }가 닫혀 있습니다. 같은 도구 모음 버튼으로 다시 여세요.",
      "map.tutorial.window_basics.step3.title": "레이어 접고 펼치기",
      "map.tutorial.window_basics.step3.body": "{ $layers } 제목 표시줄을 클릭해 창을 접은 다음, 제목 표시줄을 다시 클릭해 펼치세요.",
      "map.tutorial.window_basics.step3.expand_first": "{ $layers }가 이미 접혀 있습니다. 먼저 펼친 뒤 다시 접고 펼쳐 전체 과정을 완료하세요.",
      "map.tutorial.window_basics.step3.expand": "{ $layers }가 접혀 있습니다. 제목 표시줄을 다시 클릭해 펼치세요.",
      "map.tutorial.window_basics.step4.title": "창 이동하기",
      "map.tutorial.window_basics.step4.body": "{ $layers } 제목 표시줄을 드래그해 창을 이동하세요.",
      "map.tutorial.layer_basics.title": "레이어 시스템 사용하기",
      "map.tutorial.layer_basics.summary": "핫스팟을 표시하고 전용 상세 정보 탭까지 확인한 다음 복잡해진 레이어를 다시 숨깁니다.",
      "map.tutorial.layer_basics.step1.title": "핫스팟 표시하기",
      "map.tutorial.layer_basics.step1.body": "필요한 경우 { $layers }를 열고 { $hotspots }을 켜세요.",
      "map.tutorial.layer_basics.step1.resume": "{ $hotspots }이 숨겨져 있습니다. 레이어를 다시 켜 비교를 완료하세요.",
      "map.tutorial.layer_basics.step1.query_filtered": "{ $hotspots }이 켜져 있지만 현재 { $query }가 모든 핫스팟을 숨기고 있습니다. 검색어를 지워 표시하세요.",
      "map.tutorial.layer_basics.step2.title": "핫스팟 확인하기",
      "map.tutorial.layer_basics.step2.body": "지도에서 보이는 { $hotspots } 마커 하나를 선택하세요. 상세 정보가 선택한 랜드마크를 핫스팟으로 표시해야 합니다.",
      "map.tutorial.layer_basics.step2.not_hotspot": "다른 랜드마크입니다. 지도에 보이는 { $hotspots } 마커를 선택하세요.",
      "map.tutorial.layer_basics.step3.title": "핫스팟 상세 정보 열기",
      "map.tutorial.layer_basics.step3.body": "{ $details }에서 { $hotspot_tab } 탭을 선택하세요. 포획 수, 입질 시간, 유지 시간, 전리품, 모델 미리보기를 확인하세요.",
      "map.tutorial.layer_basics.step4.title": "핫스팟 다시 숨기기",
      "map.tutorial.layer_basics.step4.body": "{ $hotspot_tab }을 확인한 뒤 { $hotspots }을 끄세요. 필요할 때 유용하지만 지도는 복잡해집니다.",
      "map.tutorial.catch_profile_provenance.title": "포획 프로필의 출처 근거 이해하기",
      "map.tutorial.catch_profile_provenance.summary": "물고기의 존재와 확률을 뒷받침하는 서로 다른 근거를 비교합니다.",
      "map.tutorial.catch_profile_provenance.step1.title": "포획 프로필 불러오기",
      "map.tutorial.catch_profile_provenance.step1.body": "아무 낚시 지역의 열린 물을 클릭하세요. { $details }의 첫 번째 물고기에서 Presence와 Rate 근거를 비교하세요.",
      "map.tutorial.catch_profile_provenance.step2.title": "존재 근거 확인하기",
      "map.tutorial.catch_profile_provenance.step2.body": "첫 번째 물고기의 { $presence_provenance } 표시를 여세요. 여기에서 잡히는 이유를 설명하며 빈도는 뜻하지 않습니다. 출처, 상태, 조건, 날짜, 관측 횟수를 확인하세요. 색상은 근거 유형을 요약합니다.",
      "map.tutorial.catch_profile_provenance.step3.title": "확률 근거 확인하기",
      "map.tutorial.catch_profile_provenance.step3.body": "같은 물고기의 { $rate_provenance } 표시를 여세요. Presence와 별도로 Rate를 뒷받침합니다. 값(% 또는 가중치), 조건, 상태, 출처를 확인하세요. 초록색은 알려진 값, 파란색은 데이터베이스 기반, 노란색은 불확실함을 뜻합니다.",
      "map.tutorial.bookmarks.title": "낚시 위치 저장 및 공유하기",
      "map.tutorial.bookmarks.summary": "북마크를 배치하고 확인한 뒤 GameVariables.xml의 WorldmapBookMark XML을 주고받습니다.",
      "map.tutorial.bookmarks.step1.title": "북마크 배치하기",
      "map.tutorial.bookmarks.step1.body": "북마크를 열고 새 북마크를 선택한 다음 저장할 낚시 위치를 선택하세요.",
      "map.tutorial.bookmarks.step2.title": "북마크로 돌아가기",
      "map.tutorial.bookmarks.step2.body": "방금 만든 북마크를 활성화하여 해당 월드 지점으로 돌아가고 같은 상세 정보를 확인하세요.",
      "map.tutorial.bookmarks.step3.title": "상세 정보에서 좌표 복사하기",
      "map.tutorial.bookmarks.step3.body": "{ $details }에서 { $territory_tab } 탭을 선택해 현재 랜드마크의 월드 좌표를 확인하세요. 그런 다음 상세 정보 제목 표시줄의 랜드마크 유형 버튼(예: 북마크)을 클릭해 해당 좌표를 북마크 XML로 복사하세요.",
      "map.tutorial.bookmarks.step4.title": "북마크 XML 복사 또는 내보내기",
      "map.tutorial.bookmarks.step4.body": "북마크를 선택하고 복사 또는 내보내기를 사용하세요. Black Desert를 종료하고 { $game_variables }을 백업한 뒤 { $worldmap_bookmark }을 내보낸 XML로 교체하고 다시 시작하세요.",
      "map.tutorial.bookmarks.step5.title": "게임에서 북마크 가져오기",
      "map.tutorial.bookmarks.step5.body": "로컬 게임 북마크를 사이트로 가져오려면 { $game_variables }에서 { $worldmap_bookmark } 블록을 복사해 붙여넣기를 선택하거나, 블록을 XML로 저장하고 가져오기를 선택하세요.",
      "map.tutorial.layer_settings.title": "레이어 설정 사용하기",
      "map.tutorial.layer_settings.summary": "물고기 근거 설정을 펼치고 불투명도를 변경한 뒤 설정을 닫습니다.",
      "map.tutorial.layer_settings.step1.title": "물고기 근거 설정 열기",
      "map.tutorial.layer_settings.step1.body": "{ $layers }에서 { $fish_evidence } 행을 클릭해 설정을 펼치세요. 처음부터 펼쳐져 있었다면 한 번 닫았다가 다시 여세요.",
      "map.tutorial.layer_settings.step1.resume": "{ $fish_evidence } 설정이 닫혀 있습니다. 행을 다시 열어 과정을 완료하세요.",
      "map.tutorial.layer_settings.step2.title": "레이어 불투명도 변경하기",
      "map.tutorial.layer_settings.step2.body": "{ $fish_evidence } 불투명도 슬라이더를 움직여 레이어를 숨기지 않고 근거 오버레이가 변하는 모습을 확인하세요.",
      "map.tutorial.layer_settings.step3.title": "설정 닫기",
      "map.tutorial.layer_settings.step3.body": "작업을 마치면 { $fish_evidence } 행을 다시 클릭해 설정을 접으세요.",
      "map.tutorial.map_presets.title": "지도 프리셋 만들기",
      "map.tutorial.map_presets.summary": "현재 지도 설정을 복제하고 저장된 프리셋에 알아보기 쉬운 이름을 붙입니다.",
      "map.tutorial.map_presets.step1.title": "지도 프리셋 열기",
      "map.tutorial.map_presets.step1.body": "설정을 연 다음 지도 프리셋을 선택하세요. 프리셋은 지도 레이어, 쿼리, 보기, 창 배치를 재사용 가능한 사본으로 보관합니다.",
      "map.tutorial.map_presets.step2.title": "현재 설정 복제하기",
      "map.tutorial.map_presets.step2.body": "복제를 선택해 현재 선택된 설정으로 나만의 저장 프리셋을 만드세요.",
      "map.tutorial.map_presets.step3.title": "유용한 이름 붙이기",
      "map.tutorial.map_presets.step3.body": "복제된 프리셋 제목을 알아보기 쉬운 이름으로 바꾼 뒤 Enter를 누르거나 제목 입력란을 벗어나 저장하세요.",
      "map.tutorial.regions.title": "지역 호버 정보 사용하기",
      "map.tutorial.regions.summary": "출신과 자원 호버 정보를 켠 뒤 필드 위에 마우스를 올려, 두 레이어를 표시하지 않고도 비교합니다.",
      "map.tutorial.regions.step1.title": "출신 켜기",
      "map.tutorial.regions.step1.body": "{ $regions } 설정을 열고 호버를 선택한 다음 { $origin }을 켜세요. 이미 켜져 있다면 한 번 껐다가 다시 켜세요. 레이어가 숨겨져 있어도 이 정보는 계속 표시할 수 있습니다.",
      "map.tutorial.regions.step2.title": "자원 켜기",
      "map.tutorial.regions.step2.body": "{ $region_groups } 설정을 열고 호버를 선택한 다음 { $resources }을 켜세요. 이미 켜져 있다면 한 번 껐다가 다시 켜세요. 레이어가 숨겨져 있어도 이 정보는 계속 표시할 수 있습니다.",
      "map.tutorial.regions.step3.title": "필드 위에 마우스 올리기",
      "map.tutorial.regions.step3.body": "지도 필드 위에 마우스를 올려 { $origin }과 { $resources }이 함께 나타나게 하세요. 지역과 지역 그룹 레이어는 표시되어 있지 않아도 됩니다.",
      "map.tutorial.clipping.title": "한 레이어를 다른 레이어로 클리핑하기",
      "map.tutorial.clipping.summary": "지역을 지역 마스크에서 분리한 뒤 레이어 놓기 대상으로 다시 연결합니다.",
      "map.tutorial.clipping.step1.title": "지역을 지역 마스크에서 분리하기",
      "map.tutorial.clipping.step1.body": "{ $layers }에서 { $regions } 행을 다른 행의 가장자리로 드래그해 삽입선이 나타나면 놓으세요. 현재 { $zone_mask } 클리핑 관계가 제거됩니다.",
      "map.tutorial.clipping.step1.detached": "{ $regions }이 이미 분리되어 있습니다. 먼저 { $zone_mask } 중앙에 놓아 연결한 뒤, 다시 행 가장자리로 드래그해 직접 분리 작업을 수행하세요.",
      "map.tutorial.clipping.step2.title": "지역을 지역 마스크에 연결하기",
      "map.tutorial.clipping.step2.body": "행에 연결 대상이 나타날 때까지 { $regions }을 { $zone_mask } 중앙으로 드래그한 뒤 놓으세요. 지역이 클리핑 마스크 아래에 들여쓰기됩니다.",
      "map.tutorial.advanced_queries.title": "컨테이너 쿼리 사용하기",
      "map.tutorial.advanced_queries.summary": "같은 지역이나 핫스팟 안에서 한 물고기가 모두 일치하는 경우와 서로 다른 물고기가 각각 일치하는 경우를 비교합니다.",
      "map.tutorial.advanced_queries.step1.title": "한 물고기가 두 조건을 모두 충족하게 하기",
      "map.tutorial.advanced_queries.step1.body": "{ $same_fish_query }를 입력하세요. 등급과 수집 상태는 { $explicit_same_fish_query }처럼 하나의 물고기 컨테이너를 공유합니다. 물고기 하나가 붉은 등급이면서 FishyDex에 없어야 지역이나 핫스팟이 일치합니다.",
      "map.tutorial.advanced_queries.step2.title": "같은 물고기 결과 화면에 맞추기",
      "map.tutorial.advanced_queries.step2.body": "쿼리 옆의 목표 버튼으로 결과를 화면에 맞추세요. 물고기 하나가 두 조건을 충족할 때 어떤 지역이 남는지 확인하세요.",
      "map.tutorial.advanced_queries.step3.title": "서로 다른 두 물고기의 일치 허용하기",
      "map.tutorial.advanced_queries.step3.body": "{ $separate_fish_query }로 바꾸세요. 각 대괄호가 별도의 물고기 컨테이너를 만들므로 하나는 붉고 다른 하나는 없을 수 있습니다. 둘 다 같은 지역이나 핫스팟에 있어야 합니다.",
      "map.tutorial.advanced_queries.step4.title": "서로 다른 물고기 결과 화면에 맞추기",
      "map.tutorial.advanced_queries.step4.body": "목표 버튼을 다시 사용하세요. 이전 보기와 비교하면, 이 컨테이너들은 서로 다른 두 물고기로 붉은 등급과 없음 조건을 충족할 수 있습니다.",
      "map.tutorial.advanced_queries.step5.title": "하나의 공유 컨테이너 확인하기",
      "map.tutorial.advanced_queries.step5.body": "남아 있는 지역의 열린 물을 선택하고 포획 프로필을 확인하세요. 지역을 일치시킨 붉은 물고기와 없는 물고기를 찾으세요. 서로 다른 물고기일 수 있습니다.",
      "map.tutorial.selection.landmark_rejected": "랜드마크, 표본, NPC 또는 핫스팟을 선택했습니다. 대신 낚시 지역의 열린 물을 클릭하세요.",
      "map.tutorial.scroll_down": "레이어 안에서 아래로 스크롤하여 강조된 컨트롤로 이동하세요.",
      "map.tutorial.scroll_up": "레이어 안에서 위로 스크롤하여 강조된 컨트롤로 이동하세요.",
      "map.query.title": "쿼리",
      "map.query.input_label": "지도 쿼리",
      "map.query.clear": "쿼리 지우기",
      "map.query.focus_current": "현재 쿼리에 초점 맞추기",
      "map.query.status_indicator.none": "꺼짐",
      "map.query.status_indicator.applied": "적용됨",
      "map.query.status_indicator.updating": "업데이트 중",
      "map.query.status_indicator.partial": "일부 적용",
      "map.query.status_indicator.invalid": "잘못됨",
      "map.query.status_indicator.failed": "실패",
      "map.query.status.empty": "적용된 쿼리가 없습니다.",
      "map.query.status.applied": "현재 텍스트가 적용되었습니다.",
      "map.query.status.evaluating.active": "현재 텍스트를 확인하는 동안 지도에는 “{$source}” 쿼리가 계속 적용됩니다…",
      "map.query.status.evaluating.empty": "현재 텍스트를 확인하는 동안 적용되는 쿼리가 없습니다…",
      "map.query.status.applying.active": "현재 텍스트를 적용하는 동안 지도에는 “{$source}” 쿼리가 계속 적용됩니다…",
      "map.query.status.applying.empty": "현재 텍스트가 확인될 때까지 적용되는 쿼리가 없습니다…",
      "map.query.status.clearing.active": "“{$source}” 쿼리를 지우는 중입니다…",
      "map.query.status.clearing.empty": "적용된 쿼리가 없음을 확인하는 중입니다…",
      "map.query.status.composing.active": "지도에는 “{$source}” 쿼리가 계속 적용됩니다. 업데이트하려면 조합을 완료하세요.",
      "map.query.status.composing.empty": "적용되는 쿼리가 없습니다. 업데이트하려면 조합을 완료하세요.",
      "map.query.status.partial": "유효한 접두사와 연결된 단위만 적용되며 나머지 텍스트는 적용되지 않습니다.",
      "map.query.status.partial_applying.active": "유효한 접두사를 적용하는 동안 지도에는 “{$source}” 쿼리가 계속 적용됩니다…",
      "map.query.status.partial_applying.empty": "유효한 접두사를 확인하는 동안 적용되는 쿼리가 없습니다…",
      "map.query.status.invalid_clearing.active": "현재 텍스트가 올바르지 않습니다. “{$source}” 쿼리를 지우는 중입니다…",
      "map.query.status.invalid_clearing.empty": "현재 텍스트가 올바르지 않습니다. 적용된 쿼리가 없음을 확인하는 중입니다…",
      "map.query.status.invalid.active": "현재 텍스트가 올바르지 않으며 지도에는 “{$source}” 쿼리가 계속 적용됩니다.",
      "map.query.status.invalid.empty": "현재 텍스트가 올바르지 않으며 적용되는 쿼리가 없습니다.",
      "map.query.status.failed.active": "현재 텍스트를 적용하지 못했습니다. 지도에는 “{$source}” 쿼리가 계속 적용됩니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed.empty": "현재 텍스트를 적용하지 못했으며 확인된 쿼리가 없습니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_prefix.active": "유효한 접두사를 적용하지 못했습니다. 지도에는 “{$source}” 쿼리가 계속 적용됩니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_prefix.empty": "유효한 접두사를 적용하지 못했으며 확인된 쿼리가 없습니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_clearing.active": "“{$source}” 쿼리를 지우지 못했습니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_clearing.empty": "지우기를 확인하지 못했으며 이전에 확인된 쿼리는 없습니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_evaluating.active": "현재 텍스트를 해석하지 못했습니다. 지도에는 “{$source}” 쿼리가 계속 적용됩니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_evaluating.empty": "현재 텍스트를 해석하지 못했으며 확인된 쿼리가 없습니다. Enter를 눌러 다시 시도하세요.",
      "map.query.status.failed_preparing.active": "검색 데이터를 준비하지 못했습니다. 지도에는 “{$source}” 쿼리가 계속 적용됩니다. 새 지도 데이터가 도착하면 다시 시도합니다.",
      "map.query.status.failed_preparing.empty": "검색 데이터를 준비하지 못해 확인된 쿼리가 없습니다. 새 지도 데이터가 도착하면 다시 시도합니다.",
      "map.search.placeholder": "물고기, 지역, 필터 또는 패치 검색",
      "map.search.meaning.applied_query": "적용된 쿼리 의미",
      "map.search.meaning.applied_term": "적용된 검색어",
      "map.search.meaning.exclude": "제외",
      "map.search.meaning.match_all": "모두 일치",
      "map.search.meaning.match_any": "하나 이상 일치",
      "map.search.meaning.container_containing": "다음을 포함하는 컨테이너",
      "map.search.meaning.conjunction.and": "그리고",
      "map.search.meaning.conjunction.or": "또는",
      "map.search.bound.before": "이전",
      "map.search.bound.after": "이후",
      "map.search.patch.choose_date": "날짜 선택",
      "map.search.kind.filter": "필터",
      "map.search.kind.date": "날짜",
      "map.search.kind.status": "상태",
      "map.search.kind.layer": "레이어",
      "map.search.kind.layer_filter": "레이어 필터",
      "map.search.kind.layer_fact": "레이어 정보",
      "map.search.semantic.field": "필드 {$id}",
      "map.search.zone.fallback": "지역 {$zone}",
      "map.search.stinky_fish": "악취 나는 물고기",
      "map.search.triple_float_fishing_rod": "세찌 낚싯대",
      "map.search.quest.fish_for_villagers": "[벨리아 낚시] 주민들에게 선물할 물고기",
      "map.search.quest.special_fishing_rod": "[메디아 낚시] 특수 제작된 낚싯대",
      "map.search.item_group.any": "{$label} (전체)",
      "map.search.item_group.items.one": "항목 1개",
      "map.search.item_group.items.other": "항목 {$count}개",
      "map.search.layer_filter.label": "{$layer} 필터",
      "map.search.layer_group.high_quality": "고품질",
      "map.search.layer_group.prize": "보물",
      "map.search.filter.favourite.label": "즐겨찾기",
      "map.search.filter.favourite.description": "Fishydex에서 하트로 표시한 물고기입니다.",
      "map.search.filter.missing.label": "미획득",
      "map.search.filter.missing.description": "Fishydex에서 잡음으로 표시되지 않은 물고기입니다.",
      "map.search.filter.red.description": "보물 또는 빨간색 등급 물고기와 전리품입니다.",
      "map.search.filter.yellow.description": "희귀 또는 노란색 등급 물고기와 전리품입니다.",
      "map.search.filter.blue.description": "고급 또는 파란색 등급 물고기와 전리품입니다.",
      "map.search.filter.green.description": "일반 또는 초록색 등급 물고기와 전리품입니다.",
      "map.search.filter.white.description": "잡동사니 또는 흰색 등급 물고기와 전리품입니다.",
      "map.search.patch.prompt.after": "이후",
      "map.search.patch.prompt.before": "이전",
      "map.search.patch.prompt.description": "샘플을 제한할 패치 또는 날짜를 선택하세요.",
      "map.overview.zone": "지역",
      "map.overview.rgb": "RGB",
      "map.overview.bite_time": "입질 시간",
      "map.overview.resources": "자원",
      "map.overview.origin": "출처",
      "map.info.window_title": "상세 정보",
      "map.info.status.bookmark": "북마크",
      "map.info.status.waypoint": "웨이포인트",
      "map.info.status.clicked": "클릭한 지점",
      "map.info.status.no_selection": "선택 없음",
      "map.info.provenance": "사실 출처",
      "map.info.tabs": "포인트 레이어 탭",
      "map.info.empty_group": "현재 오버레이에서 이 그룹에 배정된 행이 아직 없습니다.",
      "map.info.empty_zone": "이 지역에서 사용할 수 있는 물고기 행이 아직 없습니다.",
      "map.info.empty_about_title": "검은사막 낚시 지도",
      "map.info.empty_about": "낚시 구역, 전리품 표, 핫스팟, 지역 그룹, 물고기 위치와 기록된 어획을 살펴보세요.",
      "map.info.empty_selection": "월드 포인트의 정보를 보려면 지도를 클릭하거나, 웨이포인트 대상을 사용하거나, 북마크를 선택하세요.",
      "map.info.fish.unknown": "알 수 없는 물고기",
      "map.info.pane.zone": "지역",
      "map.info.pane.landmark": "랜드마크",
      "map.info.pane.territory": "영지",
      "map.info.pane.trade": "무역",
      "map.info.pane.lineage": "계보",
      "map.info.section.zone": "지역",
      "map.info.section.landmark": "랜드마크",
      "map.info.section.territory": "영지",
      "map.info.section.trade": "무역",
      "map.info.section.fish": "물고기",
      "map.info.location.title": "위치",
      "map.info.location.world_coordinates": "월드 좌표",
      "map.info.location.unavailable": "사용할 수 없음",
      "map.info.location.copy_bookmark": "북마크 복사",
      "map.info.location.create_bookmark": "북마크로 저장",
      "map.info.location.bookmark_unavailable": "높이 정보를 사용할 수 없어 이 지점을 북마크로 사용할 수 없습니다.",
      "map.info.lineage.coordinate": "마스크 픽셀 {$x}, {$y}",
      "map.info.lineage.current_rgb": "현재 RGB {$rgb}",
      "map.info.lineage.result_rgb": "결과 RGB {$rgb}",
      "map.info.lineage.known": "알려짐",
      "map.info.lineage.guess": "추정",
      "map.info.lineage.leak": "유출",
      "map.info.lineage.evidence": "근거",
      "map.info.lineage.timestamp_source": "시간 출처",
      "map.info.lineage.source_revision": "소스 리비전 {$revision}",
      "map.info.history.title": "기록",
      "map.info.history.back": "이전 선택으로 돌아가기",
      "map.info.history.go": "{$name}(으)로 돌아가기",
      "map.info.history.previous": "이전 선택: {$name}",
      "map.info.history.next": "다음 선택: {$name}",
      "map.info.history.unknown": "선택",
      "map.info.trade.managers": "무역 관리자",
      "map.info.trade.manager_count": "목적지 무역상 {$count}명",
      "map.info.trade.filter_label": "상인 유형",
      "map.info.trade.filter_all": "전체",
      "map.info.trade.filter_standard": "무역 관리자",
      "map.info.trade.filter_imperial": "황실",
      "map.info.trade.filter_empty": "이 필터와 일치하는 상인이 없습니다.",
      "map.info.trade.multiplier_final": "{$multiplier} 판매",
      "map.info.trade.multiplier_fixed": "{$multiplier} 판매",
      "map.info.trade.multiplier_final_help": "일반 계산기의 기본 무역 설정으로 계산한 최종 판매 배수입니다.",
      "map.info.trade.multiplier_fixed_help": "물고기 고정 판매 배수입니다.",
      "map.info.trade.maximum_bonus_group": "최대 거리 보너스 적용 (150% 이상)",
      "map.info.trade.below_maximum_bonus_group": "최대 거리 보너스 미만 (150% 미만)",
      "map.info.trade.loading": "불러오는 중",
      "map.info.trade.unavailable": "사용할 수 없음",
      "map.info.trade.request_failed": "무역 관리자 요청 실패 ({$status})",
      "map.info.trade.focus_target": "{$name}에 초점 맞추기",
      "map.info.trade.focus_target_generic": "대상에 초점 맞추기",
      "map.info.notice.title": "알림",
      "map.info.zone_loot.title": "획득 프로필",
      "map.info.zone_loot.summary.default": "계산기 기본값",
      "map.info.zone_loot.notice.status_title": "획득 프로필 상태",
      "map.info.zone_loot.profile_tabs": "전리품 표",
      "map.info.zone_loot.status.idle": "지역 전리품: 대기",
      "map.info.zone_loot.status.loading": "지역 전리품: 불러오는 중",
      "map.info.zone_loot.status.loaded": "지역 전리품: 불러옴",
      "map.info.zone_loot.status.error": "지역 전리품: 오류",
      "map.info.zone_loot.status.other": "지역 전리품: {$status}",
      "map.info.zone_loot.unavailable": "지역 전리품 요약을 사용할 수 없습니다.",
      "map.info.zone_loot.condition.previous": "이전 조건",
      "map.info.zone_loot.condition.next": "다음 조건",
      "map.bookmarks.window_title": "북마크",
      "map.bookmarks.new": "새 북마크",
      "map.bookmarks.click_to_place": "배치하려면 지도 클릭",
      "map.bookmarks.select_all": "모두 선택",
      "map.bookmarks.paste": "붙여넣기",
      "map.bookmarks.empty": "아직 북마크가 없습니다.",
      "map.bookmarks.fallback": "북마크 {$index}",
      "map.bookmarks.row_label": "북마크",
      "map.bookmarks.action.drag": "{$label} 드래그",
      "map.bookmarks.action.select": "{$label} 선택",
      "map.bookmarks.action.rename": "북마크 이름 변경",
      "map.bookmarks.action.inspect": "북마크 보기",
      "map.bookmarks.action.copy_xml": "북마크 XML 복사",
      "map.bookmarks.action.delete": "북마크 삭제",
      "map.bookmarks.confirm.delete_selected.one": "선택한 북마크 {$count}개를 삭제할까요?",
      "map.bookmarks.confirm.delete_selected.other": "선택한 북마크 {$count}개를 삭제할까요?",
      "map.bookmarks.confirm.delete_single": "\"{$label}\" 북마크를 삭제할까요?",
      "map.bookmarks.prompt.rename": "북마크 이름 변경",
      "map.bookmarks.toast.select_to_copy": "복사할 북마크를 하나 이상 선택하세요.",
      "map.bookmarks.toast.clipboard_unavailable": "이 브라우저에서는 클립보드를 사용할 수 없습니다.",
      "map.bookmarks.toast.no_export": "아직 내보낼 북마크가 없습니다.",
      "map.bookmarks.toast.export_unavailable": "이 브라우저에서는 북마크 내보내기를 사용할 수 없습니다.",
      "map.bookmarks.toast.import_unavailable": "이 브라우저에서는 북마크 가져오기를 사용할 수 없습니다.",
      "map.bookmarks.toast.import_no_xml": "가져온 텍스트에 북마크 XML이 없습니다.",
      "map.bookmarks.toast.import_failed": "북마크 가져오기에 실패했습니다. 올바른 WorldmapBookMark XML을 사용하세요.",
      "map.bookmarks.toast.copied_single": "북마크 XML을 복사했습니다.",
      "map.bookmarks.toast.created_single": "북마크를 추가했습니다.",
      "map.bookmarks.toast.copy_selection.one": "북마크 {$count}개의 XML을 복사했습니다.",
      "map.bookmarks.toast.copy_selection.other": "북마크 {$count}개의 XML을 복사했습니다.",
      "map.bookmarks.toast.export_selected.one": "선택한 북마크 {$count}개를 내보냈습니다.",
      "map.bookmarks.toast.export_selected.other": "선택한 북마크 {$count}개를 내보냈습니다.",
      "map.bookmarks.toast.export_all.one": "북마크 {$count}개를 내보냈습니다.",
      "map.bookmarks.toast.export_all.other": "북마크 {$count}개를 내보냈습니다.",
      "map.bookmarks.toast.import_none": "새 북마크를 가져오지 않았습니다.",
      "map.bookmarks.toast.imported.one": "북마크 {$count}개를 가져왔습니다.",
      "map.bookmarks.toast.imported.other": "북마크 {$count}개를 가져왔습니다.",
      "map.bookmarks.toast.skipped_duplicates.one": "중복 {$count}개를 건너뛰었습니다.",
      "map.bookmarks.toast.skipped_duplicates.other": "중복 {$count}개를 건너뛰었습니다.",
      "map.layers.window_title": "레이어",
      "map.layers.unavailable": "사용할 수 없음",
      "map.layers.loading_registry": "레이어 레지스트리를 불러오는 중...",
      "map.layers.show": "표시",
      "map.layers.hide": "숨기기",
      "map.layers.live_events_unavailable": "실시간 이벤트를 사용하려면 로그인한 계정, 활성화된 낚시 로거, 실시간 캐릭터 데이터가 필요합니다.",
      "map.layers.drag_pinned": "{$name}은(는) 지형 레이어에 고정되어 있습니다",
      "map.layers.drag": "{$name} 드래그",
      "map.layers.settings_show": "{$name} 설정 표시",
      "map.layers.settings_hide": "{$name} 설정 숨기기",
      "map.layers.opacity": "불투명도",
      "map.layers.opacity_for": "{$name} 불투명도",
      "map.layers.confidence": "신뢰도",
      "map.layers.confidence_showcase": "신뢰도 표시",
      "map.layers.lineage_panel": "계보 패널 표시",
      "map.layers.tab.appearance": "모양",
      "map.layers.tab.hover": "호버",
      "map.layers.tab.highlight": "강조",
      "map.layers.tab.waypoints": "웨이포인트",
      "map.layers.highlight.enabled": "활성화",
      "map.layers.highlight.opacity": "불투명도",
      "map.layers.highlight.opacity_for": "{$name} 강조 불투명도",
      "map.layers.highlight.color": "색상",
      "map.layers.highlight.color_for": "{$name} 강조 색상",
      "map.layers.connections": "연결",
      "map.layers.names": "이름",
      "map.layers.categories": "분류",
      "map.layers.icons": "아이콘",
      "map.layers.sample_hover": "샘플 호버",
      "map.layers.hover_facts": "호버 정보",
      "map.layers.table.icon": "아이콘",
      "map.layers.table.name": "이름",
      "map.layers.table.fact": "정보",
      "map.layers.table.show": "표시",
      "map.layers.hover_show": "{$layer}에 호버할 때 {$fact} 표시",
      "map.layers.fish_evidence": "물고기 근거",
      "map.layers.fish_icon_size": "물고기 아이콘 크기",
      "map.layers.fish_icon_size_for": "{$name} 물고기 아이콘 크기",
      "map.layers.clustering": "클러스터링",
      "map.layers.search_kind.zones": "지역",
      "map.hover.extents_confidence": "범위 신뢰도",
      "map.hover.lineage": "계보",
      "map.hover.confidence.known": "확인됨",
      "map.hover.confidence.guess": "추정",
      "map.hover.zone_name": "지역 이름",
      "map.hover.zone": "지역",
      "map.hover.rgb": "RGB",
      "map.hover.world_coordinate_xz": "XZ 좌표",
      "map.hover.world_coordinate": "월드 좌표",
      "map.hover.resources": "자원",
      "map.hover.origin": "출처",
      "map.hover.affiliated_node": "소속 거점",
      "map.hover.details": "상세 정보",
      "map.settings.window_title": "설정",
      "map.settings.ready": "준비됨",
      "map.settings.loading": "불러오는 중",
      "map.settings.actions": "작업",
      "map.settings.reset_view": "보기 초기화",
      "map.settings.reset_ui": "UI 초기화",
      "map.settings.display": "표시",
      "map.settings.auto_adjust_view": "보기 자동 조정",
      "map.settings.three_d_enabled": "3D 활성화",
      "map.settings.loot_rate_display_mode": "전리품 확률 표시",
      "map.settings.loot_rate_display_mode.normalized": "정규화",
      "map.settings.loot_rate_display_mode.denormalized": "역정규화",
      "map.settings.loot_rate_display_mode.raw_weight": "원시 가중치",
      "map.settings.sample_from_filtered_elements": "필터링된 요소에서도 샘플링",
      "map.settings.effects_enabled": "애니메이션/효과",
      "map.settings.focus_waves_enabled": "연속 초점 파동",
      "map.settings.filtering": "필터링",
      "map.settings.filter_active_condition_groups": "활성 조건 그룹만 필터링",
      "map.settings.sorting": "정렬",
      "map.settings.sort_by": "정렬 기준",
      "map.settings.sort_by.calculator": "지도 기본값(가격)",
      "map.settings.sort_by.price": "가격",
      "map.settings.sort_by.grade": "등급",
      "map.settings.sort_by.droprate": "그룹 내 비율",
      "map.settings.sort_by.expected_value": "기대값",
      "map.settings.sort_by.exp": "경험치",
      "map.settings.sort_by.totem_exp": "토템 경험치",
      "map.settings.sort_by.alphabetical": "가나다순",
      "map.settings.sort_by.item_id": "아이템 ID",
      "map.settings.sort_by.database": "데이터베이스",
      "map.settings.sort_by.evidence": "가장 강한 근거",
      "map.settings.sort_order": "정렬 순서",
      "map.settings.sort_order.calculator": "지도 기본값(내림차순)",
      "map.settings.sort_order.desc": "내림차순",
      "map.settings.sort_order.asc": "오름차순",
      "map.loading.title": "검은사막 낚시 지도",
      "map.loading.starting": "지도 준비 중...",
      "map.loading.initial_detail": "처음 방문할 때는 잠시 걸릴 수 있습니다.",
      "map.loading.manifest": "지도 런타임 찾는 중...",
      "map.loading.module_import": "지도 코드 불러오는 중...",
      "map.loading.wasm_fetch": "지도 런타임 다운로드 중...",
      "map.loading.wasm_compile": "지도 런타임 컴파일 중...",
      "map.loading.renderer_start": "렌더러 시작 중...",
      "map.loading.runtime_bootstrap": "지도 데이터 불러오는 중...",
      "map.loading.first_paint": "첫 프레임 그리는 중...",
      "map.loading.ready": "지도 준비됨",
      "map.loading.fetch_bytes": "{$loaded} / {$total}",
      "map.loading.fetch_bytes_unknown": "{$loaded} 다운로드됨",
      "map.error.renderer_unavailable": "지도 렌더러를 사용할 수 없음",
      "map.error.badge": "오류",
      "map.error.renderer_start_failed": "웹페이지는 로드되었지만 Bevy/WebGL 렌더러를 시작할 수 없습니다.",
      "map.zone_loot.error.invalid_zone_rgb": "지역 전리품 요약에는 올바른 지역 RGB가 필요합니다",
      "map.zone_loot.error.missing_endpoint": "현재 API 빌드에서 지역 전리품 요약 엔드포인트를 사용할 수 없습니다.",
      "map.zone_loot.error.request_failed": "지역 전리품 요약 요청 실패: {$status}",
      "map.search.title.description": "ID 또는 이름으로 낚시 칭호 검색",
      "map.search.filter.missing_titles.description": "Fishydex 칭호 포함 설정에 따라 아직 획득하지 않은 칭호가 있는 물고기입니다.",
      "presets.select.label": "저장된 프리셋",
      "presets.select.hint": "프리셋을 선택해 확인하거나 이름을 바꾸세요. 적용을 눌러 활성화할 수 있습니다.",
      "presets.button.open_manager": "프리셋 관리자",
      "presets.manager.description": "프리셋을 다시 만들지 않고 저장, 이름 변경, 가져오기, 내보내기, 전환을 할 수 있습니다.",
      "presets.manager.open": "프리셋 관리자 열기",
      "presets.manager.close": "프리셋 관리자 닫기",
      "presets.collection.title": "{$name} 프리셋",
      "presets.collection.open": "{$name} 프리셋",
      "presets.collection.default_name": "{$name} {$index}",
      "presets.collection.workspace": "작업 공간",
      "presets.collection.calculator": "계산기",
      "presets.collection.overlay": "오버레이",
      "presets.collection.map": "지도",
      "presets.collection.dex": "도감",
      "presets.grid.title": "프리셋",
      "presets.grid.description": "카드를 선택하면 관리 대상으로만 열립니다. 사용을 눌러 현재 작업을 바꾸세요.",
      "presets.grid.count": "{$count}개 저장됨",
      "presets.grid.empty": "사용할 수 있는 프리셋이 없습니다.",
      "presets.grid.no_matches": "이 필터와 일치하는 프리셋이 없습니다.",
      "presets.grid.local_empty_account": "로컬 프리셋이 없습니다. 로그인한 동안 프리셋은 계정에 저장됩니다.",
      "presets.current.modified": "수정된 현재 프리셋",
      "presets.current.modified_from": "수정됨: {$name}",
      "presets.current.untitled": "현재 작업",
      "presets.current.unnamed": "이름 없는 프리셋",
      "presets.current.not_in_preset": "프리셋에 없는 변경 사항",
      "presets.current.based_on_preset": "프리셋 “{$name}” 기반",
      "presets.current.based_on_fixed": "기본 제공 “{$name}” 기반",
      "presets.current.no_base": "아직 이름 있는 프리셋 없음",
      "presets.current.revision": "버전 {$revision}",
      "presets.current.revision_pending": "버전 대기 중",
      "presets.current.status_unavailable": "상태를 사용할 수 없음",
      "presets.autosave.saving": "로컬에 저장 중…",
      "presets.autosave.error": "로컬 저장을 확인해야 합니다",
      "presets.section.active.title": "활성 프리셋",
      "presets.section.active.description": "페이지에서 현재 이 프리셋을 사용 중입니다. 활성 작업 변경 사항을 여기에서 저장하거나 폐기하세요.",
      "presets.section.selected.title": "선택한 프리셋",
      "presets.section.selected.description.fixed": "정의를 바꾸지 않고 이 기본 제공 프리셋을 사용합니다.",
      "presets.section.selected.description.current": "현재 저장되지 않은 프리셋입니다. 복제하면 저장된 사본을 보관합니다.",
      "presets.section.selected.description.saved": "현재 작업을 바꾸지 않고 이 프리셋의 이름을 바꾸거나 관리합니다.",
      "presets.section.selected.description.empty": "확인할 프리셋을 선택하세요.",
      "presets.section.transfer.title": "전송",
      "presets.section.transfer.description": "선택한 프리셋을 JSON으로 내보내거나 다른 플레이어가 공유한 프리셋을 가져오세요.",
      "presets.section.delete.title": "선택한 프리셋 삭제",
      "presets.section.delete.description": "선택한 저장 프리셋을 삭제합니다. 다시 전환하기 전까지 현재 보이는 상태는 그대로 유지됩니다.",
      "presets.section.delete.description.saved": "선택한 저장 프리셋을 삭제합니다. 현재 실시간 상태는 그대로 유지됩니다.",
      "presets.section.delete.description.readonly": "기본값과 현재 항목은 삭제할 수 없습니다. 편집 가능한 저장 사본이 필요하면 먼저 복제하세요.",
      "presets.dialog.name_label": "프리셋 이름",
      "presets.name.hint": "새 프리셋을 만들거나 선택한 프리셋 이름을 바꿀 때 이 이름을 사용합니다.",
      "presets.name.required": "프리셋 이름을 입력하세요.",
      "presets.field.selected_title.hint.saved": "여기에 입력하면 선택한 저장 프리셋 제목이 업데이트됩니다.",
      "presets.field.selected_title.hint.readonly": "이 제목은 고정되어 있습니다. 편집 가능한 저장 사본을 만들려면 복제하세요.",
      "presets.dialog.rename.title": "프리셋 이름 변경",
      "presets.action.apply_selected": "선택 항목 적용",
      "presets.action.import_file": "프리셋 가져오기",
      "presets.action.use_item": "이 {$item} 사용",
      "presets.action.set_active": "프리셋 활성화",
      "presets.action.set_active_named": "“{$name}” 활성화",
      "presets.action.update": "“{$name}” 업데이트",
      "presets.action.update_unavailable": "프리셋 업데이트",
      "presets.action.save_as": "새 {$item}(으)로 저장…",
      "presets.action.reset_to": "“{$name}”(으)로 초기화",
      "presets.action.reset": "현재 작업 초기화",
      "presets.selected.heading": "선택한 {$item}",
      "presets.selected.name_label": "{$item} 이름",
      "presets.status.base": "기반 프리셋",
      "presets.status.active_named": "“{$name}” 활성 프리셋",
      "presets.copy_name": "{$name} 복사본",
      "presets.default_name": "프리셋 {$index}",
      "presets.save_as.name_label": "새 프리셋 이름",
      "presets.save_as.reference_hint": "이 버전 그대로를 가리키는 이름 있는 참조를 만듭니다.",
      "presets.tab.presets": "프리셋",
      "presets.tab.changes": "저장되지 않은 변경 사항",
      "presets.tab.history": "기록",
      "presets.library.title": "프리셋 라이브러리",
      "presets.library.filter": "프리셋 필터",
      "presets.library.search": "프리셋 검색",
      "presets.selected.version": "버전",
      "presets.status.applying": "적용 중…",
      "presets.status.built_in": "기본 제공",
      "presets.confirm.delete": "\"{$name}\"을(를) 삭제할까요?",
      "presets.toast.created": "새 프리셋 \"{$name}\"을(를) 저장했습니다.",
      "presets.toast.copied": "\"{$name}\"을(를) 복제했습니다.",
      "presets.toast.saved": "\"{$name}\"을(를) 저장했습니다.",
      "presets.toast.discarded": "현재 작업을 기반 프리셋으로 초기화했습니다.",
      "presets.toast.renamed": "\"{$name}\"(으)로 이름을 변경했습니다.",
      "presets.toast.deleted": "\"{$name}\"을(를) 삭제했습니다.",
      "presets.toast.exported": "프리셋을 내보냈습니다.",
      "presets.toast.imported": "프리셋을 가져왔습니다.",
      "presets.toast.applied": "\"{$name}\"을(를) 적용했습니다.",
      "presets.error.import": "프리셋 가져오기에 실패했습니다.",
      "presets.error.apply": "프리셋 적용에 실패했습니다.",
      "presets.error.save": "프리셋 저장에 실패했습니다.",
      "presets.error.discard": "프리셋 폐기에 실패했습니다.",
      "presets.error.capture": "현재 프리셋 상태를 사용할 수 없습니다.",
      "presets.error.command": "프리셋 작업을 완료할 수 없습니다.",
      "presets.state.loading": "프리셋 작업 공간을 불러오는 중…",
      "presets.state.conflict": "이 프리셋이 다른 탭에서 변경되었습니다. 최신 버전을 확인한 뒤 다시 시도하세요.",
      "presets.state.invalid": "저장된 프리셋 데이터가 올바르지 않습니다. 복구할 수 있도록 보존했습니다.",
      "presets.state.unsupported": "이 프리셋은 더 새로운 FishyStuff 버전에서 만들어졌습니다.",
      "presets.state.unavailable": "현재 프리셋 저장소를 사용할 수 없습니다.",
      "presets.history.change": "프리셋 변경",
      "presets.history.current": "현재",
      "presets.history.shared_base": "공통 기반",
      "presets.history.show_alternates": "대체 분기 표시",
      "presets.history.old": "이전:",
      "presets.history.new": "새 값:",
      "presets.history.compacted": "이전 변경 사항 압축됨",
      "presets.history.branches": "분기 {$count}개",
      "presets.history.previewing": "{$summary} 미리 보기",
      "presets.history.undone": "이전 버전으로 이동했습니다.",
      "presets.history.redone": "다음 버전으로 이동했습니다.",
      "presets.history.version_applied": "현재 작업이 선택한 버전을 사용합니다.",
      "presets.history.title": "현재 작업 기록",
      "presets.history.description": "버전을 미리 봐도 적용되지는 않습니다. 실행 취소 후 새로 편집해도 다른 분기는 유지됩니다.",
      "presets.history.preview_not_applied": "아직 적용된 내용이 없습니다.",
      "presets.history.empty": "아직 내용 변경이 없습니다.",
      "presets.history.empty_selected": "이 프리셋에 기록된 변경 사항이 없습니다.",
      "presets.details.label": "프리셋 세부 정보",
      "presets.changes.kind": "변경",
      "presets.changes.setting": "설정",
      "presets.changes.old": "이전",
      "presets.changes.new": "새 값",
      "presets.changes.path": "경로",
      "presets.changes.saved": "저장됨",
      "presets.changes.working": "작업 중",
      "presets.changes.added": "추가됨",
      "presets.changes.removed": "제거됨",
      "presets.changes.changed": "변경됨",
      "presets.changes.summary": "저장된 프리셋과 비교한 변경 사항 {$count}개.",
      "presets.changes.summary_truncated": "처음 {$count}개 변경 사항을 표시합니다.",
      "presets.changes.empty": "이 프리셋과 다른 점이 없습니다.",
      "presets.changes.inactive": "변경 사항을 확인하려면 이 프리셋을 활성화하세요.",
      "presets.quick_switch.empty": "사용할 수 있는 프리셋이 없습니다.",
      "presets.quick_switch.search": "프리셋 검색...",
      "presets.quick_switch.current": "현재",
      "presets.quick_switch.current_modified": "현재 작업 · {$name}"
    },
    "de-DE": {
      "calculator.loading": "Rechner wird geladen...",
      "calculator.recovery.title": "Rechnerdaten müssen überprüft werden",
      "calculator.recovery.description": "Diese Arbeit konnte nicht auf die aktuellen Spieldaten angewendet werden. Möglicherweise verweist sie auf eine geänderte oder entfernte Option.",
      "calculator.recovery.dismiss": "Schließen",
      "calculator.recovery.retry": "Erneut versuchen",
      "calculator.recovery.defaults": "Aktuellen Stand zurücksetzen",
      "calculator.recovery.preservation": "Dadurch wird nur der aktuelle Rechnerstand zurückgesetzt. Gespeicherte Vorlagen und Layouts bleiben unverändert.",
      "calculator.recovery.save_failed": "Der Rechner wurde geöffnet, aber die aktuelle Arbeit konnte nicht aktualisiert werden. Versuche es vor dem Neuladen erneut.",
      "calculator.timespan.unit.minute.one": "Minute",
      "calculator.timespan.unit.minute.other": "Minuten",
      "calculator.timespan.unit.hour.one": "Stunde",
      "calculator.timespan.unit.hour.other": "Stunden",
      "calculator.timespan.unit.day.one": "Tag",
      "calculator.timespan.unit.day.other": "Tage",
      "calculator.timespan.unit.week.one": "Woche",
      "calculator.timespan.unit.week.other": "Wochen",
      "calculator.resource.exhausted": "Erschöpft",
      "calculator.resource.low": "Niedrig",
      "calculator.resource.average": "Mittel",
      "calculator.resource.abundant": "Reichlich",
      "calculator.timeline.bite_time": "Bisszeit",
      "calculator.timeline.auto_fishing_time": "Auto-Fishing-Zeit",
      "calculator.timeline.catch_time": "Fangzeit",
      "calculator.timeline.time_saved": "Gesparte Zeit",
      "calculator.share.active_lead": "Aktiv | ",
      "calculator.share.afr_lead": "{$afr} AFR | ",
      "calculator.share.link": "[FishyStuff-Rechner-Preset | {$lead}{$item_drr} Gegenstands-DRR | {$zone}]({$url})",
      "calculator.toast.preset_url_copied": "Preset-URL kopiert.",
      "calculator.toast.share_copied": "Freigabetext kopiert.",
      "calculator.title.casts_average": "Durchschnittliche Würfe ({$timespan})",
      "calculator.title.durability_loss_average": "Durchschnittlicher Haltbarkeitsverlust ({$timespan})",
      "calculator.title.expected_catches": "Erwartete Fänge ({$timespan})",
      "calculator.title.expected_profit": "Erwarteter Gewinn ({$timespan})",
      "calculator.title.bite_time": "Bisszeit: {$seconds}s ({$percent}%)",
      "calculator.title.auto_fishing_time": "Auto-Fishing-Zeit: {$seconds}s ({$percent}%)",
      "calculator.title.catch_time": "Fangzeit: {$seconds}s ({$percent}%)",
      "calculator.title.unoptimized_time": "Durchschnittliche unoptimierte Zeit: {$seconds}s ({$percent}%)",
      "calculator.server.option.none": "Keine",
      "calculator.server.option.custom_trade_distance": "Eigener Distanzbonus",
      "calculator.server.option.custom_pet": "Eigenes Tier",
      "calculator.server.result.no_matching_options": "Keine passenden Optionen",
      "calculator.server.result.no_matching_zones": "Keine passenden Zonen",
      "calculator.server.result.no_matching_hotspots": "Keine passenden Hotspots",
      "calculator.server.result.selected": "Ausgewählt",
      "calculator.server.result.added": "Hinzugefügt",
      "calculator.server.result.available_for_pet": "Für dieses Tier verfügbar",
      "calculator.server.result.group.active_zones": "Aktive Zonen",
      "calculator.server.result.group.inactive_zones": "Inaktive Zonen",
      "calculator.server.result.group.available_pet_perks": "Für dieses Tier verfügbar",
      "calculator.server.result.group.other_pet_perks": "Andere bekannte Tierboni",
      "calculator.server.result.group.compatible_pet_appearances": "Tier-Varianten mit den ausgewählten Boni",
      "calculator.server.result.group.other_pet_appearances": "Andere Tier-Varianten",
      "calculator.server.action.remove": "{$label} entfernen",
      "calculator.server.action.copy_url": "URL kopieren",
      "calculator.server.action.copy_share": "Freigabe kopieren",
      "calculator.server.action.remove_custom_card": "{$label} aus Custom entfernen",
      "calculator.server.action.drag_section": "{$label} ziehen",
      "calculator.server.action.drag_section_generic": "Abschnitt ziehen",
      "calculator.server.toggle.active_fishing": "Aktives Fischen",
      "calculator.server.toggle.debug": "Debug",
      "calculator.server.toggle.show_inactive_zones": "Inaktive Zonen anzeigen",
      "calculator.server.workspace.basics": "Grundlagen",
      "calculator.server.workspace.loadout": "Ausrüstung",
      "calculator.server.workspace.loot": "Beute",
      "calculator.server.workspace.trade": "Handel",
      "calculator.server.workspace.data": "Daten",
      "calculator.server.workspace.advanced": "Erweitert",
      "calculator.server.workspace.custom": "Benutzerdefiniert",
      "calculator.server.search.zones": "Zonen suchen",
      "calculator.server.search.hotspots": "Nach Fisch oder Hotspot-ID suchen",
      "calculator.server.search.fishing_levels": "Angelstufen suchen",
      "calculator.server.search.session_units": "Sitzungseinheiten suchen",
      "calculator.server.search.lifeskill_levels": "Lebensskill-Stufen suchen",
      "calculator.server.search.rods": "Ruten suchen",
      "calculator.server.search.floats": "Posen suchen",
      "calculator.server.search.chairs": "Stühle suchen",
      "calculator.server.search.lightstone_sets": "Lichtstein-Sets suchen",
      "calculator.server.search.backpacks": "Rucksäcke suchen",
      "calculator.server.search.foods": "Nahrung nach Name oder Effekt suchen",
      "calculator.server.search.buffs": "Buffs nach Name oder Effekt suchen",
      "calculator.server.search.trade_levels": "Handelsstufen suchen",
      "calculator.server.search.trade_origins": "Handelsursprünge suchen",
      "calculator.server.search.trade_destinations": "NPC, Region oder Distanz %",
      "calculator.server.search.loot_rows": "Beutezeilen an diesem Spot suchen",
      "calculator.server.search.pet_tiers": "Haustierstufen suchen",
      "calculator.server.search.pet_specials": "Haustier-Spezialisierungen suchen",
      "calculator.server.search.pet_talents": "Haustier-Talente suchen",
      "calculator.server.search.pet_skills": "Haustierfähigkeiten suchen",
      "calculator.server.search.pets": "Haustiere suchen",
      "calculator.server.section.mode": "Modus",
      "calculator.server.section.source": "Angelquelle",
      "calculator.server.section.bite_time": "Bisszeit",
      "calculator.server.section.catch_time": "Fangzeit",
      "calculator.server.section.session": "Sitzung",
      "calculator.server.section.gear": "Ausrüstungsset",
      "calculator.server.section.pets": "Haustiere",
      "calculator.server.section.distribution": "Verteilung",
      "calculator.server.section.loot": "Beute",
      "calculator.server.section.trade": "Handel",
      "calculator.server.section.data_editor": "Beutedaten-Editor",
      "calculator.server.field.fishing_level": "Angelstufe",
      "calculator.server.field.fishing_resources": "Angelressourcen",
      "calculator.server.field.fishing_mode": "Angelmodus",
      "calculator.server.field.rod_zone": "Ruten-Angelzone",
      "calculator.server.field.harpoon_zone": "Harpunierzone",
      "calculator.server.field.hotspot": "Hotspot",
      "calculator.server.field.fishing_method": "Methode",
      "calculator.server.field.active": "Aktiv",
      "calculator.server.field.afk": "AFK",
      "calculator.server.field.amount": "Menge",
      "calculator.server.field.unit": "Einheit",
      "calculator.server.field.lifeskill_level": "Lebensskill-Stufe",
      "calculator.server.field.fishing_rod": "Angelrute",
      "calculator.server.field.brand": "Brand",
      "calculator.server.field.float": "Pose",
      "calculator.server.field.chair": "Stuhl",
      "calculator.server.field.lightstone_set": "Lichtstein-Set",
      "calculator.server.field.backpack": "Rucksack",
      "calculator.server.field.outfit": "Outfit",
      "calculator.server.field.food": "Nahrung",
      "calculator.server.field.buffs": "Buffs",
      "calculator.server.field.pet": "Haustier",
      "calculator.server.field.tier": "Stufe",
      "calculator.server.field.special": "Spezial",
      "calculator.server.field.talent": "Talent",
      "calculator.server.field.skills": "Fähigkeiten",
      "calculator.server.field.pack_leader": "Rudelanführer",
      "calculator.server.field.mastery": "Meisterung",
      "calculator.server.field.target_fish": "Zielfisch / Beuteobjekt",
      "calculator.server.field.target_amount": "Zielmenge",
      "calculator.server.field.pmf_max_count": "PMF-Maximalanzahl",
      "calculator.server.field.trade_level": "Handelsstufe",
      "calculator.server.field.trade_origin": "Handelsursprung",
      "calculator.server.field.trade_destination": "Zielhändler",
      "calculator.server.field.distance_bonus": "Distanzbonus",
      "calculator.server.field.trade_price_curve": "Handelspreiskurve",
      "calculator.server.field.imperial_fishing_delivery": "Kaiserliche Fischabgabe",
      "calculator.server.field.distance_bonus_exp_only": "Distanzbonus (nur Handels-EP)",
      "calculator.server.field.discard_grade": "Fische bis Qualität verwerfen",
      "calculator.server.mode.rod": "Rute",
      "calculator.server.mode.hotspot": "Hotspot",
      "calculator.server.mode.harpoon_forces_active": "Harpune erzwingt vorübergehend Aktiv.",
      "calculator.server.stat.seconds": "Sekunden",
      "calculator.server.stat.average_total_fishing_time": "Durchschnittliche Gesamtangelzeit",
      "calculator.server.stat.average_bite_time": "Durchschnittliche Bisszeit",
      "calculator.server.stat.min": "Min.",
      "calculator.server.stat.average": "Durchschnitt",
      "calculator.server.stat.max": "Max.",
      "calculator.server.stat.effective_min": "Effektives Minimum",
      "calculator.server.stat.effective_average": "Effektiver Durchschnitt",
      "calculator.server.stat.effective_max": "Effektives Maximum",
      "calculator.server.stat.auto_fishing_time_aft": "Auto-Fishing-Zeit (AFT)",
      "calculator.server.stat.auto_fishing_time_reduction_afr": "Auto-Fishing-Zeit-Reduktion (AFR)",
      "calculator.server.stat.item_drr": "Gegenstands-DRR",
      "calculator.server.stat.chance_to_consume_durability": "Wahrscheinlichkeit für Haltbarkeitsverlust",
      "calculator.server.stat.raw_prize_catch_rate": "Rohe Preisfisch-Fangrate",
      "calculator.server.stat.expected_catches": "Erwartete Fänge",
      "calculator.server.stat.expected_catches_per_hour": "Erwartete Fänge / Stunde",
      "calculator.server.stat.expected_profit": "Erwarteter Gewinn",
      "calculator.server.stat.profit_per_hour": "Gewinn / Stunde",
      "calculator.server.stat.expected_exp": "Erwartete EXP",
      "calculator.server.stat.exp_per_hour": "EXP / Stunde",
      "calculator.server.stat.expected_totem_exp": "Erwartete Totem-EXP",
      "calculator.server.stat.totem_exp_per_hour": "Totem-EXP / Stunde",
      "calculator.server.stat.bargain_bonus": "Feilschbonus",
      "calculator.server.stat.sale_multiplier": "Finaler Verkaufsmultiplikator",
      "calculator.server.stat.fixed_fish_sale_value": "Fester Fischverkaufswert",
      "calculator.server.helper.mastery": "Gib deine zusammengefasste Angel-Meisterung direkt ein.",
      "calculator.server.helper.mastery_formula_prefix": "Meisterung",
      "calculator.server.helper.mastery_formula_suffix": "steuert die direkte Preisraten-Formel vor der Normalisierung.",
      "calculator.server.helper.before_zone_group_normalization": "vor der Zonen-Gruppen-Normalisierung",
      "calculator.server.helper.target_amount": "Geschätzte Zeit bis zu dieser Menge.",
      "calculator.server.helper.within_current_session_duration": "innerhalb der aktuellen Sitzungsdauer",
      "calculator.server.helper.select_target_fish": "Wähle einen Zielfisch.",
      "calculator.server.helper.target_status_per_day": "{$label} · {$per_day}/Tag",
      "calculator.server.helper.target_pmf_count": "Zeigt die diskrete Ergebnisverteilung bis zu dieser Fanganzahl; der letzte Bucket fasst jedes höhere Ergebnis zusammen.",
      "calculator.server.helper.target_pmf_auto_short": "0 = automatisch",
      "calculator.server.helper.target_select_zone_item": "Wähle einen Zielfisch oder Beutegegenstand aus dieser Zone.",
      "calculator.server.helper.target_per_day_at_spot": "{$per_day} / Tag am aktuellen Spot mit der aktuellen Konfiguration.",
      "calculator.server.helper.target_missing_at_spot": "Dieses Ziel erscheint aktuell nicht an diesem Spot.",
      "calculator.server.helper.target_pmf_auto": "0 = automatisch. Der letzte PMF-Bucket ist aktuell ≥{$count} (0,5-%-Schwanzgrenze).",
      "calculator.server.helper.target_pmf_fixed": "Der letzte PMF-Bucket ist ≥{$count}.",
      "calculator.server.helper.custom_trade_distance": "Manueller Distanzbonus",
      "calculator.server.helper.trade_price_curve": "manuelle %-Kurve, häufig etwa 105–130 %",
      "calculator.server.helper.apply_trade_settings": "Handelseinstellungen anwenden",
      "calculator.server.helper.imperial_fishing_sale_policy": "Der Fischverkaufswert beträgt immer 250 %. Der Distanzbonus gilt weiterhin nur für Handels-EP; Handelspreiskurve und Feilschbonus gelten nicht.",
      "calculator.server.helper.food_family": "Pro Nahrungskategorie wirkt immer nur eine Familie gleichzeitig. Höherstufige Nahrung ersetzt niedrigerstufige Nahrung derselben Familie.",
      "calculator.server.helper.buff_group": "Wenn du einen anderen Buff derselben Buff-Gruppe auswählst, ersetzt er den bisherigen.",
      "calculator.server.helper.fish_only_notice": "Gilt nur für Fische. Nicht-Fisch-Beute bleibt erhalten. Rote Fische werden immer behalten.",
      "calculator.server.helper.using": "verwendet",
      "calculator.server.helper.per_cast": "pro Wurf",
      "calculator.server.helper.sale": "Verkauf",
      "calculator.server.helper.pet_skills.one": "Wähle 1 Fähigkeit.",
      "calculator.server.helper.pet_skills.many": "Wähle 1 bis {$count} Fähigkeiten.",
      "calculator.server.tab.groups": "Gruppen",
      "calculator.server.tab.value_split": "Wertaufteilung",
      "calculator.server.tab.silver": "Silber",
      "calculator.server.tab.exp": "EXP",
      "calculator.server.tab.totem_exp": "Totem-EXP",
      "calculator.server.tab.normalized": "Normalisiert",
      "calculator.server.tab.denormalized": "Denormalisiert",
      "calculator.server.tab.raw_weight": "Rohgewicht",
      "calculator.server.tab.loot_flow": "Beutefluss",
      "calculator.server.tab.exp_flow": "EXP-Fluss",
      "calculator.server.tab.totem_exp_flow": "Totem-EXP-Fluss",
      "calculator.server.tab.target_fish": "Zielfisch",
      "calculator.server.tab.overview": "Übersicht",
      "calculator.server.tab.inputs": "Eingaben",
      "calculator.server.discard.none": "Nicht verwerfen",
      "calculator.server.target.expected": "Erwartet ({$timespan})",
      "calculator.server.target.time_to_target": "Zeit bis zum Ziel",
      "calculator.server.target.chance_at_least": "Wahrscheinlichkeit für mindestens {$amount}",
      "calculator.server.target.no_rows": "Für die Zielanalyse sind an diesem Spot derzeit keine Beutezeilen verfügbar.",
      "calculator.server.target.session_distribution_title": "Sitzungsanzahl-Verteilung",
      "calculator.server.target.session_distribution_description": "Diskrete Sitzungs-Ergebnisverteilung für dieses Ziel innerhalb der aktuellen Sitzungsdauer.",
      "calculator.server.target.count_bucket_probability": "Wahrscheinlichkeits-Bucket nach Anzahl",
      "calculator.server.chart.no_loot_rows": "Für diese Zone sind noch keine quellgestützten Beutezeilen verfügbar.",
      "calculator.server.chart.no_exp_rows": "Für diese Zone sind noch keine quellgestützten Fisch-EXP-Zeilen verfügbar.",
      "calculator.server.chart.no_totem_exp_rows": "Für diese Zone tragen derzeit keine behaltenen Fischzeilen mit quellgestützter oder per Stufenregel geschätzter Totem-EXP bei.",
      "calculator.server.chart.loot_flow_title": "Beutefluss",
      "calculator.server.chart.loot_flow_description": "Jeder Fluss startet bei einer Fischgruppe, läuft durch quellgestützte Artenzeilen und wird dann zu silbergewichteten Gruppensummen zusammengeführt. Die linken Kennzahlen zeigen die Rate jedes Gegenstands innerhalb seiner Gruppe, die rechten den Silberbeitrag.",
      "calculator.server.chart.exp_flow_title": "EXP-Fluss",
      "calculator.server.chart.exp_flow_description": "Jeder Fluss startet bei einer Fischgruppe, läuft durch quellgestützte Artenzeilen und wird dann zu EXP-gewichteten Gruppensummen zusammengeführt. Die linken Kennzahlen zeigen die Rate jedes Gegenstands innerhalb seiner Gruppe, die rechten den EXP-Beitrag.",
      "calculator.server.chart.totem_exp_flow_title": "Totem-EXP-Fluss",
      "calculator.server.chart.totem_exp_flow_description": "Jeder Fluss startet bei einer Fischgruppe, läuft durch behaltene Fischzeilen und wird dann zu Totem-EXP-gewichteten Gruppensummen zusammengeführt; die Herkunftsleiste markiert quellgestützte und per Stufenregel geschätzte Werte.",
      "calculator.server.chart.sort_by": "Sortieren nach",
      "calculator.server.chart.sort_by.price": "Preis",
      "calculator.server.chart.sort_by.grade": "Qualität",
      "calculator.server.chart.sort_by.droprate": "Rate innerhalb der Gruppe",
      "calculator.server.chart.sort_by.expected_value": "Erwartungswert",
      "calculator.server.chart.sort_by.exp": "EXP",
      "calculator.server.chart.sort_by.totem_exp": "Totem-EXP",
      "calculator.server.chart.sort_by.alphabetical": "Alphabetisch",
      "calculator.server.chart.sort_by.item_id": "Gegenstands-ID",
      "calculator.server.chart.sort_by.database": "Datenbank",
      "calculator.server.chart.sort_by.evidence": "Stärkster Nachweis",
      "calculator.server.chart.sort_order": "Sortierreihenfolge",
      "calculator.server.chart.sort_order.desc": "Absteigend",
      "calculator.server.chart.sort_order.asc": "Aufsteigend",
      "calculator.server.chart.group_distribution_title": "Verteilung der Gruppenauswahl",
      "calculator.server.chart.group_distribution_description.normalized": "Aktueller Fischgruppen-Anteil nach Gewichtung von Preisfisch, Selten und Hochwertig.",
      "calculator.server.chart.group_distribution_description.raw": "Rohe Fischgruppengewichte nach Preisfisch-Meisterung und aktiven Gruppenmodifikatoren, vor der Normalisierung.",
      "calculator.server.chart.group_silver_distribution_title": "Gruppen-Silberverteilung",
      "calculator.server.chart.group_silver_distribution_description": "Erwarteter Silberanteil je Fischgruppe nach Handels- und Preiseinstellungen.",
      "calculator.server.chart.group_exp_distribution_title": "Gruppen-EXP-Verteilung",
      "calculator.server.chart.group_exp_distribution_description": "Erwarteter EXP-Anteil je Fischgruppe nach quellgestützten Fisch-EXP-Werten und aktiven EXP-Modifikatoren.",
      "calculator.server.chart.group_totem_exp_distribution_title": "Gruppen-Totem-EXP-Verteilung",
      "calculator.server.chart.group_totem_exp_distribution_description": "Erwarteter Totem-EXP-Anteil je Fischgruppe aus behaltenen quellgestützten oder per Stufenregel geschätzten Fischfängen.",
      "calculator.server.chart.aria.group_distribution": "Verteilung der Gruppenauswahl",
      "calculator.server.chart.aria.group_silver_distribution": "Gruppen-Silberverteilung",
      "calculator.server.chart.aria.group_exp_distribution": "Gruppen-EXP-Verteilung",
      "calculator.server.chart.aria.group_totem_exp_distribution": "Gruppen-Totem-EXP-Verteilung",
      "calculator.server.chart.aria.loot_flow": "Erwarteter Beutefluss von Gruppen zu Beutezeilen",
      "calculator.server.chart.aria.exp_flow": "Erwarteter EXP-Fluss von Gruppen zu Beutezeilen",
      "calculator.server.chart.aria.totem_exp_flow": "Erwarteter Totem-EXP-Fluss von Gruppen zu Beutezeilen",
      "calculator.server.chart.aria.target_distribution": "Zielfisch-Sitzungsverteilung",
      "calculator.server.chart.aria.timeline": "Angelzyklus-Zeitachse",
      "calculator.server.chart.aria.distribution_tabs": "Verteilungs-Tabs",
      "calculator.server.chart.aria.value_split_metric_switch": "Metrik für Wertaufteilung",
      "calculator.server.chart.aria.loot_flow_metric_switch": "Metrik für Beutefluss",
      "calculator.server.chart.aria.loot_rate_display_mode": "Beuteratenanzeige",
      "calculator.server.chart.aria.workspace_tabs": "Rechnerabschnitte",
      "calculator.server.chart.aria.custom_tabs": "Custom-Arbeitsbereichskarten",
      "calculator.server.badge.aft": "-{$percent}% AFT",
      "calculator.server.badge.rare": "+{$percent}% Selten",
      "calculator.server.badge.hq": "+{$percent}% HQ",
      "calculator.server.badge.item_drr": "+{$percent}% Gegenstands-DRR",
      "calculator.server.badge.fish_multiplier": "Fisch ×{$multiplier}",
      "calculator.server.badge.fish_exp": "+{$percent}% Angel-EP",
      "calculator.server.badge.life_exp": "+{$percent}% Lebens-EP",
      "calculator.server.badge.set_effect": "Set-Effekt",
      "calculator.server.badge.level_drr": "+{$percent}% Stufen-DRR",
      "calculator.server.badge.zone_origin": "Zonenursprung",
      "calculator.server.loot.breakdown.label.base_price": "Grundpreis",
      "calculator.server.value.unavailable": "Nicht verfügbar",
      "calculator.server.disclaimer.title": "Warnung zur Datenqualität",
      "calculator.server.disclaimer.p1": "Die derzeit verfügbaren Daten sind UNVOLLSTÄNDIG und manche Daten könnten VOLLSTÄNDIG FEHLEN.",
      "calculator.server.disclaimer.p2": "Informationen zu Gruppenraten basieren auf älteren Daten und sind VERALTET.",
      "calculator.server.disclaimer.p3": "Insbesondere: Preisfisch-Informationen basieren ausschließlich auf Community-Schätzungen und können völlig danebenliegen. Die echten Raten sind UNBEKANNT.",
      "calculator.server.disclaimer.p4": "Wir versuchen, so genau wie möglich zu sein, aber derzeit solltest du nichts davon ungeprüft als Tatsache übernehmen.",
      "calculator.server.disclaimer.p5": "In Zukunft wollen wir Daten per Crowdsourcing sammeln und freuen uns über spätere Beiträge.",
      "calculator.data.title": "Zonendaten",
      "calculator.data.description": "Bearbeite die wirksame Beutetabelle visuell und prüfe bei Bedarf ihre genauen Quellkandidaten.",
      "calculator.data.empty": "Rechnermodell, Projektion und abgeschlossene Benutzerebene sind erforderlich.",
      "calculator.data.none": "Keine",
      "calculator.data.selected_item": "Ausgewählter Gegenstand",
      "calculator.data.item_id": "Gegenstand {$id}",
      "calculator.data.candidate": "Kandidat {$number}",
      "calculator.data.editor.title": "Beutetabellen-Editor",
      "calculator.data.editor.description": "Wähle einen Gegenstand aus und ordne ihn dann über den Pfeil einer Gruppe zu. Die Aktivierung einer Gruppe ist unabhängig von ihren gespeicherten Einträgen und ihrer Rate.",
      "calculator.data.catalog.title": "Katalog",
      "calculator.data.catalog.add_item": "Kataloggegenstand hinzufügen",
      "calculator.data.catalog.section.custom": "Benutzerdefiniert",
      "calculator.data.catalog.section.assigned": "Zugeordnet",
      "calculator.data.catalog.section.available": "Verfügbar",
      "calculator.data.catalog.section.in_zone": "Vorkommen in der Zone",
      "calculator.data.catalog.section.zone_edge": "Vorkommen am Zonenrand",
      "calculator.data.catalog.section.no_ranking_presence": "Kein Ranking-Vorkommensnachweis",
      "calculator.data.available.item_count.one": "{$count} Gegenstand",
      "calculator.data.available.item_count.other": "{$count} Gegenstände",
      "calculator.data.available.showing": "· {$count} angezeigt",
      "calculator.data.available.none": "Für diese Angelquelle sind keine Gegenstände verfügbar.",
      "calculator.data.action.add_item": "{$item} hinzufügen",
      "calculator.data.action.add_item_to_group": "{$item} zu {$group} hinzufügen",
      "calculator.data.action.add_to_group": "Zu Gruppe hinzufügen",
      "calculator.data.action.activate_group": "Aktivieren",
      "calculator.data.action.activate_group_label": "{$group} mit gespeicherten Einträgen aktivieren",
      "calculator.data.action.apply": "Anwenden",
      "calculator.data.action.apply_membership": "Gruppenzugehörigkeit anwenden",
      "calculator.data.action.apply_presence": "Vorkommen anwenden",
      "calculator.data.action.apply_price": "Preis anwenden",
      "calculator.data.action.cancel": "Abbrechen",
      "calculator.data.action.deactivate_group": "Deaktivieren",
      "calculator.data.action.deactivate_group_label": "{$group} deaktivieren, ohne Einträge zu löschen",
      "calculator.data.action.item_already_in_group": "{$item} ist bereits in {$group}",
      "calculator.data.action.refute": "Mit Benutzerebene widerlegen",
      "calculator.data.action.remove": "Entfernen",
      "calculator.data.action.remove_item_from_group": "{$item} aus {$group} entfernen",
      "calculator.data.action.inspect_group": "Angelgruppe {$group} prüfen",
      "calculator.data.action.select_item": "{$item} auswählen",
      "calculator.data.action.remove_custom_item": "{$item} aus Benutzerdefiniert entfernen",
      "calculator.data.action.inspect_item_assignment": "Zuordnung von {$item} in {$group} prüfen",
      "calculator.data.action.revert": "Zurücksetzen",
      "calculator.data.action.revert_label": "{$operation} zurücksetzen",
      "calculator.data.action.revert_user_operation": "Benutzeroperation zurücksetzen",
      "calculator.data.action.review_item": "Gegenstand prüfen",
      "calculator.data.action.search": "Suchen",
      "calculator.data.action.select_item_for_group": "Gegenstand für {$group} auswählen",
      "calculator.data.action.select_reason": "Grund auswählen",
      "calculator.data.action.use_id": "ID verwenden",
      "calculator.data.field.catalog": "Katalog",
      "calculator.data.field.detail_code_optional": "Detailcode (optional)",
      "calculator.data.field.filter": "Filter",
      "calculator.data.field.item_id": "Gegenstands-ID",
      "calculator.data.field.membership_group": "Zugehörigkeitsgruppe",
      "calculator.data.field.membership_state": "Zugehörigkeitsstatus",
      "calculator.data.field.confidence": "Sicherheit",
      "calculator.data.field.operation_comment": "Operationskommentar",
      "calculator.data.field.operation_context": "Sicherheit & Notiz",
      "calculator.data.field.presence": "Vorkommen",
      "calculator.data.field.price_silver": "Preis (Silber)",
      "calculator.data.field.price_state": "Preisstatus",
      "calculator.data.field.rate_basis": "Eingabebasis",
      "calculator.data.field.rate_value": "Wert",
      "calculator.data.field.rate_value_accessible": "Ratenwert. Normalisierte feste Raten müssen zwischen 0 und 100 Prozent liegen; denormalisierte Gewichte und Rohgewichte müssen endliche, nichtnegative Werte sein. Gewichtseingaben behalten ihre vollständige Genauigkeit.",
      "calculator.data.field.refutation_reason": "Code des Widerlegungsgrunds",
      "calculator.data.field.state": "Status",
      "calculator.data.field.unavailable_reason": "Grund der Nichtverfügbarkeit",
      "calculator.data.placeholder.reason_code": "Grundcode eingeben",
      "calculator.data.placeholder.operation_comment": "Warum diese Überschreibung existiert, welche Evidenz sie stützt oder was noch geprüft werden muss",
      "calculator.data.search.catalog_placeholder": "Gesamten Katalog durchsuchen",
      "calculator.data.search.filter_placeholder": "Gegenstand, ID, Gruppe, Ebene oder Status",
      "calculator.data.state.absent": "Nicht vorhanden",
      "calculator.data.confidence.guessed": "Geschätzt",
      "calculator.data.state.known": "Bekannt",
      "calculator.data.state.not_loaded": "Nicht geladen",
      "calculator.data.state.present": "Vorhanden",
      "calculator.data.state.unavailable": "Nicht verfügbar",
      "calculator.data.state.unknown": "Unbekannt",
      "calculator.data.status.condition_inactive": "Bedingung inaktiv",
      "calculator.data.condition.none_active": "Keine aktive Bedingung",
      "calculator.data.condition.automatic": "Automatische Bedingung verwenden",
      "calculator.data.condition.auto_short": "Auto",
      "calculator.data.status.effective": "Wirksam",
      "calculator.data.status.overridden": "Überschrieben",
      "calculator.data.status.refuted": "Widerlegt",
      "calculator.data.membership.member": "In Gruppe enthalten",
      "calculator.data.membership.not_member": "Aus Gruppe ausgeschlossen",
      "calculator.data.membership.unknown": "Zugehörigkeit unbekannt",
      "calculator.data.rate_basis.per_catch": "Pro Fang",
      "calculator.data.rate_basis.fixed_share_percent": "Fester Anteil (%)",
      "calculator.data.rate_basis.normalized_percent": "Normalisiert",
      "calculator.data.rate_basis.denormalized_weight": "Denormalisiert",
      "calculator.data.rate_basis.percent": "Prozent",
      "calculator.data.rate_basis.ratio": "Verhältnis",
      "calculator.data.rate_basis.raw_weight": "Rohgewicht",
      "calculator.data.rate.weight": "{$value} Gewicht",
      "calculator.data.rate.projected_edit_base": "Projiziert {$rate}; {$label} bearbeiten",
      "calculator.data.rate.projected_total_edit_base": "Projizierte Summe {$rate}; {$label} bearbeiten",
      "calculator.data.rate.state_label": "Rate: {$state}",
      "calculator.data.rate.unavailable": "Rate nicht verfügbar",
      "calculator.data.rate.unknown": "Rate unbekannt",
      "calculator.data.rate.unquantified_group": "{$group} · nicht quantifiziert",
      "calculator.data.rate_editor.edit": "{$label} bearbeiten",
      "calculator.data.rate_editor.group_rate": "Gruppenrateneingabe",
      "calculator.data.rate_editor.item_base": "Gegenstands-Basiseingabe",
      "calculator.data.rate_editor.user_group_override": "Benutzerüberschreibung der Gruppe",
      "calculator.data.rate_editor.shadowed_bonus": "Auf diese feste normalisierte Rate werden Rohgewicht-Boni nicht angewendet. Bearbeite die Rate als Denormalisiert oder Rohgewicht, um sie anzuwenden.",
      "calculator.data.unavailable.incomplete_provenance": "Unvollständige Provenienz",
      "calculator.data.unavailable.missing_source": "Quellfakt fehlt",
      "calculator.data.unavailable.model_selection": "Bedingung auswählen",
      "calculator.data.unavailable.no_equivalent_raw_weight": "Kein entsprechendes Rohgewicht",
      "calculator.data.unavailable.not_applicable": "Nicht anwendbar",
      "calculator.data.unavailable.unsupported_source": "Nicht unterstützte Quellvariante",
      "calculator.data.group.label": "Gruppe {$group}",
      "calculator.data.group.main_group_id": "Hauptgruppen-ID: {$value}",
      "calculator.data.group.no_memberships": "Keine wirksamen Gegenstandszugehörigkeiten.",
      "calculator.data.group.none_available": "Für diese Auswahl sind keine Gruppen verfügbar.",
      "calculator.data.assignment.independent_fact": "Unabhängiger Gruppenfakt aus {$layer}",
      "calculator.data.assignment.no_memberships": "Keine wirksamen Gruppenzugehörigkeiten",
      "calculator.data.assignment.review_label": "Zuordnung von {$item} zu {$group} prüfen",
      "calculator.data.assignment.unassigned": "Nicht zugeordnet",
      "calculator.data.assignment.via_layer": "über {$layer}",
      "calculator.data.catalog.section.assigned_absent": "Zugeordnet · nicht vorhanden",
      "calculator.data.badge.catalog_result": "Katalogtreffer",
      "calculator.data.badge.exact_id": "Exakte ID",
      "calculator.data.badge.user_layer": "Benutzerebene",
      "calculator.data.presence.label": "Vorkommen: {$state}",
      "calculator.data.provenance.membership": "Zugehörigkeit",
      "calculator.data.provenance.no_effective_rate": "Kein wirksamer Ratenfakt",
      "calculator.data.provenance.presence": "Vorkommen",
      "calculator.data.provenance.rate": "Rate",
      "calculator.data.provenance.unknown_layer": "Unbekannte Ebene",
      "calculator.data.provenance.audit_details": "Audit-Details",
      "calculator.data.provenance.final": "Endergebnis",
      "calculator.data.provenance.actions": "Aktionen",
      "calculator.data.provenance.supporting": "Unterstützend",
      "calculator.data.provenance_graph.item_presence": "Gegenstandsvorkommen",
      "calculator.data.provenance_graph.group_identity": "Gruppenidentität · {$group}",
      "calculator.data.provenance_graph.group_presence": "Gruppenvorkommen · {$group}",
      "calculator.data.provenance_graph.group_membership": "Gruppenzugehörigkeit · {$group}",
      "calculator.data.provenance_graph.group_rate": "Gruppenrate · {$group}",
      "calculator.data.provenance_graph.item_rate": "Gegenstandsrate · {$group}",
      "calculator.data.provenance_graph.item_quantity": "Gegenstandsmenge · {$group}",
      "calculator.data.provenance_graph.item_quantity_default": "Standardmenge des Gegenstands",
      "calculator.data.provenance_graph.active_condition": "Aktive Bedingung",
      "calculator.data.provenance_graph.presence": "Vorkommen",
      "calculator.data.provenance_graph.presence_description": "Direkte Vorkommensfakten für die ausgewählte Angelgruppe oder Beutezeile.",
      "calculator.data.provenance_graph.rate": "Rate",
      "calculator.data.provenance_graph.rate_description": "Direkte Ratenfakten für die ausgewählte Angelgruppe oder Beutezeile sowie Mengenfakten für eine ausgewählte Beutezeile.",
      "calculator.data.provenance_graph.result": "Ergebnis",
      "calculator.data.provenance_graph.no_effective": "Kein wirksamer Fakt",
      "calculator.data.provenance_graph.select_subject": "Wähle eine Angelgruppe oder Beutezeile aus, um ihre Provenienz zu prüfen.",
      "calculator.data.provenance_graph.details_unavailable": "Für diesen Fakt sind keine Provenienzdetails verfügbar.",
      "calculator.data.provenance_graph.no_facts": "Für diesen Kanal sind keine Provenienzfakten geladen.",
      "calculator.data.provenance_graph.scroll_label": "Provenienzdiagramm „{$channel}“",
      "calculator.data.provenance_graph.subject": "Provenienz für {$subject}",
      "calculator.data.provenance_graph.heading": "Beuteprovenienz",
      "calculator.data.provenance_graph.description": "Jede Spur beginnt mit ihrem Endwert. Nach rechts folgen die Kandidaten von der höchsten zur niedrigsten Priorität.",
      "calculator.data.metadata.content_hash": "Inhalts-Hash",
      "calculator.data.metadata.comment": "Kommentar",
      "calculator.data.metadata.confidence": "Sicherheit",
      "calculator.data.metadata.author": "Autor",
      "calculator.data.metadata.author_handle": "Autor-Handle",
      "calculator.data.metadata.author_id": "Autor-ID",
      "calculator.data.metadata.created": "Erstellt",
      "calculator.data.metadata.claim_date": "Behauptungsdatum",
      "calculator.data.metadata.claim_date_approximate_value": "Ca. {$range}",
      "calculator.data.metadata.deactivated_by": "Deaktiviert durch",
      "calculator.data.metadata.evidence_class": "Evidenzklasse",
      "calculator.data.metadata.fact_id": "Fakt-ID",
      "calculator.data.metadata.imported": "Importiert",
      "calculator.data.metadata.layer": "Ebene",
      "calculator.data.metadata.observation_count": "Beobachtungsanzahl",
      "calculator.data.metadata.observation_scope": "Beobachtungsbereich",
      "calculator.data.metadata.observed": "Beobachtet",
      "calculator.data.metadata.operation": "Operation",
      "calculator.data.metadata.operation_id": "Operations-ID",
      "calculator.data.metadata.refutation_comment": "Kommentar zur Widerlegung",
      "calculator.data.metadata.refutation_confidence": "Sicherheit der Widerlegung",
      "calculator.data.metadata.refutation_author": "Autor der Widerlegung",
      "calculator.data.metadata.refutation_author_handle": "Handle des Widerlegungsautors",
      "calculator.data.metadata.refutation_author_id": "ID des Widerlegungsautors",
      "calculator.data.metadata.refutation_created": "Widerlegung erstellt",
      "calculator.data.metadata.refutation_claim_date": "Widerlegungsdatum",
      "calculator.data.metadata.refutation_reason": "Widerlegungsgrund",
      "calculator.data.metadata.refuted_by": "Widerlegt durch",
      "calculator.data.metadata.row": "Zeile",
      "calculator.data.metadata.sheet": "Tabellenblatt",
      "calculator.data.metadata.source_id": "Quell-ID",
      "calculator.data.metadata.source_revision": "Quellrevision",
      "calculator.data.metadata.table": "Tabelle",
      "calculator.data.metadata.value": "Wert",
      "calculator.data.metadata.conditions": "Bedingungen",
      "calculator.data.metadata.branch_id": "Zweig-ID",
      "calculator.data.metadata.alternative": "Alternative",
      "calculator.data.evidence.catalog_result": "Aktueller Katalogsuchtreffer",
      "calculator.data.evidence.description": "Räumliche Ranglistenbeobachtungen stützen das Vorkommen eines Gegenstands in der ausgewählten Zone. Gruppenzuordnungen sind separate Fakten und können mehrere Gruppen umfassen.",
      "calculator.data.evidence.details_heading": "Details der Ranglistenbelege",
      "calculator.data.evidence.exact_identity": "Exakte numerische Gegenstandsidentität",
      "calculator.data.evidence.no_matches": "Keine Ranglistenbelege entsprechen diesem Filter.",
      "calculator.data.evidence.observed_at": "Beobachtet: {$time}",
      "calculator.data.evidence.presence_not_loaded": "Vorkommensfakt nicht geladen",
      "calculator.data.evidence.rate_warning": "Beobachtungszahlen belegen das Zonenvorkommen und sind niemals Schätzungen der Droprate.",
      "calculator.data.evidence.scope.fully_contained": "Vollständig enthaltene Ranglistenringe",
      "calculator.data.evidence.scope.partial_intersection": "Ranglistenringe mit Randüberschneidung",
      "calculator.data.evidence.review_item_label": "Belege und Zuordnungen für {$item} prüfen",
      "calculator.data.evidence.showing_limit": "Die ersten {$visible} von {$total} Treffern werden angezeigt. Verfeinere den Filter für die übrigen.",
      "calculator.data.evidence.table_caption": "Ranglistenbeobachtungen zum Vorkommen und unabhängige wirksame Gruppenzuordnungen je Gegenstand",
      "calculator.data.evidence.title": "Ranglistenbelege und Gruppenzuordnungen",
      "calculator.data.evidence.unassigned_help": "Die Rangliste stützt nur das Zonenvorkommen; wähle eine oder mehrere Gruppen.",
      "calculator.data.evidence.unquantified_in": "Nicht quantifiziert in {$group}",
      "calculator.data.evidence.user_layer_reference": "Von der Benutzerebene referenziert",
      "calculator.data.evidence.candidate_count.one": "{$count} Kandidatenfakt",
      "calculator.data.evidence.candidate_count.other": "{$count} Kandidatenfakten",
      "calculator.data.evidence.zone_count.one": "{$count} durch Ranglisten gestützter Gegenstand für diese Zone.",
      "calculator.data.evidence.zone_count.other": "{$count} durch Ranglisten gestützte Gegenstände für diese Zone.",
      "calculator.data.table.actions": "Aktionen",
      "calculator.data.table.group_facts": "Wirksame Gruppenfakten",
      "calculator.data.table.item": "Gegenstand",
      "calculator.data.table.zone_presence": "Belege für Zonenvorkommen",
      "calculator.data.advanced.editing_item": "{$item} wird bearbeitet. Vorkommen und jede Gruppenzugehörigkeit sind unabhängige typisierte Fakten.",
      "calculator.data.advanced.heading": "Erweiterter Editor für typisierte Fakten",
      "calculator.data.advanced.user_layer_edit": "Benutzerebene bearbeiten",
      "calculator.data.layer.current_source": "Ebenen der aktuellen Angelquelle",
      "calculator.data.layer.description": "Die Auflösung läuft von unveränderlichen Basisfakten über geordnete Quellen bis zuletzt zu deiner Ebene.",
      "calculator.data.layer.effective_for_fact": "Wirksam für den ausgewählten Fakt",
      "calculator.data.layer.loaded_sources.one": "{$count} geladene wirksame Quelle",
      "calculator.data.layer.loaded_sources.other": "{$count} geladene wirksame Quellen",
      "calculator.data.layer.no_model": "Kein Modell geladen.",
      "calculator.data.layer.order": "Reihenfolge {$order}",
      "calculator.data.layer.read_only": "Schreibgeschützt",
      "calculator.data.layer.user_editable": "Vom Benutzer bearbeitbar",
      "calculator.data.fact_count.one": "{$count} Faktoperation",
      "calculator.data.fact_count.other": "{$count} Faktoperationen",
      "calculator.data.operation_count.one": "{$count} Operation",
      "calculator.data.operation_count.other": "{$count} Operationen",
      "calculator.data.operations.description": "Nur diese Ebene ist bearbeitbar. Angezeigt werden Operationen für {$source}; ein Zurücksetzen legt den nächsten wirksamen Kandidaten frei.",
      "calculator.data.operations.global_count": "Globale Operationen · {$count}",
      "calculator.data.operations.hidden_source_count.one": "{$count} Operation für eine andere Angelquelle ausgeblendet.",
      "calculator.data.operations.hidden_source_count.other": "{$count} Operationen für andere Angelquellen ausgeblendet.",
      "calculator.data.operations.none_global": "Keine globalen persönlichen Operationen.",
      "calculator.data.operations.none_source": "Noch keine persönlichen Operationen für diese Angelquelle. Prüfe Belege oder füge einen Kataloggegenstand hinzu.",
      "calculator.data.operations.title": "Operationen des persönlichen Overlays",
      "calculator.data.operations.source_count.one": "{$count} Quellenoperation",
      "calculator.data.operations.source_count.other": "{$count} Quellenoperationen",
      "calculator.data.trace.effective_fact_id": "Wirksame Fakt-ID",
      "calculator.data.trace.effective_layer": "Wirksame Ebene",
      "calculator.data.trace.heading": "Provenienz des ausgewählten Fakts",
      "calculator.data.trace.none": "Keine Provenienzspuren verfügbar.",
      "calculator.data.trace.selected_fact": "Ausgewählter Fakt",
      "calculator.data.fact.branch": "Zweig {$id}",
      "calculator.data.fact.fact": "Fakt {$id}",
      "calculator.data.fact.group": "Gruppe {$id}",
      "calculator.data.fact.zone": "Zone {$id}",
      "calculator.data.boundary.initialization": "Initialisierung",
      "calculator.data.boundary.storage": "Speicher",
      "calculator.data.status.active_local": "Die aktive Benutzerebene wird lokal ausgewertet.",
      "calculator.data.status.invalid_saved_document": "Das gespeicherte v4-Dokument wurde ignoriert, da es ungültig ist: {$error} Die aktive Modellebene wurde trotzdem validiert; der Speicher wurde nicht geändert.",
      "calculator.data.status.model_refresh_failed": "Aktualisierung des Rechnermodells fehlgeschlagen.",
      "calculator.data.status.saved_removed": "Das gespeicherte v4-Overlay wurde an anderer Stelle entfernt; das aktive lokale Overlay bleibt in Verwendung.",
      "calculator.data.status.server_confirmed": "Der Server hat diese Benutzerebene bestätigt.",
      "calculator.data.status.storage_unavailable": "Der lokale Overlay-Speicher ist nicht verfügbar.",
      "calculator.data.status.storage_write_failed": "Das Overlay ist aktiv, konnte aber nicht lokal gespeichert werden: {$error}",
      "calculator.data.status.stored_locally": "Das aktive v4-Overlay ist lokal gespeichert.",
      "calculator.data.status.validation_superseded": "Neuere lokale Eingaben haben diese Validierungsantwort überholt.",
      "calculator.data.status.stored_invalid": "Die gespeicherte v4-Ebene ist ungültig.",
      "calculator.data.status.validating_boundary": "Benutzerebene wird an der Grenze „{$boundary}“ validiert.",
      "calculator.data.status.validating_result": "Rechnerergebnis wird mit dem Server validiert.",
      "calculator.data.status.waiting_for_model": "Warten auf das Rechnermodell.",
      "calculator.data.error.wait_for_model": "Warte, bis die ausgewählten Modellfakten geladen sind, bevor du die Benutzerebene bearbeitest.",
      "calculator.data.error.wait_for_author": "Warte, bis die aktuelle Änderung mit Autorenzuordnung abgeschlossen ist, bevor du weiterbearbeitest.",
      "calculator.data.announcement.custom_item_added": "{$item} wurde zu Benutzerdefiniert hinzugefügt.",
      "calculator.data.announcement.custom_item_removed": "{$item} wurde aus Benutzerdefiniert entfernt.",
      "calculator.data.announcement.filter_applied": "Filter für Ranglistenbelege angewendet.",
      "calculator.data.announcement.loading_before_add": "Die Fakten dieses Gegenstands werden geladen. Füge ihn nach Abschluss des Ladevorgangs einer Gruppe hinzu.",
      "calculator.data.announcement.loading_before_assign": "Die Fakten dieses Gegenstands werden vor der Zuordnung geladen.",
      "calculator.data.announcement.loading_item": "Fakten für Gegenstand {$id} werden geladen.",
      "calculator.data.announcement.user_layer_updated": "Benutzerebene aktualisiert.",
      "calculator.data.quantity.accessible_exact": "Menge {$quantity}",
      "calculator.data.quantity.accessible_range": "Menge {$minimum} bis {$maximum}",
      "calculator.data.quantity.accessible_expected": "Erwartete Menge {$quantity}",
      "calculator.data.quantity.expected_short": "EW",
      "calculator.data.quantity.editor_title": "Beutemenge",
      "calculator.data.quantity.minimum": "Minimum",
      "calculator.data.quantity.maximum": "Maximum",
      "calculator.data.action.revert_quantity": "Zurücksetzen",
      "calculator.data.action.edit_item_facts_for": "Daten für {$item} bearbeiten",
      "calculator.data.action.close_item_facts_for": "Daten für {$item} schließen",
      "calculator.data.item_facts.title": "Gegenstandsdaten",
      "calculator.data.item_facts.description": "Diese Werte gelten global für diesen Gegenstand.",
      "calculator.data.item_facts.price_unknown": "Unbekannt",
      "calculator.data.item_facts.revert_price": "Preis zurücksetzen",
      "calculator.data.item_facts.quantity_default": "Standard-Mengenbereich",
      "calculator.data.item_facts.revert_quantity_default": "Standard zurücksetzen",
      "calculator.server.recovery.unavailable": "Die gewählte Konfiguration konnte nicht berechnet werden. Deine Einstellungen und der gespeicherte Verlauf sind weiterhin verfügbar.",
      "calculator.server.recovery.instructions": "Für diese Konfiguration sind keine Ergebnisse verfügbar. Passe unten die Quelle oder die Begleiter an oder verwende den Vorlagenverlauf, um eine Änderung rückgängig zu machen oder eine andere Vorlage zu wählen. Versuche es anschließend erneut. Die aktuelle Arbeit wird nicht zurückgesetzt.",
      "calculator.server.recovery.retry": "Mit diesen Einstellungen erneut versuchen",
      "calculator.server.recovery.request": "Anfragedetails",
      "nav.get_started": "Erste Schritte",
      "nav.guides": "Anleitungen",
      "nav.map": "Karte",
      "nav.dex": "Dex",
      "nav.calculator": "Rechner",
      "nav.community": "Community",
      "nav.glossary": "Glossar",
      "nav.log": "Log",
      "nav.devlog": "Entwicklungslog",
      "nav.menu.open": "Navigationsmenü öffnen",
      "nav.scroll_to_top": "Nach oben scrollen",
      "admin.contest_moderator": "Wettbewerbsmoderator",
      "admin.no_contest_moderator": "Keine Wettbewerbsmoderatorenrolle",
      "admin.grant_contest_moderator": "Wettbewerbsmoderation gewähren",
      "admin.revoke_contest_moderator": "Wettbewerbsmoderation entziehen",
      "admin.contest_moderator_help": "Wettbewerbsmoderatoren können vorgeschlagene Fische bestätigen. Diese Rolle gewährt weder Kontoverwaltung noch Zugriff auf die Fishing-Logger-Beta. Administratoren können Fische auch ohne diese separate Rolle bestätigen.",
      "footer.about": "Über",
      "footer.feedback": "Feedback",
      "footer.legal": "Rechtliches",
      "footer.provider_terms": "Anbieter & Nutzungsbedingungen",
      "footer.privacy_policy": "Datenschutzerklärung",
      "footer.crio_terms": "Crio-Nutzungsbedingungen",
      "footer.crio_privacy": "Crio-Datenschutzerklärung",
      "footer.pearl_abyss_disclaimer": "FishyStuff ist ein gemeinschaftliches Hobbyprojekt und nicht mit Pearl Abyss verbunden. Dies sind inoffizielle Inhalte, die urheberrechtlich geschützte Materialien und geistiges Eigentum von Pearl Abyss enthalten und weder offiziell sind noch von Pearl Abyss unterstützt werden.",
      "common.action.save": "Speichern",
      "common.action.discard": "Verwerfen",
      "common.action.rename": "Umbenennen",
      "common.action.delete": "Löschen",
      "common.action.export": "Exportieren",
      "common.action.import": "Importieren",
      "common.action.cancel": "Abbrechen",
      "common.action.copy": "Kopieren",
      "common.action.clone": "Klonen",
      "common.action.search": "Suche",
      "common.action.close": "Schließen",
      "common.action.undo": "Rückgängig",
      "common.action.redo": "Wiederholen",
      "common.action.clear_selection": "Auswahl aufheben",
      "common.action.clear_selection_count": "Auswahl aufheben ({$count})",
      "common.status.current": "Aktuell",
      "common.status.saved": "Gespeichert",
      "common.status.modified": "Geändert",
      "common.status.default": "Standard",
      "common.status.applied": "Angewendet",
      "common.status.original": "Original",
      "common.status.active": "Aktiv",
      "common.status.selected": "Ausgewählt",
      "common.status.not_selected": "Nicht ausgewählt",
      "common.field.title": "Titel",
      "profile.menu.open": "Kontomenü öffnen",
      "profile.menu.account": "Konto",
      "profile.menu.loading": "Konto wird geprüft…",
      "profile.menu.sign_in": "Anmelden",
      "profile.menu.discord": "Mit Discord anmelden",
      "profile.menu.sign_out": "Abmelden",
      "profile.menu.unavailable": "Konto vorübergehend nicht verfügbar",
      "profile.menu.action_failed": "Die Kontoaktion konnte nicht abgeschlossen werden. Versuche es erneut.",
      "profile.menu.theme": "Design",
      "profile.menu.presets": "Vorlagen",
      "account.state.loading": "Anmeldung wird geprüft…",
      "account.state.signed_out": "Nicht angemeldet",
      "account.state.signed_out_detail": "Melde dich an oder erstelle ein FishyStuff-Konto, um synchronisierte Einstellungen und gespeicherte Daten auf diesem Gerät zu nutzen.",
      "account.state.signed_in": "Angemeldet",
      "account.state.no_recovery_email": "Es ist keine Wiederherstellungs-E-Mail hinterlegt. Eine Wiederherstellung per E-Mail ist nicht möglich.",
      "account.login.title": "Bei FishyStuff anmelden",
      "account.registration.title": "FishyStuff-Konto erstellen",
      "account.registration.email_recovery_notice": "Die Wiederherstellungs-E-Mail ist optional; ohne sie ist eine Wiederherstellung per E-Mail nicht möglich, bis du in den Kontoeinstellungen eine hinzufügst.",
      "account.registration.discord_handle_help": "Lass das Feld leer, um deinen Discord-Benutzernamen zu verwenden.",
      "account.registration.legal_title": "Nutzungsbedingungen und Datenschutzinformationen",
      "account.registration.terms_prefix": "Ich bestätige, dass ich mindestens 18 Jahre alt bin, und akzeptiere die",
      "account.registration.terms_link": "Nutzungsbedingungen",
      "account.registration.privacy_link": "Datenschutzerklärung",
      "account.registration.privacy_notice": "Wie FishyStuff Kontodaten verarbeitet, steht in der",
      "account.legal.required_title": "Aktualisierte Nutzungsbedingungen prüfen",
      "account.legal.required_detail": "Für dieses Konto ist keine Annahme genau dieser Fassung der Nutzungsbedingungen gespeichert. Die Bedingungen wurden möglicherweise aktualisiert.",
      "account.legal.notice_title": "Aktualisierte Nutzungsbedingungen erfordern deine Aufmerksamkeit",
      "account.legal.notice_detail": "Einige API-Funktionen funktionieren möglicherweise nicht mehr, bis du die aktualisierten Nutzungsbedingungen akzeptierst. Prüfe und akzeptiere sie auf der Seite der Nutzungsbedingungen oder lösche dein Konto.",
      "account.legal.review_action": "Bedingungen prüfen und akzeptieren",
      "account.legal.delete_action": "Konto löschen",
      "account.legal.version": "Version",
      "account.legal.effective": "Gültig ab",
      "account.legal.terms_prefix": "Ich bestätige, dass ich mindestens 18 Jahre alt bin, und akzeptiere die",
      "account.legal.privacy_notice": "wird zu deiner Information bereitgestellt und erläutert, wie FishyStuff Kontodaten verarbeitet.",
      "account.legal.submit": "Akzeptieren und fortfahren",
      "account.legal.status_unavailable": "Der Status der Nutzungsbedingungen ist nicht verfügbar.",
      "account.legal.recording": "Annahme wird gespeichert…",
      "account.legal.failed": "Die Annahme konnte nicht gespeichert werden. Versuche es erneut.",
      "account.discord_handle_conflict.title": "Discord-Handle nicht verfügbar",
      "account.discord_handle_conflict.detail": "Dieser Discord-Handle ist nicht verfügbar. Melde dich an, um Discord mit deinem Konto zu verknüpfen, oder registriere dich manuell mit einem anderen Handle.",
      "account.error.discord": "Die Discord-Anmeldung konnte nicht abgeschlossen werden. Versuche es erneut.",
      "account.error.discord_session": "Die Discord-Anmeldung wurde abgeschlossen, aber dein FishyStuff-Konto konnte nicht geladen werden. Lade diese Seite neu.",
      "account.discord_linked": "Discord ist jetzt mit deinem Konto verknüpft.",
      "account.settings.title": "Kontoeinstellungen",
      "account.settings.detail": "Aktualisiere deine Kontoeinstellungen.",
      "account.settings.group.account": "Konto",
      "account.settings.group.sign_in": "Anmeldemethoden",
      "account.settings.group.two_step": "Zwei-Schritt-Bestätigung",
      "account.settings.group.sessions": "Sitzungen",
      "account.settings.group.danger": "Gefahrenbereich",
      "account.settings.navigation.profile": "Profil",
      "account.settings.navigation.password": "Passwort",
      "account.settings.navigation.oidc": "Soziale Anmeldung",
      "account.settings.navigation.passkey": "Passkeys",
      "account.settings.navigation.webauthn": "Sicherheitsschlüssel",
      "account.settings.navigation.totp": "Authenticator-App",
      "account.settings.navigation.lookup_secret": "Backup-Codes",
      "account.settings.profile.title": "Profileinstellungen",
      "account.settings.profile.detail": "Aktualisiere deine Profilinformationen.",
      "account.settings.password.title": "Passwort ändern",
      "account.settings.password.detail": "Ändere oder entferne die Passwort-Anmeldung.",
      "account.settings.first_factor_removal_blocked": "Dies ist deine einzige Anmeldemethode. Füge eine weitere hinzu, bevor du sie entfernst.",
      "account.settings.oidc.title": "Verbundene Konten",
      "account.settings.oidc.detail": "Verbinde oder trenne die Discord-Anmeldung.",
      "account.settings.passkey.title": "Passkeys verwalten",
      "account.settings.passkey.detail": "Füge Passkeys hinzu oder entferne sie von diesem Konto.",
      "account.settings.webauthn.title": "Sicherheitsschlüssel",
      "account.settings.webauthn.detail": "Verwalte Gerätebiometrie und Hardware-Sicherheitsschlüssel für die Zwei-Schritt-Verifizierung.",
      "account.settings.totp.title": "Authenticator-App",
      "account.settings.totp.detail": "Verwalte die Zwei-Schritt-Verifizierung mit einer Authenticator-App.",
      "account.settings.lookup_secret.title": "Backup-Wiederherstellungscodes",
      "account.settings.lookup_secret.detail": "Verwalte Wiederherstellungscodes für die Zwei-Schritt-Verifizierung.",
      "account.recovery.title": "Kontozugriff wiederherstellen",
      "account.recovery.detail": "Wir senden einen kurzzeitig gültigen Code an die in deinem Konto hinterlegte Wiederherstellungs-E-Mail.",
      "account.verification.title": "Wiederherstellungs-E-Mail bestätigen",
      "account.verification.detail": "Bestätige deine Wiederherstellungs-E-Mail, damit sie für die Kontowiederherstellung verwendet werden kann.",
      "account.verification.complete_title": "Wiederherstellungs-E-Mail bestätigt",
      "account.verification.complete_detail": "Deine Wiederherstellungs-E-Mail ist bestätigt und kann jetzt zur Kontowiederherstellung verwendet werden.",
      "account.step_up.title": "Zwei-Schritt-Bestätigung abschließen",
      "account.step_up.detail": "Verwende einen Sicherheitsschlüssel, deine Authenticator-App oder einen Backup-Code, um sicher fortzufahren.",
      "account.reauthenticate.title": "Identität bestätigen",
      "account.reauthenticate.detail": "Melde dich erneut an, bevor du sensible Kontodaten änderst.",
      "account.identity_owned": "Änderungen an Profil, Anmeldung und Sicherheit werden direkt vom FishyStuff-Kontodienst verarbeitet, getrennt von synchronisierten Einstellungen und lokalen Browserdaten.",
      "account.field.identifier": "Konto-Handle oder Wiederherstellungs-E-Mail",
      "account.field.identifier_optional": "Konto-Handle oder Wiederherstellungs-E-Mail (optional)",
      "account.field.handle": "Konto-Handle",
      "account.field.handle_optional": "Konto-Handle (optional)",
      "account.field.display_name": "Anzeigename",
      "account.field.display_name_optional": "Anzeigename (optional)",
      "account.field.display_name_help": "Wenn dieses Feld leer bleibt, zeigt FishyStuff stattdessen dein Konto-Handle an.",
      "account.field.password": "Passwort",
      "account.field.recovery_email": "Wiederherstellungs-E-Mail",
      "account.field.recovery_email_help": "Behalte mindestens eine bestätigte Adresse, damit du dein Konto per E-Mail wiederherstellen kannst.",
      "account.field.email_code": "E-Mail-Code",
      "account.field.authenticator_code": "Authenticator-Code",
      "account.field.backup_code": "Backup-Code",
      "account.field.security_key_name": "Name des Sicherheitsschlüssels",
      "account.method.password": "Konto-Handle und Passwort",
      "account.method.regular_sign_in": "Regulär anmelden",
      "account.method.password_change": "Passwort",
      "account.method.discord": "Discord",
      "account.method.passkey": "Passkeys",
      "account.method.passkey_sign_in": "Passkey",
      "account.method.security_key": "Sicherheitsschlüssel",
      "account.method.profile": "Profildaten",
      "account.avatar.title": "Profilbild",
      "account.avatar.detail": "Wähle dein Discord-Bild oder einen FishyStuff-Avatar. Es wird zusammen mit deinem Profil gespeichert.",
      "account.avatar.discord": "Discord",
      "account.avatar.search": "Avatare suchen",
      "account.avatar.fishystuff": "FishyStuff-Avatare",
      "account.avatar.choose_fishystuff": "FishyStuff-Avatar auswählen",
      "account.avatar.color": "Avatarfarbe",
      "account.avatar.color.base": "Theme",
      "account.avatar.color.primary": "Primär",
      "account.avatar.color.secondary": "Sekundär",
      "account.avatar.color.accent": "Akzent",
      "account.avatar.fish": "Fisch",
      "account.avatar.cat": "Katze",
      "account.avatar.dog": "Hund",
      "account.avatar.rabbit": "Kaninchen",
      "account.avatar.bear": "Bär",
      "account.avatar.deer": "Hirsch",
      "account.avatar.bird": "Vogel",
      "account.avatar.butterfly": "Schmetterling",
      "account.avatar.flower": "Blume",
      "account.avatar.leaf": "Blatt",
      "account.avatar.tree": "Baum",
      "account.avatar.wave": "Welle",
      "account.avatar.paw": "Pfote",
      "account.avatar.birthday-2": "Geburtstagstorte",
      "account.avatar.bone": "Knochen",
      "account.avatar.bottle-glass": "Glasflasche",
      "account.avatar.bowl-2": "Schale 2",
      "account.avatar.bowl": "Schale",
      "account.avatar.bread": "Brot",
      "account.avatar.cake": "Kuchen",
      "account.avatar.candy-2": "Bonbon 2",
      "account.avatar.candy": "Bonbon",
      "account.avatar.carrot": "Karotte",
      "account.avatar.champagne": "Champagner",
      "account.avatar.chicken": "Huhn",
      "account.avatar.chopsticks": "Essstäbchen",
      "account.avatar.cookie": "Keks",
      "account.avatar.cookie-man": "Lebkuchenmännchen",
      "account.avatar.cupcake": "Cupcake",
      "account.avatar.dinner": "Abendessen",
      "account.avatar.dish-cover": "Servierglocke",
      "account.avatar.donut": "Donut",
      "account.avatar.drink": "Getränk",
      "account.avatar.egg-crack": "Aufgeschlagenes Ei",
      "account.avatar.egg": "Ei",
      "account.avatar.electric-cooker": "Reiskocher",
      "account.avatar.feeder": "Futterspender",
      "account.avatar.fork": "Gabel",
      "account.avatar.fork-knife": "Gabel und Messer",
      "account.avatar.fork-spoon": "Gabel und Löffel",
      "account.avatar.fried-egg": "Spiegelei",
      "account.avatar.fries": "Pommes",
      "account.avatar.glass-cup": "Trinkglas",
      "account.avatar.hamburger": "Hamburger",
      "account.avatar.ice-cream-2": "Eis 2",
      "account.avatar.ice-cream": "Eis",
      "account.avatar.lollipop": "Lutscher",
      "account.avatar.pizza": "Pizza",
      "account.avatar.soup-pot-2": "Suppentopf 2",
      "account.avatar.soup-pot": "Suppentopf",
      "account.avatar.spatula": "Pfannenwender",
      "account.avatar.spoon": "Löffel",
      "account.avatar.sugar-coated-haws": "Kandierte Früchte",
      "account.avatar.teacup": "Teetasse",
      "account.avatar.wine": "Wein",
      "account.avatar.wineglass-2": "Weinglas 2",
      "account.avatar.wineglass": "Weinglas",
      "account.avatar.none": "Kein Bild",
      "account.method.authenticator": "Authenticator-App",
      "account.method.backup_codes": "Backup-Codes",
      "account.method.email_code": "E-Mail-Code",
      "account.action.sign_in": "Anmelden",
      "account.action.submit": "Anmelden",
      "account.action.create": "Konto erstellen",
      "account.action.register": "Konto erstellen",
      "account.action.sign_in_discord": "Mit Discord anmelden",
      "account.action.register_discord": "Mit Discord registrieren",
      "account.action.link_discord": "Discord verknüpfen",
      "account.action.unlink_discord": "Discord-Verknüpfung entfernen",
      "account.action.remove_password": "Passwort entfernen",
      "account.action.sign_in_passkey": "Mit Passkey anmelden",
      "account.login.or": "oder",
      "account.action.register_passkey": "Mit Passkey registrieren",
      "account.action.add_passkey": "Passkey hinzufügen",
      "account.action.remove_passkey": "Passkey entfernen",
      "account.action.add_security_key": "Sicherheitsschlüssel hinzufügen",
      "account.action.use_security_key": "Sicherheitsschlüssel verwenden",
      "account.action.remove_security_key": "Sicherheitsschlüssel entfernen",
      "account.action.rename_passkey": "Umbenennen",
      "account.passkey.default_name": "Passkey",
      "account.passkey.rename_prompt": "Gib einen neuen Namen für diesen Passkey ein (1–80 Zeichen).",
      "account.passkey.name_invalid": "Verwende 1–80 Zeichen ohne Leerzeichen am Anfang oder Ende.",
      "account.passkey.name_saved": "Passkey-Name gespeichert.",
      "account.passkey.name_failed": "Der Passkey-Name konnte nicht gespeichert werden.",
      "account.passkey.name_conflict": "Dieser Passkey-Name wurde an anderer Stelle geändert. Der neueste Name wird angezeigt.",
      "account.passkey.identifier_help": "Normalerweise kannst du das Konto in der Passkey-Abfrage deines Geräts auswählen.",
      "account.action.save_profile": "Kontodaten speichern",
      "account.action.change_password": "Passwort ändern",
      "account.action.continue": "Weiter",
      "account.action.need_account": "Noch kein Konto? Registrieren",
      "account.action.register_manually": "Konto manuell erstellen",
      "account.action.have_account": "Bereits registriert? Anmelden",
      "account.action.sign_out": "Abmelden",
      "account.action.sign_in_again": "Erneut anmelden",
      "account.action.cancel": "Abbrechen",
      "account.action.back": "Zurück zum Konto",
      "account.action.back_to_sign_in": "Zurück zur Anmeldung",
      "account.action.forgot_password": "Passwort vergessen?",
      "account.action.recover": "Konto wiederherstellen",
      "account.action.verify": "Bestätigen",
      "account.action.verify_email": "Wiederherstellungs-E-Mail bestätigen",
      "account.action.send_code": "Code senden",
      "account.action.resend_code": "Neuen Code senden",
      "account.action.send_recovery_code": "Wiederherstellungscode senden",
      "account.action.send_verification_code": "Bestätigungscode senden",
      "account.action.enable_authenticator": "Bestätigen und aktivieren",
      "account.action.remove_authenticator": "Authenticator-App entfernen",
      "account.action.show_backup_codes": "Backup-Codes anzeigen",
      "account.action.regenerate_backup_codes": "Neue Backup-Codes erzeugen",
      "account.action.remove_backup_codes": "Backup-Codes entfernen",
      "account.action.confirm_backup_codes": "Ich habe diese Codes gespeichert",
      "account.confirm.remove_passkey": "Diesen Passkey entfernen?",
      "account.confirm.remove_password": "Die Passwort-Anmeldung von diesem Konto entfernen?",
      "account.confirm.unlink_discord": "Die Discord-Anmeldung von diesem Konto trennen?",
      "account.confirm.remove_security_key": "Diesen Sicherheitsschlüssel aus deinen Methoden zur Zwei-Schritt-Verifizierung entfernen?",
      "account.confirm.remove_authenticator": "Die Authenticator-App von diesem Konto entfernen?",
      "account.confirm.regenerate_backup_codes": "Neue Backup-Codes erzeugen? Deine bisherigen Backup-Codes funktionieren danach nicht mehr.",
      "account.confirm.remove_backup_codes": "Alle Backup-Codes von diesem Konto entfernen?",
      "account.confirm.revoke_sessions": "Alle anderen aktiven Sitzungen abmelden?",
      "account.error.title": "Problem beim Kontozugriff",
      "account.error.connection_title": "Kontoverknüpfung erfordert Aufmerksamkeit",
      "account.error.connection_conflict": "Diese Anmeldemethode ist bereits mit einem anderen Konto verknüpft. Melde dich zuerst bei diesem Konto an, wenn du seine Verknüpfungen ändern möchtest.",
      "account.error.login_expired": "Deine Anmeldung ist abgelaufen. Melde dich erneut an, um fortzufahren.",
      "account.error.flow_expired": "Dieses Sicherheitsformular ist abgelaufen. Prüfe das neue Formular und sende es erneut ab.",
      "account.error.sign_out": "Die Abmeldung konnte nicht abgeschlossen werden.",
      "account.reauthentication.complete": "Anmeldung erneuert und deine Änderung wurde abgeschlossen.",
      "account.error.unsupported": "Diese Anmeldeseite enthält Steuerelemente, die diese FishyStuff-Version nicht sicher darstellen kann.",
      "account.message.continue": "Fahre fort, um diesen Kontoschritt abzuschließen.",
      "account.message.request_failed": "Die Anfrage konnte nicht abgeschlossen werden. Prüfe die Angaben und versuche es erneut.",
      "account.error.last_sign_in_method": "Dies ist deine einzige Anmeldemethode. Füge eine weitere hinzu, bevor du sie entfernst.",
      "account.passkey.loading": "Passkey-Unterstützung wird geladen…",
      "account.passkey.cancelled": "Die Passkey-Anfrage wurde nicht abgeschlossen.",
      "account.passkey.unavailable": "Passkey-Unterstützung ist nicht verfügbar.",
      "account.passkey.device_unavailable": "Dieses Gerät kann keinen FishyStuff-Passkey erstellen. Versuche es mit einem Gerät mit unterstütztem Passwortmanager und Bildschirmsperre.",
      "account.webauthn.default_name": "Sicherheitsschlüssel",
      "account.webauthn.loading": "Sicherheitsschlüssel-Unterstützung wird geladen…",
      "account.webauthn.cancelled": "Die Sicherheitsschlüssel-Anfrage wurde nicht abgeschlossen.",
      "account.webauthn.unavailable": "Sicherheitsschlüssel-Unterstützung ist nicht verfügbar.",
      "account.webauthn.device_unavailable": "Dieses Gerät kann keinen FishyStuff-Sicherheitsschlüssel erstellen. Versuche es mit einem anderen Browser, Gerätebiometrie oder einem Hardware-Sicherheitsschlüssel.",
      "account.navigation": "Kontozugriff",
      "account.totp.qr_alt": "QR-Code zum Einrichten der Authenticator-App",
      "account.totp.qr_help": "Scanne diesen Code mit deiner Authenticator-App und gib anschließend den erzeugten Code unten ein.",
      "account.totp.manual_help": "Du kannst den QR-Code nicht scannen? Gib diesen Einrichtungsschlüssel manuell ein:",
      "account.backup_codes.save_notice": "Bewahre diese Codes an einem sicheren Ort auf. Jeder verfügbare Code kann einmal verwendet werden, falls du den Zugriff auf deine Authenticator-App verlierst.",
      "account.backup_codes.used": "Verwendeter Code",
      "account.email.title": "E-Mail-Adressen",
      "account.email.address": "E-Mail-Adresse",
      "account.email.verified": "Bestätigt",
      "account.email.unverified": "Nicht bestätigt",
      "account.action.add_display_name": "Anzeigenamen hinzufügen",
      "account.action.remove_display_name": "Anzeigenamen entfernen",
      "account.action.add_email": "E-Mail hinzufügen",
      "account.action.remove_email": "E-Mail entfernen",
      "account.session.standard": "Diese Sitzung verwendet die Standardanmeldung.",
      "account.session.two_step": "Für diese Sitzung wurde die Zwei-Schritt-Bestätigung abgeschlossen.",
      "account.sessions.title": "Andere angemeldete Sitzungen",
      "account.sessions.tab": "Sitzungen",
      "account.sessions.none": "Keine weiteren aktiven Sitzungen.",
      "account.sessions.unavailable": "Deine anderen Sitzungen sind derzeit nicht verfügbar. Profil- und Abmeldefunktionen funktionieren weiterhin.",
      "account.sessions.unsupported": "Deine anderen Sitzungen können in dieser Version nicht sicher angezeigt werden.",
      "account.sessions.item": "Angemeldete Sitzung",
      "account.sessions.signed_in": "Angemeldet am",
      "account.sessions.expires": "gültig bis",
      "account.sessions.revoke": "Sitzung abmelden",
      "account.sessions.revoke_all": "Alle anderen Sitzungen abmelden",
      "account.sessions.revoking": "Ausgewählte Sitzung wird abgemeldet…",
      "account.sessions.revoking_all": "Alle anderen Sitzungen werden abgemeldet…",
      "account.sessions.revoke_failed": "Diese Sitzung konnte nicht abgemeldet werden. Versuche es erneut.",
      "account.deletion.title": "Konto löschen",
      "account.deletion.warning": "Das Löschen deines Kontos kann nicht rückgängig gemacht werden. Dein FishyStuff-Konto und die über das Konto zugängliche synchronisierte private Historie werden entfernt und du wirst auf allen Geräten abgemeldet.",
      "account.deletion.retention": "Serverseitige Kontodaten und die synchronisierte private Historie werden gelöscht. Bei der Löschung zusammengeführte Minimal-Kontext-Angelstatistiken bleiben ohne feste Löschfrist erhalten und können wie in der Datenschutzerklärung beschrieben weitergegeben oder veröffentlicht werden. FishyStuff bewahrt keine Verbindung zwischen Konto und Beitrag auf; eine Zuordnung mithilfe externer Informationen kann dennoch möglich sein. Auf deinen Geräten gespeicherte Daten werden nicht gelöscht. Für Backups, vorübergehende Löschungsnachweise, Sicherheitsprotokolle und rechtliche Aufzeichnungen gelten die Fristen der Datenschutzerklärung.",
      "account.deletion.confirm_prompt": "Gib dieses Handle zur Bestätigung exakt ein:",
      "account.deletion.action": "Konto löschen",
      "account.deletion.pending": "Dein Konto wird gelöscht…",
      "account.deletion.accepted_title": "Kontolöschung gestartet",
      "account.deletion.accepted_detail": "Deine Kontodaten sind gesperrt und die Bereinigung wird fortgesetzt. Du wirst auf allen Geräten abgemeldet, sobald die Löschung abgeschlossen ist.",
      "account.deletion.retryable": "Das Löschen des Kontos konnte nicht abgeschlossen werden. Versuche es erneut.",
      "account.deletion.identity_changed": "Wir haben dein Konto erneut geprüft. Bestätige das aktuelle Handle, bevor du es löschst.",
      "account.deletion.reauthenticate": "Melde dich zu deiner Sicherheit erneut an, bevor du dein Konto löschst.",
      "account.deletion.reauthenticate_action": "Erneut anmelden",
      "account.deletion.complete_title": "Konto gelöscht",
      "account.deletion.complete_detail": "Dein FishyStuff-Konto und die über das Konto zugängliche synchronisierte private Historie wurden gelöscht. Du wurdest auf allen Geräten abgemeldet.",
      "account.deletion.complete_local": "Browserlokale und Offline-Daten auf diesem oder anderen Geräten wurden nicht gelöscht.",
      "account.privacy.title": "Datenschutz & Daten",
      "account.privacy.detail": "Prüfe die optionale Übermittlung von Diagnosedaten und Discord-Profilbilder.",
      "desktop.privacy.title": "Datenschutzhinweise für Desktop / Datensatzbeitrag",
      "desktop.privacy.detail": "Lies diese gesonderten Hinweise vor dem Download von Desktop oder dem Verbinden der Synchronisierung. Sie erläutern lokale Erfassung, private Synchronisierung und Datensatzbeiträge. Dies ist Information, keine Einwilligung; Öffnen oder Speichern aktiviert keinen Beitrag.",
      "desktop.privacy.access": "Die vollständigen deutschen und englischen Hinweise sind online für angemeldete, berechtigte Kontoinhaber schon vor der Teilnahme zugänglich. Zum Lesen oder Herunterladen ist keine Annahme der aktuellen Nutzungsbedingungen erforderlich.",
      "desktop.privacy.contact": "Ehemalige Teilnehmende, geschlossene Konten oder kein Zugriff: Fordere diese Informationen an oder übe Datenschutzrechte per E-Mail aus. Registrierung, Zahlung und Annahme von Nutzungsbedingungen sind dafür nicht erforderlich:",
      "desktop.privacy.before_download": "Vor der Installation: Datenschutzhinweise für Desktop / Datensatzbeitrag lesen (Information, keine Einwilligung).",
      "account.privacy.no_active_consent": "Keine aktive Einwilligung",
      "account.privacy.clear_declined": "Abgelehnte Auswahl löschen",
      "account.browser.title": "Dieser Browser",
      "account.browser.detail": "Verwalte Daten, die nur auf diesem Gerät gespeichert sind. Diese Aktionen löschen keine synchronisierten Kontodaten.",
      "account.browser.local_detail": "Lösche das abgemeldete Autorenschaftsprofil, lokale Darstellungs- und Spracheinstellungen oder gemeinsame Browser-Einstellungen.",
      "account.browser.clear_profile": "Lokales Profil löschen",
      "account.browser.reset_appearance": "Lokale Darstellung zurücksetzen",
      "account.browser.reset_interface": "Browser-Oberfläche zurücksetzen",
      "account.browser.cache_detail": "Lösche wiederherstellbare Laufzeitdateien der FishyStuff-Karte, ohne Lesezeichen, Karteneinstellungen oder andere gespeicherte Daten zu entfernen.",
      "account.browser.clear_cache": "Laufzeit-Cache löschen",
      "account.browser.delete_detail": "Lösche alle gespeicherten Benutzerdaten aus diesem Browser. Synchronisierte Kontodaten und der Sitzungszustand offener Karten-Tabs werden nicht gelöscht.",
      "account.browser.delete_all": "Browserdaten löschen",
      "appearance.domain_colors.title": "Palettenquellen",
      "appearance.domain_colors.detail": "Wähle, ob quellengestützte Bezeichnungen Spielfarben oder Farben des aktiven Designs verwenden.",
      "appearance.domain_colors.game.label": "Spielfarben verwenden",
      "appearance.domain_colors.game.detail": "Qualitäts-, Rang- und übliche Statusfarben verwenden die Spielpalette.",
      "appearance.domain_colors.game_grades.label": "Designfarben verwenden, aber Spielfarben für Qualitäten und Ränge",
      "appearance.domain_colors.game_grades.detail": "Statusfarben folgen dem Design; Gegenstandsqualitäten und Lebensfertigkeitsränge behalten ihre Spielfarben.",
      "appearance.domain_colors.theme.label": "Designfarben verwenden",
      "appearance.domain_colors.theme.detail": "Gegenstandsqualitäten und Lebensfertigkeitsränge folgen beide dem aktiven Design.",
      "profile.role.profile": "Profil",
      "profile.role.member": "Mitglied",
      "profile.provider.account": "Konto",
      "profile.actor.guest_name": "Angler {$id}",
      "profile.actor.provider_profile": "{$provider}-Profil",
      "profile.actor.provider_user": "{$provider}-Benutzer",
      "profile.local_profile.label": "Browser {$id}",
      "profile.session.label": "Sitzung {$id}",
      "profile.telemetry.status.on": "An",
      "profile.telemetry.status.off": "Aus",
      "profile.telemetry.preference.requested_on": "Aktivierung angefragt",
      "profile.telemetry.preference.stored_off": "Deaktiviert gespeichert",
      "profile.telemetry.preference.unavailable": "Nicht verfügbar",
      "profile.telemetry.preference.always_on": "Immer an",
      "profile.telemetry.preference.always_off": "Immer aus",
      "profile.telemetry.preference.using_default": "Standard verwenden",
      "profile.telemetry.detail.unavailable": "Telemetrie ist nicht verfügbar.",
      "profile.telemetry.detail.enabled": "Telemetrie ist aktiviert.",
      "profile.telemetry.detail.disabled": "Telemetrie ist deaktiviert.",
      "profile.telemetry.detail.off": "Telemetrie ist aus.",
      "profile.diagnostic_reports.status.manual": "Manuell",
      "profile.diagnostic_reports.detail.manual": "Berichte werden manuell geteilt.",
      "profile.data_scope.profile_data": "Profildaten",
      "profile.data_scope.profile_ui": "Profil-UI",
      "profile.data_scope.browser_data": "Browserdaten",
      "profile.data_scope.browser_ui": "Browser-UI",
      "profile.data_scope.map_data": "Kartendaten",
      "profile.data_scope.map_ui": "Karten-UI",
      "profile.data_scope.dex_data": "Dex-Daten",
      "profile.data_scope.dex_ui": "Dex-UI",
      "profile.data_scope.calculator_data": "Rechnerdaten",
      "profile.data_scope.calculator_ui": "Rechner-UI",
      "profile.data_scope.presets_data": "Gespeicherte Vorlagen",
      "profile.data_scope.overrides_data": "Override-Daten",
      "profile.data_scope.tutorial_progress": "Tutorial-Fortschritt",
      "profile.data_scope.all": "Alle lokalen Daten",
      "health.menu.open": "Statusmenü öffnen",
      "health.menu.title": "Seitenstatus",
      "health.menu.send_report": "Bericht senden",
      "health.menu.dismiss_all": "Alle ausblenden",
      "health.menu.show_status": "Statusmenü anzeigen",
      "health.menu.show_warnings": "Statuswarnungen anzeigen",
      "health.menu.visible_when_warnings": "Sichtbar, wenn Warnungen aktiv sind",
      "health.menu.visible_for_errors": "Sichtbar, solange Fehler aktiv sind",
      "health.menu.hidden_in_settings": "In den Einstellungen ausgeblendet",
      "health.telemetry.detail.export_failed": "Der letzte manuelle Bericht konnte nicht zugestellt werden.",
      "health.telemetry.detail.ready": "Manuelle Berichte können gesendet werden.",
      "health.telemetry.detail.missing_logs_exporter": "Der Versand manueller Berichte ist nicht konfiguriert.",
      "health.telemetry.detail.logs_unavailable": "Manuelle Berichte können derzeit nicht gesendet werden.",
      "health.telemetry.detail.disabled_by_runtime_policy": "Manuelle Berichte sind durch die Laufzeitrichtlinie deaktiviert.",
      "health.telemetry.detail.uninitialized": "Der Versand manueller Berichte wurde für diese Seite noch nicht initialisiert.",
      "health.issue.default_page_title": "Seitenproblem",
      "health.issue.active_warning.one": "1 aktive Warnung",
      "health.issue.active_warning.many": "{$count} aktive Warnungen",
      "health.issue.severity.error": "Fehler",
      "health.issue.severity.warning": "Warnung",
      "health.issue.severity.info": "Info",
      "health.issue.dismiss": "Ausblenden",
      "health.issue.copy_details": "Details kopieren",
      "health.issue.copy_success": "Fehlerdetails kopiert.",
      "health.issue.copy_failure": "Die Zwischenablage ist in diesem Browser nicht verfügbar.",
      "health.console_error.title": "Konsolenfehler",
      "health.resource_error.title": "Ressourcen-Ladefehler",
      "health.runtime_error.title": "Seitenskriptfehler",
      "health.unhandled_rejection.title": "Unbehandelter Seitenfehler",
      "health.report.summary.warnings": "{$count} Seitenstatus-Warnungen",
      "health.report.failure.delivery": "Der manuelle Bericht konnte nicht zugestellt werden.",
      "health.report.failure.telemetry_off": "Manuelle Berichte können für diese Seite nicht gesendet werden.",
      "health.report.failure.logs_unavailable": "Manuelle Berichte können derzeit nicht gesendet werden.",
      "health.report.failure.telemetry_unavailable": "Manuelle Berichte können derzeit nicht gesendet werden.",
      "health.report.success.sent": "Diagnosebericht gesendet.",
      "health.report.send_title": "Ausgewählte Probleme und Beschreibung prüfen",
      "health.report.preview_title": "Diesen Diagnosebericht prüfen",
      "health.report.preview_notice": "Nur das unten exakt angezeigte JSON wird gesendet, wenn du „Diesen Bericht senden“ auswählst.",
      "health.report.preview_cancel": "Abbrechen",
      "health.report.preview_confirm": "Diesen Bericht senden",
      "common.provenance.label.default": "Provenienz",
      "common.provenance.channel.presence": "Präsenz",
      "common.provenance.channel.rate": "Rate",
      "common.provenance.source.database": "Datenbank",
      "common.provenance.source.ranking": "Ranking",
      "common.provenance.source.ranking_ring": "Ranking-Ring",
      "common.provenance.source.community": "Community",
      "common.provenance.source.community_guess": "Community-Schätzwert",
      "common.provenance.source.community_support": "Community-Hinweis",
      "common.provenance.source.derived": "Abgeleitet",
      "common.provenance.source.overlay": "Persönliches Overlay",
      "common.provenance.source.overlay_short": "Overlay",
      "common.provenance.source.mixed_support": "Gemischte Hinweise",
      "common.provenance.source.mixed_sources": "Gemischte Quellen",
      "common.provenance.source.full_ring": "Vollständiger Ring",
      "common.provenance.source.partial_ring": "Teilweiser Ring",
      "common.provenance.source.unspecified": "Nicht angegeben",
      "common.provenance.source.detail": "Detail",
      "common.provenance.detail.database_rate": "Datenbankgestützte Rate.",
      "common.provenance.detail.database_rate_value": "Datenbankgestützte Rate. Aktueller Wert: {$value}.",
      "common.provenance.detail.database_presence": "Datenbankgestützte Präsenz.",
      "common.provenance.detail.ranking_presence": "Ranking-Ring-Unterstützung durch beobachtete Spielerpositionen.",
      "common.provenance.detail.ranking_rate": "Ranking-abgeleitete Provenienz.",
      "common.provenance.detail.community_rate": "Von der Community gepflegter Schätzwert.",
      "common.provenance.detail.community_presence": "Von der Community gepflegte Präsenzunterstützung.",
      "common.provenance.detail.derived_rate": "Abgeleitete Rate.",
      "common.provenance.detail.derived_rate_value": "Abgeleitete Rate. Aktueller Wert: {$value}.",
      "common.provenance.detail.derived_presence": "Abgeleitete Präsenzunterstützung.",
      "common.provenance.detail.overlay": "Persönlicher Overlay-Vorschlag.",
      "common.provenance.detail.overlay_rate_value": "Persönlicher Overlay-Vorschlag. Aktueller Wert: {$value}.",
      "common.provenance.detail.mixed_presence": "Mehrere Präsenzquellen unterstützen diese Zeile.",
      "common.provenance.detail.mixed": "Mehrere Provenienzquellen unterstützen diese Zeile.",
      "common.provenance.detail.missing": "Keine Provenienz für {$channel} erfasst.",
      "domain.entity.fish": "Fisch",
      "domain.entity.fish_id": "Fisch {$id}",
      "domain.entity.item": "Gegenstand",
      "domain.entity.item_id": "Gegenstand {$id}",
      "domain.entity.zone": "Zone",
      "domain.entity.map": "Karte",
      "domain.taxonomy.grade": "Qualität",
      "domain.taxonomy.method": "Methode",
      "domain.method.rod": "Angel",
      "domain.method.hotspot": "Hotspot",
      "domain.method.harpoon": "Harpune",
      "domain.method.fishing": "Angeln",
      "domain.source.zone": "Zone",
      "domain.source.hotspot": "Hotspot",
      "domain.source.ice_fishing": "Eisfischen",
      "domain.grade.prize": "Preisfisch",
      "domain.grade.red": "Rot",
      "domain.grade.yellow": "Gelb",
      "domain.grade.blue": "Blau",
      "domain.grade.green": "Grün",
      "domain.grade.white": "Weiß",
      "domain.grade.unknown": "Unbekannt",
      "domain.loot_group.prize": "Preisfisch",
      "domain.loot_group.rare": "Selten",
      "domain.loot_group.high_quality": "Hochwertig",
      "domain.loot_group.general": "Allgemein",
      "domain.loot_group.trash": "Schrott",
      "domain.loot_group.unassigned": "Nicht zugewiesen",
      "common.rate_basis.normalized.description": "Endgültiger zugeteilter Prozentsatz, nachdem feste Anteile und Gewichtungen aufgelöst wurden.",
      "common.rate_basis.denormalized.description": "Dasselbe Rohgewicht geteilt durch 10.000 und mit % dargestellt.",
      "common.rate_basis.raw_weight.description": "Eine nichtnegative relative Eingabe, die die nach festen Anteilen verbleibende Wahrscheinlichkeit aufteilt.",
      "by": "Von",
      "by_lower": "von",
      "last_updated": "Zuletzt aktualisiert",
      "originally_posted": "Ursprünglich veröffentlicht",
      "updated": "Aktualisiert",
      "minutes_read_suffix": "Min. Lesezeit",
      "minutes_read_abbrev": "Min.",
      "language.menu.label": "Sprache",
      "language.menu.content": "Inhaltssprache",
      "language.menu.locale": "UI-Sprache",
      "language.menu.api": "Datensprache",
      "language.menu.service_region": "Spiel-Serviceregion",
      "language.menu.content_help": "Ändert Seiteninhalte wie Guides, wenn eine Übersetzung verfügbar ist.",
      "language.menu.locale_help": "Ändert Oberflächenbeschriftungen wie Menüs, Buttons und Steuerelemente.",
      "language.menu.api_help": "Ändert Spieldatentexte wie Item-, Regions- und Knotennamen.",
      "language.menu.service_region_help": "Legt deine Spiel-Serviceregion für regionsspezifische Daten und Standardwerte fest.",
      "language.option.auto.locale": "Inhaltssprache folgen",
      "language.option.follow_content.api": "Inhaltssprache folgen",
      "language.option.region_default.api": "Regionale Standard-Datensprache verwenden",
      "language.option.content.en-US": "English",
      "language.option.content.de-DE": "Deutsch",
      "language.option.locale.en-US": "English (en-US)",
      "language.option.locale.de-DE": "Deutsch (de-DE)",
      "language.option.locale.ko-KR": "한국어 (ko-KR)",
      "language.option.api.en": "English (en)",
      "language.option.api.de": "Deutsch (de)",
      "language.option.api.es": "Español (es)",
      "language.option.api.fr": "Français (fr)",
      "language.option.api.id": "Bahasa Indonesia (id)",
      "language.option.api.jp": "日本語 (jp)",
      "language.option.api.kr": "한국어 (kr)",
      "language.option.api.pt": "Português (pt)",
      "language.option.api.ru": "Русский (ru)",
      "language.option.api.sp": "Español (sp)",
      "language.option.api.th": "ไทย (th)",
      "language.option.api.tr": "Türkçe (tr)",
      "language.option.api.tr_en": "English (tr_en)",
      "language.option.api.tw": "繁體中文 (tw)",
      "language.option.service_region.na": "Nordamerika (NA)",
      "language.option.service_region.eu": "Europa (EU)",
      "language.option.service_region.mena": "Nahost/Nordafrika (MENA)",
      "language.option.service_region.ru": "Russland (RU)",
      "language.option.service_region.asia": "Asien (TH/SEA) (ASIA)",
      "language.option.service_region.jp": "Japan (JP)",
      "language.option.service_region.sa": "Südamerika (SA)",
      "language.option.service_region.kr": "Korea (KR)",
      "language.option.service_region.tw": "Taiwan (TW)",
      "language.option.service_region.gt": "Global Lab (GT)",
      "language.option.service_region.ceu": "Konsole Europa (CEU)",
      "language.option.service_region.cna": "Konsole Nordamerika (CNA)",
      "language.option.service_region.cas": "Konsole Asien (CAS)",
      "translation_notice.title": "Übersetzung gesucht",
      "translation_notice.body": "Diese Seite wurde noch nicht übersetzt. Du siehst gerade den englischen Quellinhalt.",
      "translation_notice.help": "Du möchtest helfen?",
      "translation_notice.community_link": "Community-Seite",
      "translation_notice.target_path_label": "Zieldatei:",
      "account.privacy.optional_features": "Einwilligungen für externe Funktionen",
      "account.privacy.optional_features_detail": "Externe Funktionen bleiben ausgeschaltet, bis du dem jeweiligen Zweck zustimmst. Du kannst deine Einwilligung jederzeit widerrufen.",
      "account.privacy.telemetry_consent": "Optionale Telemetrie",
      "account.privacy.telemetry_consent_detail": "Begrenzte technische Fehler, Ablaufdaten und Leistungsmessungen an FishyStuff senden.",
      "account.privacy.telemetry_account_only": "Einstellungen für optionale Telemetrie sind nur im angemeldeten Zustand verfügbar.",
      "account.privacy.discord_images": "Discord-Profilbilder",
      "account.privacy.discord_images_detail": "Dein ausgewähltes Profilbild direkt vom Discord-CDN laden. Discord erhält dabei deine IP-Adresse und Anfrageinformationen.",
      "account.privacy.settings": "Datenschutzeinstellungen",
      "account.privacy.settings_detail": "Einstellungen und Einwilligungen sind getrennt. Ohne die erforderliche Einwilligung werden keine Daten gesendet.",
      "consent.title": "Optionale Funktionen",
      "consent.detail": "FishyStuff funktioniert ohne diese Funktionen. Wähle aus, welche externen Funktionen aktiv sein dürfen.",
      "consent.dismiss": "Später entscheiden",
      "consent.open": "Datenschutzauswahl",
      "consent.telemetry.title": "Optionale Telemetrie",
      "consent.telemetry.detail": "Begrenzte technische Fehler, Ablaufdaten und Leistungsmessungen an FishyStuff senden.",
      "consent.telemetry.granted": "Nach dem aktuellen Telemetriehinweis erlaubt.",
      "consent.telemetry.denied": "Nicht erlaubt.",
      "consent.telemetry.unset": "Noch keine Entscheidung; Telemetrie bleibt ausgeschaltet.",
      "consent.telemetry.selection_approved": "Für den Versand freigegeben",
      "consent.telemetry.selection_not_approved": "Nicht für den Versand freigegeben",
      "consent.discord_images.title": "Discord-Profilbilder",
      "consent.discord_images.detail": "Ein ausgewähltes Profilbild direkt vom Discord-CDN laden.",
      "consent.discord_images.granted": "Von Discord gehostete Profilbilder dürfen geladen werden.",
      "consent.discord_images.denied": "Von Discord gehostete Bilder bleiben blockiert.",
      "consent.discord_images.unset": "Noch keine Entscheidung; Discord-Bilder bleiben blockiert.",
      "consent.settings": "Datenschutzeinstellungen",
      "consent.keep_off": "Optionale Funktionen ausgeschaltet lassen",
      "consent.save": "Auswahl erlauben",
      "consent.save_failed": "Deine Datenschutzauswahl konnte nicht gespeichert werden. Versuche es erneut.",
      "participation.title": "Teilnahme",
      "participation.activity": "Aktivität",
      "participation.download": "Desktop laden",
      "participation.refresh": "Status aktualisieren",
      "participation.review": "Teilnahme prüfen",
      "participation.signed_out": "Melde dich an, um deine Installationen zu verwalten. Lokale Aufzeichnung erfordert keine Teilnahme.",
      "participation.loading": "Teilnahmestatus wird geladen…",
      "participation.unavailable": "Der Teilnahmestatus ist nicht verfügbar. Keine Änderung wurde bestätigt.",
      "participation.intro": "Verwalte jede Installation einzeln. Das Beenden der Beiträge stoppt künftige Übermittlungen; es löscht keine vorhandenen Daten und ersetzt keinen Antrag zur Ausübung von Datenschutzrechten.",
      "participation.no_installations": "Für dieses Konto sind keine Installationen registriert. Wähle in Desktop „Review synchronization and contribution“, um die gespeicherte Historie und künftige Übermittlungen zu prüfen. Der Besuch dieser Seite aktiviert nichts.",
      "participation.active": "Freigegeben",
      "participation.disabled": "Beendet",
      "participation.review_required": "Prüfung erforderlich",
      "participation.revocation_pending": "Neue Freigaben sind gesperrt. Der Broker-Widerruf steht noch aus; gehe nicht davon aus, dass bestehende Verbindungen bereits beendet wurden.",
      "participation.revocation_complete": "Broker-Widerruf bestätigt.",
      "participation.prepare_again": "Bereite in dieser Desktop-Installation eine neue Prüfung vor, bevor du Beiträge aktivierst.",
      "participation.retry_stop": "Broker-Widerruf erneut anfordern",
      "participation.stop": "Beiträge beenden",
      "participation.account": "Konto",
      "participation.installation": "Installation",
      "participation.retained_history": "Von dieser Installation vorbereitete gespeicherte Historie",
      "participation.fact_count": "Ausstehende Datensätze",
      "participation.fact_kinds": "Datensatzarten",
      "participation.source_range": "Verfügbarer Quellzeitraum (Nanosekunden)",
      "participation.names": "Identitätsnamen in gespeicherten Datensätzen",
      "participation.gaps": "Bekannte Lücken in der Historie",
      "participation.yes": "Ja",
      "participation.no": "Nein",
      "participation.none": "Keine",
      "participation.unknown": "Nicht verfügbar",
      "participation.full_notice": "Vollständige Datenschutzhinweise für Desktop und Datenbeiträge lesen",
      "participation.keep_local": "Daten lokal behalten",
      "participation.enable": "Synchronisierung und Beiträge aktivieren",
      "participation.saving": "Teilnahmeänderung wird angewendet…",
      "participation.uncertain": "Diese Änderung konnte nicht bestätigt werden. Aktualisiere vor einem erneuten Versuch den Status; gehe nicht davon aus, dass Beiträge bereits beendet wurden.",
      "participation.enable_unavailable": "Zum Aktivieren sind die aktuellen Nutzungsbedingungen und eine Desktop-Berechtigung erforderlich. Eine bestehende Registrierung kannst du hier weiterhin beenden.",
      "participation.no_installations_unavailable": "Für dieses Konto sind keine Installationen registriert. Zum Aktivieren der Teilnahme sind die aktuellen Nutzungsbedingungen und eine Desktop-Berechtigung erforderlich.",
      "desktop.privacy.reader.open": "Datenschutzhinweise lesen",
      "desktop.privacy.reader.title": "Datenschutzhinweise für Desktop und Datenbeiträge",
      "desktop.privacy.reader.loading": "Datenschutzhinweise werden geladen…",
      "desktop.privacy.reader.ready": "Datenschutzhinweise geladen.",
      "desktop.privacy.reader.signed_out": "Melde dich mit einem berechtigten Konto an, um die Hinweise hier zu lesen, oder fordere unten eine Kopie per E-Mail an.",
      "desktop.privacy.reader.denied": "Dieses Konto kann die Hinweise nicht online lesen. Du kannst die maßgeblichen Hinweise unten per E-Mail anfordern.",
      "desktop.privacy.reader.error": "Die Datenschutzhinweise konnten nicht geladen werden. Versuche es erneut oder fordere unten eine Kopie per E-Mail an.",
      "desktop.privacy.reader.sign_in": "Anmelden",
      "desktop.privacy.reader.retry": "Erneut versuchen",
      "desktop.privacy.reader.javascript": "Aktiviere JavaScript, um die Hinweise hier zu lesen, oder fordere unten eine Kopie per E-Mail an.",
      "desktop.privacy.reader.downloads": "Downloads der Datenschutzhinweise",
      "page_outline.open": "Inhaltsverzeichnis öffnen",
      "page_outline.title": "Auf dieser Seite",
      "page_outline.close": "Inhaltsverzeichnis schließen",
      "desktop.privacy.reader.rss": "RSS-Aktualisierungen",
      "desktop.privacy.reader.text": "Als .txt herunterladen",
      "desktop.privacy.reader.request_title": "Kopie ohne Kontozugang benötigt?",
      "desktop.privacy.reader.request_detail": "Frühere Teilnehmende und alle, deren Daten betroffen sein können, können die maßgeblichen aktuellen Hinweise und Informationen über frühere Verarbeitungen anfordern. Dafür sind weder Registrierung, erneute Berechtigung, Zahlung noch die Annahme neuer Nutzungsbedingungen erforderlich.",
      "contest.title": "Wettbewerb dieser Woche",
      "contest.query_title": "Wöchentlicher Wettbewerb",
      "contest.explanation": "Hilf der Community, die Wettbewerbsfische dieser Woche für deine ausgewählte Region zu ermitteln: Schlage Fische vor, stimme pro Kategorie für einen Fisch und bei Bedarf gegen andere Vorschläge. Klicke erneut auf einen aktiven Daumen, um die Stimme zurückzuziehen. Angemeldet zählen Stimmen pro Konto, abgemeldet pro IP-Adresse; wer eine IP teilt, teilt auch die Stimmen.",
      "contest.loading": "Community-Meldungen dieser Woche werden geladen…",
      "contest.unavailable": "Wettbewerbsmeldungen sind nicht verfügbar.",
      "contest.period": "Woche: { $start } bis { $end } · 00:00 UTC",
      "contest.prize": "Preisfisch",
      "contest.rare": "Selten",
      "contest.highQuality": "Hohe Qualität",
      "contest.no_leader": "Kein eindeutiger Spitzenreiter",
      "contest.contribute": "Community-Meldungen und Beiträge",
      "contest.voting": "Abstimmen",
      "contest.vote": "Abstimmen",
      "contest.view_results_vote": "Ergebnisse ansehen und abstimmen",
      "contest.close": "Schließen",
      "contest.slot_loading": "Wird geladen…",
      "contest.slot_unavailable": "Nicht verfügbar",
      "contest.no_candidates": "In dieser Kategorie wurden noch keine Fische vorgeschlagen.",
      "contest.leader": "Vorläufiger Stimmenführer",
      "contest.vote_name": "Für { $name } stimmen · { $count } Dafür-Stimmen",
      "contest.retract_name": "Deine Stimme für { $name } zurückziehen · { $count } Dafür-Stimmen",
      "contest.downvote_name": "Gegen { $name } stimmen · { $count } Dagegen-Stimmen",
      "contest.retract_downvote_name": "Deine Stimme gegen { $name } zurückziehen · { $count } Dagegen-Stimmen",
      "contest.net_support": "Netto: { $count }",
      "contest.net_support_help": "Netto-Unterstützung ist die Anzahl der Dafür-Stimmen abzüglich der Dagegen-Stimmen.",
      "contest.vote_retracted": "Deine Dafür-Stimme wurde zurückgezogen.",
      "contest.downvote_retracted": "Deine Dagegen-Stimme wurde zurückgezogen.",
      "contest.choose": "Fisch auswählen",
      "contest.add_candidate": "Fisch vorschlagen und dafür stimmen",
      "contest.search": "Fische suchen",
      "contest.saving": "Dein Beitrag wird gesendet…",
      "contest.voted": "Deine Dafür-Stimme wurde erfasst.",
      "contest.downvoted": "Deine Dagegen-Stimme wurde erfasst.",
      "contest.conflict": "Teilnahme, Bestätigung oder Woche haben sich geändert. Dein Beitrag wurde nicht erneut gesendet.",
      "contest.forbidden": "Dieser Beitrag war nicht erlaubt. Kontostimmen erfordern die Zustimmung zu den aktuellen Nutzungsbedingungen; Bestätigungen zusätzlich eine aktuelle Moderatorenberechtigung. Nichts wurde erneut gesendet.",
      "contest.uncertain": "Dieser Beitrag konnte nicht bestätigt werden. Er wurde nicht erneut gesendet.",
      "contest.week_changed": "Eine neue Wettbewerbswoche hat begonnen. Die Fische der Vorwoche wurden entfernt.",
      "contest.moderator_confirmed": "Bestätigt",
      "contest.confirm_fish": "Fisch bestätigen",
      "contest.confirm_fish_name": "Bestätigung von { $name } prüfen",
      "contest.replace_confirmation": "Bestätigung ersetzen",
      "contest.replace_confirmation_name": "Ersetzen der Bestätigung durch { $name } prüfen",
      "contest.review_confirmation": "Moderatorenbestätigung prüfen",
      "contest.review_replacement": "Ersetzen der Bestätigung prüfen",
      "contest.confirmation_help": "Bestätige einen vorgeschlagenen Fisch für diese Kategorie, Region und Woche. Diese Wahl ersetzt jede bisherige Bestätigung und gilt im Wettbewerbsfilter auch dann, wenn ein anderer Fisch mehr Netto-Unterstützung hat. Sie ändert keine Stimmen und bestätigt kein offizielles Ziel.",
      "contest.previous_confirmation": "Bisher bestätigt: { $name }",
      "contest.cancel_confirmation": "Abbrechen",
      "contest.save_confirmation": "Für diese Woche bestätigen",
      "contest.save_replacement": "Bestätigten Fisch ersetzen",
      "contest.confirmation_saved": "Der von der Moderation bestätigte Fisch wurde aktualisiert.",
      "fishydex.progress.panel": "Fortschritt",
      "fishydex.progress.aria.catalog": "Katalogfortschritt: {$caught} von {$total} Fischen gefangen ({$percent}%)",
      "fishydex.progress.aria.grade": "{$grade}-Fortschritt: {$caught} von {$total} Fischen gefangen ({$percent}%)",
      "fishydex.progress.kicker": "Gesamt",
      "fishydex.progress.title": "Katalogfortschritt",
      "fishydex.progress.remaining": "{$count} verbleibend",
      "fishydex.progress.empty": "Noch keine Katalogeinträge",
      "fishydex.progress.empty_grade": "Keine Katalogfische",
      "fishydex.presets.preview.caught": "{$count} gefangen",
      "fishydex.presets.preview.favourite": "{$count} Favoriten",
      "fishydex.presets.preview.tracked": "{$count} markiert",
      "fishydex.presets.change.dried_visibility": "Sichtbarkeit getrockneter Fische",
      "fishydex.presets.change.caught_fish": "Gefangener Fisch",
      "fishydex.presets.change.favourite_fish": "Favorisierter Fisch",
      "fishydex.presets.change.not_favourite": "Kein Favorit",
      "fishydex.presets.change.shown": "Sichtbar",
      "fishydex.presets.change.hidden": "Ausgeblendet",
      "fishydex.presets.change.enabled": "Aktiviert",
      "fishydex.presets.change.disabled": "Deaktiviert",
      "fishydex.presets.change.none": "Keine",
      "fishydex.presets.change.fish_guide": "Fischführer",
      "fishydex.filter.panel": "Filter",
      "fishydex.filter.expand": "Filterbereich erweitern",
      "fishydex.filter.collapse": "Filterbereich einklappen",
      "fishydex.filter.search.sr": "Fisch suchen",
      "fishydex.filter.search.placeholder": "Nach Fischname oder ID suchen",
      "fishydex.filter.status.legend": "Status",
      "fishydex.filter.status.group": "Statusfilter",
      "fishydex.filter.status.all": "Alle",
      "fishydex.filter.status.caught": "Gefangen",
      "fishydex.filter.status.missing": "Fehlend",
      "fishydex.filter.status.favourite": "Favorit",
      "fishydex.filter.grade.group": "Qualitätsfarbenfilter",
      "fishydex.filter.grade.red_help": "Rote Qualitätsstufe — typischerweise in der Preisfisch-Gruppe zu finden",
      "fishydex.filter.grade.yellow_help": "Gelbe Qualitätsstufe — typischerweise in der Selten-Gruppe zu finden",
      "fishydex.filter.grade.blue_help": "Blaue Qualitätsstufe — typischerweise in der Hochwertig-Gruppe zu finden",
      "fishydex.filter.grade.green_help": "Grüne Qualitätsstufe — typischerweise in der Allgemein-Gruppe zu finden",
      "fishydex.filter.grade.white_help": "Weiße Qualitätsstufe — keine typische Angelgruppen-Zuordnung ist dokumentiert",
      "fishydex.filter.method.group": "Fangmethodenfilter und Sichtbarkeit getrockneter Fische",
      "fishydex.filter.method.show_dried": "Getrocknete Fische einbeziehen",
      "fishydex.filter.matches": "{$visible}/{$total} Treffer angezeigt",
      "fishydex.filter.clear": "Filter zurücksetzen",
      "fishydex.filter.status_label": "Status:",
      "fishydex.catalog.panel": "Katalog",
      "fishydex.catalog.controls": "Katalogsteuerung",
      "fishydex.catalog.view": "Katalogansicht",
      "fishydex.catalog.view.guide": "Fischführer",
      "fishydex.catalog.sort": "Katalogsortierung",
      "fishydex.catalog.sort.price": "Preis",
      "fishydex.catalog.sort.name": "Name",
      "fishydex.catalog.sort.current": "Sortierrichtung für {$field} umschalten. Aktuell: {$direction}.",
      "fishydex.catalog.sort.default": "Katalog nach {$field} aufsteigend sortieren.",
      "fishydex.catalog.sort.direction.asc": "aufsteigend",
      "fishydex.catalog.sort.direction.desc": "absteigend",
      "fishydex.details.open": "Details für {$name} öffnen",
      "fishydex.details.favourite_toggle": "Fisch als Favorit markieren",
      "fishydex.details.caught_toggle": "Fisch als gefangen markieren",
      "fishydex.details.favourite": "Favorit",
      "fishydex.details.caught": "Gefangen",
      "fishydex.details.not_caught": "Nicht gefangen",
      "fishydex.details.unknown": "Unbekannt",
      "fishydex.details.dried": "Getrocknet",
      "fishydex.details.close": "Fischdetails schließen",
      "fishydex.details.item_key": "Item-Key",
      "fishydex.details.vendor_price": "Händlerpreis",
      "fishydex.details.catch_count": "Fangzahl",
      "fishydex.details.tabs.label": "Fischdetails",
      "fishydex.details.tabs.info": "Info",
      "fishydex.details.tabs.zones": "Zonen",
      "fishydex.details.tabs.titles": "Titel",
      "fishydex.details.view_on_map": "Auf Karte ansehen: {$name}",
      "fishydex.details.description_unavailable": "In der ausgewählten Datensprache ist keine offizielle Beschreibung verfügbar.",
      "fishydex.details.zones.heading": "Angelzonen",
      "fishydex.page.context": "{$name} ist ein Black-Desert-Fisch der Qualitätsstufe {$grade} mit einem Händlerpreis von {$price}. {$locations}.",
      "fishydex.page.silver": "Silber",
      "fishydex.page.locations.first_group": "Dieser Fisch gehört in {$zones} zur Gruppe {$groups}",
      "fishydex.page.locations.additional_group": "zur Gruppe {$groups} in {$zones}",
      "fishydex.page.locations.first_groups": "Dieser Fisch gehört in {$zones} zu den Gruppen {$groups}",
      "fishydex.page.locations.additional_groups": "zu den Gruppen {$groups} in {$zones}",
      "fishydex.page.locations.first_unknown": "Dieser Fisch kommt in {$zones} vor",
      "fishydex.page.locations.additional_unknown": "kommt außerdem in {$zones} vor",
      "fishydex.page.locations.none": "Derzeit ist keine bekannte Angelzone aufgeführt",
      "fishydex.page.locations.known_one": "1 weitere bekannte Angelzone",
      "fishydex.page.locations.known_many": "{$count} weitere bekannte Angelzonen",
      "fishydex.page.locations.potential_one": "1 mögliche Angelzone",
      "fishydex.page.locations.potential_many": "{$count} mögliche Angelzonen",
      "fishydex.page.locations.explore": "Entdecke {$locations} auf FishyStuff",
      "fishydex.index.title": "Fischfundort-Index",
      "fishydex.index.description": "Durchsuche einzelne Fischseiten mit Beschreibungen aus dem Spiel sowie bekannten oder möglichen Angelzonen.",
      "fishydex.index.summary": "{$count} Fische durchsuchen",
      "fishydex.details.zones.loading": "Angelzonen werden geladen…",
      "fishydex.details.zones.error": "Angelzonen konnten nicht geladen werden.",
      "fishydex.details.zones.empty": "Für diesen Fisch sind derzeit keine bekannten oder möglichen Angelzonen aufgeführt.",
      "fishydex.details.zones.tab_known": "Bekannte Angelzonen",
      "fishydex.details.zones.tab_potential": "Mögliche Angelzonen",
      "fishydex.details.zones.known_intro": "Bekannte Angelzonen stammen aus geprüften Basisdaten oder gepflegten Community-Zuordnungen.",
      "fishydex.details.zones.potential_intro": "Mögliche Angelzonen werden automatisch aus aufgezeichneten Ranglistenbeobachtungen von Spielern vorgeschlagen und müssen noch geprüft werden.",
      "fishydex.details.zones.explainer_summary": "So wird Ranglisten-Evidenz räumlich zugeordnet",
      "fishydex.details.zones.ranking_context": "Ranglistenbeobachtungen erfassen einen Fisch, einen Zeitpunkt und die Spielerposition – nicht den genauen Fangort. FishyStuff gleicht einen Unsicherheitsring mit 500 Spieleinheiten um diese Position mit der aktuellen Angelzonenkarte ab.",
      "fishydex.details.zones.fully_contained_label": "Vollständig enthalten",
      "fishydex.details.zones.fully_contained_explanation": "Der gesamte Unsicherheitsring liegt in der aktuellen Karte innerhalb einer einzigen Angelzone. Das ist eine stärkere räumliche Stütze, wird aber nicht automatisch bestätigt: Ranglisten-Evidenz bestimmt keine Angelgruppe, und Zonengrenzen müssen eventuell geprüft werden.",
      "fishydex.details.zones.partial_overlap_label": "Teilweise Überlappung",
      "fishydex.details.zones.partial_overlap_explanation": "Der Ring überschreitet eine Zonengrenze und berührt mehr als eine Angelzone. Jede berührte Zone erhält schwächere positive Unterstützung, weil die genaue räumliche Zuordnung unklar ist.",
      "fishydex.details.zones.ranking_limit": "Diese Anzahlen zeigen Hinweise auf ein Vorkommen, keine Fang- oder Dropraten.",
      "fishydex.details.zones.unknown_zone": "Unbekannte Zone",
      "fishydex.details.zones.ranking_fully_contained": "Vollständig enthaltene Ranking-Ringe ×{$count}",
      "fishydex.details.zones.ranking_partial_overlap": "Teilweise überlappende Ranking-Ringe ×{$count}",
      "fishydex.details.zones.baseline_group": "Basisdaten {$group}",
      "fishydex.details.zones.maintained_group": "Gepflegt {$group}",
      "fishydex.empty.title": "Kein Fisch passt zu diesem Filter.",
      "fishydex.empty.filtered": "Versuche eine breitere Suche oder entferne einige Filter.",
      "fishydex.empty.unfiltered": "Der Fischkatalog ist leer.",
      "fishydex.group.count": "{$count} Einträge",
      "fishydex.group.guide.freshwater": "Süßwasserfische",
      "fishydex.group.guide.saltwater": "Salzwasserfische",
      "fishydex.group.guide.crustacean": "Krebstiere",
      "fishydex.group.guide.other": "Sonstige",
      "fishydex.group.guide.unknown": "Nicht zugeordnet",
      "fishydex.details.icon_alt": "{$name}-Symbol",
      "fishydex.details.guide_alt": "{$name}-Guidebild",
      "fishydex.guide.catch_count": "Fänge: {$count}",
      "fishydex.guide.catch_count_short": "{$count}x",
      "fishydex.state.unavailable": "Nicht verfügbar",
      "fishydex.state.not_applicable": "Nicht anwendbar",
      "fishydex.state.local_storage_unavailable": "localStorage ist nicht verfügbar; Fortschritt wird nicht gespeichert.",
      "fishydex.state.corrupt_filters": "Beschädigte lokale Fishydex-Filter wurden zurückgesetzt.",
      "fishydex.state.corrupt_progress": "Beschädigter lokaler Fishydex-Fortschritt wurde zurückgesetzt.",
      "fishydex.state.corrupt_favourites": "Beschädigte lokale Fishydex-Favoriten wurden zurückgesetzt.",
      "fishydex.state.corrupt_fish_guide": "Beschädigter lokaler Fischführer-Fortschritt wurde zurückgesetzt.",
      "fishydex.action.favourite.add": "{$name} zu den Favoriten hinzufügen",
      "fishydex.action.favourite.remove": "{$name} aus den Favoriten entfernen",
      "fishydex.action.caught.mark": "Fangzahl für {$name} auf 1 setzen",
      "fishydex.action.caught.unmark": "Fangzahl für {$name} auf 0 zurücksetzen",
      "fishydex.api.zone_evidence_error": "Angelzonen-Evidenz konnte nicht geladen werden ({$message}).",
      "fishydex.api.contract_error": "Die Fish-API hat einen nicht unterstützten Katalogvertrag zurückgegeben ({$detail}).",
      "fishydex.api.fish_error": "Fish-API-Anfrage fehlgeschlagen.",
      "fishydex.api.fish_error_status": "Fish-API-Anfrage fehlgeschlagen (HTTP {$status}).",
      "fishydex.api.retrying": "Fish-API-Anfrage wird erneut versucht.",
      "fishydex.api.cors_hint": "Wenn diese Seite auf einer anderen Origin als die API läuft, prüfe, ob die API-CORS-Liste diese Site enthält.",
      "fishydex.api.retry_hint": "Die Anfrage konnte nicht sauber abgeschlossen werden.",
      "fishydex.titles.include_contest": "Wettbewerbstitel einbeziehen",
      "fishydex.titles.include_unobtainable": "Unerreichbare Titel einbeziehen",
      "fishydex.titles.unobtainable": "Unerreichbar",
      "fishydex.titles.catch": "Fangtitel",
      "fishydex.titles.contest": "Wettbewerbstitel",
      "fishydex.titles.quest": "Questtitel",
      "fishydex.titles.exchange": "Tauschtitel",
      "fishydex.titles.other": "Weitere Angeltitel",
      "fishydex.titles.unknown": "Unbekannt",
      "fishydex.titles.name_unknown": "Titel {$id}: Name nicht verfügbar",
      "fishydex.titles.description_unknown": "Originalbeschreibung in dieser Datensprache nicht verfügbar.",
      "fishydex.titles.owned": "Titel erhalten",
      "fishydex.titles.not_owned": "Titel nicht erhalten",
      "fishydex.titles.owned_total": "Erhaltene Titel: {$owned}/{$total}",
      "fishydex.titles.image_progress": "Titelfortschritt am Fischbild",
      "fishydex.titles.current_count": "Erfasste Fänge: {$count}",
      "fishydex.titles.reference_count": "Community-Referenz: {$count} Fänge",
      "fishydex.titles.community_count": "Community-Schätzung: {$count} Fänge",
      "fishydex.titles.requirement_unknown": "Benötigte Fangzahl unbekannt",
      "fishydex.titles.reference_source": "Quelle der Community-Referenz",
      "fishydex.titles.manual_count": "Fangzahl",
      "fishydex.titles.save_error": "Fortschritt konnte nicht gespeichert werden. Der bestätigte Stand wird angezeigt; versuche es erneut.",
      "fishydex.titles.state_unavailable": "Fortschritt ist derzeit nicht beschreibbar. Kläre vor dem Bearbeiten den Status des aktuellen Fortschritts.",
      "fishydex.titles.loading": "Angeltitel werden geladen…",
      "fishydex.titles.catalog_error": "Angeltitel konnten in dieser Datensprache nicht geladen werden. Lade die Seite erneut; dein gespeicherter Fortschritt bleibt unverändert.",
      "fishydex.titles.no_titles": "Diesem Fisch sind derzeit keine Angeltitel zugeordnet.",
      "fishydex.titles.reports": "Community-Erwerbsmeldungen: {$count}; im Mittel {$average} Fänge. Dies ist keine exakte Voraussetzung.",
      "fishydex.titles.no_reports": "Noch keine Erwerbsmeldungen.",
      "fishydex.titles.report_heading": "Erwerbsmeldung beitragen",
      "fishydex.titles.report_help": "Beitrag mit Anmeldung: Melde die Fangzahl beim Erhalt eines Titels. Nur Anzahl und Mittelwert der Meldungen sind öffentlich. Eine Meldung pro Konto und Titel; erneutes Senden ersetzt deine Meldung. Persönlicher Fortschritt sendet niemals automatisch eine Meldung.",
      "fishydex.titles.report_count": "Fangzahl beim Erhalt",
      "fishydex.titles.report_date": "Erhalten am (optional)",
      "fishydex.titles.report_submit": "Erwerbsmeldung senden",
      "fishydex.titles.report_sending": "Meldung wird gesendet…",
      "fishydex.titles.report_saved": "Deine Erwerbsmeldung wurde gespeichert. Öffentliche Mittelwerte werden beim nächsten Laden des Katalogs aktualisiert.",
      "fishydex.titles.report_sign_in": "Melde dich an, um eine Erwerbsmeldung zu senden. Dein persönlicher Fortschritt bleibt unverändert.",
      "fishydex.titles.report_error": "Die Erwerbsmeldung konnte nicht gespeichert werden. Bitte versuche es erneut.",
      "fishydex.titles.provenance": "Belege",
      "fishydex.titles.used_requirement": "Aktuelle Anforderung (Fänge)",
      "fishydex.titles.community_evidence": "Community-Meldungen",
      "fishydex.titles.estimate_difference": "Durchschnitt minus aktuelle Anforderung",
      "fishydex.titles.difference_value": "{$count} Fänge",
      "fishydex.titles.estimate_used": "Keine Referenzanforderung verfügbar; der gerundete Community-Durchschnitt wird verwendet.",
      "fishydex.titles.evidence_limits": "Grenzen der Belege",
      "fishydex.titles.no_distribution": "Nur Anzahl und Durchschnitt der Meldungen sind verfügbar. Streuung und Unsicherheit lassen sich nicht bestimmen.",
      "fishydex.titles.required_catches": "{$count} Fänge",
      "fishydex.titles.estimated_catches": "≈ {$count} Fänge",
      "fishydex.titles.table_caption": "Angeltitel",
      "fishydex.titles.title_column": "Titel",
      "fishydex.titles.requirement_column": "Anforderung",
      "fishydex.titles.mark_obtained": "Als erhalten markieren",
      "fishydex.titles.description_column": "Beschreibung",
      "fishydex.titles.condition_unknown": "Bedingung nicht verfügbar",
      "fishydex.titles.tab_memory_error": "Der ausgewählte Tab konnte für diese Browsersitzung nicht gespeichert werden.",
      "fishydex.titles.mark_not_obtained": "Als nicht erhalten markieren",
      "fishydex.query.label": "Fische filtern",
      "fishydex.query.placeholder": "Fische, Titel… oder zone:\"Velia\" AND missing",
      "fishydex.query.unavailable": "Suchdaten fehlen oder gehören zu einem anderen Quellenstand. Nach der Katalogaktualisierung neu laden.",
      "fishydex.query.loading": "Suchdaten werden geladen…",
      "fishydex.query.term.missing-titles": "Fehlende Titel",
      "fishydex.query.term.caught": "Gefangen",
      "fishydex.query.term.missing": "Nicht gefangen",
      "fishydex.query.term.favourite": "Favorit",
      "fishydex.query.term.red": "Rote Qualität",
      "fishydex.query.term.yellow": "Gelbe Qualität",
      "fishydex.query.term.blue": "Blaue Qualität",
      "fishydex.query.term.green": "Grüne Qualität",
      "fishydex.query.term.white": "Weiße Qualität",
      "fishydex.query.term.rod": "Angel",
      "fishydex.query.term.hotspot": "Hotspot",
      "fishydex.query.term.harpoon": "Harpune",
      "fishydex.query.term.dried": "Getrocknete Fische",
      "fishydex.query.field.fish": "Fischname",
      "fishydex.query.field.title": "Titelname",
      "fishydex.query.field.zone": "Bekanntes Angelgebiet",
      "fishydex.query.field.potential-zone": "Mögliches Angelgebiet",
      "fishydex.query.state.empty": "Keine Abfrage angewendet.",
      "fishydex.query.state.applied": "Der aktuelle Text ist angewendet.",
      "fishydex.query.state.partial": "Nur der gültige Anfang ist angewendet; der restliche Text nicht.",
      "fishydex.query.state.invalid": "Keine Abfrage angewendet. Filtername, Anführungszeichen und Klammern prüfen.",
      "fishydex.query.updating": "Abfrage wird aktualisiert…",
      "fishydex.query.composing": "Texteingabe abschließen, um die Abfrage zu aktualisieren.",
      "fishydex.query.field.status": "Status",
      "fishydex.query.field.grade": "Qualität",
      "fishydex.query.field.method": "Angelmethode",
      "fishydex.query.field.dried": "Getrocknete Fische",
      "fishydex.titles.completion": "Titelfortschritt",
      "fishydex.titles.empty_grade": "Keine Titel",
      "fishydex.details.navigation.label": "Fische durchblättern",
      "fishydex.details.navigation.previous": "Vorheriger Fisch",
      "fishydex.details.navigation.next": "Nächster Fisch",
      "fishydex.filter.include_non_fish": "Nicht-Fisch-Gegenstände einbeziehen",
      "fishydex.catalog.kind.item": "Nicht-Fisch-Gegenstand",
      "fishydex.page.context_item": "{$name} ist ein Black-Desert-Gegenstand der Qualitätsstufe {$grade} mit einem Händlerpreis von {$price}. {$locations}.",
      "fishydex.catalog.display_options": "Anzeigeoptionen",
      "fishydex.catalog.sort.label": "Sortieren nach",
      "fishydex.catalog.view.simple": "Einfach",
      "fishydex.group.all": "Alle Gegenstände",
      "frontpage.hero.title": "Alles, was du zum Angeln brauchst",
      "frontpage.guides.title": "Anleitungen",
      "frontpage.guides.body": "Von der Community beigetragene Anleitungen helfen dir beim Einstieg ins Angeln.",
      "frontpage.guides.cta": "Anleitungen öffnen",
      "frontpage.map.title": "Karte",
      "frontpage.map.body": "Erkunde Zonen, Beutetabellen, Hotspots und aufgezeichnete Fänge, um Angelplätze zu finden.",
      "frontpage.map.cta": "Karte öffnen",
      "frontpage.dex.title": "Dex",
      "frontpage.dex.body_intro": "Gotta Catch 'Em All",
      "frontpage.dex.body_detail": "Durchstöbere Fische und verfolge deinen Fortschritt.",
      "frontpage.dex.cta": "Dex öffnen",
      "map.toolbar.map_windows": "Kartenfenster",
      "map.toolbar.bookmarks": "Lesezeichen",
      "map.toolbar.settings": "Einstellungen",
      "map.toolbar.info": "Info",
      "map.toolbar.layers": "Ebenen",
      "map.tutorial.window_title": "Hilfe & Tutorials",
      "map.tutorial.about_title": "Interaktive Angelkarte für Black Desert",
      "map.tutorial.about_body": "Finde Fische auf der interaktiven BDO-Angelkarte von FishyStuff, untersuche Angelzonen und Beutetabellen, vergleiche Hotspots und prüfe aufgezeichnete Fangbelege.",
      "map.tutorial.provenance_body": "FishyStuff ist ein von der Community gepflegtes Projekt für Black Desert Online. Kartenfakten behalten ihren Quellen- und Evidenzkontext, damit fehlende oder unsichere Angaben sichtbar bleiben und nicht als bestätigt erscheinen.",
      "map.tutorial.catalog_title": "Interaktive Tutorials",
      "map.tutorial.group.beginner": "Grundlagen",
      "map.tutorial.group.beginner_summary": "Lerne die wichtigsten Abfrage-, Fenster- und Ebenenfunktionen der Karte.",
      "map.tutorial.group.intermediate": "Fortgeschritten",
      "map.tutorial.group.intermediate_summary": "Speichere Orte und gestalte einen wiederverwendbaren Kartenarbeitsbereich.",
      "map.tutorial.group.advanced": "Expertenwissen",
      "map.tutorial.group.advanced_summary": "Prüfe Nachweise und kombiniere geografische Ebenen, Clipping-Beziehungen und strukturierte Abfragen.",
      "map.tutorial.start": "Starten",
      "map.tutorial.continue": "Fortsetzen",
      "map.tutorial.exit": "Tutorial beenden",
      "map.tutorial.complete": "Abschließen",
      "map.tutorial.hide": "Tutorial ausblenden",
      "map.tutorial.proceed": "Weiter",
      "map.tutorial.task_completed": "Abgeschlossen",
      "map.tutorial.unavailable_title": "Tutorial nicht verfügbar",
      "map.tutorial.unavailable_body": "Dieses Tutorial gehört nicht zum aktuellen Kartenleitfaden.",
      "map.tutorial.query_basics.title": "Das Abfragesystem verwenden",
      "map.tutorial.query_basics.summary": "Finde Pink Dolphin und Sea Bunny und lies dann Fanggruppe, Fischpreis und Rate innerhalb der Gruppe.",
      "map.tutorial.query_basics.step1.title": "Pink Dolphin finden",
      "map.tutorial.query_basics.step1.body": "Tippe „Pink“ in { $query }. Höre auf, sobald die Eingabe vor dem vollständigen Namen als { $pink_dolphin } aufgelöst wird.",
      "map.tutorial.query_basics.step2.title": "Pink Dolphin bestätigen",
      "map.tutorial.query_basics.step2.body": "Der hervorgehobene Abfragebegriff ist { $pink_dolphin }. Der vollständige Name setzt automatisch fort.",
      "map.tutorial.query_basics.step3.title": "Abfrage löschen",
      "map.tutorial.query_basics.step3.body": "Lösche { $pink_dolphin } mit der Löschen-Schaltfläche oder entferne den Text aus { $query }.",
      "map.tutorial.query_basics.step4.title": "Sea Bunny finden",
      "map.tutorial.query_basics.step4.body": "Suche nach { $sea_bunny } und wende das passende Ergebnis an. Die Karte zeigt nun seine Fangevidenz.",
      "map.tutorial.query_basics.step5.title": "Ergebnisse wieder ins Bild holen",
      "map.tutorial.query_basics.step5.body": "Verschiebe oder zoome dich optional von den Ergebnissen weg. Hole die Sea-Bunny-Treffer mit { $focus_query } in der Abfrage wieder ins Bild.",
      "map.tutorial.query_basics.step6.title": "Ein Fangprofil laden",
      "map.tutorial.query_basics.step6.body": "Klicke in einer beliebigen Angelzone auf offenes Wasser. Warte, bis { $details } das Fangprofil zeigt; die Zone muss Sea Bunny nicht enthalten.",
      "map.tutorial.query_basics.step7.title": "Fanggruppen",
      "map.tutorial.query_basics.step7.body": "Wähle bei Bedarf { $zone_tab } in { $details }. Fanggruppen sammeln Fische derselben Beutekategorie, etwa Prize oder Rare. { $group_share } ist der Anteil dieser Gruppe am gesamten Profil.",
      "map.tutorial.query_basics.step8.title": "Fisch und Grundpreis",
      "map.tutorial.query_basics.step8.body": "Das nach Seltenheitsgrad gefärbte Symbol und der Name identifizieren den Fisch; { $base_price } ist sein Händler-Grundpreis.",
      "map.tutorial.query_basics.step9.title": "Rate innerhalb der Gruppe",
      "map.tutorial.query_basics.step9.body": "{ $within_group_rate } ist der Anteil des Fisches innerhalb seiner Gruppe, nicht am gesamten Profil, und kann als Prozentwert oder Gewicht erscheinen.",
      "map.tutorial.window_basics.title": "Das Fenstersystem verwenden",
      "map.tutorial.window_basics.summary": "Blende ein Tutorial aus und hole es zurück, öffne und schließe Fenster, klappe sie ein und verschiebe sie.",
      "map.tutorial.window_basics.step1.title": "Dieses Tutorial ausblenden und zurückholen",
      "map.tutorial.window_basics.step1.body": "Wähle unten „Tutorial ausblenden“. Öffne Hilfe & Tutorials über die Fragezeichen-Schaltfläche erneut und wähle hier Fortsetzen.",
      "map.tutorial.window_basics.step2.title": "Abfrage schließen und erneut öffnen",
      "map.tutorial.window_basics.step2.body": "Schließe das Fenster { $query } über seine Schaltfläche in der Werkzeugleiste und öffne es danach mit derselben Schaltfläche erneut.",
      "map.tutorial.window_basics.step2.open_first": "{ $query } ist bereits geschlossen. Öffne das Fenster zuerst; schließe und öffne es anschließend erneut, um den vollständigen Ablauf abzuschließen.",
      "map.tutorial.window_basics.step2.reopen": "{ $query } ist geschlossen. Öffne das Fenster mit derselben Schaltfläche in der Werkzeugleiste erneut.",
      "map.tutorial.window_basics.step3.title": "Ebenen ein- und ausklappen",
      "map.tutorial.window_basics.step3.body": "Klicke auf die Titelleiste von { $layers }, um das Fenster einzuklappen, und danach erneut auf die Titelleiste, um es auszuklappen.",
      "map.tutorial.window_basics.step3.expand_first": "{ $layers } ist bereits eingeklappt. Klappe das Fenster zuerst aus; klappe es danach noch einmal ein und aus.",
      "map.tutorial.window_basics.step3.expand": "{ $layers } ist eingeklappt. Klicke erneut auf die Titelleiste, um das Fenster auszuklappen.",
      "map.tutorial.window_basics.step4.title": "Ein Fenster verschieben",
      "map.tutorial.window_basics.step4.body": "Ziehe die Titelleiste von { $layers }, um das Fenster zu verschieben.",
      "map.tutorial.layer_basics.title": "Das Ebenensystem verwenden",
      "map.tutorial.layer_basics.summary": "Zeige Hotspots, untersuche einen samt eigenem Details-Tab und blende die unübersichtliche Ebene danach wieder aus.",
      "map.tutorial.layer_basics.step1.title": "Hotspots anzeigen",
      "map.tutorial.layer_basics.step1.body": "Öffne bei Bedarf { $layers } und schalte { $hotspots } ein.",
      "map.tutorial.layer_basics.step1.resume": "{ $hotspots } sind ausgeblendet. Schalte die Ebene wieder ein, um den Vergleich abzuschließen.",
      "map.tutorial.layer_basics.step1.query_filtered": "{ $hotspots } ist eingeschaltet, aber die aktuelle { $query } blendet alle Hotspots aus. Leere die Abfrage, um sie anzuzeigen.",
      "map.tutorial.layer_basics.step2.title": "Einen Hotspot untersuchen",
      "map.tutorial.layer_basics.step2.body": "Wähle eine sichtbare Markierung der Ebene { $hotspots } auf der Karte. Details sollte die ausgewählte Landmarke als Hotspot ausweisen.",
      "map.tutorial.layer_basics.step2.not_hotspot": "Das ist eine andere Landmarke. Wähle stattdessen eine sichtbare Markierung der Ebene { $hotspots } aus.",
      "map.tutorial.layer_basics.step3.title": "Die Hotspot-Details öffnen",
      "map.tutorial.layer_basics.step3.body": "Wähle { $hotspot_tab } in { $details }. Sieh dir Fangzahlen, Anbisszeiten, Lebensdauer, Beute und Modellvorschauen an.",
      "map.tutorial.layer_basics.step4.title": "Hotspots wieder ausblenden",
      "map.tutorial.layer_basics.step4.body": "Schalte { $hotspots } aus, nachdem du { $hotspot_tab } angesehen hast. Die Ebene ist bei Bedarf nützlich, aber unübersichtlich.",
      "map.tutorial.catch_profile_provenance.title": "Herkunft im Fangprofil verstehen",
      "map.tutorial.catch_profile_provenance.summary": "Vergleiche die getrennten Nachweise für Anwesenheit und Rate eines Fisches.",
      "map.tutorial.catch_profile_provenance.step1.title": "Ein Fangprofil laden",
      "map.tutorial.catch_profile_provenance.step1.body": "Klicke in einer beliebigen Angelzone auf offenes Wasser. Vergleiche in { $details } beim ersten Fisch Anwesenheits- und Ratennachweis.",
      "map.tutorial.catch_profile_provenance.step2.title": "Anwesenheitsnachweis untersuchen",
      "map.tutorial.catch_profile_provenance.step2.body": "Öffne beim ersten Fisch { $presence_provenance }. Die Anzeige erklärt, warum er hier vorkommt, nicht wie häufig. Prüfe Quelle, Status, Bedingungen, Datum und Beobachtungszahl; die Farbe fasst den Evidenztyp zusammen.",
      "map.tutorial.catch_profile_provenance.step3.title": "Ratennachweis untersuchen",
      "map.tutorial.catch_profile_provenance.step3.body": "Öffne beim selben Fisch { $rate_provenance }. Die Anzeige stützt die Rate getrennt von der Anwesenheit. Prüfe Wert (% oder Gewicht), Bedingungen, Status und Quelle. Grün bedeutet bekannt, Blau datenbankgestützt und Gelb unsicher.",
      "map.tutorial.bookmarks.title": "Angelorte speichern und teilen",
      "map.tutorial.bookmarks.summary": "Setze und untersuche Lesezeichen und tausche danach WorldmapBookMark-XML mit GameVariables.xml aus.",
      "map.tutorial.bookmarks.step1.title": "Ein Lesezeichen setzen",
      "map.tutorial.bookmarks.step1.body": "Öffne Lesezeichen, wähle Neues Lesezeichen und danach den Angelort aus, den du behalten möchtest.",
      "map.tutorial.bookmarks.step2.title": "Zu einem Lesezeichen zurückkehren",
      "map.tutorial.bookmarks.step2.body": "Aktiviere das gerade erstellte Lesezeichen, um zu seinem Weltpunkt zurückzukehren und dieselben Fakten in Details zu untersuchen.",
      "map.tutorial.bookmarks.step3.title": "Koordinaten aus Details kopieren",
      "map.tutorial.bookmarks.step3.body": "Wähle { $territory_tab } in { $details }, um die Weltkoordinaten der aktuellen Landmarke zu sehen. Klicke dann in der Details-Titelleiste auf die Schaltfläche für den Landmarken-Typ (zum Beispiel „Lesezeichen“), um diese Koordinaten als Lesezeichen-XML zu kopieren.",
      "map.tutorial.bookmarks.step4.title": "Lesezeichen-XML kopieren oder exportieren",
      "map.tutorial.bookmarks.step4.body": "Wähle ein Lesezeichen und nutze Kopieren oder Exportieren. Beende für Black Desert das Spiel, sichere { $game_variables }, ersetze { $worldmap_bookmark } durch das exportierte XML und starte neu.",
      "map.tutorial.bookmarks.step5.title": "Lesezeichen aus dem Spiel importieren",
      "map.tutorial.bookmarks.step5.body": "Um lokale Spiel-Lesezeichen auf die Website zu übertragen, kopiere den Block { $worldmap_bookmark } aus { $game_variables } und wähle Einfügen. Alternativ kannst du den Block als XML speichern und Importieren wählen.",
      "map.tutorial.layer_settings.title": "Ebeneneinstellungen verwenden",
      "map.tutorial.layer_settings.summary": "Öffne die Einstellungen der Fangevidenz, ändere die Deckkraft und schließe die Einstellungen wieder.",
      "map.tutorial.layer_settings.step1.title": "Einstellungen der Fangevidenz öffnen",
      "map.tutorial.layer_settings.step1.body": "Klicke in { $layers } auf die Zeile { $fish_evidence }, um ihre Einstellungen auszuklappen. Falls sie bereits ausgeklappt waren, schließe und öffne sie einmal.",
      "map.tutorial.layer_settings.step1.resume": "Die Einstellungen von { $fish_evidence } sind geschlossen. Öffne die Zeile erneut, um den Ablauf abzuschließen.",
      "map.tutorial.layer_settings.step2.title": "Deckkraft der Ebene ändern",
      "map.tutorial.layer_settings.step2.body": "Bewege den Deckkraftregler von { $fish_evidence } und beobachte, wie sich die Evidenzdarstellung verändert, ohne die Ebene auszublenden.",
      "map.tutorial.layer_settings.step3.title": "Einstellungen schließen",
      "map.tutorial.layer_settings.step3.body": "Klicke erneut auf die Zeile { $fish_evidence }, um die Einstellungen nach Abschluss einzuklappen.",
      "map.tutorial.map_presets.title": "Eine Kartenvoreinstellung erstellen",
      "map.tutorial.map_presets.summary": "Klone die aktuelle Karteneinstellung und gib der gespeicherten Voreinstellung einen aussagekräftigen Namen.",
      "map.tutorial.map_presets.step1.title": "Kartenvoreinstellungen öffnen",
      "map.tutorial.map_presets.step1.body": "Öffne Einstellungen und wähle dann Kartenvoreinstellungen. Voreinstellungen bewahren eine wiederverwendbare Kopie deiner Kartenebenen, Abfrage, Ansicht und Fensteranordnung.",
      "map.tutorial.map_presets.step2.title": "Aktuelle Einstellung klonen",
      "map.tutorial.map_presets.step2.body": "Wähle Klonen, um aus der aktuell ausgewählten Einstellung eine eigene gespeicherte Voreinstellung zu erstellen.",
      "map.tutorial.map_presets.step3.title": "Einen nützlichen Namen vergeben",
      "map.tutorial.map_presets.step3.body": "Ersetze den Titel der geklonten Voreinstellung durch einen wiedererkennbaren Namen und drücke Enter oder verlasse das Titelfeld, um ihn zu speichern.",
      "map.tutorial.regions.title": "Hover-Fakten für Regionen verwenden",
      "map.tutorial.regions.summary": "Aktiviere die Hover-Fakten Herkunft und Ressourcen und fahre dann über ein Feld, um sie zu vergleichen, ohne eine der Ebenen einzublenden.",
      "map.tutorial.regions.step1.title": "Herkunft aktivieren",
      "map.tutorial.regions.step1.body": "Öffne die Einstellungen von { $regions }, wähle Hover und aktiviere { $origin }. Falls bereits aktiv, schalte den Fakt einmal aus und wieder ein. Er bleibt verfügbar, während die Ebene ausgeblendet ist.",
      "map.tutorial.regions.step2.title": "Ressourcen aktivieren",
      "map.tutorial.regions.step2.body": "Öffne die Einstellungen von { $region_groups }, wähle Hover und aktiviere { $resources }. Falls bereits aktiv, schalte den Fakt einmal aus und wieder ein. Er bleibt verfügbar, während die Ebene ausgeblendet ist.",
      "map.tutorial.regions.step3.title": "Über ein Feld fahren",
      "map.tutorial.regions.step3.body": "Fahre auf der Karte über ein Feld, bis { $origin } und { $resources } gemeinsam erscheinen. Weder die Regionen- noch die Regionsgruppen-Ebene muss sichtbar sein.",
      "map.tutorial.clipping.title": "Eine Ebene durch eine andere begrenzen",
      "map.tutorial.clipping.summary": "Löse Regionen von der Zonenmaske und hänge sie danach über das Ebenen-Ablageziel wieder an.",
      "map.tutorial.clipping.step1.title": "Regionen von der Zonenmaske lösen",
      "map.tutorial.clipping.step1.body": "Ziehe die Zeile { $regions } in { $layers } an den Rand einer anderen Zeile, bis eine Einfügelinie erscheint, und lege sie dort ab. Dadurch wird die aktuelle Clipping-Beziehung mit { $zone_mask } entfernt.",
      "map.tutorial.clipping.step1.detached": "{ $regions } ist bereits gelöst. Lege die Ebene zunächst auf der Mitte von { $zone_mask } ab und ziehe sie danach wieder an einen Zeilenrand, damit du den Lösevorgang selbst ausführst.",
      "map.tutorial.clipping.step2.title": "Regionen an die Zonenmaske anhängen",
      "map.tutorial.clipping.step2.body": "Ziehe { $regions } auf die Mitte von { $zone_mask }, bis die Zeile das Anhängeziel zeigt, und lege sie dort ab. Regionen wird unter seiner Clipping-Maske eingerückt.",
      "map.tutorial.advanced_queries.title": "Container-Abfragen verwenden",
      "map.tutorial.advanced_queries.summary": "Vergleiche einen einzelnen passenden Fisch mit getrennten Fischzeugen innerhalb derselben Zone oder desselben Hotspots.",
      "map.tutorial.advanced_queries.step1.title": "Einen Fisch beide Bedingungen erfüllen lassen",
      "map.tutorial.advanced_queries.step1.body": "Gib { $same_fish_query } ein. Güte und Sammlungsstatus teilen einen Fisch-Container—wie bei { $explicit_same_fish_query }. Eine Zone oder ein Hotspot passt nur, wenn ein Fisch rot ist und in deinem FishyDex fehlt.",
      "map.tutorial.advanced_queries.step2.title": "Treffer desselben Fisches einrahmen",
      "map.tutorial.advanced_queries.step2.body": "Rahme die Treffer mit der Zielschaltfläche neben Abfrage ein. Achte darauf, welche Zonen bleiben, wenn ein Fisch beide Bedingungen erfüllen muss.",
      "map.tutorial.advanced_queries.step3.title": "Zwei verschiedene Fische zulassen",
      "map.tutorial.advanced_queries.step3.body": "Ersetze sie durch { $separate_fish_query }. Jede Klammer erzeugt einen Fisch-Container: Ein Fisch darf rot sein, während ein anderer fehlt. Beide müssen weiterhin in derselben Zone oder demselben Hotspot vorkommen.",
      "map.tutorial.advanced_queries.step4.title": "Treffer verschiedener Fische einrahmen",
      "map.tutorial.advanced_queries.step4.body": "Nutze die Zielschaltfläche erneut. Vergleiche diese Ansicht mit der vorherigen: Diese Container dürfen die Bedingungen „rot“ und „fehlend“ mit zwei verschiedenen Fischen erfüllen.",
      "map.tutorial.advanced_queries.step5.title": "Einen gemeinsamen Container untersuchen",
      "map.tutorial.advanced_queries.step5.body": "Wähle offenes Wasser in einer verbleibenden Zone und untersuche das Fangprofil. Finde den roten und den fehlenden Fisch, durch die die Zone passt; es dürfen verschiedene Fische sein.",
      "map.tutorial.selection.landmark_rejected": "Das ist eine Landmarke, Probe, ein NPC oder Hotspot. Klicke stattdessen auf offenes Wasser in einer Angelzone.",
      "map.tutorial.scroll_down": "Scrolle in Ebenen nach unten, um das hervorgehobene Steuerelement zu erreichen.",
      "map.tutorial.scroll_up": "Scrolle in Ebenen nach oben, um das hervorgehobene Steuerelement zu erreichen.",
      "map.query.title": "Abfrage",
      "map.query.input_label": "Kartenabfrage",
      "map.query.clear": "Abfrage löschen",
      "map.query.focus_current": "Aktuelle Abfrage fokussieren",
      "map.query.status_indicator.none": "Aus",
      "map.query.status_indicator.applied": "Aktiv",
      "map.query.status_indicator.updating": "Läuft",
      "map.query.status_indicator.partial": "Teil",
      "map.query.status_indicator.invalid": "Ungültig",
      "map.query.status_indicator.failed": "Fehler",
      "map.query.status.empty": "Keine Abfrage ist aktiv.",
      "map.query.status.applied": "Der aktuelle Text ist aktiv.",
      "map.query.status.evaluating.active": "Der aktuelle Text wird geprüft; die Karte verwendet weiterhin „{$source}“…",
      "map.query.status.evaluating.empty": "Während der Prüfung des aktuellen Texts ist nichts aktiv…",
      "map.query.status.applying.active": "Der aktuelle Text wird angewendet; die Karte verwendet weiterhin „{$source}“…",
      "map.query.status.applying.empty": "Bis zur Bestätigung des aktuellen Texts ist nichts aktiv…",
      "map.query.status.clearing.active": "„{$source}“ wird entfernt…",
      "map.query.status.clearing.empty": "Es wird bestätigt, dass keine Abfrage aktiv ist…",
      "map.query.status.composing.active": "Die Karte verwendet weiterhin „{$source}“; Texteingabe abschließen, um zu aktualisieren.",
      "map.query.status.composing.empty": "Nichts ist aktiv; Texteingabe abschließen, um zu aktualisieren.",
      "map.query.status.partial": "Nur dem gültigen Präfix zugeordnete Einheiten sind aktiv; der restliche Text ist es nicht.",
      "map.query.status.partial_applying.active": "Das gültige Präfix wird angewendet; die Karte verwendet weiterhin „{$source}“…",
      "map.query.status.partial_applying.empty": "Während der Bestätigung des gültigen Präfixes ist nichts aktiv…",
      "map.query.status.invalid_clearing.active": "Der aktuelle Text ist ungültig; „{$source}“ wird entfernt…",
      "map.query.status.invalid_clearing.empty": "Der aktuelle Text ist ungültig; es wird bestätigt, dass keine Abfrage aktiv ist…",
      "map.query.status.invalid.active": "Der aktuelle Text ist ungültig; die Karte verwendet weiterhin „{$source}“.",
      "map.query.status.invalid.empty": "Der aktuelle Text ist ungültig; keine Abfrage ist aktiv.",
      "map.query.status.failed.active": "Der aktuelle Text konnte nicht angewendet werden; die Karte verwendet weiterhin „{$source}“. Zum Wiederholen Enter drücken.",
      "map.query.status.failed.empty": "Der aktuelle Text konnte nicht angewendet werden; keine Abfrage ist bestätigt. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_prefix.active": "Das gültige Präfix konnte nicht angewendet werden; die Karte verwendet weiterhin „{$source}“. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_prefix.empty": "Das gültige Präfix konnte nicht angewendet werden; keine Abfrage ist bestätigt. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_clearing.active": "„{$source}“ konnte nicht entfernt werden. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_clearing.empty": "Das Entfernen konnte nicht bestätigt werden; zuvor war keine Abfrage bestätigt. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_evaluating.active": "Der aktuelle Text konnte nicht ausgewertet werden; die Karte verwendet weiterhin „{$source}“. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_evaluating.empty": "Der aktuelle Text konnte nicht ausgewertet werden; keine Abfrage ist bestätigt. Zum Wiederholen Enter drücken.",
      "map.query.status.failed_preparing.active": "Die Suchdaten konnten nicht vorbereitet werden; die Karte verwendet weiterhin „{$source}“. Neue Kartendaten lösen einen weiteren Versuch aus.",
      "map.query.status.failed_preparing.empty": "Die Suchdaten konnten nicht vorbereitet werden; keine Abfrage ist bestätigt. Neue Kartendaten lösen einen weiteren Versuch aus.",
      "map.search.placeholder": "Fisch, Zone, Filter oder Patch suchen",
      "map.search.meaning.applied_query": "Bedeutung der angewendeten Abfrage",
      "map.search.meaning.applied_term": "Angewendeter Suchbegriff",
      "map.search.meaning.exclude": "Ausschließen",
      "map.search.meaning.match_all": "Alle müssen zutreffen",
      "map.search.meaning.match_any": "Mindestens eins muss zutreffen",
      "map.search.meaning.container_containing": "Behälter enthält",
      "map.search.meaning.conjunction.and": "UND",
      "map.search.meaning.conjunction.or": "ODER",
      "map.search.bound.before": "Vor",
      "map.search.bound.after": "Nach",
      "map.search.patch.choose_date": "Datum wählen",
      "map.search.kind.filter": "Filter",
      "map.search.kind.date": "Datum",
      "map.search.kind.status": "Status",
      "map.search.kind.layer": "Ebene",
      "map.search.kind.layer_filter": "Ebenenfilter",
      "map.search.kind.layer_fact": "Ebenenfakt",
      "map.search.semantic.field": "Feld {$id}",
      "map.search.zone.fallback": "Zone {$zone}",
      "map.search.stinky_fish": "Stinkender Fisch",
      "map.search.triple_float_fishing_rod": "Angelrute mit drei Posen",
      "map.search.quest.fish_for_villagers": "Fisch für die Dorfbewohner",
      "map.search.quest.special_fishing_rod": "Eine besondere Angelrute",
      "map.search.item_group.any": "{$label} (beliebig)",
      "map.search.item_group.items.one": "1 Gegenstand",
      "map.search.item_group.items.other": "{$count} Gegenstände",
      "map.search.layer_filter.label": "{$layer}-Filter",
      "map.search.layer_group.high_quality": "Hohe Qualität",
      "map.search.layer_group.prize": "Preis",
      "map.search.filter.favourite.label": "Favorit",
      "map.search.filter.favourite.description": "Fische, die im Fishydex mit einem Herz markiert sind.",
      "map.search.filter.missing.label": "Fehlend",
      "map.search.filter.missing.description": "Fische, die im Fishydex nicht als gefangen markiert sind.",
      "map.search.filter.red.description": "Preis- oder rotstufige Fische und Beute.",
      "map.search.filter.yellow.description": "Seltene oder gelbstufige Fische und Beute.",
      "map.search.filter.blue.description": "Hochwertige oder blaustufige Fische und Beute.",
      "map.search.filter.green.description": "Allgemeine oder grünstufige Fische und Beute.",
      "map.search.filter.white.description": "Schrott- oder weißstufige Fische und Beute.",
      "map.search.patch.prompt.after": "Nach",
      "map.search.patch.prompt.before": "Vor",
      "map.search.patch.prompt.description": "Wähle einen Patch oder ein Datum, um Stichproben einzugrenzen.",
      "map.overview.zone": "Zone",
      "map.overview.rgb": "RGB",
      "map.overview.bite_time": "Bisszeit",
      "map.overview.resources": "Ressourcen",
      "map.overview.origin": "Herkunft",
      "map.info.window_title": "Details",
      "map.info.status.bookmark": "Lesezeichen",
      "map.info.status.waypoint": "Wegpunkt",
      "map.info.status.clicked": "Angeklickter Punkt",
      "map.info.status.no_selection": "nichts ausgewählt",
      "map.info.provenance": "Fakt-Herkunft",
      "map.info.tabs": "Punkt-Ebenen-Tabs",
      "map.info.empty_group": "Diesem Abschnitt sind im aktuellen Overlay noch keine Zeilen zugewiesen.",
      "map.info.empty_zone": "Für diese Zone sind noch keine Fischzeilen verfügbar.",
      "map.info.empty_about_title": "Black Desert Angelkarte",
      "map.info.empty_about": "Erkunde Angelzonen, Beutetabellen, Hotspots, Regionsgruppen, Fischfundorte und aufgezeichnete Fänge.",
      "map.info.empty_selection": "Klicke auf die Karte, verwende ein Wegpunktziel oder wähle ein Lesezeichen aus, um Fakten zu einem Weltpunkt anzuzeigen.",
      "map.info.fish.unknown": "Unbekannter Fisch",
      "map.info.pane.zone": "Zone",
      "map.info.pane.landmark": "Landmarke",
      "map.info.pane.territory": "Gebiet",
      "map.info.pane.trade": "Handel",
      "map.info.pane.lineage": "Herkunft",
      "map.info.section.zone": "Zone",
      "map.info.section.landmark": "Landmarke",
      "map.info.section.territory": "Gebiet",
      "map.info.section.trade": "Handel",
      "map.info.section.fish": "Fisch",
      "map.info.location.title": "Standort",
      "map.info.location.world_coordinates": "Weltkoordinaten",
      "map.info.location.unavailable": "nicht verfügbar",
      "map.info.location.copy_bookmark": "Lesezeichen kopieren",
      "map.info.location.create_bookmark": "Als Lesezeichen speichern",
      "map.info.location.bookmark_unavailable": "Die Höhe ist nicht verfügbar, daher kann dieser Punkt nicht als Lesezeichen verwendet werden.",
      "map.info.lineage.coordinate": "Maskenpixel {$x}, {$y}",
      "map.info.lineage.current_rgb": "Aktuelles RGB {$rgb}",
      "map.info.lineage.result_rgb": "Ergebnis-RGB {$rgb}",
      "map.info.lineage.known": "Bekannt",
      "map.info.lineage.guess": "Vermutung",
      "map.info.lineage.leak": "Leak",
      "map.info.lineage.evidence": "Beleg",
      "map.info.lineage.timestamp_source": "Zeitquelle",
      "map.info.lineage.source_revision": "Quellrevision {$revision}",
      "map.info.history.title": "Verlauf",
      "map.info.history.back": "Zur vorherigen Auswahl",
      "map.info.history.go": "Zurück zu {$name}",
      "map.info.history.previous": "Vorherige Auswahl: {$name}",
      "map.info.history.next": "Nächste Auswahl: {$name}",
      "map.info.history.unknown": "Auswahl",
      "map.info.trade.managers": "Handelsverwalter",
      "map.info.trade.manager_count": "{$count} Zielhändler",
      "map.info.trade.filter_label": "Händlertyp",
      "map.info.trade.filter_all": "Alle",
      "map.info.trade.filter_standard": "Handelsverwalter",
      "map.info.trade.filter_imperial": "Kaiserlich",
      "map.info.trade.filter_empty": "Keine Händler entsprechen diesem Filter.",
      "map.info.trade.multiplier_final": "{$multiplier} Verkauf",
      "map.info.trade.multiplier_fixed": "{$multiplier} Verkauf",
      "map.info.trade.multiplier_final_help": "Finaler Verkaufsmultiplikator aus den regulären Rechner-Standardeinstellungen.",
      "map.info.trade.multiplier_fixed_help": "Fester Verkaufsmultiplikator für Fisch.",
      "map.info.trade.maximum_bonus_group": "Maximaler Distanzbonus (ab 150 %)",
      "map.info.trade.below_maximum_bonus_group": "Unter maximalem Distanzbonus (unter 150 %)",
      "map.info.trade.loading": "lädt",
      "map.info.trade.unavailable": "nicht verfügbar",
      "map.info.trade.request_failed": "Handelsverwalter-Anfrage fehlgeschlagen ({$status})",
      "map.info.trade.focus_target": "{$name} fokussieren",
      "map.info.trade.focus_target_generic": "Ziel fokussieren",
      "map.info.notice.title": "Hinweis",
      "map.info.zone_loot.title": "Fangprofil",
      "map.info.zone_loot.summary.default": "Rechner-Standardwerte",
      "map.info.zone_loot.notice.status_title": "Fangprofil-Status",
      "map.info.zone_loot.profile_tabs": "Beutetabellen",
      "map.info.zone_loot.status.idle": "Zonenfang: inaktiv",
      "map.info.zone_loot.status.loading": "Zonenfang: lädt",
      "map.info.zone_loot.status.loaded": "Zonenfang: geladen",
      "map.info.zone_loot.status.error": "Zonenfang: Fehler",
      "map.info.zone_loot.status.other": "Zonenfang: {$status}",
      "map.info.zone_loot.unavailable": "Die Zonenfang-Zusammenfassung ist nicht verfügbar.",
      "map.info.zone_loot.condition.previous": "Vorherige Bedingung",
      "map.info.zone_loot.condition.next": "Nächste Bedingung",
      "map.bookmarks.window_title": "Lesezeichen",
      "map.bookmarks.new": "Neues Lesezeichen",
      "map.bookmarks.click_to_place": "Auf Karte klicken zum Platzieren",
      "map.bookmarks.select_all": "Alle auswählen",
      "map.bookmarks.paste": "Einfügen",
      "map.bookmarks.empty": "Noch keine Lesezeichen.",
      "map.bookmarks.fallback": "Lesezeichen {$index}",
      "map.bookmarks.row_label": "Lesezeichen",
      "map.bookmarks.action.drag": "{$label} ziehen",
      "map.bookmarks.action.select": "{$label} auswählen",
      "map.bookmarks.action.rename": "Lesezeichen umbenennen",
      "map.bookmarks.action.inspect": "Lesezeichen ansehen",
      "map.bookmarks.action.copy_xml": "Lesezeichen-XML kopieren",
      "map.bookmarks.action.delete": "Lesezeichen löschen",
      "map.bookmarks.confirm.delete_selected.one": "{$count} ausgewähltes Lesezeichen löschen?",
      "map.bookmarks.confirm.delete_selected.other": "{$count} ausgewählte Lesezeichen löschen?",
      "map.bookmarks.confirm.delete_single": "Lesezeichen \"{$label}\" löschen?",
      "map.bookmarks.prompt.rename": "Lesezeichen umbenennen",
      "map.bookmarks.toast.select_to_copy": "Wähle ein oder mehrere Lesezeichen zum Kopieren aus.",
      "map.bookmarks.toast.clipboard_unavailable": "Zwischenablage ist in diesem Browser nicht verfügbar.",
      "map.bookmarks.toast.no_export": "Es gibt noch keine Lesezeichen zum Exportieren.",
      "map.bookmarks.toast.export_unavailable": "Lesezeichen-Export ist in diesem Browser nicht verfügbar.",
      "map.bookmarks.toast.import_unavailable": "Lesezeichen-Import ist in diesem Browser nicht verfügbar.",
      "map.bookmarks.toast.import_no_xml": "Der importierte Text enthielt keine Lesezeichen-XML.",
      "map.bookmarks.toast.import_failed": "Lesezeichen-Import fehlgeschlagen. Verwende gültiges WorldmapBookMark-XML.",
      "map.bookmarks.toast.copied_single": "Lesezeichen-XML kopiert.",
      "map.bookmarks.toast.created_single": "Lesezeichen hinzugefügt.",
      "map.bookmarks.toast.copy_selection.one": "XML für {$count} Lesezeichen kopiert.",
      "map.bookmarks.toast.copy_selection.other": "XML für {$count} Lesezeichen kopiert.",
      "map.bookmarks.toast.export_selected.one": "{$count} ausgewähltes Lesezeichen exportiert.",
      "map.bookmarks.toast.export_selected.other": "{$count} ausgewählte Lesezeichen exportiert.",
      "map.bookmarks.toast.export_all.one": "{$count} Lesezeichen exportiert.",
      "map.bookmarks.toast.export_all.other": "{$count} Lesezeichen exportiert.",
      "map.bookmarks.toast.import_none": "Es wurden keine neuen Lesezeichen importiert.",
      "map.bookmarks.toast.imported.one": "{$count} Lesezeichen importiert.",
      "map.bookmarks.toast.imported.other": "{$count} Lesezeichen importiert.",
      "map.bookmarks.toast.skipped_duplicates.one": "{$count} Duplikat übersprungen.",
      "map.bookmarks.toast.skipped_duplicates.other": "{$count} Duplikate übersprungen.",
      "map.layers.window_title": "Ebenen",
      "map.layers.unavailable": "Nicht verfügbar",
      "map.layers.loading_registry": "Ebenenregister wird geladen...",
      "map.layers.show": "Einblenden",
      "map.layers.hide": "Ausblenden",
      "map.layers.live_events_unavailable": "Live-Events erfordern ein angemeldetes Konto, ein aktiviertes Angelprotokoll und Live-Charakterdaten.",
      "map.layers.drag_pinned": "{$name} ist an die Bodenebene angeheftet",
      "map.layers.drag": "{$name} ziehen",
      "map.layers.settings_show": "Einstellungen für {$name} anzeigen",
      "map.layers.settings_hide": "Einstellungen für {$name} ausblenden",
      "map.layers.opacity": "Deckkraft",
      "map.layers.opacity_for": "Deckkraft für {$name}",
      "map.layers.confidence": "Konfidenz",
      "map.layers.confidence_showcase": "Konfidenz anzeigen",
      "map.layers.lineage_panel": "Herkunftspanel anzeigen",
      "map.layers.tab.appearance": "Erscheinungsbild",
      "map.layers.tab.hover": "Hover",
      "map.layers.tab.highlight": "Hervorhebung",
      "map.layers.tab.waypoints": "Wegpunkte",
      "map.layers.highlight.enabled": "Aktiviert",
      "map.layers.highlight.opacity": "Deckkraft",
      "map.layers.highlight.opacity_for": "Hervorhebungsdeckkraft für {$name}",
      "map.layers.highlight.color": "Farbe",
      "map.layers.highlight.color_for": "Hervorhebungsfarbe für {$name}",
      "map.layers.connections": "Verbindungen",
      "map.layers.names": "Namen",
      "map.layers.categories": "Kategorien",
      "map.layers.icons": "Symbole",
      "map.layers.sample_hover": "Sample-Hover",
      "map.layers.hover_facts": "Hover-Fakten",
      "map.layers.table.icon": "Symbol",
      "map.layers.table.name": "Name",
      "map.layers.table.fact": "Fakt",
      "map.layers.table.show": "Anzeigen",
      "map.layers.hover_show": "{$fact} beim Hover über {$layer} anzeigen",
      "map.layers.fish_evidence": "Fisch-Hinweise",
      "map.layers.fish_icon_size": "Fischsymbolgröße",
      "map.layers.fish_icon_size_for": "Fischsymbolgröße für {$name}",
      "map.layers.clustering": "Clustering",
      "map.layers.search_kind.zones": "Zonen",
      "map.hover.extents_confidence": "Grenzkonfidenz",
      "map.hover.lineage": "Herkunft",
      "map.hover.confidence.known": "Bekannt",
      "map.hover.confidence.guess": "Vermutet",
      "map.hover.zone_name": "Zonenname",
      "map.hover.zone": "Zone",
      "map.hover.rgb": "RGB",
      "map.hover.world_coordinate_xz": "XZ-Koordinate",
      "map.hover.world_coordinate": "Weltkoordinate",
      "map.hover.resources": "Ressourcen",
      "map.hover.origin": "Herkunft",
      "map.hover.affiliated_node": "Angegliederter Posten",
      "map.hover.details": "Details",
      "map.settings.window_title": "Einstellungen",
      "map.settings.ready": "Bereit",
      "map.settings.loading": "Lädt",
      "map.settings.actions": "Aktionen",
      "map.settings.reset_view": "Ansicht zurücksetzen",
      "map.settings.reset_ui": "UI zurücksetzen",
      "map.settings.display": "Anzeige",
      "map.settings.auto_adjust_view": "Ansicht automatisch anpassen",
      "map.settings.three_d_enabled": "3D aktivieren",
      "map.settings.loot_rate_display_mode": "Beuteratenanzeige",
      "map.settings.loot_rate_display_mode.normalized": "Normalisiert",
      "map.settings.loot_rate_display_mode.denormalized": "Denormalisiert",
      "map.settings.loot_rate_display_mode.raw_weight": "Rohgewicht",
      "map.settings.sample_from_filtered_elements": "Aus gefilterten Elementen abtasten",
      "map.settings.effects_enabled": "Animationen/Effekte",
      "map.settings.focus_waves_enabled": "Kontinuierliche Fokuswellen",
      "map.settings.filtering": "Filter",
      "map.settings.filter_active_condition_groups": "Nur aktive Bedingungsgruppen filtern",
      "map.settings.sorting": "Sortierung",
      "map.settings.sort_by": "Sortieren nach",
      "map.settings.sort_by.calculator": "Kartenstandard (Preis)",
      "map.settings.sort_by.price": "Preis",
      "map.settings.sort_by.grade": "Qualität",
      "map.settings.sort_by.droprate": "Rate innerhalb der Gruppe",
      "map.settings.sort_by.expected_value": "Erwartungswert",
      "map.settings.sort_by.exp": "EXP",
      "map.settings.sort_by.totem_exp": "Totem-EXP",
      "map.settings.sort_by.alphabetical": "Alphabetisch",
      "map.settings.sort_by.item_id": "Gegenstands-ID",
      "map.settings.sort_by.database": "Datenbank",
      "map.settings.sort_by.evidence": "Stärkster Nachweis",
      "map.settings.sort_order": "Sortierreihenfolge",
      "map.settings.sort_order.calculator": "Kartenstandard (absteigend)",
      "map.settings.sort_order.desc": "Absteigend",
      "map.settings.sort_order.asc": "Aufsteigend",
      "map.loading.title": "Black Desert Angelkarte",
      "map.loading.starting": "Karte wird vorbereitet...",
      "map.loading.initial_detail": "Beim ersten Besuch kann das einen Moment dauern.",
      "map.loading.manifest": "Kartenruntime wird gesucht...",
      "map.loading.module_import": "Kartencode wird geladen...",
      "map.loading.wasm_fetch": "Kartenruntime wird heruntergeladen...",
      "map.loading.wasm_compile": "Kartenruntime wird kompiliert...",
      "map.loading.renderer_start": "Renderer wird gestartet...",
      "map.loading.runtime_bootstrap": "Kartendaten werden geladen...",
      "map.loading.first_paint": "Erster Frame wird gezeichnet...",
      "map.loading.ready": "Karte bereit",
      "map.loading.fetch_bytes": "{$loaded} von {$total}",
      "map.loading.fetch_bytes_unknown": "{$loaded} heruntergeladen",
      "map.error.renderer_unavailable": "Kartenrenderer nicht verfügbar",
      "map.error.badge": "Fehler",
      "map.error.renderer_start_failed": "Die Webseite wurde geladen, aber der Bevy/WebGL-Renderer konnte nicht starten.",
      "map.zone_loot.error.invalid_zone_rgb": "Die Zonenfang-Zusammenfassung benötigt eine gültige Zonen-RGB.",
      "map.zone_loot.error.missing_endpoint": "Der Endpunkt für die Zonenfang-Zusammenfassung ist in diesem API-Build nicht verfügbar.",
      "map.zone_loot.error.request_failed": "Anfrage für die Zonenfang-Zusammenfassung fehlgeschlagen: {$status}",
      "map.search.title.description": "Angeltitel nach ID oder Name",
      "map.search.filter.missing_titles.description": "Fische mit noch nicht erhaltenen Titeln gemäß deinen Fishydex-Titeloptionen.",
      "presets.select.label": "Gespeicherte Vorlagen",
      "presets.select.hint": "Wähle eine Vorlage aus, um sie zu prüfen oder umzubenennen. Mit Anwenden aktivierst du sie.",
      "presets.button.open_manager": "Vorlagenverwaltung",
      "presets.manager.description": "Speichere, benenne um, importiere, exportiere und wechsle zwischen gespeicherten Vorlagen, ohne sie neu aufzubauen.",
      "presets.manager.open": "Vorlagenverwaltung öffnen",
      "presets.manager.close": "Vorlagenverwaltung schließen",
      "presets.collection.title": "{$name}-Vorlagen",
      "presets.collection.open": "{$name}-Vorlagen",
      "presets.collection.default_name": "{$name} {$index}",
      "presets.collection.workspace": "Arbeitsbereich",
      "presets.collection.calculator": "Rechner",
      "presets.collection.overlay": "Overlay",
      "presets.collection.map": "Karte",
      "presets.collection.dex": "Dex",
      "presets.grid.title": "Vorlagen",
      "presets.grid.description": "Die Auswahl einer Karte öffnet sie nur zur Verwaltung. Verwende sie, um die aktuelle Arbeit zu ersetzen.",
      "presets.grid.count": "{$count} gespeichert",
      "presets.grid.empty": "Keine Vorlagen verfügbar.",
      "presets.grid.no_matches": "Keine Vorlage entspricht diesem Filter.",
      "presets.grid.local_empty_account": "Keine lokalen Vorlagen gefunden. Solange du angemeldet bist, werden Vorlagen in deinem Konto gespeichert.",
      "presets.current.modified": "Geänderte aktuelle Vorlage",
      "presets.current.modified_from": "Geändert: {$name}",
      "presets.current.untitled": "Aktuelle Arbeit",
      "presets.current.unnamed": "Unbenannte Vorlage",
      "presets.current.not_in_preset": "Änderungen nicht in der Vorlage",
      "presets.current.based_on_preset": "Basiert auf Vorlage „{$name}“",
      "presets.current.based_on_fixed": "Basiert auf integrierter Vorlage „{$name}“",
      "presets.current.no_base": "Noch keine benannte Vorlage",
      "presets.current.revision": "Version {$revision}",
      "presets.current.revision_pending": "Version ausstehend",
      "presets.current.status_unavailable": "Status nicht verfügbar",
      "presets.autosave.saving": "Wird lokal gespeichert…",
      "presets.autosave.error": "Lokales Speichern erfordert Aufmerksamkeit",
      "presets.section.active.title": "Aktive Vorlage",
      "presets.section.active.description": "Die Seite verwendet derzeit diese Vorlage. Speichere oder verwirf ihre aktiven Änderungen hier.",
      "presets.section.selected.title": "Ausgewählte Vorlage",
      "presets.section.selected.description.fixed": "Verwende diese integrierte Vorlage, ohne ihre Definition zu ändern.",
      "presets.section.selected.description.current": "Dies ist die aktuelle ungespeicherte Vorlage. Klonen speichert eine dauerhafte Kopie.",
      "presets.section.selected.description.saved": "Benenne oder verwalte diese Vorlage, ohne die aktuelle Arbeit zu ändern.",
      "presets.section.selected.description.empty": "Wähle eine Vorlage aus, um sie zu prüfen.",
      "presets.section.transfer.title": "Übertragen",
      "presets.section.transfer.description": "Exportiere die ausgewählte Vorlage als JSON oder importiere eine Vorlage, die ein anderer Spieler geteilt hat.",
      "presets.section.delete.title": "Ausgewählte Vorlage entfernen",
      "presets.section.delete.description": "Lösche die ausgewählte gespeicherte Vorlage. Dein aktuell sichtbarer Zustand bleibt unverändert, bis du wieder wechselst.",
      "presets.section.delete.description.saved": "Lösche die ausgewählte gespeicherte Vorlage. Der aktuelle Live-Zustand bleibt unverändert.",
      "presets.section.delete.description.readonly": "Standard und Aktuell können nicht entfernt werden. Nutze zuerst Klonen, wenn du eine bearbeitbare gespeicherte Kopie möchtest.",
      "presets.dialog.name_label": "Vorlagenname",
      "presets.name.hint": "Verwende diesen Namen zum Erstellen einer neuen Vorlage oder zum Umbenennen der ausgewählten Vorlage.",
      "presets.name.required": "Gib einen Vorlagennamen ein.",
      "presets.field.selected_title.hint.saved": "Eingaben hier aktualisieren den Titel der ausgewählten gespeicherten Vorlage.",
      "presets.field.selected_title.hint.readonly": "Dieser Titel ist fest. Nutze Klonen, um eine bearbeitbare gespeicherte Kopie zu erstellen.",
      "presets.dialog.rename.title": "Vorlage umbenennen",
      "presets.action.apply_selected": "Auswahl anwenden",
      "presets.action.import_file": "Vorlagen importieren",
      "presets.action.use_item": "Diese {$item} verwenden",
      "presets.action.set_active": "Vorlage aktivieren",
      "presets.action.set_active_named": "„{$name}“ aktivieren",
      "presets.action.update": "„{$name}“ aktualisieren",
      "presets.action.update_unavailable": "Vorlage aktualisieren",
      "presets.action.save_as": "Als neue {$item} speichern…",
      "presets.action.reset_to": "Auf „{$name}“ zurücksetzen",
      "presets.action.reset": "Aktuelle Arbeit zurücksetzen",
      "presets.selected.heading": "Ausgewählte {$item}",
      "presets.selected.name_label": "Name der {$item}",
      "presets.status.base": "Basisvorlage",
      "presets.status.active_named": "„{$name}“ ist die aktive Vorlage",
      "presets.copy_name": "Kopie von {$name}",
      "presets.default_name": "Vorlage {$index}",
      "presets.save_as.name_label": "Name der neuen Vorlage",
      "presets.save_as.reference_hint": "Erstellt eine benannte Referenz auf genau diese Version.",
      "presets.tab.presets": "Vorlagen",
      "presets.tab.changes": "Ungespeicherte Änderungen",
      "presets.tab.history": "Verlauf",
      "presets.library.title": "Vorlagenbibliothek",
      "presets.library.filter": "Vorlagen filtern",
      "presets.library.search": "Vorlagen suchen",
      "presets.selected.version": "Version",
      "presets.status.applying": "Wird angewendet…",
      "presets.status.built_in": "Integriert",
      "presets.confirm.delete": "\"{$name}\" löschen?",
      "presets.toast.created": "Neue Vorlage \"{$name}\" gespeichert.",
      "presets.toast.copied": "\"{$name}\" geklont.",
      "presets.toast.saved": "\"{$name}\" gespeichert.",
      "presets.toast.discarded": "Aktuelle Arbeit auf ihre Basisvorlage zurückgesetzt.",
      "presets.toast.renamed": "Umbenannt in \"{$name}\".",
      "presets.toast.deleted": "\"{$name}\" gelöscht.",
      "presets.toast.exported": "Vorlage exportiert.",
      "presets.toast.imported": "Vorlage importiert.",
      "presets.toast.applied": "\"{$name}\" angewendet.",
      "presets.error.import": "Vorlagenimport fehlgeschlagen.",
      "presets.error.apply": "Vorlage konnte nicht angewendet werden.",
      "presets.error.save": "Vorlage konnte nicht gespeichert werden.",
      "presets.error.discard": "Vorlage konnte nicht verworfen werden.",
      "presets.error.capture": "Aktueller Vorlagenzustand ist nicht verfügbar.",
      "presets.error.command": "Die Vorlagenaktion konnte nicht abgeschlossen werden.",
      "presets.state.loading": "Vorlagenarbeitsbereich wird geladen…",
      "presets.state.conflict": "Diese Vorlage wurde in einem anderen Tab geändert. Prüfe die aktuelle Version und versuche es erneut.",
      "presets.state.invalid": "Gespeicherte Vorlagendaten sind ungültig. Sie wurden zur Wiederherstellung aufbewahrt.",
      "presets.state.unsupported": "Diese Vorlagen wurden mit einer neueren FishyStuff-Version erstellt.",
      "presets.state.unavailable": "Der Vorlagenspeicher ist derzeit nicht verfügbar.",
      "presets.history.change": "Vorlage geändert",
      "presets.history.current": "Aktuell",
      "presets.history.shared_base": "Gemeinsame Basis",
      "presets.history.show_alternates": "Alternative Zweige anzeigen",
      "presets.history.old": "alt:",
      "presets.history.new": "neu:",
      "presets.history.compacted": "Ältere Änderungen zusammengefasst",
      "presets.history.branches": "{$count} Zweige",
      "presets.history.previewing": "Vorschau: {$summary}",
      "presets.history.undone": "Zur vorherigen Version gewechselt.",
      "presets.history.redone": "Zur nächsten Version gewechselt.",
      "presets.history.version_applied": "Die aktuelle Arbeit verwendet jetzt die ausgewählte Version.",
      "presets.history.title": "Verlauf der aktuellen Arbeit",
      "presets.history.description": "Die Vorschau einer Version wendet sie nicht an. Neue Änderungen nach Rückgängig behalten den anderen Zweig.",
      "presets.history.preview_not_applied": "Es wurde noch nichts angewendet.",
      "presets.history.empty": "Noch keine Inhaltsänderungen.",
      "presets.history.empty_selected": "Keine aufgezeichneten Änderungen für diese Vorlage.",
      "presets.details.label": "Vorlagendetails",
      "presets.changes.kind": "Änderung",
      "presets.changes.setting": "Einstellung",
      "presets.changes.old": "Alt",
      "presets.changes.new": "Neu",
      "presets.changes.path": "Pfad",
      "presets.changes.saved": "Gespeichert",
      "presets.changes.working": "Arbeitsstand",
      "presets.changes.added": "Hinzugefügt",
      "presets.changes.removed": "Entfernt",
      "presets.changes.changed": "Geändert",
      "presets.changes.summary": "{$count} Änderungen gegenüber der gespeicherten Vorlage.",
      "presets.changes.summary_truncated": "Die ersten {$count} Änderungen werden angezeigt.",
      "presets.changes.empty": "Keine Unterschiede zu dieser Vorlage.",
      "presets.changes.inactive": "Aktiviere diese Vorlage, um ihre Änderungen zu prüfen.",
      "presets.quick_switch.empty": "Keine Vorlagen verfügbar.",
      "presets.quick_switch.search": "Vorlagen suchen...",
      "presets.quick_switch.current": "Aktuell",
      "presets.quick_switch.current_modified": "Aktuelle Arbeit · {$name}"
    }
  },
  "pageManifest": {
    "/community/": {
      "en-US": "/community/",
      "de-DE": "/de-DE/community/"
    },
    "/crio/privacy/": {
      "en-US": "/crio/privacy/",
      "de-DE": "/de-DE/crio/privacy/"
    },
    "/crio/terms/": {
      "en-US": "/crio/terms/",
      "de-DE": "/de-DE/crio/terms/"
    },
    "/desktop/privacy/": {
      "en-US": "/desktop/privacy/",
      "de-DE": "/de-DE/desktop/privacy/"
    },
    "/devlog/": {
      "en-US": "/devlog/"
    },
    "/feedback/": {
      "en-US": "/feedback/",
      "de-DE": "/de-DE/feedback/"
    },
    "/glossary/": {
      "en-US": "/glossary/"
    },
    "/guides/3x-tfr-quest/": {
      "en-US": "/guides/3x-tfr-quest/",
      "de-DE": "/de-DE/guides/3x-tfr-quest/"
    },
    "/guides/drr/": {
      "en-US": "/guides/drr/",
      "de-DE": "/de-DE/guides/drr/"
    },
    "/guides/experience/": {
      "en-US": "/guides/experience/",
      "de-DE": "/de-DE/guides/experience/"
    },
    "/guides/groups/": {
      "en-US": "/guides/groups/",
      "de-DE": "/de-DE/guides/groups/"
    },
    "/guides/": {
      "en-US": "/guides/",
      "de-DE": "/de-DE/guides/"
    },
    "/guides/money/": {
      "en-US": "/guides/money/",
      "de-DE": "/de-DE/guides/money/"
    },
    "/guides/mystical/": {
      "en-US": "/guides/mystical/",
      "de-DE": "/de-DE/guides/mystical/"
    },
    "/guides/where-am-i-fishing/": {
      "en-US": "/guides/where-am-i-fishing/",
      "de-DE": "/de-DE/guides/where-am-i-fishing/"
    },
    "/guides/zones/": {
      "en-US": "/guides/zones/",
      "de-DE": "/de-DE/guides/zones/"
    },
    "/log/": {
      "en-US": "/log/",
      "de-DE": "/de-DE/log/"
    },
    "/privacy/": {
      "en-US": "/privacy/",
      "de-DE": "/de-DE/privacy/"
    },
    "/terms/": {
      "en-US": "/terms/",
      "de-DE": "/de-DE/terms/"
    },
    "/admin/konten/": {
      "en-US": "/admin/accounts/",
      "de-DE": "/de-DE/admin/konten/"
    },
    "/admin/accounts/": {
      "en-US": "/admin/accounts/",
      "de-DE": "/de-DE/admin/konten/"
    },
    "/dex/": {
      "en-US": "/dex/",
      "de-DE": "/de-DE/dex/"
    },
    "/dex/catalog/": {
      "en-US": "/dex/catalog/",
      "de-DE": "/de-DE/dex/catalog/"
    },
    "/dex/progress/": {
      "en-US": "/dex/progress/",
      "de-DE": "/de-DE/dex/progress/"
    },
    "/dex/weekly-contest/": {
      "en-US": "/dex/weekly-contest/",
      "de-DE": "/de-DE/dex/weekly-contest/"
    },
    "/": {
      "en-US": "/",
      "de-DE": "/de-DE/"
    },
    "/karte/": {
      "en-US": "/map/",
      "de-DE": "/de-DE/karte/"
    },
    "/map/": {
      "en-US": "/map/",
      "de-DE": "/de-DE/karte/"
    },
    "/konto/": {
      "en-US": "/account/",
      "de-DE": "/de-DE/konto/"
    },
    "/account/": {
      "en-US": "/account/",
      "de-DE": "/de-DE/konto/"
    },
    "/konto/administration-bestaetigen/": {
      "en-US": "/account/confirm-administration/",
      "de-DE": "/de-DE/konto/administration-bestaetigen/"
    },
    "/account/confirm-administration/": {
      "en-US": "/account/confirm-administration/",
      "de-DE": "/de-DE/konto/administration-bestaetigen/"
    },
    "/konto/authenticator/": {
      "en-US": "/account/authenticator/",
      "de-DE": "/de-DE/konto/authenticator/"
    },
    "/account/authenticator/": {
      "en-US": "/account/authenticator/",
      "de-DE": "/de-DE/konto/authenticator/"
    },
    "/konto/browser/": {
      "en-US": "/account/browser/",
      "de-DE": "/de-DE/konto/browser/"
    },
    "/account/browser/": {
      "en-US": "/account/browser/",
      "de-DE": "/de-DE/konto/browser/"
    },
    "/konto/datenschutz/": {
      "en-US": "/account/privacy/",
      "de-DE": "/de-DE/konto/datenschutz/"
    },
    "/account/privacy/": {
      "en-US": "/account/privacy/",
      "de-DE": "/de-DE/konto/datenschutz/"
    },
    "/konto/identitaet-abschliessen/": {
      "en-US": "/account/identity-complete/",
      "de-DE": "/de-DE/konto/identitaet-abschliessen/"
    },
    "/account/identity-complete/": {
      "en-US": "/account/identity-complete/",
      "de-DE": "/de-DE/konto/identitaet-abschliessen/"
    },
    "/konto/loeschen/": {
      "en-US": "/account/delete/",
      "de-DE": "/de-DE/konto/loeschen/"
    },
    "/account/delete/": {
      "en-US": "/account/delete/",
      "de-DE": "/de-DE/konto/loeschen/"
    },
    "/konto/passkeys/": {
      "en-US": "/account/passkeys/",
      "de-DE": "/de-DE/konto/passkeys/"
    },
    "/account/passkeys/": {
      "en-US": "/account/passkeys/",
      "de-DE": "/de-DE/konto/passkeys/"
    },
    "/konto/passwort/": {
      "en-US": "/account/password/",
      "de-DE": "/de-DE/konto/passwort/"
    },
    "/account/password/": {
      "en-US": "/account/password/",
      "de-DE": "/de-DE/konto/passwort/"
    },
    "/konto/registrieren/": {
      "en-US": "/account/register/",
      "de-DE": "/de-DE/konto/registrieren/"
    },
    "/account/register/": {
      "en-US": "/account/register/",
      "de-DE": "/de-DE/konto/registrieren/"
    },
    "/konto/sicherheitsschluessel/": {
      "en-US": "/account/security-keys/",
      "de-DE": "/de-DE/konto/sicherheitsschluessel/"
    },
    "/account/security-keys/": {
      "en-US": "/account/security-keys/",
      "de-DE": "/de-DE/konto/sicherheitsschluessel/"
    },
    "/konto/sitzungen/": {
      "en-US": "/account/sessions/",
      "de-DE": "/de-DE/konto/sitzungen/"
    },
    "/account/sessions/": {
      "en-US": "/account/sessions/",
      "de-DE": "/de-DE/konto/sitzungen/"
    },
    "/konto/verknuepfungen/": {
      "en-US": "/account/connections/",
      "de-DE": "/de-DE/konto/verknuepfungen/"
    },
    "/account/connections/": {
      "en-US": "/account/connections/",
      "de-DE": "/de-DE/konto/verknuepfungen/"
    },
    "/konto/wiederherstellen/": {
      "en-US": "/account/recover/",
      "de-DE": "/de-DE/konto/wiederherstellen/"
    },
    "/account/recover/": {
      "en-US": "/account/recover/",
      "de-DE": "/de-DE/konto/wiederherstellen/"
    },
    "/konto/wiederherstellungscodes/": {
      "en-US": "/account/recovery-codes/",
      "de-DE": "/de-DE/konto/wiederherstellungscodes/"
    },
    "/account/recovery-codes/": {
      "en-US": "/account/recovery-codes/",
      "de-DE": "/de-DE/konto/wiederherstellungscodes/"
    },
    "/rechner/": {
      "en-US": "/calculator/",
      "de-DE": "/de-DE/rechner/"
    },
    "/calculator/": {
      "en-US": "/calculator/",
      "de-DE": "/de-DE/rechner/"
    },
    "/rechner/advanced/": {
      "en-US": "/calculator/advanced/",
      "de-DE": "/de-DE/rechner/advanced/"
    },
    "/calculator/advanced/": {
      "en-US": "/calculator/advanced/",
      "de-DE": "/de-DE/rechner/advanced/"
    },
    "/rechner/basics/": {
      "en-US": "/calculator/basics/",
      "de-DE": "/de-DE/rechner/basics/"
    },
    "/calculator/basics/": {
      "en-US": "/calculator/basics/",
      "de-DE": "/de-DE/rechner/basics/"
    },
    "/rechner/custom/": {
      "en-US": "/calculator/custom/",
      "de-DE": "/de-DE/rechner/custom/"
    },
    "/calculator/custom/": {
      "en-US": "/calculator/custom/",
      "de-DE": "/de-DE/rechner/custom/"
    },
    "/rechner/data/": {
      "en-US": "/calculator/data/",
      "de-DE": "/de-DE/rechner/data/"
    },
    "/calculator/data/": {
      "en-US": "/calculator/data/",
      "de-DE": "/de-DE/rechner/data/"
    },
    "/rechner/loadout/": {
      "en-US": "/calculator/loadout/",
      "de-DE": "/de-DE/rechner/loadout/"
    },
    "/calculator/loadout/": {
      "en-US": "/calculator/loadout/",
      "de-DE": "/de-DE/rechner/loadout/"
    },
    "/rechner/loot/": {
      "en-US": "/calculator/loot/",
      "de-DE": "/de-DE/rechner/loot/"
    },
    "/calculator/loot/": {
      "en-US": "/calculator/loot/",
      "de-DE": "/de-DE/rechner/loot/"
    },
    "/rechner/trade/": {
      "en-US": "/calculator/trade/",
      "de-DE": "/de-DE/rechner/trade/"
    },
    "/calculator/trade/": {
      "en-US": "/calculator/trade/",
      "de-DE": "/de-DE/rechner/trade/"
    },
    "/desktop-auth/": {
      "en-US": "/desktop-auth/"
    },
    "/dex/aesche/": {
      "en-US": "/dex/grayling/",
      "de-DE": "/de-DE/dex/aesche/"
    },
    "/dex/grayling/": {
      "en-US": "/dex/grayling/",
      "de-DE": "/de-DE/dex/aesche/"
    },
    "/dex/albino-quastenflosser/": {
      "en-US": "/dex/albino-coelacanth/",
      "de-DE": "/de-DE/dex/albino-quastenflosser/"
    },
    "/dex/albino-coelacanth/": {
      "en-US": "/dex/albino-coelacanth/",
      "de-DE": "/de-DE/dex/albino-quastenflosser/"
    },
    "/dex/alburnuskarpfen/": {
      "en-US": "/dex/common-bleak/",
      "de-DE": "/de-DE/dex/alburnuskarpfen/"
    },
    "/dex/common-bleak/": {
      "en-US": "/dex/common-bleak/",
      "de-DE": "/de-DE/dex/alburnuskarpfen/"
    },
    "/dex/amur-elritze/": {
      "en-US": "/dex/amur-minnow/",
      "de-DE": "/de-DE/dex/amur-elritze/"
    },
    "/dex/amur-minnow/": {
      "en-US": "/dex/amur-minnow/",
      "de-DE": "/de-DE/dex/amur-elritze/"
    },
    "/dex/amur-nasengrundel/": {
      "en-US": "/dex/amur-goby/",
      "de-DE": "/de-DE/dex/amur-nasengrundel/"
    },
    "/dex/amur-goby/": {
      "en-US": "/dex/amur-goby/",
      "de-DE": "/de-DE/dex/amur-nasengrundel/"
    },
    "/dex/amur-weissfisch/": {
      "en-US": "/dex/amur-ide/",
      "de-DE": "/de-DE/dex/amur-weissfisch/"
    },
    "/dex/amur-ide/": {
      "en-US": "/dex/amur-ide/",
      "de-DE": "/de-DE/dex/amur-weissfisch/"
    },
    "/dex/anemonenfisch/": {
      "en-US": "/dex/clownfish/",
      "de-DE": "/de-DE/dex/anemonenfisch/"
    },
    "/dex/clownfish/": {
      "en-US": "/dex/clownfish/",
      "de-DE": "/de-DE/dex/anemonenfisch/"
    },
    "/dex/anglerfisch/": {
      "en-US": "/dex/angler/",
      "de-DE": "/de-DE/dex/anglerfisch/"
    },
    "/dex/angler/": {
      "en-US": "/dex/angler/",
      "de-DE": "/de-DE/dex/anglerfisch/"
    },
    "/dex/ansprechendes-gekochtes-vogelei-9436/": {
      "en-US": "/dex/appealing-boiled-bird-egg-9436/",
      "de-DE": "/de-DE/dex/ansprechendes-gekochtes-vogelei-9436/"
    },
    "/dex/appealing-boiled-bird-egg-9436/": {
      "en-US": "/dex/appealing-boiled-bird-egg-9436/",
      "de-DE": "/de-DE/dex/ansprechendes-gekochtes-vogelei-9436/"
    },
    "/dex/arapaima/": {
      "en-US": "/dex/pirarucu/",
      "de-DE": "/de-DE/dex/arapaima/"
    },
    "/dex/pirarucu/": {
      "en-US": "/dex/pirarucu/",
      "de-DE": "/de-DE/dex/arapaima/"
    },
    "/dex/arowana/": {
      "en-US": "/dex/arowana/",
      "de-DE": "/de-DE/dex/arowana/"
    },
    "/dex/aschfarbenes-blatt-von-quturan-45018/": {
      "en-US": "/dex/quturans-ashen-leaf-45018/",
      "de-DE": "/de-DE/dex/aschfarbenes-blatt-von-quturan-45018/"
    },
    "/dex/quturans-ashen-leaf-45018/": {
      "en-US": "/dex/quturans-ashen-leaf-45018/",
      "de-DE": "/de-DE/dex/aschfarbenes-blatt-von-quturan-45018/"
    },
    "/dex/atka-makrele/": {
      "en-US": "/dex/atka-mackerel/",
      "de-DE": "/de-DE/dex/atka-makrele/"
    },
    "/dex/atka-mackerel/": {
      "en-US": "/dex/atka-mackerel/",
      "de-DE": "/de-DE/dex/atka-makrele/"
    },
    "/dex/axolotl/": {
      "en-US": "/dex/axolotl/",
      "de-DE": "/de-DE/dex/axolotl/"
    },
    "/dex/ayu/": {
      "en-US": "/dex/sweetfish/",
      "de-DE": "/de-DE/dex/ayu/"
    },
    "/dex/sweetfish/": {
      "en-US": "/dex/sweetfish/",
      "de-DE": "/de-DE/dex/ayu/"
    },
    "/dex/bachneunauge/": {
      "en-US": "/dex/lamprey/",
      "de-DE": "/de-DE/dex/bachneunauge/"
    },
    "/dex/lamprey/": {
      "en-US": "/dex/lamprey/",
      "de-DE": "/de-DE/dex/bachneunauge/"
    },
    "/dex/bahaba/": {
      "en-US": "/dex/bahaba/",
      "de-DE": "/de-DE/dex/bahaba/"
    },
    "/dex/barbe/": {
      "en-US": "/dex/barbel-steed/",
      "de-DE": "/de-DE/dex/barbe/"
    },
    "/dex/barbel-steed/": {
      "en-US": "/dex/barbel-steed/",
      "de-DE": "/de-DE/dex/barbe/"
    },
    "/dex/barsch/": {
      "en-US": "/dex/bass/",
      "de-DE": "/de-DE/dex/barsch/"
    },
    "/dex/bass/": {
      "en-US": "/dex/bass/",
      "de-DE": "/de-DE/dex/barsch/"
    },
    "/dex/bartelgruendling/": {
      "en-US": "/dex/short-barbel-gudgeon/",
      "de-DE": "/de-DE/dex/bartelgruendling/"
    },
    "/dex/short-barbel-gudgeon/": {
      "en-US": "/dex/short-barbel-gudgeon/",
      "de-DE": "/de-DE/dex/bartelgruendling/"
    },
    "/dex/beilbauch-weissfisch/": {
      "en-US": "/dex/sharpbelly/",
      "de-DE": "/de-DE/dex/beilbauch-weissfisch/"
    },
    "/dex/sharpbelly/": {
      "en-US": "/dex/sharpbelly/",
      "de-DE": "/de-DE/dex/beilbauch-weissfisch/"
    },
    "/dex/beilbauchfisch/": {
      "en-US": "/dex/hatchetfish/",
      "de-DE": "/de-DE/dex/beilbauchfisch/"
    },
    "/dex/hatchetfish/": {
      "en-US": "/dex/hatchetfish/",
      "de-DE": "/de-DE/dex/beilbauchfisch/"
    },
    "/dex/betta-kampffisch/": {
      "en-US": "/dex/betta/",
      "de-DE": "/de-DE/dex/betta-kampffisch/"
    },
    "/dex/betta/": {
      "en-US": "/dex/betta/",
      "de-DE": "/de-DE/dex/betta-kampffisch/"
    },
    "/dex/bitterling/": {
      "en-US": "/dex/bitterling/",
      "de-DE": "/de-DE/dex/bitterling/"
    },
    "/dex/blattfisch/": {
      "en-US": "/dex/leaffish/",
      "de-DE": "/de-DE/dex/blattfisch/"
    },
    "/dex/leaffish/": {
      "en-US": "/dex/leaffish/",
      "de-DE": "/de-DE/dex/blattfisch/"
    },
    "/dex/blau-zackenbarsch/": {
      "en-US": "/dex/blue-grouper/",
      "de-DE": "/de-DE/dex/blau-zackenbarsch/"
    },
    "/dex/blue-grouper/": {
      "en-US": "/dex/blue-grouper/",
      "de-DE": "/de-DE/dex/blau-zackenbarsch/"
    },
    "/dex/blaubandbaerbling/": {
      "en-US": "/dex/stone-moroko/",
      "de-DE": "/de-DE/dex/blaubandbaerbling/"
    },
    "/dex/stone-moroko/": {
      "en-US": "/dex/stone-moroko/",
      "de-DE": "/de-DE/dex/blaubandbaerbling/"
    },
    "/dex/blaue-ozeanschnecke/": {
      "en-US": "/dex/blue-angel/",
      "de-DE": "/de-DE/dex/blaue-ozeanschnecke/"
    },
    "/dex/blue-angel/": {
      "en-US": "/dex/blue-angel/",
      "de-DE": "/de-DE/dex/blaue-ozeanschnecke/"
    },
    "/dex/blaue-sprotte/": {
      "en-US": "/dex/silver-stripe-round-herring/",
      "de-DE": "/de-DE/dex/blaue-sprotte/"
    },
    "/dex/silver-stripe-round-herring/": {
      "en-US": "/dex/silver-stripe-round-herring/",
      "de-DE": "/de-DE/dex/blaue-sprotte/"
    },
    "/dex/blauer-hummer/": {
      "en-US": "/dex/blue-lobster/",
      "de-DE": "/de-DE/dex/blauer-hummer/"
    },
    "/dex/blue-lobster/": {
      "en-US": "/dex/blue-lobster/",
      "de-DE": "/de-DE/dex/blauer-hummer/"
    },
    "/dex/blauer-netzstern/": {
      "en-US": "/dex/blue-bat-star/",
      "de-DE": "/de-DE/dex/blauer-netzstern/"
    },
    "/dex/blue-bat-star/": {
      "en-US": "/dex/blue-bat-star/",
      "de-DE": "/de-DE/dex/blauer-netzstern/"
    },
    "/dex/blauer-riffbarsch/": {
      "en-US": "/dex/neon-damselfish/",
      "de-DE": "/de-DE/dex/blauer-riffbarsch/"
    },
    "/dex/neon-damselfish/": {
      "en-US": "/dex/neon-damselfish/",
      "de-DE": "/de-DE/dex/blauer-riffbarsch/"
    },
    "/dex/blauer-sonnenbarsch/": {
      "en-US": "/dex/bluegill/",
      "de-DE": "/de-DE/dex/blauer-sonnenbarsch/"
    },
    "/dex/bluegill/": {
      "en-US": "/dex/bluegill/",
      "de-DE": "/de-DE/dex/blauer-sonnenbarsch/"
    },
    "/dex/blaufisch/": {
      "en-US": "/dex/bluefish/",
      "de-DE": "/de-DE/dex/blaufisch/"
    },
    "/dex/bluefish/": {
      "en-US": "/dex/bluefish/",
      "de-DE": "/de-DE/dex/blaufisch/"
    },
    "/dex/blauflossen-thunfisch/": {
      "en-US": "/dex/bluefin-tuna/",
      "de-DE": "/de-DE/dex/blauflossen-thunfisch/"
    },
    "/dex/bluefin-tuna/": {
      "en-US": "/dex/bluefin-tuna/",
      "de-DE": "/de-DE/dex/blauflossen-thunfisch/"
    },
    "/dex/blaugeringelter-krake/": {
      "en-US": "/dex/blue-ringed-octopus/",
      "de-DE": "/de-DE/dex/blaugeringelter-krake/"
    },
    "/dex/blue-ringed-octopus/": {
      "en-US": "/dex/blue-ringed-octopus/",
      "de-DE": "/de-DE/dex/blaugeringelter-krake/"
    },
    "/dex/blauhai/": {
      "en-US": "/dex/blue-shark/",
      "de-DE": "/de-DE/dex/blauhai/"
    },
    "/dex/blue-shark/": {
      "en-US": "/dex/blue-shark/",
      "de-DE": "/de-DE/dex/blauhai/"
    },
    "/dex/blobfisch/": {
      "en-US": "/dex/blobfish/",
      "de-DE": "/de-DE/dex/blobfisch/"
    },
    "/dex/blobfish/": {
      "en-US": "/dex/blobfish/",
      "de-DE": "/de-DE/dex/blobfisch/"
    },
    "/dex/blumeneisfisch/": {
      "en-US": "/dex/flower-icefish/",
      "de-DE": "/de-DE/dex/blumeneisfisch/"
    },
    "/dex/flower-icefish/": {
      "en-US": "/dex/flower-icefish/",
      "de-DE": "/de-DE/dex/blumeneisfisch/"
    },
    "/dex/boto-delfin/": {
      "en-US": "/dex/pink-dolphin/",
      "de-DE": "/de-DE/dex/boto-delfin/"
    },
    "/dex/pink-dolphin/": {
      "en-US": "/dex/pink-dolphin/",
      "de-DE": "/de-DE/dex/boto-delfin/"
    },
    "/dex/brachsenmakrele/": {
      "en-US": "/dex/pomfret/",
      "de-DE": "/de-DE/dex/brachsenmakrele/"
    },
    "/dex/pomfret/": {
      "en-US": "/dex/pomfret/",
      "de-DE": "/de-DE/dex/brachsenmakrele/"
    },
    "/dex/brandungsbarsch/": {
      "en-US": "/dex/surfperch/",
      "de-DE": "/de-DE/dex/brandungsbarsch/"
    },
    "/dex/surfperch/": {
      "en-US": "/dex/surfperch/",
      "de-DE": "/de-DE/dex/brandungsbarsch/"
    },
    "/dex/brisen-muschelseegras-50809/": {
      "en-US": "/dex/breezy-conch-seaweed-50809/",
      "de-DE": "/de-DE/dex/brisen-muschelseegras-50809/"
    },
    "/dex/breezy-conch-seaweed-50809/": {
      "en-US": "/dex/breezy-conch-seaweed-50809/",
      "de-DE": "/de-DE/dex/brisen-muschelseegras-50809/"
    },
    "/dex/bronzener-schluessel-44166/": {
      "en-US": "/dex/bronze-key-44166/",
      "de-DE": "/de-DE/dex/bronzener-schluessel-44166/"
    },
    "/dex/bronze-key-44166/": {
      "en-US": "/dex/bronze-key-44166/",
      "de-DE": "/de-DE/dex/bronzener-schluessel-44166/"
    },
    "/dex/buckelwal/": {
      "en-US": "/dex/humpback-whale/",
      "de-DE": "/de-DE/dex/buckelwal/"
    },
    "/dex/humpback-whale/": {
      "en-US": "/dex/humpback-whale/",
      "de-DE": "/de-DE/dex/buckelwal/"
    },
    "/dex/bueffelkopf-papageifisch/": {
      "en-US": "/dex/humphead-parrotfish/",
      "de-DE": "/de-DE/dex/bueffelkopf-papageifisch/"
    },
    "/dex/humphead-parrotfish/": {
      "en-US": "/dex/humphead-parrotfish/",
      "de-DE": "/de-DE/dex/bueffelkopf-papageifisch/"
    },
    "/dex/buerschling/": {
      "en-US": "/dex/perch/",
      "de-DE": "/de-DE/dex/buerschling/"
    },
    "/dex/perch/": {
      "en-US": "/dex/perch/",
      "de-DE": "/de-DE/dex/buerschling/"
    },
    "/dex/butterfisch/": {
      "en-US": "/dex/gunnel/",
      "de-DE": "/de-DE/dex/butterfisch/"
    },
    "/dex/gunnel/": {
      "en-US": "/dex/gunnel/",
      "de-DE": "/de-DE/dex/butterfisch/"
    },
    "/dex/cano-kroetenfisch/": {
      "en-US": "/dex/cano-toadfish/",
      "de-DE": "/de-DE/dex/cano-kroetenfisch/"
    },
    "/dex/cano-toadfish/": {
      "en-US": "/dex/cano-toadfish/",
      "de-DE": "/de-DE/dex/cano-kroetenfisch/"
    },
    "/dex/chamaeleongrundel/": {
      "en-US": "/dex/chameleon-goby/",
      "de-DE": "/de-DE/dex/chamaeleongrundel/"
    },
    "/dex/chameleon-goby/": {
      "en-US": "/dex/chameleon-goby/",
      "de-DE": "/de-DE/dex/chamaeleongrundel/"
    },
    "/dex/cobitis-choi/": {
      "en-US": "/dex/miho-spine-loach/",
      "de-DE": "/de-DE/dex/cobitis-choi/"
    },
    "/dex/miho-spine-loach/": {
      "en-US": "/dex/miho-spine-loach/",
      "de-DE": "/de-DE/dex/cobitis-choi/"
    },
    "/dex/deckenkrake/": {
      "en-US": "/dex/blanket-octopus/",
      "de-DE": "/de-DE/dex/deckenkrake/"
    },
    "/dex/blanket-octopus/": {
      "en-US": "/dex/blanket-octopus/",
      "de-DE": "/de-DE/dex/deckenkrake/"
    },
    "/dex/diamant-elritze/": {
      "en-US": "/dex/diamond-minnow/",
      "de-DE": "/de-DE/dex/diamant-elritze/"
    },
    "/dex/diamond-minnow/": {
      "en-US": "/dex/diamond-minnow/",
      "de-DE": "/de-DE/dex/diamant-elritze/"
    },
    "/dex/dianafisch/": {
      "en-US": "/dex/luvar/",
      "de-DE": "/de-DE/dex/dianafisch/"
    },
    "/dex/luvar/": {
      "en-US": "/dex/luvar/",
      "de-DE": "/de-DE/dex/dianafisch/"
    },
    "/dex/doktorfisch/": {
      "en-US": "/dex/red-garra/",
      "de-DE": "/de-DE/dex/doktorfisch/"
    },
    "/dex/red-garra/": {
      "en-US": "/dex/red-garra/",
      "de-DE": "/de-DE/dex/doktorfisch/"
    },
    "/dex/dorngrundel/": {
      "en-US": "/dex/spotted-spined-loach/",
      "de-DE": "/de-DE/dex/dorngrundel/"
    },
    "/dex/spotted-spined-loach/": {
      "en-US": "/dex/spotted-spined-loach/",
      "de-DE": "/de-DE/dex/dorngrundel/"
    },
    "/dex/dourado/": {
      "en-US": "/dex/dorado/",
      "de-DE": "/de-DE/dex/dourado/"
    },
    "/dex/dorado/": {
      "en-US": "/dex/dorado/",
      "de-DE": "/de-DE/dex/dourado/"
    },
    "/dex/dreibeinfisch/": {
      "en-US": "/dex/tripod-fish/",
      "de-DE": "/de-DE/dex/dreibeinfisch/"
    },
    "/dex/tripod-fish/": {
      "en-US": "/dex/tripod-fish/",
      "de-DE": "/de-DE/dex/dreibeinfisch/"
    },
    "/dex/dunkelband-stachelkopf/": {
      "en-US": "/dex/dark-banded-rockfish/",
      "de-DE": "/de-DE/dex/dunkelband-stachelkopf/"
    },
    "/dex/dark-banded-rockfish/": {
      "en-US": "/dex/dark-banded-rockfish/",
      "de-DE": "/de-DE/dex/dunkelband-stachelkopf/"
    },
    "/dex/dunkelflossen-granatbarsch/": {
      "en-US": "/dex/blackfin-sea-perch/",
      "de-DE": "/de-DE/dex/dunkelflossen-granatbarsch/"
    },
    "/dex/blackfin-sea-perch/": {
      "en-US": "/dex/blackfin-sea-perch/",
      "de-DE": "/de-DE/dex/dunkelflossen-granatbarsch/"
    },
    "/dex/dunkler-doebel/": {
      "en-US": "/dex/dark-chub/",
      "de-DE": "/de-DE/dex/dunkler-doebel/"
    },
    "/dex/dark-chub/": {
      "en-US": "/dex/dark-chub/",
      "de-DE": "/de-DE/dex/dunkler-doebel/"
    },
    "/dex/dunkler-plattkopf/": {
      "en-US": "/dex/dusky-flathead/",
      "de-DE": "/de-DE/dex/dunkler-plattkopf/"
    },
    "/dex/dusky-flathead/": {
      "en-US": "/dex/dusky-flathead/",
      "de-DE": "/de-DE/dex/dunkler-plattkopf/"
    },
    "/dex/echter-bonito/": {
      "en-US": "/dex/skipjack/",
      "de-DE": "/de-DE/dex/echter-bonito/"
    },
    "/dex/skipjack/": {
      "en-US": "/dex/skipjack/",
      "de-DE": "/de-DE/dex/echter-bonito/"
    },
    "/dex/edania-knochenhecht/": {
      "en-US": "/dex/edania-gar/",
      "de-DE": "/de-DE/dex/edania-knochenhecht/"
    },
    "/dex/edania-gar/": {
      "en-US": "/dex/edania-gar/",
      "de-DE": "/de-DE/dex/edania-knochenhecht/"
    },
    "/dex/eier-9064/": {
      "en-US": "/dex/egg-9064/",
      "de-DE": "/de-DE/dex/eier-9064/"
    },
    "/dex/egg-9064/": {
      "en-US": "/dex/egg-9064/",
      "de-DE": "/de-DE/dex/eier-9064/"
    },
    "/dex/eisen-falterfisch/": {
      "en-US": "/dex/wrought-iron-butterflyfish/",
      "de-DE": "/de-DE/dex/eisen-falterfisch/"
    },
    "/dex/wrought-iron-butterflyfish/": {
      "en-US": "/dex/wrought-iron-butterflyfish/",
      "de-DE": "/de-DE/dex/eisen-falterfisch/"
    },
    "/dex/elritze/": {
      "en-US": "/dex/minnow/",
      "de-DE": "/de-DE/dex/elritze/"
    },
    "/dex/minnow/": {
      "en-US": "/dex/minnow/",
      "de-DE": "/de-DE/dex/elritze/"
    },
    "/dex/fadenflosser/": {
      "en-US": "/dex/fourfinger-threadfin/",
      "de-DE": "/de-DE/dex/fadenflosser/"
    },
    "/dex/fourfinger-threadfin/": {
      "en-US": "/dex/fourfinger-threadfin/",
      "de-DE": "/de-DE/dex/fadenflosser/"
    },
    "/dex/falterfisch/": {
      "en-US": "/dex/butterflyfish/",
      "de-DE": "/de-DE/dex/falterfisch/"
    },
    "/dex/butterflyfish/": {
      "en-US": "/dex/butterflyfish/",
      "de-DE": "/de-DE/dex/falterfisch/"
    },
    "/dex/fangschreckenkrebs/": {
      "en-US": "/dex/mantis-shrimp/",
      "de-DE": "/de-DE/dex/fangschreckenkrebs/"
    },
    "/dex/mantis-shrimp/": {
      "en-US": "/dex/mantis-shrimp/",
      "de-DE": "/de-DE/dex/fangschreckenkrebs/"
    },
    "/dex/fangzahnfisch/": {
      "en-US": "/dex/ghost-fish/",
      "de-DE": "/de-DE/dex/fangzahnfisch/"
    },
    "/dex/ghost-fish/": {
      "en-US": "/dex/ghost-fish/",
      "de-DE": "/de-DE/dex/fangzahnfisch/"
    },
    "/dex/feilenfisch/": {
      "en-US": "/dex/filefish/",
      "de-DE": "/de-DE/dex/feilenfisch/"
    },
    "/dex/filefish/": {
      "en-US": "/dex/filefish/",
      "de-DE": "/de-DE/dex/feilenfisch/"
    },
    "/dex/fetter-quastenflosser-768923/": {
      "en-US": "/dex/plump-coelacanth-768923/",
      "de-DE": "/de-DE/dex/fetter-quastenflosser-768923/"
    },
    "/dex/plump-coelacanth-768923/": {
      "en-US": "/dex/plump-coelacanth-768923/",
      "de-DE": "/de-DE/dex/fetter-quastenflosser-768923/"
    },
    "/dex/feuerfisch/": {
      "en-US": "/dex/lionfish/",
      "de-DE": "/de-DE/dex/feuerfisch/"
    },
    "/dex/lionfish/": {
      "en-US": "/dex/lionfish/",
      "de-DE": "/de-DE/dex/feuerfisch/"
    },
    "/dex/flaggenschwanz/": {
      "en-US": "/dex/kuhlia-marginata/",
      "de-DE": "/de-DE/dex/flaggenschwanz/"
    },
    "/dex/kuhlia-marginata/": {
      "en-US": "/dex/kuhlia-marginata/",
      "de-DE": "/de-DE/dex/flaggenschwanz/"
    },
    "/dex/flammen-fahnenbarsch/": {
      "en-US": "/dex/redfin-anthias/",
      "de-DE": "/de-DE/dex/flammen-fahnenbarsch/"
    },
    "/dex/redfin-anthias/": {
      "en-US": "/dex/redfin-anthias/",
      "de-DE": "/de-DE/dex/flammen-fahnenbarsch/"
    },
    "/dex/flapjack-oktopus/": {
      "en-US": "/dex/flapjack-octopus/",
      "de-DE": "/de-DE/dex/flapjack-oktopus/"
    },
    "/dex/flapjack-octopus/": {
      "en-US": "/dex/flapjack-octopus/",
      "de-DE": "/de-DE/dex/flapjack-oktopus/"
    },
    "/dex/flaschenpost-43801/": {
      "en-US": "/dex/bottle-with-a-note-43801/",
      "de-DE": "/de-DE/dex/flaschenpost-43801/"
    },
    "/dex/bottle-with-a-note-43801/": {
      "en-US": "/dex/bottle-with-a-note-43801/",
      "de-DE": "/de-DE/dex/flaschenpost-43801/"
    },
    "/dex/flaschenpost-43802/": {
      "en-US": "/dex/bottle-with-a-note-43802/",
      "de-DE": "/de-DE/dex/flaschenpost-43802/"
    },
    "/dex/bottle-with-a-note-43802/": {
      "en-US": "/dex/bottle-with-a-note-43802/",
      "de-DE": "/de-DE/dex/flaschenpost-43802/"
    },
    "/dex/fliegender-fisch/": {
      "en-US": "/dex/flying-fish/",
      "de-DE": "/de-DE/dex/fliegender-fisch/"
    },
    "/dex/flying-fish/": {
      "en-US": "/dex/flying-fish/",
      "de-DE": "/de-DE/dex/fliegender-fisch/"
    },
    "/dex/flitzgruendling/": {
      "en-US": "/dex/rapid-goby/",
      "de-DE": "/de-DE/dex/flitzgruendling/"
    },
    "/dex/rapid-goby/": {
      "en-US": "/dex/rapid-goby/",
      "de-DE": "/de-DE/dex/flitzgruendling/"
    },
    "/dex/floesselhecht/": {
      "en-US": "/dex/cuvier/",
      "de-DE": "/de-DE/dex/floesselhecht/"
    },
    "/dex/cuvier/": {
      "en-US": "/dex/cuvier/",
      "de-DE": "/de-DE/dex/floesselhecht/"
    },
    "/dex/flunder/": {
      "en-US": "/dex/flounder/",
      "de-DE": "/de-DE/dex/flunder/"
    },
    "/dex/flounder/": {
      "en-US": "/dex/flounder/",
      "de-DE": "/de-DE/dex/flunder/"
    },
    "/dex/flussaal/": {
      "en-US": "/dex/freshwater-eel/",
      "de-DE": "/de-DE/dex/flussaal/"
    },
    "/dex/freshwater-eel/": {
      "en-US": "/dex/freshwater-eel/",
      "de-DE": "/de-DE/dex/flussaal/"
    },
    "/dex/forelle/": {
      "en-US": "/dex/trout/",
      "de-DE": "/de-DE/dex/forelle/"
    },
    "/dex/trout/": {
      "en-US": "/dex/trout/",
      "de-DE": "/de-DE/dex/forelle/"
    },
    "/dex/fuchshai/": {
      "en-US": "/dex/thresher-shark/",
      "de-DE": "/de-DE/dex/fuchshai/"
    },
    "/dex/thresher-shark/": {
      "en-US": "/dex/thresher-shark/",
      "de-DE": "/de-DE/dex/fuchshai/"
    },
    "/dex/gefleckter-barbus/": {
      "en-US": "/dex/spotted-barbel/",
      "de-DE": "/de-DE/dex/gefleckter-barbus/"
    },
    "/dex/spotted-barbel/": {
      "en-US": "/dex/spotted-barbel/",
      "de-DE": "/de-DE/dex/gefleckter-barbus/"
    },
    "/dex/gefleckter-wolfsbarsch/": {
      "en-US": "/dex/spotted-sea-bass/",
      "de-DE": "/de-DE/dex/gefleckter-wolfsbarsch/"
    },
    "/dex/spotted-sea-bass/": {
      "en-US": "/dex/spotted-sea-bass/",
      "de-DE": "/de-DE/dex/gefleckter-wolfsbarsch/"
    },
    "/dex/geigenrochen/": {
      "en-US": "/dex/skate/",
      "de-DE": "/de-DE/dex/geigenrochen/"
    },
    "/dex/skate/": {
      "en-US": "/dex/skate/",
      "de-DE": "/de-DE/dex/geigenrochen/"
    },
    "/dex/gekochte-vogeleier-9402/": {
      "en-US": "/dex/boiled-bird-eggs-9402/",
      "de-DE": "/de-DE/dex/gekochte-vogeleier-9402/"
    },
    "/dex/boiled-bird-eggs-9402/": {
      "en-US": "/dex/boiled-bird-eggs-9402/",
      "de-DE": "/de-DE/dex/gekochte-vogeleier-9402/"
    },
    "/dex/gelber-schlankwels/": {
      "en-US": "/dex/south-torrent-catfish/",
      "de-DE": "/de-DE/dex/gelber-schlankwels/"
    },
    "/dex/south-torrent-catfish/": {
      "en-US": "/dex/south-torrent-catfish/",
      "de-DE": "/de-DE/dex/gelber-schlankwels/"
    },
    "/dex/gelber-schwertfisch/": {
      "en-US": "/dex/yellow-swordfish/",
      "de-DE": "/de-DE/dex/gelber-schwertfisch/"
    },
    "/dex/yellow-swordfish/": {
      "en-US": "/dex/yellow-swordfish/",
      "de-DE": "/de-DE/dex/gelber-schwertfisch/"
    },
    "/dex/gelber-trommler-8456/": {
      "en-US": "/dex/yellow-corvina-8456/",
      "de-DE": "/de-DE/dex/gelber-trommler-8456/"
    },
    "/dex/yellow-corvina-8456/": {
      "en-US": "/dex/yellow-corvina-8456/",
      "de-DE": "/de-DE/dex/gelber-trommler-8456/"
    },
    "/dex/gelber-trommler/": {
      "en-US": "/dex/yellow-corvina/",
      "de-DE": "/de-DE/dex/gelber-trommler/"
    },
    "/dex/yellow-corvina/": {
      "en-US": "/dex/yellow-corvina/",
      "de-DE": "/de-DE/dex/gelber-trommler/"
    },
    "/dex/gelbflossen-thun/": {
      "en-US": "/dex/yellowfin-tuna/",
      "de-DE": "/de-DE/dex/gelbflossen-thun/"
    },
    "/dex/yellowfin-tuna/": {
      "en-US": "/dex/yellowfin-tuna/",
      "de-DE": "/de-DE/dex/gelbflossen-thun/"
    },
    "/dex/gelbflossengroppe/": {
      "en-US": "/dex/yellowfin-sculpin/",
      "de-DE": "/de-DE/dex/gelbflossengroppe/"
    },
    "/dex/yellowfin-sculpin/": {
      "en-US": "/dex/yellowfin-sculpin/",
      "de-DE": "/de-DE/dex/gelbflossengroppe/"
    },
    "/dex/gelbkopfwels/": {
      "en-US": "/dex/yellow-head-catfish/",
      "de-DE": "/de-DE/dex/gelbkopfwels/"
    },
    "/dex/yellow-head-catfish/": {
      "en-US": "/dex/yellow-head-catfish/",
      "de-DE": "/de-DE/dex/gelbkopfwels/"
    },
    "/dex/gespensterfisch/": {
      "en-US": "/dex/barreleye/",
      "de-DE": "/de-DE/dex/gespensterfisch/"
    },
    "/dex/barreleye/": {
      "en-US": "/dex/barreleye/",
      "de-DE": "/de-DE/dex/gespensterfisch/"
    },
    "/dex/gespensterwal/": {
      "en-US": "/dex/ghost-whale/",
      "de-DE": "/de-DE/dex/gespensterwal/"
    },
    "/dex/ghost-whale/": {
      "en-US": "/dex/ghost-whale/",
      "de-DE": "/de-DE/dex/gespensterwal/"
    },
    "/dex/gestreifte-orfe/": {
      "en-US": "/dex/striped-shiner/",
      "de-DE": "/de-DE/dex/gestreifte-orfe/"
    },
    "/dex/striped-shiner/": {
      "en-US": "/dex/striped-shiner/",
      "de-DE": "/de-DE/dex/gestreifte-orfe/"
    },
    "/dex/gestreifter-stachelwels/": {
      "en-US": "/dex/stumpy-bullhead/",
      "de-DE": "/de-DE/dex/gestreifter-stachelwels/"
    },
    "/dex/stumpy-bullhead/": {
      "en-US": "/dex/stumpy-bullhead/",
      "de-DE": "/de-DE/dex/gestreifter-stachelwels/"
    },
    "/dex/gestreifter-wels/": {
      "en-US": "/dex/striped-catfish/",
      "de-DE": "/de-DE/dex/gestreifter-wels/"
    },
    "/dex/striped-catfish/": {
      "en-US": "/dex/striped-catfish/",
      "de-DE": "/de-DE/dex/gestreifter-wels/"
    },
    "/dex/gestreifter-zackenbarsch/": {
      "en-US": "/dex/striped-goliath-grouper/",
      "de-DE": "/de-DE/dex/gestreifter-zackenbarsch/"
    },
    "/dex/striped-goliath-grouper/": {
      "en-US": "/dex/striped-goliath-grouper/",
      "de-DE": "/de-DE/dex/gestreifter-zackenbarsch/"
    },
    "/dex/getrocknete-abalone/": {
      "en-US": "/dex/dried-abalone/",
      "de-DE": "/de-DE/dex/getrocknete-abalone/"
    },
    "/dex/dried-abalone/": {
      "en-US": "/dex/dried-abalone/",
      "de-DE": "/de-DE/dex/getrocknete-abalone/"
    },
    "/dex/getrocknete-aesche/": {
      "en-US": "/dex/dried-grayling/",
      "de-DE": "/de-DE/dex/getrocknete-aesche/"
    },
    "/dex/dried-grayling/": {
      "en-US": "/dex/dried-grayling/",
      "de-DE": "/de-DE/dex/getrocknete-aesche/"
    },
    "/dex/getrocknete-amur-nasengrundel/": {
      "en-US": "/dex/dried-amur-goby/",
      "de-DE": "/de-DE/dex/getrocknete-amur-nasengrundel/"
    },
    "/dex/dried-amur-goby/": {
      "en-US": "/dex/dried-amur-goby/",
      "de-DE": "/de-DE/dex/getrocknete-amur-nasengrundel/"
    },
    "/dex/getrocknete-atka-makrele/": {
      "en-US": "/dex/dried-atka-mackerel/",
      "de-DE": "/de-DE/dex/getrocknete-atka-makrele/"
    },
    "/dex/dried-atka-mackerel/": {
      "en-US": "/dex/dried-atka-mackerel/",
      "de-DE": "/de-DE/dex/getrocknete-atka-makrele/"
    },
    "/dex/getrocknete-barbe/": {
      "en-US": "/dex/dried-barbel-steed/",
      "de-DE": "/de-DE/dex/getrocknete-barbe/"
    },
    "/dex/dried-barbel-steed/": {
      "en-US": "/dex/dried-barbel-steed/",
      "de-DE": "/de-DE/dex/getrocknete-barbe/"
    },
    "/dex/getrocknete-blaue-sprotte/": {
      "en-US": "/dex/dried-silver-stripe-round-herring/",
      "de-DE": "/de-DE/dex/getrocknete-blaue-sprotte/"
    },
    "/dex/dried-silver-stripe-round-herring/": {
      "en-US": "/dex/dried-silver-stripe-round-herring/",
      "de-DE": "/de-DE/dex/getrocknete-blaue-sprotte/"
    },
    "/dex/getrocknete-blauer-riffbarsch/": {
      "en-US": "/dex/dried-neon-damselfish/",
      "de-DE": "/de-DE/dex/getrocknete-blauer-riffbarsch/"
    },
    "/dex/dried-neon-damselfish/": {
      "en-US": "/dex/dried-neon-damselfish/",
      "de-DE": "/de-DE/dex/getrocknete-blauer-riffbarsch/"
    },
    "/dex/getrocknete-brachsenmakrele/": {
      "en-US": "/dex/dried-pomfret/",
      "de-DE": "/de-DE/dex/getrocknete-brachsenmakrele/"
    },
    "/dex/dried-pomfret/": {
      "en-US": "/dex/dried-pomfret/",
      "de-DE": "/de-DE/dex/getrocknete-brachsenmakrele/"
    },
    "/dex/getrocknete-chamaeleongrundel/": {
      "en-US": "/dex/dried-chameleon-goby/",
      "de-DE": "/de-DE/dex/getrocknete-chamaeleongrundel/"
    },
    "/dex/dried-chameleon-goby/": {
      "en-US": "/dex/dried-chameleon-goby/",
      "de-DE": "/de-DE/dex/getrocknete-chamaeleongrundel/"
    },
    "/dex/getrocknete-diamant-elritze/": {
      "en-US": "/dex/dried-diamond-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-diamant-elritze/"
    },
    "/dex/dried-diamond-minnow/": {
      "en-US": "/dex/dried-diamond-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-diamant-elritze/"
    },
    "/dex/getrocknete-elritze/": {
      "en-US": "/dex/dried-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-elritze/"
    },
    "/dex/dried-minnow/": {
      "en-US": "/dex/dried-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-elritze/"
    },
    "/dex/getrocknete-flunder/": {
      "en-US": "/dex/dried-flounder/",
      "de-DE": "/de-DE/dex/getrocknete-flunder/"
    },
    "/dex/dried-flounder/": {
      "en-US": "/dex/dried-flounder/",
      "de-DE": "/de-DE/dex/getrocknete-flunder/"
    },
    "/dex/getrocknete-forelle/": {
      "en-US": "/dex/dried-trout/",
      "de-DE": "/de-DE/dex/getrocknete-forelle/"
    },
    "/dex/dried-trout/": {
      "en-US": "/dex/dried-trout/",
      "de-DE": "/de-DE/dex/getrocknete-forelle/"
    },
    "/dex/getrocknete-gelbflossengroppe/": {
      "en-US": "/dex/dried-yellowfin-sculpin/",
      "de-DE": "/de-DE/dex/getrocknete-gelbflossengroppe/"
    },
    "/dex/dried-yellowfin-sculpin/": {
      "en-US": "/dex/dried-yellowfin-sculpin/",
      "de-DE": "/de-DE/dex/getrocknete-gelbflossengroppe/"
    },
    "/dex/getrocknete-gestreifte-orfe/": {
      "en-US": "/dex/dried-striped-shiner/",
      "de-DE": "/de-DE/dex/getrocknete-gestreifte-orfe/"
    },
    "/dex/dried-striped-shiner/": {
      "en-US": "/dex/dried-striped-shiner/",
      "de-DE": "/de-DE/dex/getrocknete-gestreifte-orfe/"
    },
    "/dex/getrocknete-goby-elritze/": {
      "en-US": "/dex/dried-goby-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-goby-elritze/"
    },
    "/dex/dried-goby-minnow/": {
      "en-US": "/dex/dried-goby-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-goby-elritze/"
    },
    "/dex/getrocknete-goldmakrele/": {
      "en-US": "/dex/dried-dolphinfish/",
      "de-DE": "/de-DE/dex/getrocknete-goldmakrele/"
    },
    "/dex/dried-dolphinfish/": {
      "en-US": "/dex/dried-dolphinfish/",
      "de-DE": "/de-DE/dex/getrocknete-goldmakrele/"
    },
    "/dex/getrocknete-grenadiersardelle/": {
      "en-US": "/dex/dried-tapertail-anchovy/",
      "de-DE": "/de-DE/dex/getrocknete-grenadiersardelle/"
    },
    "/dex/dried-tapertail-anchovy/": {
      "en-US": "/dex/dried-tapertail-anchovy/",
      "de-DE": "/de-DE/dex/getrocknete-grenadiersardelle/"
    },
    "/dex/getrocknete-jackmakrele/": {
      "en-US": "/dex/dried-saurel/",
      "de-DE": "/de-DE/dex/getrocknete-jackmakrele/"
    },
    "/dex/dried-saurel/": {
      "en-US": "/dex/dried-saurel/",
      "de-DE": "/de-DE/dex/getrocknete-jackmakrele/"
    },
    "/dex/getrocknete-karausche/": {
      "en-US": "/dex/dried-crucian-carp/",
      "de-DE": "/de-DE/dex/getrocknete-karausche/"
    },
    "/dex/dried-crucian-carp/": {
      "en-US": "/dex/dried-crucian-carp/",
      "de-DE": "/de-DE/dex/getrocknete-karausche/"
    },
    "/dex/getrocknete-koenigsmakrele/": {
      "en-US": "/dex/dried-cero/",
      "de-DE": "/de-DE/dex/getrocknete-koenigsmakrele/"
    },
    "/dex/dried-cero/": {
      "en-US": "/dex/dried-cero/",
      "de-DE": "/de-DE/dex/getrocknete-koenigsmakrele/"
    },
    "/dex/getrocknete-koenigsschmerle/": {
      "en-US": "/dex/dried-king-spine-loach/",
      "de-DE": "/de-DE/dex/getrocknete-koenigsschmerle/"
    },
    "/dex/dried-king-spine-loach/": {
      "en-US": "/dex/dried-king-spine-loach/",
      "de-DE": "/de-DE/dex/getrocknete-koenigsschmerle/"
    },
    "/dex/getrocknete-languste/": {
      "en-US": "/dex/dried-crawfish/",
      "de-DE": "/de-DE/dex/getrocknete-languste/"
    },
    "/dex/dried-crawfish/": {
      "en-US": "/dex/dried-crawfish/",
      "de-DE": "/de-DE/dex/getrocknete-languste/"
    },
    "/dex/getrocknete-makrele/": {
      "en-US": "/dex/dried-mackerel/",
      "de-DE": "/de-DE/dex/getrocknete-makrele/"
    },
    "/dex/dried-mackerel/": {
      "en-US": "/dex/dried-mackerel/",
      "de-DE": "/de-DE/dex/getrocknete-makrele/"
    },
    "/dex/getrocknete-meeraesche/": {
      "en-US": "/dex/dried-mullet/",
      "de-DE": "/de-DE/dex/getrocknete-meeraesche/"
    },
    "/dex/dried-mullet/": {
      "en-US": "/dex/dried-mullet/",
      "de-DE": "/de-DE/dex/getrocknete-meeraesche/"
    },
    "/dex/getrocknete-meerbrasse/": {
      "en-US": "/dex/dried-porgy/",
      "de-DE": "/de-DE/dex/getrocknete-meerbrasse/"
    },
    "/dex/dried-porgy/": {
      "en-US": "/dex/dried-porgy/",
      "de-DE": "/de-DE/dex/getrocknete-meerbrasse/"
    },
    "/dex/getrocknete-miesmuschel/": {
      "en-US": "/dex/dried-shellfish/",
      "de-DE": "/de-DE/dex/getrocknete-miesmuschel/"
    },
    "/dex/dried-shellfish/": {
      "en-US": "/dex/dried-shellfish/",
      "de-DE": "/de-DE/dex/getrocknete-miesmuschel/"
    },
    "/dex/getrocknete-muraene/": {
      "en-US": "/dex/dried-moray/",
      "de-DE": "/de-DE/dex/getrocknete-muraene/"
    },
    "/dex/dried-moray/": {
      "en-US": "/dex/dried-moray/",
      "de-DE": "/de-DE/dex/getrocknete-muraene/"
    },
    "/dex/getrocknete-nasenmuraene/": {
      "en-US": "/dex/dried-ribbon-eel/",
      "de-DE": "/de-DE/dex/getrocknete-nasenmuraene/"
    },
    "/dex/dried-ribbon-eel/": {
      "en-US": "/dex/dried-ribbon-eel/",
      "de-DE": "/de-DE/dex/getrocknete-nasenmuraene/"
    },
    "/dex/getrocknete-orientalische-schmerle/": {
      "en-US": "/dex/dried-morning-loach/",
      "de-DE": "/de-DE/dex/getrocknete-orientalische-schmerle/"
    },
    "/dex/dried-morning-loach/": {
      "en-US": "/dex/dried-morning-loach/",
      "de-DE": "/de-DE/dex/getrocknete-orientalische-schmerle/"
    },
    "/dex/getrocknete-pazifische-kliesche/": {
      "en-US": "/dex/dried-yellowfin-sole/",
      "de-DE": "/de-DE/dex/getrocknete-pazifische-kliesche/"
    },
    "/dex/dried-yellowfin-sole/": {
      "en-US": "/dex/dried-yellowfin-sole/",
      "de-DE": "/de-DE/dex/getrocknete-pazifische-kliesche/"
    },
    "/dex/getrocknete-qualle/": {
      "en-US": "/dex/dried-jellyfish/",
      "de-DE": "/de-DE/dex/getrocknete-qualle/"
    },
    "/dex/dried-jellyfish/": {
      "en-US": "/dex/dried-jellyfish/",
      "de-DE": "/de-DE/dex/getrocknete-qualle/"
    },
    "/dex/getrocknete-quappe/": {
      "en-US": "/dex/dried-burbot/",
      "de-DE": "/de-DE/dex/getrocknete-quappe/"
    },
    "/dex/dried-burbot/": {
      "en-US": "/dex/dried-burbot/",
      "de-DE": "/de-DE/dex/getrocknete-quappe/"
    },
    "/dex/getrocknete-rote-meerbrasse/": {
      "en-US": "/dex/dried-red-seabream/",
      "de-DE": "/de-DE/dex/getrocknete-rote-meerbrasse/"
    },
    "/dex/dried-red-seabream/": {
      "en-US": "/dex/dried-red-seabream/",
      "de-DE": "/de-DE/dex/getrocknete-rote-meerbrasse/"
    },
    "/dex/getrocknete-rote-schneekrabbe/": {
      "en-US": "/dex/dried-red-snow-crab/",
      "de-DE": "/de-DE/dex/getrocknete-rote-schneekrabbe/"
    },
    "/dex/dried-red-snow-crab/": {
      "en-US": "/dex/dried-red-snow-crab/",
      "de-DE": "/de-DE/dex/getrocknete-rote-schneekrabbe/"
    },
    "/dex/getrocknete-rundschwanzmakropode/": {
      "en-US": "/dex/dried-roundtail-paradisefish/",
      "de-DE": "/de-DE/dex/getrocknete-rundschwanzmakropode/"
    },
    "/dex/dried-roundtail-paradisefish/": {
      "en-US": "/dex/dried-roundtail-paradisefish/",
      "de-DE": "/de-DE/dex/getrocknete-rundschwanzmakropode/"
    },
    "/dex/getrocknete-sardine/": {
      "en-US": "/dex/dried-sardine/",
      "de-DE": "/de-DE/dex/getrocknete-sardine/"
    },
    "/dex/dried-sardine/": {
      "en-US": "/dex/dried-sardine/",
      "de-DE": "/de-DE/dex/getrocknete-sardine/"
    },
    "/dex/getrocknete-schwarm-elritze/": {
      "en-US": "/dex/dried-common-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-schwarm-elritze/"
    },
    "/dex/dried-common-minnow/": {
      "en-US": "/dex/dried-common-minnow/",
      "de-DE": "/de-DE/dex/getrocknete-schwarm-elritze/"
    },
    "/dex/getrocknete-seezunge/": {
      "en-US": "/dex/dried-tongue-sole/",
      "de-DE": "/de-DE/dex/getrocknete-seezunge/"
    },
    "/dex/dried-tongue-sole/": {
      "en-US": "/dex/dried-tongue-sole/",
      "de-DE": "/de-DE/dex/getrocknete-seezunge/"
    },
    "/dex/getrocknete-spitzschaedel-elritze/": {
      "en-US": "/dex/dried-bleeker/",
      "de-DE": "/de-DE/dex/getrocknete-spitzschaedel-elritze/"
    },
    "/dex/dried-bleeker/": {
      "en-US": "/dex/dried-bleeker/",
      "de-DE": "/de-DE/dex/getrocknete-spitzschaedel-elritze/"
    },
    "/dex/getrocknete-stachelmakrele/": {
      "en-US": "/dex/dried-amberjack/",
      "de-DE": "/de-DE/dex/getrocknete-stachelmakrele/"
    },
    "/dex/dried-amberjack/": {
      "en-US": "/dex/dried-amberjack/",
      "de-DE": "/de-DE/dex/getrocknete-stachelmakrele/"
    },
    "/dex/getrocknete-stinte/": {
      "en-US": "/dex/dried-smelt/",
      "de-DE": "/de-DE/dex/getrocknete-stinte/"
    },
    "/dex/dried-smelt/": {
      "en-US": "/dex/dried-smelt/",
      "de-DE": "/de-DE/dex/getrocknete-stinte/"
    },
    "/dex/getrocknete-wasserschildkroete/": {
      "en-US": "/dex/dried-terrapin/",
      "de-DE": "/de-DE/dex/getrocknete-wasserschildkroete/"
    },
    "/dex/dried-terrapin/": {
      "en-US": "/dex/dried-terrapin/",
      "de-DE": "/de-DE/dex/getrocknete-wasserschildkroete/"
    },
    "/dex/getrocknete-zahn-schlaefergrundel/": {
      "en-US": "/dex/dried-dark-sleeper/",
      "de-DE": "/de-DE/dex/getrocknete-zahn-schlaefergrundel/"
    },
    "/dex/dried-dark-sleeper/": {
      "en-US": "/dex/dried-dark-sleeper/",
      "de-DE": "/de-DE/dex/getrocknete-zahn-schlaefergrundel/"
    },
    "/dex/getrockneter-alburnuskarpfen/": {
      "en-US": "/dex/dried-common-bleak/",
      "de-DE": "/de-DE/dex/getrockneter-alburnuskarpfen/"
    },
    "/dex/dried-common-bleak/": {
      "en-US": "/dex/dried-common-bleak/",
      "de-DE": "/de-DE/dex/getrockneter-alburnuskarpfen/"
    },
    "/dex/getrockneter-amur-elritze/": {
      "en-US": "/dex/dried-amur-minnow/",
      "de-DE": "/de-DE/dex/getrockneter-amur-elritze/"
    },
    "/dex/dried-amur-minnow/": {
      "en-US": "/dex/dried-amur-minnow/",
      "de-DE": "/de-DE/dex/getrockneter-amur-elritze/"
    },
    "/dex/getrockneter-amur-weissfisch/": {
      "en-US": "/dex/dried-amur-ide/",
      "de-DE": "/de-DE/dex/getrockneter-amur-weissfisch/"
    },
    "/dex/dried-amur-ide/": {
      "en-US": "/dex/dried-amur-ide/",
      "de-DE": "/de-DE/dex/getrockneter-amur-weissfisch/"
    },
    "/dex/getrockneter-anemonenfisch/": {
      "en-US": "/dex/dried-clownfish/",
      "de-DE": "/de-DE/dex/getrockneter-anemonenfisch/"
    },
    "/dex/dried-clownfish/": {
      "en-US": "/dex/dried-clownfish/",
      "de-DE": "/de-DE/dex/getrockneter-anemonenfisch/"
    },
    "/dex/getrockneter-anglerfisch/": {
      "en-US": "/dex/dried-angler/",
      "de-DE": "/de-DE/dex/getrockneter-anglerfisch/"
    },
    "/dex/dried-angler/": {
      "en-US": "/dex/dried-angler/",
      "de-DE": "/de-DE/dex/getrockneter-anglerfisch/"
    },
    "/dex/getrockneter-arowana/": {
      "en-US": "/dex/dried-arowana/",
      "de-DE": "/de-DE/dex/getrockneter-arowana/"
    },
    "/dex/dried-arowana/": {
      "en-US": "/dex/dried-arowana/",
      "de-DE": "/de-DE/dex/getrockneter-arowana/"
    },
    "/dex/getrockneter-ayu/": {
      "en-US": "/dex/dried-sweetfish/",
      "de-DE": "/de-DE/dex/getrockneter-ayu/"
    },
    "/dex/dried-sweetfish/": {
      "en-US": "/dex/dried-sweetfish/",
      "de-DE": "/de-DE/dex/getrockneter-ayu/"
    },
    "/dex/getrockneter-barsch/": {
      "en-US": "/dex/dried-bass/",
      "de-DE": "/de-DE/dex/getrockneter-barsch/"
    },
    "/dex/dried-bass/": {
      "en-US": "/dex/dried-bass/",
      "de-DE": "/de-DE/dex/getrockneter-barsch/"
    },
    "/dex/getrockneter-bartelgruendling/": {
      "en-US": "/dex/dried-short-barbel-gudgeon/",
      "de-DE": "/de-DE/dex/getrockneter-bartelgruendling/"
    },
    "/dex/dried-short-barbel-gudgeon/": {
      "en-US": "/dex/dried-short-barbel-gudgeon/",
      "de-DE": "/de-DE/dex/getrockneter-bartelgruendling/"
    },
    "/dex/getrockneter-beilbauch-weissfisch/": {
      "en-US": "/dex/dried-sharpbelly/",
      "de-DE": "/de-DE/dex/getrockneter-beilbauch-weissfisch/"
    },
    "/dex/dried-sharpbelly/": {
      "en-US": "/dex/dried-sharpbelly/",
      "de-DE": "/de-DE/dex/getrockneter-beilbauch-weissfisch/"
    },
    "/dex/getrockneter-beilbauchfisch/": {
      "en-US": "/dex/dried-hatchetfish/",
      "de-DE": "/de-DE/dex/getrockneter-beilbauchfisch/"
    },
    "/dex/dried-hatchetfish/": {
      "en-US": "/dex/dried-hatchetfish/",
      "de-DE": "/de-DE/dex/getrockneter-beilbauchfisch/"
    },
    "/dex/getrockneter-bitterling/": {
      "en-US": "/dex/dried-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-bitterling/"
    },
    "/dex/dried-bitterling/": {
      "en-US": "/dex/dried-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-bitterling/"
    },
    "/dex/getrockneter-blattfisch/": {
      "en-US": "/dex/dried-leaffish/",
      "de-DE": "/de-DE/dex/getrockneter-blattfisch/"
    },
    "/dex/dried-leaffish/": {
      "en-US": "/dex/dried-leaffish/",
      "de-DE": "/de-DE/dex/getrockneter-blattfisch/"
    },
    "/dex/getrockneter-blaubandbaerbling/": {
      "en-US": "/dex/dried-stone-moroko/",
      "de-DE": "/de-DE/dex/getrockneter-blaubandbaerbling/"
    },
    "/dex/dried-stone-moroko/": {
      "en-US": "/dex/dried-stone-moroko/",
      "de-DE": "/de-DE/dex/getrockneter-blaubandbaerbling/"
    },
    "/dex/getrockneter-blauer-sonnenbarsch/": {
      "en-US": "/dex/dried-bluegill/",
      "de-DE": "/de-DE/dex/getrockneter-blauer-sonnenbarsch/"
    },
    "/dex/dried-bluegill/": {
      "en-US": "/dex/dried-bluegill/",
      "de-DE": "/de-DE/dex/getrockneter-blauer-sonnenbarsch/"
    },
    "/dex/getrockneter-blaufisch/": {
      "en-US": "/dex/dried-bluefish/",
      "de-DE": "/de-DE/dex/getrockneter-blaufisch/"
    },
    "/dex/dried-bluefish/": {
      "en-US": "/dex/dried-bluefish/",
      "de-DE": "/de-DE/dex/getrockneter-blaufisch/"
    },
    "/dex/getrockneter-blumeneisfisch/": {
      "en-US": "/dex/dried-flower-icefish/",
      "de-DE": "/de-DE/dex/getrockneter-blumeneisfisch/"
    },
    "/dex/dried-flower-icefish/": {
      "en-US": "/dex/dried-flower-icefish/",
      "de-DE": "/de-DE/dex/getrockneter-blumeneisfisch/"
    },
    "/dex/getrockneter-brandungsbarsch/": {
      "en-US": "/dex/dried-surfperch/",
      "de-DE": "/de-DE/dex/getrockneter-brandungsbarsch/"
    },
    "/dex/dried-surfperch/": {
      "en-US": "/dex/dried-surfperch/",
      "de-DE": "/de-DE/dex/getrockneter-brandungsbarsch/"
    },
    "/dex/getrockneter-buerschling/": {
      "en-US": "/dex/dried-perch/",
      "de-DE": "/de-DE/dex/getrockneter-buerschling/"
    },
    "/dex/dried-perch/": {
      "en-US": "/dex/dried-perch/",
      "de-DE": "/de-DE/dex/getrockneter-buerschling/"
    },
    "/dex/getrockneter-butterfisch/": {
      "en-US": "/dex/dried-gunnel/",
      "de-DE": "/de-DE/dex/getrockneter-butterfisch/"
    },
    "/dex/dried-gunnel/": {
      "en-US": "/dex/dried-gunnel/",
      "de-DE": "/de-DE/dex/getrockneter-butterfisch/"
    },
    "/dex/getrockneter-cobitis-choi/": {
      "en-US": "/dex/dried-miho-spine-loach/",
      "de-DE": "/de-DE/dex/getrockneter-cobitis-choi/"
    },
    "/dex/dried-miho-spine-loach/": {
      "en-US": "/dex/dried-miho-spine-loach/",
      "de-DE": "/de-DE/dex/getrockneter-cobitis-choi/"
    },
    "/dex/getrockneter-diamant-seestern/": {
      "en-US": "/dex/dried-diamond-starfish/",
      "de-DE": "/de-DE/dex/getrockneter-diamant-seestern/"
    },
    "/dex/dried-diamond-starfish/": {
      "en-US": "/dex/dried-diamond-starfish/",
      "de-DE": "/de-DE/dex/getrockneter-diamant-seestern/"
    },
    "/dex/getrockneter-dunkelband-stachelkopf/": {
      "en-US": "/dex/dried-dark-banded-rockfish/",
      "de-DE": "/de-DE/dex/getrockneter-dunkelband-stachelkopf/"
    },
    "/dex/dried-dark-banded-rockfish/": {
      "en-US": "/dex/dried-dark-banded-rockfish/",
      "de-DE": "/de-DE/dex/getrockneter-dunkelband-stachelkopf/"
    },
    "/dex/getrockneter-dunkler-doebel/": {
      "en-US": "/dex/dried-dark-chub/",
      "de-DE": "/de-DE/dex/getrockneter-dunkler-doebel/"
    },
    "/dex/dried-dark-chub/": {
      "en-US": "/dex/dried-dark-chub/",
      "de-DE": "/de-DE/dex/getrockneter-dunkler-doebel/"
    },
    "/dex/getrockneter-dunkler-plattkopf/": {
      "en-US": "/dex/dried-dusky-flathead/",
      "de-DE": "/de-DE/dex/getrockneter-dunkler-plattkopf/"
    },
    "/dex/dried-dusky-flathead/": {
      "en-US": "/dex/dried-dusky-flathead/",
      "de-DE": "/de-DE/dex/getrockneter-dunkler-plattkopf/"
    },
    "/dex/getrockneter-echter-bonito/": {
      "en-US": "/dex/dried-skipjack/",
      "de-DE": "/de-DE/dex/getrockneter-echter-bonito/"
    },
    "/dex/dried-skipjack/": {
      "en-US": "/dex/dried-skipjack/",
      "de-DE": "/de-DE/dex/getrockneter-echter-bonito/"
    },
    "/dex/getrockneter-eisen-falterfisch/": {
      "en-US": "/dex/dried-wrought-iron-butterflyfish/",
      "de-DE": "/de-DE/dex/getrockneter-eisen-falterfisch/"
    },
    "/dex/dried-wrought-iron-butterflyfish/": {
      "en-US": "/dex/dried-wrought-iron-butterflyfish/",
      "de-DE": "/de-DE/dex/getrockneter-eisen-falterfisch/"
    },
    "/dex/getrockneter-fadenflosser/": {
      "en-US": "/dex/dried-fourfinger-threadfin/",
      "de-DE": "/de-DE/dex/getrockneter-fadenflosser/"
    },
    "/dex/dried-fourfinger-threadfin/": {
      "en-US": "/dex/dried-fourfinger-threadfin/",
      "de-DE": "/de-DE/dex/getrockneter-fadenflosser/"
    },
    "/dex/getrockneter-falterfisch/": {
      "en-US": "/dex/dried-butterflyfish/",
      "de-DE": "/de-DE/dex/getrockneter-falterfisch/"
    },
    "/dex/dried-butterflyfish/": {
      "en-US": "/dex/dried-butterflyfish/",
      "de-DE": "/de-DE/dex/getrockneter-falterfisch/"
    },
    "/dex/getrockneter-feilenfisch/": {
      "en-US": "/dex/dried-filefish/",
      "de-DE": "/de-DE/dex/getrockneter-feilenfisch/"
    },
    "/dex/dried-filefish/": {
      "en-US": "/dex/dried-filefish/",
      "de-DE": "/de-DE/dex/getrockneter-feilenfisch/"
    },
    "/dex/getrockneter-feuerfisch/": {
      "en-US": "/dex/dried-lionfish/",
      "de-DE": "/de-DE/dex/getrockneter-feuerfisch/"
    },
    "/dex/dried-lionfish/": {
      "en-US": "/dex/dried-lionfish/",
      "de-DE": "/de-DE/dex/getrockneter-feuerfisch/"
    },
    "/dex/getrockneter-flaggenschwanz/": {
      "en-US": "/dex/dried-kuhlia-marginata/",
      "de-DE": "/de-DE/dex/getrockneter-flaggenschwanz/"
    },
    "/dex/dried-kuhlia-marginata/": {
      "en-US": "/dex/dried-kuhlia-marginata/",
      "de-DE": "/de-DE/dex/getrockneter-flaggenschwanz/"
    },
    "/dex/getrockneter-flammen-fahnenbarsch/": {
      "en-US": "/dex/dried-redfin-anthias/",
      "de-DE": "/de-DE/dex/getrockneter-flammen-fahnenbarsch/"
    },
    "/dex/dried-redfin-anthias/": {
      "en-US": "/dex/dried-redfin-anthias/",
      "de-DE": "/de-DE/dex/getrockneter-flammen-fahnenbarsch/"
    },
    "/dex/getrockneter-fliegender-fisch/": {
      "en-US": "/dex/dried-flying-fish/",
      "de-DE": "/de-DE/dex/getrockneter-fliegender-fisch/"
    },
    "/dex/dried-flying-fish/": {
      "en-US": "/dex/dried-flying-fish/",
      "de-DE": "/de-DE/dex/getrockneter-fliegender-fisch/"
    },
    "/dex/getrockneter-flitzgruendling/": {
      "en-US": "/dex/dried-rapid-goby/",
      "de-DE": "/de-DE/dex/getrockneter-flitzgruendling/"
    },
    "/dex/dried-rapid-goby/": {
      "en-US": "/dex/dried-rapid-goby/",
      "de-DE": "/de-DE/dex/getrockneter-flitzgruendling/"
    },
    "/dex/getrockneter-floesselhecht/": {
      "en-US": "/dex/dried-cuvier/",
      "de-DE": "/de-DE/dex/getrockneter-floesselhecht/"
    },
    "/dex/dried-cuvier/": {
      "en-US": "/dex/dried-cuvier/",
      "de-DE": "/de-DE/dex/getrockneter-floesselhecht/"
    },
    "/dex/getrockneter-flussaal/": {
      "en-US": "/dex/dried-freshwater-eel/",
      "de-DE": "/de-DE/dex/getrockneter-flussaal/"
    },
    "/dex/dried-freshwater-eel/": {
      "en-US": "/dex/dried-freshwater-eel/",
      "de-DE": "/de-DE/dex/getrockneter-flussaal/"
    },
    "/dex/getrockneter-fuchshai/": {
      "en-US": "/dex/dried-thresher-shark/",
      "de-DE": "/de-DE/dex/getrockneter-fuchshai/"
    },
    "/dex/dried-thresher-shark/": {
      "en-US": "/dex/dried-thresher-shark/",
      "de-DE": "/de-DE/dex/getrockneter-fuchshai/"
    },
    "/dex/getrockneter-gefleckter-barbus/": {
      "en-US": "/dex/dried-spotted-barbel/",
      "de-DE": "/de-DE/dex/getrockneter-gefleckter-barbus/"
    },
    "/dex/dried-spotted-barbel/": {
      "en-US": "/dex/dried-spotted-barbel/",
      "de-DE": "/de-DE/dex/getrockneter-gefleckter-barbus/"
    },
    "/dex/getrockneter-gelber-schlankwels/": {
      "en-US": "/dex/dried-south-torrent-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gelber-schlankwels/"
    },
    "/dex/dried-south-torrent-catfish/": {
      "en-US": "/dex/dried-south-torrent-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gelber-schlankwels/"
    },
    "/dex/getrockneter-gelbkopfwels/": {
      "en-US": "/dex/dried-yellow-head-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gelbkopfwels/"
    },
    "/dex/dried-yellow-head-catfish/": {
      "en-US": "/dex/dried-yellow-head-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gelbkopfwels/"
    },
    "/dex/getrockneter-gestreifter-stachelwels/": {
      "en-US": "/dex/dried-stumpy-bullhead/",
      "de-DE": "/de-DE/dex/getrockneter-gestreifter-stachelwels/"
    },
    "/dex/dried-stumpy-bullhead/": {
      "en-US": "/dex/dried-stumpy-bullhead/",
      "de-DE": "/de-DE/dex/getrockneter-gestreifter-stachelwels/"
    },
    "/dex/getrockneter-gestreifter-wels/": {
      "en-US": "/dex/dried-striped-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gestreifter-wels/"
    },
    "/dex/dried-striped-catfish/": {
      "en-US": "/dex/dried-striped-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-gestreifter-wels/"
    },
    "/dex/getrockneter-goldstreifenbarsch/": {
      "en-US": "/dex/dried-goldenstriped-soapfish/",
      "de-DE": "/de-DE/dex/getrockneter-goldstreifenbarsch/"
    },
    "/dex/dried-goldenstriped-soapfish/": {
      "en-US": "/dex/dried-goldenstriped-soapfish/",
      "de-DE": "/de-DE/dex/getrockneter-goldstreifenbarsch/"
    },
    "/dex/getrockneter-gotteslachs/": {
      "en-US": "/dex/dried-sunfish/",
      "de-DE": "/de-DE/dex/getrockneter-gotteslachs/"
    },
    "/dex/dried-sunfish/": {
      "en-US": "/dex/dried-sunfish/",
      "de-DE": "/de-DE/dex/getrockneter-gotteslachs/"
    },
    "/dex/getrockneter-graskarpfen/": {
      "en-US": "/dex/dried-grass-carp/",
      "de-DE": "/de-DE/dex/getrockneter-graskarpfen/"
    },
    "/dex/dried-grass-carp/": {
      "en-US": "/dex/dried-grass-carp/",
      "de-DE": "/de-DE/dex/getrockneter-graskarpfen/"
    },
    "/dex/getrockneter-grosskopf-gruendling/": {
      "en-US": "/dex/dried-large-headed-goby/",
      "de-DE": "/de-DE/dex/getrockneter-grosskopf-gruendling/"
    },
    "/dex/dried-large-headed-goby/": {
      "en-US": "/dex/dried-large-headed-goby/",
      "de-DE": "/de-DE/dex/getrockneter-grosskopf-gruendling/"
    },
    "/dex/getrockneter-grossmaul-barrakuda/": {
      "en-US": "/dex/dried-obtuse-barracuda/",
      "de-DE": "/de-DE/dex/getrockneter-grossmaul-barrakuda/"
    },
    "/dex/dried-obtuse-barracuda/": {
      "en-US": "/dex/dried-obtuse-barracuda/",
      "de-DE": "/de-DE/dex/getrockneter-grossmaul-barrakuda/"
    },
    "/dex/getrockneter-gruener-stoer/": {
      "en-US": "/dex/dried-green-sturgeon/",
      "de-DE": "/de-DE/dex/getrockneter-gruener-stoer/"
    },
    "/dex/dried-green-sturgeon/": {
      "en-US": "/dex/dried-green-sturgeon/",
      "de-DE": "/de-DE/dex/getrockneter-gruener-stoer/"
    },
    "/dex/getrockneter-gruenling/": {
      "en-US": "/dex/dried-greenling/",
      "de-DE": "/de-DE/dex/getrockneter-gruenling/"
    },
    "/dex/dried-greenling/": {
      "en-US": "/dex/dried-greenling/",
      "de-DE": "/de-DE/dex/getrockneter-gruenling/"
    },
    "/dex/getrockneter-grunzer/": {
      "en-US": "/dex/dried-grunt/",
      "de-DE": "/de-DE/dex/getrockneter-grunzer/"
    },
    "/dex/dried-grunt/": {
      "en-US": "/dex/dried-grunt/",
      "de-DE": "/de-DE/dex/getrockneter-grunzer/"
    },
    "/dex/getrockneter-haesling/": {
      "en-US": "/dex/dried-dace/",
      "de-DE": "/de-DE/dex/getrockneter-haesling/"
    },
    "/dex/dried-dace/": {
      "en-US": "/dex/dried-dace/",
      "de-DE": "/de-DE/dex/getrockneter-haesling/"
    },
    "/dex/getrockneter-hecht/": {
      "en-US": "/dex/dried-pike/",
      "de-DE": "/de-DE/dex/getrockneter-hecht/"
    },
    "/dex/dried-pike/": {
      "en-US": "/dex/dried-pike/",
      "de-DE": "/de-DE/dex/getrockneter-hecht/"
    },
    "/dex/getrockneter-hechtsalmler/": {
      "en-US": "/dex/dried-pike-characin/",
      "de-DE": "/de-DE/dex/getrockneter-hechtsalmler/"
    },
    "/dex/dried-pike-characin/": {
      "en-US": "/dex/dried-pike-characin/",
      "de-DE": "/de-DE/dex/getrockneter-hechtsalmler/"
    },
    "/dex/getrockneter-hellgruendling/": {
      "en-US": "/dex/dried-morning-river-goby/",
      "de-DE": "/de-DE/dex/getrockneter-hellgruendling/"
    },
    "/dex/dried-morning-river-goby/": {
      "en-US": "/dex/dried-morning-river-goby/",
      "de-DE": "/de-DE/dex/getrockneter-hellgruendling/"
    },
    "/dex/getrockneter-hering/": {
      "en-US": "/dex/dried-herring/",
      "de-DE": "/de-DE/dex/getrockneter-hering/"
    },
    "/dex/dried-herring/": {
      "en-US": "/dex/dried-herring/",
      "de-DE": "/de-DE/dex/getrockneter-hering/"
    },
    "/dex/getrockneter-himmelsgucker/": {
      "en-US": "/dex/dried-giant-talking-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-himmelsgucker/"
    },
    "/dex/dried-giant-talking-catfish/": {
      "en-US": "/dex/dried-giant-talking-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-himmelsgucker/"
    },
    "/dex/getrockneter-hornfisch/": {
      "en-US": "/dex/dried-horn-fish/",
      "de-DE": "/de-DE/dex/getrockneter-hornfisch/"
    },
    "/dex/dried-horn-fish/": {
      "en-US": "/dex/dried-horn-fish/",
      "de-DE": "/de-DE/dex/getrockneter-hornfisch/"
    },
    "/dex/getrockneter-hummer/": {
      "en-US": "/dex/dried-lobster/",
      "de-DE": "/de-DE/dex/getrockneter-hummer/"
    },
    "/dex/dried-lobster/": {
      "en-US": "/dex/dried-lobster/",
      "de-DE": "/de-DE/dex/getrockneter-hummer/"
    },
    "/dex/getrockneter-igelfisch/": {
      "en-US": "/dex/dried-porcupine-fish/",
      "de-DE": "/de-DE/dex/getrockneter-igelfisch/"
    },
    "/dex/dried-porcupine-fish/": {
      "en-US": "/dex/dried-porcupine-fish/",
      "de-DE": "/de-DE/dex/getrockneter-igelfisch/"
    },
    "/dex/getrockneter-kahlhecht/": {
      "en-US": "/dex/dried-bowfin/",
      "de-DE": "/de-DE/dex/getrockneter-kahlhecht/"
    },
    "/dex/dried-bowfin/": {
      "en-US": "/dex/dried-bowfin/",
      "de-DE": "/de-DE/dex/getrockneter-kahlhecht/"
    },
    "/dex/getrockneter-kalmar/": {
      "en-US": "/dex/dried-squid/",
      "de-DE": "/de-DE/dex/getrockneter-kalmar/"
    },
    "/dex/dried-squid/": {
      "en-US": "/dex/dried-squid/",
      "de-DE": "/de-DE/dex/getrockneter-kalmar/"
    },
    "/dex/getrockneter-kaninchenfisch/": {
      "en-US": "/dex/dried-siganid/",
      "de-DE": "/de-DE/dex/getrockneter-kaninchenfisch/"
    },
    "/dex/dried-siganid/": {
      "en-US": "/dex/dried-siganid/",
      "de-DE": "/de-DE/dex/getrockneter-kaninchenfisch/"
    },
    "/dex/getrockneter-karpfen/": {
      "en-US": "/dex/dried-carp/",
      "de-DE": "/de-DE/dex/getrockneter-karpfen/"
    },
    "/dex/dried-carp/": {
      "en-US": "/dex/dried-carp/",
      "de-DE": "/de-DE/dex/getrockneter-karpfen/"
    },
    "/dex/getrockneter-kerbenkieferfisch/": {
      "en-US": "/dex/dried-notch-jaw/",
      "de-DE": "/de-DE/dex/getrockneter-kerbenkieferfisch/"
    },
    "/dex/dried-notch-jaw/": {
      "en-US": "/dex/dried-notch-jaw/",
      "de-DE": "/de-DE/dex/getrockneter-kerbenkieferfisch/"
    },
    "/dex/getrockneter-kiemenschlitzaal/": {
      "en-US": "/dex/dried-swamp-eel/",
      "de-DE": "/de-DE/dex/getrockneter-kiemenschlitzaal/"
    },
    "/dex/dried-swamp-eel/": {
      "en-US": "/dex/dried-swamp-eel/",
      "de-DE": "/de-DE/dex/getrockneter-kiemenschlitzaal/"
    },
    "/dex/getrockneter-kirschblueten-eisfisch/": {
      "en-US": "/dex/dried-cherry-icefish/",
      "de-DE": "/de-DE/dex/getrockneter-kirschblueten-eisfisch/"
    },
    "/dex/dried-cherry-icefish/": {
      "en-US": "/dex/dried-cherry-icefish/",
      "de-DE": "/de-DE/dex/getrockneter-kirschblueten-eisfisch/"
    },
    "/dex/getrockneter-knabberfisch/": {
      "en-US": "/dex/dried-nibbler/",
      "de-DE": "/de-DE/dex/getrockneter-knabberfisch/"
    },
    "/dex/dried-nibbler/": {
      "en-US": "/dex/dried-nibbler/",
      "de-DE": "/de-DE/dex/getrockneter-knabberfisch/"
    },
    "/dex/getrockneter-knurrhahn/": {
      "en-US": "/dex/dried-gurnard/",
      "de-DE": "/de-DE/dex/getrockneter-knurrhahn/"
    },
    "/dex/dried-gurnard/": {
      "en-US": "/dex/dried-gurnard/",
      "de-DE": "/de-DE/dex/getrockneter-knurrhahn/"
    },
    "/dex/getrockneter-kofferfisch/": {
      "en-US": "/dex/dried-boxfish/",
      "de-DE": "/de-DE/dex/getrockneter-kofferfisch/"
    },
    "/dex/dried-boxfish/": {
      "en-US": "/dex/dried-boxfish/",
      "de-DE": "/de-DE/dex/getrockneter-kofferfisch/"
    },
    "/dex/getrockneter-krebs/": {
      "en-US": "/dex/dried-crab/",
      "de-DE": "/de-DE/dex/getrockneter-krebs/"
    },
    "/dex/dried-crab/": {
      "en-US": "/dex/dried-crab/",
      "de-DE": "/de-DE/dex/getrockneter-krebs/"
    },
    "/dex/getrockneter-kugelfisch/": {
      "en-US": "/dex/dried-swellfish/",
      "de-DE": "/de-DE/dex/getrockneter-kugelfisch/"
    },
    "/dex/dried-swellfish/": {
      "en-US": "/dex/dried-swellfish/",
      "de-DE": "/de-DE/dex/getrockneter-kugelfisch/"
    },
    "/dex/getrockneter-lachs/": {
      "en-US": "/dex/dried-salmon/",
      "de-DE": "/de-DE/dex/getrockneter-lachs/"
    },
    "/dex/dried-salmon/": {
      "en-US": "/dex/dried-salmon/",
      "de-DE": "/de-DE/dex/getrockneter-lachs/"
    },
    "/dex/getrockneter-langschnauzen-knochenhecht/": {
      "en-US": "/dex/dried-longnose-gar/",
      "de-DE": "/de-DE/dex/getrockneter-langschnauzen-knochenhecht/"
    },
    "/dex/dried-longnose-gar/": {
      "en-US": "/dex/dried-longnose-gar/",
      "de-DE": "/de-DE/dex/getrockneter-langschnauzen-knochenhecht/"
    },
    "/dex/getrockneter-langschnauzenwels/": {
      "en-US": "/dex/dried-longsnout-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-langschnauzenwels/"
    },
    "/dex/dried-longsnout-catfish/": {
      "en-US": "/dex/dried-longsnout-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-langschnauzenwels/"
    },
    "/dex/getrockneter-lavaschuppen-sterngucker/": {
      "en-US": "/dex/dried-lavascale-stargazer/",
      "de-DE": "/de-DE/dex/getrockneter-lavaschuppen-sterngucker/"
    },
    "/dex/dried-lavascale-stargazer/": {
      "en-US": "/dex/dried-lavascale-stargazer/",
      "de-DE": "/de-DE/dex/getrockneter-lavaschuppen-sterngucker/"
    },
    "/dex/getrockneter-lederkarpfen/": {
      "en-US": "/dex/dried-leather-carp/",
      "de-DE": "/de-DE/dex/getrockneter-lederkarpfen/"
    },
    "/dex/dried-leather-carp/": {
      "en-US": "/dex/dried-leather-carp/",
      "de-DE": "/de-DE/dex/getrockneter-lederkarpfen/"
    },
    "/dex/getrockneter-lenok/": {
      "en-US": "/dex/dried-lenok/",
      "de-DE": "/de-DE/dex/getrockneter-lenok/"
    },
    "/dex/dried-lenok/": {
      "en-US": "/dex/dried-lenok/",
      "de-DE": "/de-DE/dex/getrockneter-lenok/"
    },
    "/dex/getrockneter-lungenfisch/": {
      "en-US": "/dex/dried-lungfish/",
      "de-DE": "/de-DE/dex/getrockneter-lungenfisch/"
    },
    "/dex/dried-lungfish/": {
      "en-US": "/dex/dried-lungfish/",
      "de-DE": "/de-DE/dex/getrockneter-lungenfisch/"
    },
    "/dex/getrockneter-makrelenhecht/": {
      "en-US": "/dex/dried-mackerel-pike/",
      "de-DE": "/de-DE/dex/getrockneter-makrelenhecht/"
    },
    "/dex/dried-mackerel-pike/": {
      "en-US": "/dex/dried-mackerel-pike/",
      "de-DE": "/de-DE/dex/getrockneter-makrelenhecht/"
    },
    "/dex/getrockneter-mandarinfisch/": {
      "en-US": "/dex/dried-mandarin-fish/",
      "de-DE": "/de-DE/dex/getrockneter-mandarinfisch/"
    },
    "/dex/dried-mandarin-fish/": {
      "en-US": "/dex/dried-mandarin-fish/",
      "de-DE": "/de-DE/dex/getrockneter-mandarinfisch/"
    },
    "/dex/getrockneter-maomao/": {
      "en-US": "/dex/dried-maomao/",
      "de-DE": "/de-DE/dex/getrockneter-maomao/"
    },
    "/dex/dried-maomao/": {
      "en-US": "/dex/dried-maomao/",
      "de-DE": "/de-DE/dex/getrockneter-maomao/"
    },
    "/dex/getrockneter-masu-lachs/": {
      "en-US": "/dex/dried-cherry-salmon/",
      "de-DE": "/de-DE/dex/getrockneter-masu-lachs/"
    },
    "/dex/dried-cherry-salmon/": {
      "en-US": "/dex/dried-cherry-salmon/",
      "de-DE": "/de-DE/dex/getrockneter-masu-lachs/"
    },
    "/dex/getrockneter-meeraal/": {
      "en-US": "/dex/dried-sea-eel/",
      "de-DE": "/de-DE/dex/getrockneter-meeraal/"
    },
    "/dex/dried-sea-eel/": {
      "en-US": "/dex/dried-sea-eel/",
      "de-DE": "/de-DE/dex/getrockneter-meeraal/"
    },
    "/dex/getrockneter-messing-ruderfisch/": {
      "en-US": "/dex/dried-brassy-chub/",
      "de-DE": "/de-DE/dex/getrockneter-messing-ruderfisch/"
    },
    "/dex/dried-brassy-chub/": {
      "en-US": "/dex/dried-brassy-chub/",
      "de-DE": "/de-DE/dex/getrockneter-messing-ruderfisch/"
    },
    "/dex/getrockneter-mitra-tintenfisch/": {
      "en-US": "/dex/dried-mitre-squid/",
      "de-DE": "/de-DE/dex/getrockneter-mitra-tintenfisch/"
    },
    "/dex/dried-mitre-squid/": {
      "en-US": "/dex/dried-mitre-squid/",
      "de-DE": "/de-DE/dex/getrockneter-mitra-tintenfisch/"
    },
    "/dex/getrockneter-moenchsfisch/": {
      "en-US": "/dex/dried-smokey-chromis/",
      "de-DE": "/de-DE/dex/getrockneter-moenchsfisch/"
    },
    "/dex/dried-smokey-chromis/": {
      "en-US": "/dex/dried-smokey-chromis/",
      "de-DE": "/de-DE/dex/getrockneter-moenchsfisch/"
    },
    "/dex/getrockneter-mori/": {
      "en-US": "/dex/dried-mori/",
      "de-DE": "/de-DE/dex/getrockneter-mori/"
    },
    "/dex/dried-mori/": {
      "en-US": "/dex/dried-mori/",
      "de-DE": "/de-DE/dex/getrockneter-mori/"
    },
    "/dex/getrockneter-oeliger-gruendling/": {
      "en-US": "/dex/dried-oily-shiner/",
      "de-DE": "/de-DE/dex/getrockneter-oeliger-gruendling/"
    },
    "/dex/dried-oily-shiner/": {
      "en-US": "/dex/dried-oily-shiner/",
      "de-DE": "/de-DE/dex/getrockneter-oeliger-gruendling/"
    },
    "/dex/getrockneter-oktopus/": {
      "en-US": "/dex/dried-octopus/",
      "de-DE": "/de-DE/dex/getrockneter-oktopus/"
    },
    "/dex/dried-octopus/": {
      "en-US": "/dex/dried-octopus/",
      "de-DE": "/de-DE/dex/getrockneter-oktopus/"
    },
    "/dex/getrockneter-opah/": {
      "en-US": "/dex/dried-opah/",
      "de-DE": "/de-DE/dex/getrockneter-opah/"
    },
    "/dex/dried-opah/": {
      "en-US": "/dex/dried-opah/",
      "de-DE": "/de-DE/dex/getrockneter-opah/"
    },
    "/dex/getrockneter-orientalischer-schlammspringer/": {
      "en-US": "/dex/dried-shuttles-hoppfish/",
      "de-DE": "/de-DE/dex/getrockneter-orientalischer-schlammspringer/"
    },
    "/dex/dried-shuttles-hoppfish/": {
      "en-US": "/dex/dried-shuttles-hoppfish/",
      "de-DE": "/de-DE/dex/getrockneter-orientalischer-schlammspringer/"
    },
    "/dex/getrockneter-pacu/": {
      "en-US": "/dex/dried-pacu/",
      "de-DE": "/de-DE/dex/getrockneter-pacu/"
    },
    "/dex/dried-pacu/": {
      "en-US": "/dex/dried-pacu/",
      "de-DE": "/de-DE/dex/getrockneter-pacu/"
    },
    "/dex/getrockneter-paletten-doktorfisch/": {
      "en-US": "/dex/dried-blue-tang/",
      "de-DE": "/de-DE/dex/getrockneter-paletten-doktorfisch/"
    },
    "/dex/dried-blue-tang/": {
      "en-US": "/dex/dried-blue-tang/",
      "de-DE": "/de-DE/dex/getrockneter-paletten-doktorfisch/"
    },
    "/dex/getrockneter-petersfisch/": {
      "en-US": "/dex/dried-john-dory/",
      "de-DE": "/de-DE/dex/getrockneter-petersfisch/"
    },
    "/dex/dried-john-dory/": {
      "en-US": "/dex/dried-john-dory/",
      "de-DE": "/de-DE/dex/getrockneter-petersfisch/"
    },
    "/dex/getrockneter-pintado/": {
      "en-US": "/dex/dried-pintado/",
      "de-DE": "/de-DE/dex/getrockneter-pintado/"
    },
    "/dex/dried-pintado/": {
      "en-US": "/dex/dried-pintado/",
      "de-DE": "/de-DE/dex/getrockneter-pintado/"
    },
    "/dex/getrockneter-piranha/": {
      "en-US": "/dex/dried-piranha/",
      "de-DE": "/de-DE/dex/getrockneter-piranha/"
    },
    "/dex/dried-piranha/": {
      "en-US": "/dex/dried-piranha/",
      "de-DE": "/de-DE/dex/getrockneter-piranha/"
    },
    "/dex/getrockneter-plattfisch/": {
      "en-US": "/dex/dried-flatfish/",
      "de-DE": "/de-DE/dex/getrockneter-plattfisch/"
    },
    "/dex/dried-flatfish/": {
      "en-US": "/dex/dried-flatfish/",
      "de-DE": "/de-DE/dex/getrockneter-plattfisch/"
    },
    "/dex/getrockneter-punktierter-butterfisch/": {
      "en-US": "/dex/dried-stippled-gunnel/",
      "de-DE": "/de-DE/dex/getrockneter-punktierter-butterfisch/"
    },
    "/dex/dried-stippled-gunnel/": {
      "en-US": "/dex/dried-stippled-gunnel/",
      "de-DE": "/de-DE/dex/getrockneter-punktierter-butterfisch/"
    },
    "/dex/getrockneter-riesenhai/": {
      "en-US": "/dex/dried-basking-shark/",
      "de-DE": "/de-DE/dex/getrockneter-riesenhai/"
    },
    "/dex/dried-basking-shark/": {
      "en-US": "/dex/dried-basking-shark/",
      "de-DE": "/de-DE/dex/getrockneter-riesenhai/"
    },
    "/dex/getrockneter-riffbarsch/": {
      "en-US": "/dex/dried-blacktip-chromis/",
      "de-DE": "/de-DE/dex/getrockneter-riffbarsch/"
    },
    "/dex/dried-blacktip-chromis/": {
      "en-US": "/dex/dried-blacktip-chromis/",
      "de-DE": "/de-DE/dex/getrockneter-riffbarsch/"
    },
    "/dex/getrockneter-rochen/": {
      "en-US": "/dex/dried-ray/",
      "de-DE": "/de-DE/dex/getrockneter-rochen/"
    },
    "/dex/dried-ray/": {
      "en-US": "/dex/dried-ray/",
      "de-DE": "/de-DE/dex/getrockneter-rochen/"
    },
    "/dex/getrockneter-rosiger-bitterling/": {
      "en-US": "/dex/dried-rosy-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-rosiger-bitterling/"
    },
    "/dex/dried-rosy-bitterling/": {
      "en-US": "/dex/dried-rosy-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-rosiger-bitterling/"
    },
    "/dex/getrockneter-rotbarsch/": {
      "en-US": "/dex/dried-rosefish/",
      "de-DE": "/de-DE/dex/getrockneter-rotbarsch/"
    },
    "/dex/dried-rosefish/": {
      "en-US": "/dex/dried-rosefish/",
      "de-DE": "/de-DE/dex/getrockneter-rotbarsch/"
    },
    "/dex/getrockneter-rotbrustlippfisch/": {
      "en-US": "/dex/dried-redbreasted-wrasse/",
      "de-DE": "/de-DE/dex/getrockneter-rotbrustlippfisch/"
    },
    "/dex/dried-redbreasted-wrasse/": {
      "en-US": "/dex/dried-redbreasted-wrasse/",
      "de-DE": "/de-DE/dex/getrockneter-rotbrustlippfisch/"
    },
    "/dex/getrockneter-rundhering/": {
      "en-US": "/dex/dried-round-herring/",
      "de-DE": "/de-DE/dex/getrockneter-rundhering/"
    },
    "/dex/dried-round-herring/": {
      "en-US": "/dex/dried-round-herring/",
      "de-DE": "/de-DE/dex/getrockneter-rundhering/"
    },
    "/dex/getrockneter-saibling/": {
      "en-US": "/dex/dried-charr/",
      "de-DE": "/de-DE/dex/getrockneter-saibling/"
    },
    "/dex/dried-charr/": {
      "en-US": "/dex/dried-charr/",
      "de-DE": "/de-DE/dex/getrockneter-saibling/"
    },
    "/dex/getrockneter-sandaal/": {
      "en-US": "/dex/dried-sandeel/",
      "de-DE": "/de-DE/dex/getrockneter-sandaal/"
    },
    "/dex/dried-sandeel/": {
      "en-US": "/dex/dried-sandeel/",
      "de-DE": "/de-DE/dex/getrockneter-sandaal/"
    },
    "/dex/getrockneter-sandfisch/": {
      "en-US": "/dex/dried-sandfish/",
      "de-DE": "/de-DE/dex/getrockneter-sandfisch/"
    },
    "/dex/dried-sandfish/": {
      "en-US": "/dex/dried-sandfish/",
      "de-DE": "/de-DE/dex/getrockneter-sandfisch/"
    },
    "/dex/getrockneter-saugmaulwels/": {
      "en-US": "/dex/dried-common-pleco/",
      "de-DE": "/de-DE/dex/getrockneter-saugmaulwels/"
    },
    "/dex/dried-common-pleco/": {
      "en-US": "/dex/dried-common-pleco/",
      "de-DE": "/de-DE/dex/getrockneter-saugmaulwels/"
    },
    "/dex/getrockneter-schachbrett-junker/": {
      "en-US": "/dex/dried-checkerboard-wrasse/",
      "de-DE": "/de-DE/dex/getrockneter-schachbrett-junker/"
    },
    "/dex/dried-checkerboard-wrasse/": {
      "en-US": "/dex/dried-checkerboard-wrasse/",
      "de-DE": "/de-DE/dex/getrockneter-schachbrett-junker/"
    },
    "/dex/getrockneter-schlammfisch/": {
      "en-US": "/dex/dried-mudfish/",
      "de-DE": "/de-DE/dex/getrockneter-schlammfisch/"
    },
    "/dex/dried-mudfish/": {
      "en-US": "/dex/dried-mudfish/",
      "de-DE": "/de-DE/dex/getrockneter-schlammfisch/"
    },
    "/dex/getrockneter-schlammspringer/": {
      "en-US": "/dex/dried-mudskipper/",
      "de-DE": "/de-DE/dex/getrockneter-schlammspringer/"
    },
    "/dex/dried-mudskipper/": {
      "en-US": "/dex/dried-mudskipper/",
      "de-DE": "/de-DE/dex/getrockneter-schlammspringer/"
    },
    "/dex/getrockneter-schlangenkopffisch/": {
      "en-US": "/dex/dried-snakehead/",
      "de-DE": "/de-DE/dex/getrockneter-schlangenkopffisch/"
    },
    "/dex/dried-snakehead/": {
      "en-US": "/dex/dried-snakehead/",
      "de-DE": "/de-DE/dex/getrockneter-schlangenkopffisch/"
    },
    "/dex/getrockneter-schuppen-brandungsbarsch/": {
      "en-US": "/dex/dried-ransonnets-surfperch/",
      "de-DE": "/de-DE/dex/getrockneter-schuppen-brandungsbarsch/"
    },
    "/dex/dried-ransonnets-surfperch/": {
      "en-US": "/dex/dried-ransonnets-surfperch/",
      "de-DE": "/de-DE/dex/getrockneter-schuppen-brandungsbarsch/"
    },
    "/dex/getrockneter-schwanzstreifensalmler/": {
      "en-US": "/dex/dried-silver-prochilodus/",
      "de-DE": "/de-DE/dex/getrockneter-schwanzstreifensalmler/"
    },
    "/dex/dried-silver-prochilodus/": {
      "en-US": "/dex/dried-silver-prochilodus/",
      "de-DE": "/de-DE/dex/getrockneter-schwanzstreifensalmler/"
    },
    "/dex/getrockneter-schwarzer-gruendling/": {
      "en-US": "/dex/dried-black-shiner/",
      "de-DE": "/de-DE/dex/getrockneter-schwarzer-gruendling/"
    },
    "/dex/dried-black-shiner/": {
      "en-US": "/dex/dried-black-shiner/",
      "de-DE": "/de-DE/dex/getrockneter-schwarzer-gruendling/"
    },
    "/dex/getrockneter-schwarzflossen-beilfisch/": {
      "en-US": "/dex/dried-blackfin-sweeper/",
      "de-DE": "/de-DE/dex/getrockneter-schwarzflossen-beilfisch/"
    },
    "/dex/dried-blackfin-sweeper/": {
      "en-US": "/dex/dried-blackfin-sweeper/",
      "de-DE": "/de-DE/dex/getrockneter-schwarzflossen-beilfisch/"
    },
    "/dex/getrockneter-schwertfisch/": {
      "en-US": "/dex/dried-swordfish/",
      "de-DE": "/de-DE/dex/getrockneter-schwertfisch/"
    },
    "/dex/dried-swordfish/": {
      "en-US": "/dex/dried-swordfish/",
      "de-DE": "/de-DE/dex/getrockneter-schwertfisch/"
    },
    "/dex/getrockneter-seelachs/": {
      "en-US": "/dex/dried-pollack/",
      "de-DE": "/de-DE/dex/getrockneter-seelachs/"
    },
    "/dex/dried-pollack/": {
      "en-US": "/dex/dried-pollack/",
      "de-DE": "/de-DE/dex/getrockneter-seelachs/"
    },
    "/dex/getrockneter-seestern/": {
      "en-US": "/dex/dried-starfish/",
      "de-DE": "/de-DE/dex/getrockneter-seestern/"
    },
    "/dex/dried-starfish/": {
      "en-US": "/dex/dried-starfish/",
      "de-DE": "/de-DE/dex/getrockneter-seestern/"
    },
    "/dex/getrockneter-silberkarpfen/": {
      "en-US": "/dex/dried-silver-carp/",
      "de-DE": "/de-DE/dex/getrockneter-silberkarpfen/"
    },
    "/dex/dried-silver-carp/": {
      "en-US": "/dex/dried-silver-carp/",
      "de-DE": "/de-DE/dex/getrockneter-silberkarpfen/"
    },
    "/dex/getrockneter-silberpampel/": {
      "en-US": "/dex/dried-dollarfish/",
      "de-DE": "/de-DE/dex/getrockneter-silberpampel/"
    },
    "/dex/dried-dollarfish/": {
      "en-US": "/dex/dried-dollarfish/",
      "de-DE": "/de-DE/dex/getrockneter-silberpampel/"
    },
    "/dex/getrockneter-skorpionfisch/": {
      "en-US": "/dex/dried-scorpion-fish/",
      "de-DE": "/de-DE/dex/getrockneter-skorpionfisch/"
    },
    "/dex/dried-scorpion-fish/": {
      "en-US": "/dex/dried-scorpion-fish/",
      "de-DE": "/de-DE/dex/getrockneter-skorpionfisch/"
    },
    "/dex/getrockneter-soho-bitterling/": {
      "en-US": "/dex/dried-soho-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-soho-bitterling/"
    },
    "/dex/dried-soho-bitterling/": {
      "en-US": "/dex/dried-soho-bitterling/",
      "de-DE": "/de-DE/dex/getrockneter-soho-bitterling/"
    },
    "/dex/getrockneter-sprenzling/": {
      "en-US": "/dex/dried-yalu-grayling/",
      "de-DE": "/de-DE/dex/getrockneter-sprenzling/"
    },
    "/dex/dried-yalu-grayling/": {
      "en-US": "/dex/dried-yalu-grayling/",
      "de-DE": "/de-DE/dex/getrockneter-sprenzling/"
    },
    "/dex/getrockneter-stachelbitterling/": {
      "en-US": "/dex/dried-spined-bittering/",
      "de-DE": "/de-DE/dex/getrockneter-stachelbitterling/"
    },
    "/dex/dried-spined-bittering/": {
      "en-US": "/dex/dried-spined-bittering/",
      "de-DE": "/de-DE/dex/getrockneter-stachelbitterling/"
    },
    "/dex/getrockneter-stachelkopf/": {
      "en-US": "/dex/dried-rockfish/",
      "de-DE": "/de-DE/dex/getrockneter-stachelkopf/"
    },
    "/dex/dried-rockfish/": {
      "en-US": "/dex/dried-rockfish/",
      "de-DE": "/de-DE/dex/getrockneter-stachelkopf/"
    },
    "/dex/getrockneter-steinbarsch/": {
      "en-US": "/dex/dried-rock-hind/",
      "de-DE": "/de-DE/dex/getrockneter-steinbarsch/"
    },
    "/dex/dried-rock-hind/": {
      "en-US": "/dex/dried-rock-hind/",
      "de-DE": "/de-DE/dex/getrockneter-steinbarsch/"
    },
    "/dex/getrockneter-steinbeisser/": {
      "en-US": "/dex/dried-spined-loach/",
      "de-DE": "/de-DE/dex/getrockneter-steinbeisser/"
    },
    "/dex/dried-spined-loach/": {
      "en-US": "/dex/dried-spined-loach/",
      "de-DE": "/de-DE/dex/getrockneter-steinbeisser/"
    },
    "/dex/getrockneter-steinschnapper/": {
      "en-US": "/dex/dried-golden-thread/",
      "de-DE": "/de-DE/dex/getrockneter-steinschnapper/"
    },
    "/dex/dried-golden-thread/": {
      "en-US": "/dex/dried-golden-thread/",
      "de-DE": "/de-DE/dex/getrockneter-steinschnapper/"
    },
    "/dex/getrockneter-stichling/": {
      "en-US": "/dex/dried-stickleback/",
      "de-DE": "/de-DE/dex/getrockneter-stichling/"
    },
    "/dex/dried-stickleback/": {
      "en-US": "/dex/dried-stickleback/",
      "de-DE": "/de-DE/dex/getrockneter-stichling/"
    },
    "/dex/getrockneter-stoer/": {
      "en-US": "/dex/dried-sturgeon/",
      "de-DE": "/de-DE/dex/getrockneter-stoer/"
    },
    "/dex/dried-sturgeon/": {
      "en-US": "/dex/dried-sturgeon/",
      "de-DE": "/de-DE/dex/getrockneter-stoer/"
    },
    "/dex/getrockneter-strumpfbandfisch/": {
      "en-US": "/dex/dried-beltfish/",
      "de-DE": "/de-DE/dex/getrockneter-strumpfbandfisch/"
    },
    "/dex/dried-beltfish/": {
      "en-US": "/dex/dried-beltfish/",
      "de-DE": "/de-DE/dex/getrockneter-strumpfbandfisch/"
    },
    "/dex/getrockneter-swiri/": {
      "en-US": "/dex/dried-swiri/",
      "de-DE": "/de-DE/dex/getrockneter-swiri/"
    },
    "/dex/dried-swiri/": {
      "en-US": "/dex/dried-swiri/",
      "de-DE": "/de-DE/dex/getrockneter-swiri/"
    },
    "/dex/getrockneter-teufelsfisch/": {
      "en-US": "/dex/dried-devil-stinger/",
      "de-DE": "/de-DE/dex/getrockneter-teufelsfisch/"
    },
    "/dex/dried-devil-stinger/": {
      "en-US": "/dex/dried-devil-stinger/",
      "de-DE": "/de-DE/dex/getrockneter-teufelsfisch/"
    },
    "/dex/getrockneter-thunfisch/": {
      "en-US": "/dex/dried-tuna/",
      "de-DE": "/de-DE/dex/getrockneter-thunfisch/"
    },
    "/dex/dried-tuna/": {
      "en-US": "/dex/dried-tuna/",
      "de-DE": "/de-DE/dex/getrockneter-thunfisch/"
    },
    "/dex/getrockneter-tigerfisch/": {
      "en-US": "/dex/dried-goliath-tigerfish/",
      "de-DE": "/de-DE/dex/getrockneter-tigerfisch/"
    },
    "/dex/dried-goliath-tigerfish/": {
      "en-US": "/dex/dried-goliath-tigerfish/",
      "de-DE": "/de-DE/dex/getrockneter-tigerfisch/"
    },
    "/dex/getrockneter-tigerhai/": {
      "en-US": "/dex/dried-tiger-shark/",
      "de-DE": "/de-DE/dex/getrockneter-tigerhai/"
    },
    "/dex/dried-tiger-shark/": {
      "en-US": "/dex/dried-tiger-shark/",
      "de-DE": "/de-DE/dex/getrockneter-tigerhai/"
    },
    "/dex/getrockneter-tintenfisch/": {
      "en-US": "/dex/dried-cuttlefish/",
      "de-DE": "/de-DE/dex/getrockneter-tintenfisch/"
    },
    "/dex/dried-cuttlefish/": {
      "en-US": "/dex/dried-cuttlefish/",
      "de-DE": "/de-DE/dex/getrockneter-tintenfisch/"
    },
    "/dex/getrockneter-torpedobarsch/": {
      "en-US": "/dex/dried-tilefish/",
      "de-DE": "/de-DE/dex/getrockneter-torpedobarsch/"
    },
    "/dex/dried-tilefish/": {
      "en-US": "/dex/dried-tilefish/",
      "de-DE": "/de-DE/dex/getrockneter-torpedobarsch/"
    },
    "/dex/getrockneter-umberfisch/": {
      "en-US": "/dex/dried-croaker/",
      "de-DE": "/de-DE/dex/getrockneter-umberfisch/"
    },
    "/dex/dried-croaker/": {
      "en-US": "/dex/dried-croaker/",
      "de-DE": "/de-DE/dex/getrockneter-umberfisch/"
    },
    "/dex/getrockneter-wels/": {
      "en-US": "/dex/dried-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-wels/"
    },
    "/dex/dried-catfish/": {
      "en-US": "/dex/dried-catfish/",
      "de-DE": "/de-DE/dex/getrockneter-wels/"
    },
    "/dex/getrockneter-wittling/": {
      "en-US": "/dex/dried-whiting/",
      "de-DE": "/de-DE/dex/getrockneter-wittling/"
    },
    "/dex/dried-whiting/": {
      "en-US": "/dex/dried-whiting/",
      "de-DE": "/de-DE/dex/getrockneter-wittling/"
    },
    "/dex/getrockneter-wolfsbarsch/": {
      "en-US": "/dex/dried-sea-bass/",
      "de-DE": "/de-DE/dex/getrockneter-wolfsbarsch/"
    },
    "/dex/dried-sea-bass/": {
      "en-US": "/dex/dried-sea-bass/",
      "de-DE": "/de-DE/dex/getrockneter-wolfsbarsch/"
    },
    "/dex/getrockneter-zackenbarsch/": {
      "en-US": "/dex/dried-grouper/",
      "de-DE": "/de-DE/dex/getrockneter-zackenbarsch/"
    },
    "/dex/dried-grouper/": {
      "en-US": "/dex/dried-grouper/",
      "de-DE": "/de-DE/dex/getrockneter-zackenbarsch/"
    },
    "/dex/getrockneter-zwergengruendling/": {
      "en-US": "/dex/dried-dwarf-gudgeon/",
      "de-DE": "/de-DE/dex/getrockneter-zwergengruendling/"
    },
    "/dex/dried-dwarf-gudgeon/": {
      "en-US": "/dex/dried-dwarf-gudgeon/",
      "de-DE": "/de-DE/dex/getrockneter-zwergengruendling/"
    },
    "/dex/getrockneter-zwergstichling/": {
      "en-US": "/dex/dried-short-ninespine-stickleback/",
      "de-DE": "/de-DE/dex/getrockneter-zwergstichling/"
    },
    "/dex/dried-short-ninespine-stickleback/": {
      "en-US": "/dex/dried-short-ninespine-stickleback/",
      "de-DE": "/de-DE/dex/getrockneter-zwergstichling/"
    },
    "/dex/getrockneter-zwergwels/": {
      "en-US": "/dex/dried-ussurian-bullhead/",
      "de-DE": "/de-DE/dex/getrockneter-zwergwels/"
    },
    "/dex/dried-ussurian-bullhead/": {
      "en-US": "/dex/dried-ussurian-bullhead/",
      "de-DE": "/de-DE/dex/getrockneter-zwergwels/"
    },
    "/dex/getrocknetes-bachneunauge/": {
      "en-US": "/dex/dried-lamprey/",
      "de-DE": "/de-DE/dex/getrocknetes-bachneunauge/"
    },
    "/dex/dried-lamprey/": {
      "en-US": "/dex/dried-lamprey/",
      "de-DE": "/de-DE/dex/getrocknetes-bachneunauge/"
    },
    "/dex/getrocknetes-glupschauge/": {
      "en-US": "/dex/dried-bubble-eye/",
      "de-DE": "/de-DE/dex/getrocknetes-glupschauge/"
    },
    "/dex/dried-bubble-eye/": {
      "en-US": "/dex/dried-bubble-eye/",
      "de-DE": "/de-DE/dex/getrocknetes-glupschauge/"
    },
    "/dex/getrocknetes-grossauge/": {
      "en-US": "/dex/dried-bigeye/",
      "de-DE": "/de-DE/dex/getrocknetes-grossauge/"
    },
    "/dex/dried-bigeye/": {
      "en-US": "/dex/dried-bigeye/",
      "de-DE": "/de-DE/dex/getrocknetes-grossauge/"
    },
    "/dex/getrocknetes-perlenausterfleisch/": {
      "en-US": "/dex/dried-pearl-oyster-flesh/",
      "de-DE": "/de-DE/dex/getrocknetes-perlenausterfleisch/"
    },
    "/dex/dried-pearl-oyster-flesh/": {
      "en-US": "/dex/dried-pearl-oyster-flesh/",
      "de-DE": "/de-DE/dex/getrocknetes-perlenausterfleisch/"
    },
    "/dex/getrocknetes-seepferdchen/": {
      "en-US": "/dex/dried-seahorse/",
      "de-DE": "/de-DE/dex/getrocknetes-seepferdchen/"
    },
    "/dex/dried-seahorse/": {
      "en-US": "/dex/dried-seahorse/",
      "de-DE": "/de-DE/dex/getrocknetes-seepferdchen/"
    },
    "/dex/glaskrake/": {
      "en-US": "/dex/glass-octopus/",
      "de-DE": "/de-DE/dex/glaskrake/"
    },
    "/dex/glass-octopus/": {
      "en-US": "/dex/glass-octopus/",
      "de-DE": "/de-DE/dex/glaskrake/"
    },
    "/dex/glupschauge/": {
      "en-US": "/dex/bubble-eye/",
      "de-DE": "/de-DE/dex/glupschauge/"
    },
    "/dex/bubble-eye/": {
      "en-US": "/dex/bubble-eye/",
      "de-DE": "/de-DE/dex/glupschauge/"
    },
    "/dex/goby-elritze/": {
      "en-US": "/dex/goby-minnow/",
      "de-DE": "/de-DE/dex/goby-elritze/"
    },
    "/dex/goby-minnow/": {
      "en-US": "/dex/goby-minnow/",
      "de-DE": "/de-DE/dex/goby-elritze/"
    },
    "/dex/goldener-langflossenthun/": {
      "en-US": "/dex/golden-albacore/",
      "de-DE": "/de-DE/dex/goldener-langflossenthun/"
    },
    "/dex/golden-albacore/": {
      "en-US": "/dex/golden-albacore/",
      "de-DE": "/de-DE/dex/goldener-langflossenthun/"
    },
    "/dex/goldener-mandarinfisch/": {
      "en-US": "/dex/golden-siniperca/",
      "de-DE": "/de-DE/dex/goldener-mandarinfisch/"
    },
    "/dex/golden-siniperca/": {
      "en-US": "/dex/golden-siniperca/",
      "de-DE": "/de-DE/dex/goldener-mandarinfisch/"
    },
    "/dex/goldener-wolfsbarsch/": {
      "en-US": "/dex/golden-sea-bass/",
      "de-DE": "/de-DE/dex/goldener-wolfsbarsch/"
    },
    "/dex/golden-sea-bass/": {
      "en-US": "/dex/golden-sea-bass/",
      "de-DE": "/de-DE/dex/goldener-wolfsbarsch/"
    },
    "/dex/goldmaehne-glasflasche-5187/": {
      "en-US": "/dex/golden-mane-glass-vase-5187/",
      "de-DE": "/de-DE/dex/goldmaehne-glasflasche-5187/"
    },
    "/dex/golden-mane-glass-vase-5187/": {
      "en-US": "/dex/golden-mane-glass-vase-5187/",
      "de-DE": "/de-DE/dex/goldmaehne-glasflasche-5187/"
    },
    "/dex/goldmakrele/": {
      "en-US": "/dex/dolphinfish/",
      "de-DE": "/de-DE/dex/goldmakrele/"
    },
    "/dex/dolphinfish/": {
      "en-US": "/dex/dolphinfish/",
      "de-DE": "/de-DE/dex/goldmakrele/"
    },
    "/dex/goldstreifenbarsch/": {
      "en-US": "/dex/goldenstriped-soapfish/",
      "de-DE": "/de-DE/dex/goldstreifenbarsch/"
    },
    "/dex/goldenstriped-soapfish/": {
      "en-US": "/dex/goldenstriped-soapfish/",
      "de-DE": "/de-DE/dex/goldstreifenbarsch/"
    },
    "/dex/golftuemmler/": {
      "en-US": "/dex/vaquita/",
      "de-DE": "/de-DE/dex/golftuemmler/"
    },
    "/dex/vaquita/": {
      "en-US": "/dex/vaquita/",
      "de-DE": "/de-DE/dex/golftuemmler/"
    },
    "/dex/goliat-zackenbarsch/": {
      "en-US": "/dex/goliath-grouper/",
      "de-DE": "/de-DE/dex/goliat-zackenbarsch/"
    },
    "/dex/goliath-grouper/": {
      "en-US": "/dex/goliath-grouper/",
      "de-DE": "/de-DE/dex/goliat-zackenbarsch/"
    },
    "/dex/gotteslachs/": {
      "en-US": "/dex/sunfish/",
      "de-DE": "/de-DE/dex/gotteslachs/"
    },
    "/dex/sunfish/": {
      "en-US": "/dex/sunfish/",
      "de-DE": "/de-DE/dex/gotteslachs/"
    },
    "/dex/granges-dor/": {
      "en-US": "/dex/granges-dor/",
      "de-DE": "/de-DE/dex/granges-dor/"
    },
    "/dex/graskarpfen/": {
      "en-US": "/dex/grass-carp/",
      "de-DE": "/de-DE/dex/graskarpfen/"
    },
    "/dex/grass-carp/": {
      "en-US": "/dex/grass-carp/",
      "de-DE": "/de-DE/dex/graskarpfen/"
    },
    "/dex/grenadiersardelle/": {
      "en-US": "/dex/tapertail-anchovy/",
      "de-DE": "/de-DE/dex/grenadiersardelle/"
    },
    "/dex/tapertail-anchovy/": {
      "en-US": "/dex/tapertail-anchovy/",
      "de-DE": "/de-DE/dex/grenadiersardelle/"
    },
    "/dex/grossauge/": {
      "en-US": "/dex/bigeye/",
      "de-DE": "/de-DE/dex/grossauge/"
    },
    "/dex/bigeye/": {
      "en-US": "/dex/bigeye/",
      "de-DE": "/de-DE/dex/grossauge/"
    },
    "/dex/grossaugenthun/": {
      "en-US": "/dex/bigeye-tuna/",
      "de-DE": "/de-DE/dex/grossaugenthun/"
    },
    "/dex/bigeye-tuna/": {
      "en-US": "/dex/bigeye-tuna/",
      "de-DE": "/de-DE/dex/grossaugenthun/"
    },
    "/dex/grosse-stachelmakrele/": {
      "en-US": "/dex/greater-amberjack/",
      "de-DE": "/de-DE/dex/grosse-stachelmakrele/"
    },
    "/dex/greater-amberjack/": {
      "en-US": "/dex/greater-amberjack/",
      "de-DE": "/de-DE/dex/grosse-stachelmakrele/"
    },
    "/dex/grosser-tuemmler/": {
      "en-US": "/dex/bottlenose-dolphin/",
      "de-DE": "/de-DE/dex/grosser-tuemmler/"
    },
    "/dex/bottlenose-dolphin/": {
      "en-US": "/dex/bottlenose-dolphin/",
      "de-DE": "/de-DE/dex/grosser-tuemmler/"
    },
    "/dex/grosskopf-gruendling/": {
      "en-US": "/dex/large-headed-goby/",
      "de-DE": "/de-DE/dex/grosskopf-gruendling/"
    },
    "/dex/large-headed-goby/": {
      "en-US": "/dex/large-headed-goby/",
      "de-DE": "/de-DE/dex/grosskopf-gruendling/"
    },
    "/dex/grossmaul-barrakuda/": {
      "en-US": "/dex/obtuse-barracuda/",
      "de-DE": "/de-DE/dex/grossmaul-barrakuda/"
    },
    "/dex/obtuse-barracuda/": {
      "en-US": "/dex/obtuse-barracuda/",
      "de-DE": "/de-DE/dex/grossmaul-barrakuda/"
    },
    "/dex/gruene-meeresschildkroete/": {
      "en-US": "/dex/green-sea-turtle/",
      "de-DE": "/de-DE/dex/gruene-meeresschildkroete/"
    },
    "/dex/green-sea-turtle/": {
      "en-US": "/dex/green-sea-turtle/",
      "de-DE": "/de-DE/dex/gruene-meeresschildkroete/"
    },
    "/dex/gruener-stoer/": {
      "en-US": "/dex/green-sturgeon/",
      "de-DE": "/de-DE/dex/gruener-stoer/"
    },
    "/dex/green-sturgeon/": {
      "en-US": "/dex/green-sturgeon/",
      "de-DE": "/de-DE/dex/gruener-stoer/"
    },
    "/dex/gruenling/": {
      "en-US": "/dex/greenling/",
      "de-DE": "/de-DE/dex/gruenling/"
    },
    "/dex/greenling/": {
      "en-US": "/dex/greenling/",
      "de-DE": "/de-DE/dex/gruenling/"
    },
    "/dex/grunzer/": {
      "en-US": "/dex/grunt/",
      "de-DE": "/de-DE/dex/grunzer/"
    },
    "/dex/grunt/": {
      "en-US": "/dex/grunt/",
      "de-DE": "/de-DE/dex/grunzer/"
    },
    "/dex/guild-afuarus-damaged-map-piece-41663/": {
      "en-US": "/dex/guild-afuarus-damaged-map-piece-41663/",
      "de-DE": "/de-DE/dex/guild-afuarus-damaged-map-piece-41663/"
    },
    "/dex/haesling/": {
      "en-US": "/dex/dace/",
      "de-DE": "/de-DE/dex/haesling/"
    },
    "/dex/dace/": {
      "en-US": "/dex/dace/",
      "de-DE": "/de-DE/dex/haesling/"
    },
    "/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-i-66076/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-i-66076/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-i-66076/"
    },
    "/dex/hall-of-heroes-darkened-dawn-breaker-i-66076/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-i-66076/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-i-66076/"
    },
    "/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-ii-66077/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-ii-66077/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-ii-66077/"
    },
    "/dex/hall-of-heroes-darkened-dawn-breaker-ii-66077/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-ii-66077/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-ii-66077/"
    },
    "/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iii-66078/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-iii-66078/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iii-66078/"
    },
    "/dex/hall-of-heroes-darkened-dawn-breaker-iii-66078/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-iii-66078/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iii-66078/"
    },
    "/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iv-66079/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-iv-66079/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iv-66079/"
    },
    "/dex/hall-of-heroes-darkened-dawn-breaker-iv-66079/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-iv-66079/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-iv-66079/"
    },
    "/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-v-66080/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-v-66080/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-v-66080/"
    },
    "/dex/hall-of-heroes-darkened-dawn-breaker-v-66080/": {
      "en-US": "/dex/hall-of-heroes-darkened-dawn-breaker-v-66080/",
      "de-DE": "/de-DE/dex/halle-der-helden-vorbote-der-verfinsterten-morgenroete-v-66080/"
    },
    "/dex/hammerhai/": {
      "en-US": "/dex/hammerhead/",
      "de-DE": "/de-DE/dex/hammerhai/"
    },
    "/dex/hammerhead/": {
      "en-US": "/dex/hammerhead/",
      "de-DE": "/de-DE/dex/hammerhai/"
    },
    "/dex/hammermakrele/": {
      "en-US": "/dex/hammer-mackerel/",
      "de-DE": "/de-DE/dex/hammermakrele/"
    },
    "/dex/hammer-mackerel/": {
      "en-US": "/dex/hammer-mackerel/",
      "de-DE": "/de-DE/dex/hammermakrele/"
    },
    "/dex/hammerwal/": {
      "en-US": "/dex/hammer-whale/",
      "de-DE": "/de-DE/dex/hammerwal/"
    },
    "/dex/hammer-whale/": {
      "en-US": "/dex/hammer-whale/",
      "de-DE": "/de-DE/dex/hammerwal/"
    },
    "/dex/hecht/": {
      "en-US": "/dex/pike/",
      "de-DE": "/de-DE/dex/hecht/"
    },
    "/dex/pike/": {
      "en-US": "/dex/pike/",
      "de-DE": "/de-DE/dex/hecht/"
    },
    "/dex/hechtsalmler/": {
      "en-US": "/dex/pike-characin/",
      "de-DE": "/de-DE/dex/hechtsalmler/"
    },
    "/dex/pike-characin/": {
      "en-US": "/dex/pike-characin/",
      "de-DE": "/de-DE/dex/hechtsalmler/"
    },
    "/dex/hellgruendling/": {
      "en-US": "/dex/morning-river-goby/",
      "de-DE": "/de-DE/dex/hellgruendling/"
    },
    "/dex/morning-river-goby/": {
      "en-US": "/dex/morning-river-goby/",
      "de-DE": "/de-DE/dex/hellgruendling/"
    },
    "/dex/hering/": {
      "en-US": "/dex/herring/",
      "de-DE": "/de-DE/dex/hering/"
    },
    "/dex/herring/": {
      "en-US": "/dex/herring/",
      "de-DE": "/de-DE/dex/hering/"
    },
    "/dex/herzog-tintenfisch/": {
      "en-US": "/dex/duke-squid/",
      "de-DE": "/de-DE/dex/herzog-tintenfisch/"
    },
    "/dex/duke-squid/": {
      "en-US": "/dex/duke-squid/",
      "de-DE": "/de-DE/dex/herzog-tintenfisch/"
    },
    "/dex/himmelsgucker/": {
      "en-US": "/dex/giant-talking-catfish/",
      "de-DE": "/de-DE/dex/himmelsgucker/"
    },
    "/dex/giant-talking-catfish/": {
      "en-US": "/dex/giant-talking-catfish/",
      "de-DE": "/de-DE/dex/himmelsgucker/"
    },
    "/dex/hornfisch/": {
      "en-US": "/dex/horn-fish/",
      "de-DE": "/de-DE/dex/hornfisch/"
    },
    "/dex/horn-fish/": {
      "en-US": "/dex/horn-fish/",
      "de-DE": "/de-DE/dex/hornfisch/"
    },
    "/dex/igelfisch/": {
      "en-US": "/dex/porcupine-fish/",
      "de-DE": "/de-DE/dex/igelfisch/"
    },
    "/dex/porcupine-fish/": {
      "en-US": "/dex/porcupine-fish/",
      "de-DE": "/de-DE/dex/igelfisch/"
    },
    "/dex/item-43871/": {
      "en-US": "/dex/item-43871/",
      "de-DE": "/de-DE/dex/item-43871/"
    },
    "/dex/jackmakrele/": {
      "en-US": "/dex/saurel/",
      "de-DE": "/de-DE/dex/jackmakrele/"
    },
    "/dex/saurel/": {
      "en-US": "/dex/saurel/",
      "de-DE": "/de-DE/dex/jackmakrele/"
    },
    "/dex/kahlhecht/": {
      "en-US": "/dex/bowfin/",
      "de-DE": "/de-DE/dex/kahlhecht/"
    },
    "/dex/bowfin/": {
      "en-US": "/dex/bowfin/",
      "de-DE": "/de-DE/dex/kahlhecht/"
    },
    "/dex/kalmar/": {
      "en-US": "/dex/squid/",
      "de-DE": "/de-DE/dex/kalmar/"
    },
    "/dex/squid/": {
      "en-US": "/dex/squid/",
      "de-DE": "/de-DE/dex/kalmar/"
    },
    "/dex/kaninchenfisch/": {
      "en-US": "/dex/siganid/",
      "de-DE": "/de-DE/dex/kaninchenfisch/"
    },
    "/dex/siganid/": {
      "en-US": "/dex/siganid/",
      "de-DE": "/de-DE/dex/kaninchenfisch/"
    },
    "/dex/kaputte-handelskiste-44422/": {
      "en-US": "/dex/broken-trade-box-44422/",
      "de-DE": "/de-DE/dex/kaputte-handelskiste-44422/"
    },
    "/dex/broken-trade-box-44422/": {
      "en-US": "/dex/broken-trade-box-44422/",
      "de-DE": "/de-DE/dex/kaputte-handelskiste-44422/"
    },
    "/dex/karausche/": {
      "en-US": "/dex/crucian-carp/",
      "de-DE": "/de-DE/dex/karausche/"
    },
    "/dex/crucian-carp/": {
      "en-US": "/dex/crucian-carp/",
      "de-DE": "/de-DE/dex/karausche/"
    },
    "/dex/karpfen/": {
      "en-US": "/dex/carp/",
      "de-DE": "/de-DE/dex/karpfen/"
    },
    "/dex/carp/": {
      "en-US": "/dex/carp/",
      "de-DE": "/de-DE/dex/karpfen/"
    },
    "/dex/kerbenkieferfisch/": {
      "en-US": "/dex/notch-jaw/",
      "de-DE": "/de-DE/dex/kerbenkieferfisch/"
    },
    "/dex/notch-jaw/": {
      "en-US": "/dex/notch-jaw/",
      "de-DE": "/de-DE/dex/kerbenkieferfisch/"
    },
    "/dex/kiemenschlitzaal/": {
      "en-US": "/dex/swamp-eel/",
      "de-DE": "/de-DE/dex/kiemenschlitzaal/"
    },
    "/dex/swamp-eel/": {
      "en-US": "/dex/swamp-eel/",
      "de-DE": "/de-DE/dex/kiemenschlitzaal/"
    },
    "/dex/kirschblueten-eisfisch/": {
      "en-US": "/dex/cherry-icefish/",
      "de-DE": "/de-DE/dex/kirschblueten-eisfisch/"
    },
    "/dex/cherry-icefish/": {
      "en-US": "/dex/cherry-icefish/",
      "de-DE": "/de-DE/dex/kirschblueten-eisfisch/"
    },
    "/dex/kleine-jorunna/": {
      "en-US": "/dex/sea-bunny/",
      "de-DE": "/de-DE/dex/kleine-jorunna/"
    },
    "/dex/sea-bunny/": {
      "en-US": "/dex/sea-bunny/",
      "de-DE": "/de-DE/dex/kleine-jorunna/"
    },
    "/dex/knabberfisch/": {
      "en-US": "/dex/nibbler/",
      "de-DE": "/de-DE/dex/knabberfisch/"
    },
    "/dex/nibbler/": {
      "en-US": "/dex/nibbler/",
      "de-DE": "/de-DE/dex/knabberfisch/"
    },
    "/dex/knochenhecht/": {
      "en-US": "/dex/gar/",
      "de-DE": "/de-DE/dex/knochenhecht/"
    },
    "/dex/gar/": {
      "en-US": "/dex/gar/",
      "de-DE": "/de-DE/dex/knochenhecht/"
    },
    "/dex/knurrhahn/": {
      "en-US": "/dex/gurnard/",
      "de-DE": "/de-DE/dex/knurrhahn/"
    },
    "/dex/gurnard/": {
      "en-US": "/dex/gurnard/",
      "de-DE": "/de-DE/dex/knurrhahn/"
    },
    "/dex/koenigsmakrele/": {
      "en-US": "/dex/cero/",
      "de-DE": "/de-DE/dex/koenigsmakrele/"
    },
    "/dex/cero/": {
      "en-US": "/dex/cero/",
      "de-DE": "/de-DE/dex/koenigsmakrele/"
    },
    "/dex/koenigsschmerle/": {
      "en-US": "/dex/king-spine-loach/",
      "de-DE": "/de-DE/dex/koenigsschmerle/"
    },
    "/dex/king-spine-loach/": {
      "en-US": "/dex/king-spine-loach/",
      "de-DE": "/de-DE/dex/koenigsschmerle/"
    },
    "/dex/kofferfisch/": {
      "en-US": "/dex/boxfish/",
      "de-DE": "/de-DE/dex/kofferfisch/"
    },
    "/dex/boxfish/": {
      "en-US": "/dex/boxfish/",
      "de-DE": "/de-DE/dex/kofferfisch/"
    },
    "/dex/koi/": {
      "en-US": "/dex/koi/",
      "de-DE": "/de-DE/dex/koi/"
    },
    "/dex/kragenhai/": {
      "en-US": "/dex/frilled-shark/",
      "de-DE": "/de-DE/dex/kragenhai/"
    },
    "/dex/frilled-shark/": {
      "en-US": "/dex/frilled-shark/",
      "de-DE": "/de-DE/dex/kragenhai/"
    },
    "/dex/krebs/": {
      "en-US": "/dex/crab/",
      "de-DE": "/de-DE/dex/krebs/"
    },
    "/dex/crab/": {
      "en-US": "/dex/crab/",
      "de-DE": "/de-DE/dex/krebs/"
    },
    "/dex/kristall-des-walds-820036/": {
      "en-US": "/dex/forest-crystal-820036/",
      "de-DE": "/de-DE/dex/kristall-des-walds-820036/"
    },
    "/dex/forest-crystal-820036/": {
      "en-US": "/dex/forest-crystal-820036/",
      "de-DE": "/de-DE/dex/kristall-des-walds-820036/"
    },
    "/dex/kugelfisch/": {
      "en-US": "/dex/swellfish/",
      "de-DE": "/de-DE/dex/kugelfisch/"
    },
    "/dex/swellfish/": {
      "en-US": "/dex/swellfish/",
      "de-DE": "/de-DE/dex/kugelfisch/"
    },
    "/dex/lachs/": {
      "en-US": "/dex/salmon/",
      "de-DE": "/de-DE/dex/lachs/"
    },
    "/dex/salmon/": {
      "en-US": "/dex/salmon/",
      "de-DE": "/de-DE/dex/lachs/"
    },
    "/dex/lailas-bluetenblatt-54031/": {
      "en-US": "/dex/lailas-petal-54031/",
      "de-DE": "/de-DE/dex/lailas-bluetenblatt-54031/"
    },
    "/dex/lailas-petal-54031/": {
      "en-US": "/dex/lailas-petal-54031/",
      "de-DE": "/de-DE/dex/lailas-bluetenblatt-54031/"
    },
    "/dex/langflossenthun/": {
      "en-US": "/dex/albacore/",
      "de-DE": "/de-DE/dex/langflossenthun/"
    },
    "/dex/albacore/": {
      "en-US": "/dex/albacore/",
      "de-DE": "/de-DE/dex/langflossenthun/"
    },
    "/dex/langschnauzen-knochenhecht/": {
      "en-US": "/dex/longnose-gar/",
      "de-DE": "/de-DE/dex/langschnauzen-knochenhecht/"
    },
    "/dex/longnose-gar/": {
      "en-US": "/dex/longnose-gar/",
      "de-DE": "/de-DE/dex/langschnauzen-knochenhecht/"
    },
    "/dex/langschnauzenwels/": {
      "en-US": "/dex/longsnout-catfish/",
      "de-DE": "/de-DE/dex/langschnauzenwels/"
    },
    "/dex/longsnout-catfish/": {
      "en-US": "/dex/longsnout-catfish/",
      "de-DE": "/de-DE/dex/langschnauzenwels/"
    },
    "/dex/languste/": {
      "en-US": "/dex/crawfish/",
      "de-DE": "/de-DE/dex/languste/"
    },
    "/dex/crawfish/": {
      "en-US": "/dex/crawfish/",
      "de-DE": "/de-DE/dex/languste/"
    },
    "/dex/laternenhai/": {
      "en-US": "/dex/cloaking-shark/",
      "de-DE": "/de-DE/dex/laternenhai/"
    },
    "/dex/cloaking-shark/": {
      "en-US": "/dex/cloaking-shark/",
      "de-DE": "/de-DE/dex/laternenhai/"
    },
    "/dex/lavaschuppen-sterngucker/": {
      "en-US": "/dex/lavascale-stargazer/",
      "de-DE": "/de-DE/dex/lavaschuppen-sterngucker/"
    },
    "/dex/lavascale-stargazer/": {
      "en-US": "/dex/lavascale-stargazer/",
      "de-DE": "/de-DE/dex/lavaschuppen-sterngucker/"
    },
    "/dex/lederkarpfen/": {
      "en-US": "/dex/leather-carp/",
      "de-DE": "/de-DE/dex/lederkarpfen/"
    },
    "/dex/leather-carp/": {
      "en-US": "/dex/leather-carp/",
      "de-DE": "/de-DE/dex/lederkarpfen/"
    },
    "/dex/lenok/": {
      "en-US": "/dex/lenok/",
      "de-DE": "/de-DE/dex/lenok/"
    },
    "/dex/lungenfisch/": {
      "en-US": "/dex/lungfish/",
      "de-DE": "/de-DE/dex/lungenfisch/"
    },
    "/dex/lungfish/": {
      "en-US": "/dex/lungfish/",
      "de-DE": "/de-DE/dex/lungenfisch/"
    },
    "/dex/makohai/": {
      "en-US": "/dex/mako-shark/",
      "de-DE": "/de-DE/dex/makohai/"
    },
    "/dex/mako-shark/": {
      "en-US": "/dex/mako-shark/",
      "de-DE": "/de-DE/dex/makohai/"
    },
    "/dex/makrele/": {
      "en-US": "/dex/mackerel/",
      "de-DE": "/de-DE/dex/makrele/"
    },
    "/dex/mackerel/": {
      "en-US": "/dex/mackerel/",
      "de-DE": "/de-DE/dex/makrele/"
    },
    "/dex/makrelenhecht/": {
      "en-US": "/dex/mackerel-pike/",
      "de-DE": "/de-DE/dex/makrelenhecht/"
    },
    "/dex/mackerel-pike/": {
      "en-US": "/dex/mackerel-pike/",
      "de-DE": "/de-DE/dex/makrelenhecht/"
    },
    "/dex/makrelenthunfisch/": {
      "en-US": "/dex/mackerel-tuna/",
      "de-DE": "/de-DE/dex/makrelenthunfisch/"
    },
    "/dex/mackerel-tuna/": {
      "en-US": "/dex/mackerel-tuna/",
      "de-DE": "/de-DE/dex/makrelenthunfisch/"
    },
    "/dex/mandarinfisch/": {
      "en-US": "/dex/mandarin-fish/",
      "de-DE": "/de-DE/dex/mandarinfisch/"
    },
    "/dex/mandarin-fish/": {
      "en-US": "/dex/mandarin-fish/",
      "de-DE": "/de-DE/dex/mandarinfisch/"
    },
    "/dex/maomao/": {
      "en-US": "/dex/maomao/",
      "de-DE": "/de-DE/dex/maomao/"
    },
    "/dex/masu-lachs/": {
      "en-US": "/dex/cherry-salmon/",
      "de-DE": "/de-DE/dex/masu-lachs/"
    },
    "/dex/cherry-salmon/": {
      "en-US": "/dex/cherry-salmon/",
      "de-DE": "/de-DE/dex/masu-lachs/"
    },
    "/dex/meeraal/": {
      "en-US": "/dex/sea-eel/",
      "de-DE": "/de-DE/dex/meeraal/"
    },
    "/dex/sea-eel/": {
      "en-US": "/dex/sea-eel/",
      "de-DE": "/de-DE/dex/meeraal/"
    },
    "/dex/meeraesche/": {
      "en-US": "/dex/mullet/",
      "de-DE": "/de-DE/dex/meeraesche/"
    },
    "/dex/mullet/": {
      "en-US": "/dex/mullet/",
      "de-DE": "/de-DE/dex/meeraesche/"
    },
    "/dex/meerbrasse/": {
      "en-US": "/dex/porgy/",
      "de-DE": "/de-DE/dex/meerbrasse/"
    },
    "/dex/porgy/": {
      "en-US": "/dex/porgy/",
      "de-DE": "/de-DE/dex/meerbrasse/"
    },
    "/dex/meeresengel/": {
      "en-US": "/dex/sea-angel/",
      "de-DE": "/de-DE/dex/meeresengel/"
    },
    "/dex/sea-angel/": {
      "en-US": "/dex/sea-angel/",
      "de-DE": "/de-DE/dex/meeresengel/"
    },
    "/dex/messing-ruderfisch/": {
      "en-US": "/dex/brassy-chub/",
      "de-DE": "/de-DE/dex/messing-ruderfisch/"
    },
    "/dex/brassy-chub/": {
      "en-US": "/dex/brassy-chub/",
      "de-DE": "/de-DE/dex/messing-ruderfisch/"
    },
    "/dex/miesmuschel/": {
      "en-US": "/dex/shellfish/",
      "de-DE": "/de-DE/dex/miesmuschel/"
    },
    "/dex/shellfish/": {
      "en-US": "/dex/shellfish/",
      "de-DE": "/de-DE/dex/miesmuschel/"
    },
    "/dex/migaloo/": {
      "en-US": "/dex/migaloo/",
      "de-DE": "/de-DE/dex/migaloo/"
    },
    "/dex/mitra-tintenfisch/": {
      "en-US": "/dex/mitre-squid/",
      "de-DE": "/de-DE/dex/mitra-tintenfisch/"
    },
    "/dex/mitre-squid/": {
      "en-US": "/dex/mitre-squid/",
      "de-DE": "/de-DE/dex/mitra-tintenfisch/"
    },
    "/dex/moenchsfisch/": {
      "en-US": "/dex/smokey-chromis/",
      "de-DE": "/de-DE/dex/moenchsfisch/"
    },
    "/dex/smokey-chromis/": {
      "en-US": "/dex/smokey-chromis/",
      "de-DE": "/de-DE/dex/moenchsfisch/"
    },
    "/dex/mori/": {
      "en-US": "/dex/mori/",
      "de-DE": "/de-DE/dex/mori/"
    },
    "/dex/muraene/": {
      "en-US": "/dex/moray/",
      "de-DE": "/de-DE/dex/muraene/"
    },
    "/dex/moray/": {
      "en-US": "/dex/moray/",
      "de-DE": "/de-DE/dex/muraene/"
    },
    "/dex/mystischer-fisch-42281/": {
      "en-US": "/dex/mystical-fish-42281/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42281/"
    },
    "/dex/mystical-fish-42281/": {
      "en-US": "/dex/mystical-fish-42281/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42281/"
    },
    "/dex/mystischer-fisch-42282/": {
      "en-US": "/dex/mystical-fish-42282/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42282/"
    },
    "/dex/mystical-fish-42282/": {
      "en-US": "/dex/mystical-fish-42282/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42282/"
    },
    "/dex/mystischer-fisch-42283/": {
      "en-US": "/dex/mystical-fish-42283/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42283/"
    },
    "/dex/mystical-fish-42283/": {
      "en-US": "/dex/mystical-fish-42283/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42283/"
    },
    "/dex/mystischer-fisch-42284/": {
      "en-US": "/dex/mystical-fish-42284/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42284/"
    },
    "/dex/mystical-fish-42284/": {
      "en-US": "/dex/mystical-fish-42284/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42284/"
    },
    "/dex/mystischer-fisch-42285/": {
      "en-US": "/dex/mystical-fish-42285/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42285/"
    },
    "/dex/mystical-fish-42285/": {
      "en-US": "/dex/mystical-fish-42285/",
      "de-DE": "/de-DE/dex/mystischer-fisch-42285/"
    },
    "/dex/narwal/": {
      "en-US": "/dex/narwhal/",
      "de-DE": "/de-DE/dex/narwal/"
    },
    "/dex/narwhal/": {
      "en-US": "/dex/narwhal/",
      "de-DE": "/de-DE/dex/narwal/"
    },
    "/dex/nasenmuraene/": {
      "en-US": "/dex/ribbon-eel/",
      "de-DE": "/de-DE/dex/nasenmuraene/"
    },
    "/dex/ribbon-eel/": {
      "en-US": "/dex/ribbon-eel/",
      "de-DE": "/de-DE/dex/nasenmuraene/"
    },
    "/dex/obskurer-kugelfisch-8495/": {
      "en-US": "/dex/pufferfish-8495/",
      "de-DE": "/de-DE/dex/obskurer-kugelfisch-8495/"
    },
    "/dex/pufferfish-8495/": {
      "en-US": "/dex/pufferfish-8495/",
      "de-DE": "/de-DE/dex/obskurer-kugelfisch-8495/"
    },
    "/dex/oeliger-gruendling/": {
      "en-US": "/dex/oily-shiner/",
      "de-DE": "/de-DE/dex/oeliger-gruendling/"
    },
    "/dex/oily-shiner/": {
      "en-US": "/dex/oily-shiner/",
      "de-DE": "/de-DE/dex/oeliger-gruendling/"
    },
    "/dex/ohrenqualle/": {
      "en-US": "/dex/moon-jelly/",
      "de-DE": "/de-DE/dex/ohrenqualle/"
    },
    "/dex/moon-jelly/": {
      "en-US": "/dex/moon-jelly/",
      "de-DE": "/de-DE/dex/ohrenqualle/"
    },
    "/dex/oktopus/": {
      "en-US": "/dex/octopus/",
      "de-DE": "/de-DE/dex/oktopus/"
    },
    "/dex/octopus/": {
      "en-US": "/dex/octopus/",
      "de-DE": "/de-DE/dex/oktopus/"
    },
    "/dex/opah/": {
      "en-US": "/dex/opah/",
      "de-DE": "/de-DE/dex/opah/"
    },
    "/dex/orientalische-schmerle/": {
      "en-US": "/dex/morning-loach/",
      "de-DE": "/de-DE/dex/orientalische-schmerle/"
    },
    "/dex/morning-loach/": {
      "en-US": "/dex/morning-loach/",
      "de-DE": "/de-DE/dex/orientalische-schmerle/"
    },
    "/dex/orientalischer-schlammspringer/": {
      "en-US": "/dex/shuttles-hoppfish/",
      "de-DE": "/de-DE/dex/orientalischer-schlammspringer/"
    },
    "/dex/shuttles-hoppfish/": {
      "en-US": "/dex/shuttles-hoppfish/",
      "de-DE": "/de-DE/dex/orientalischer-schlammspringer/"
    },
    "/dex/pacu/": {
      "en-US": "/dex/pacu/",
      "de-DE": "/de-DE/dex/pacu/"
    },
    "/dex/palembang-kugelfisch/": {
      "en-US": "/dex/eyespot-puffer/",
      "de-DE": "/de-DE/dex/palembang-kugelfisch/"
    },
    "/dex/eyespot-puffer/": {
      "en-US": "/dex/eyespot-puffer/",
      "de-DE": "/de-DE/dex/palembang-kugelfisch/"
    },
    "/dex/paletten-doktorfisch/": {
      "en-US": "/dex/blue-tang/",
      "de-DE": "/de-DE/dex/paletten-doktorfisch/"
    },
    "/dex/blue-tang/": {
      "en-US": "/dex/blue-tang/",
      "de-DE": "/de-DE/dex/paletten-doktorfisch/"
    },
    "/dex/pazifische-kliesche/": {
      "en-US": "/dex/yellowfin-sole/",
      "de-DE": "/de-DE/dex/pazifische-kliesche/"
    },
    "/dex/yellowfin-sole/": {
      "en-US": "/dex/yellowfin-sole/",
      "de-DE": "/de-DE/dex/pazifische-kliesche/"
    },
    "/dex/peitschenangler/": {
      "en-US": "/dex/footballfish/",
      "de-DE": "/de-DE/dex/peitschenangler/"
    },
    "/dex/footballfish/": {
      "en-US": "/dex/footballfish/",
      "de-DE": "/de-DE/dex/peitschenangler/"
    },
    "/dex/perlboot/": {
      "en-US": "/dex/nautilus/",
      "de-DE": "/de-DE/dex/perlboot/"
    },
    "/dex/nautilus/": {
      "en-US": "/dex/nautilus/",
      "de-DE": "/de-DE/dex/perlboot/"
    },
    "/dex/petersfisch/": {
      "en-US": "/dex/john-dory/",
      "de-DE": "/de-DE/dex/petersfisch/"
    },
    "/dex/john-dory/": {
      "en-US": "/dex/john-dory/",
      "de-DE": "/de-DE/dex/petersfisch/"
    },
    "/dex/pintado/": {
      "en-US": "/dex/pintado/",
      "de-DE": "/de-DE/dex/pintado/"
    },
    "/dex/piranha/": {
      "en-US": "/dex/piranha/",
      "de-DE": "/de-DE/dex/piranha/"
    },
    "/dex/plattfisch/": {
      "en-US": "/dex/flatfish/",
      "de-DE": "/de-DE/dex/plattfisch/"
    },
    "/dex/flatfish/": {
      "en-US": "/dex/flatfish/",
      "de-DE": "/de-DE/dex/plattfisch/"
    },
    "/dex/pottwal/": {
      "en-US": "/dex/sperm-whale/",
      "de-DE": "/de-DE/dex/pottwal/"
    },
    "/dex/sperm-whale/": {
      "en-US": "/dex/sperm-whale/",
      "de-DE": "/de-DE/dex/pottwal/"
    },
    "/dex/punktierter-butterfisch/": {
      "en-US": "/dex/stippled-gunnel/",
      "de-DE": "/de-DE/dex/punktierter-butterfisch/"
    },
    "/dex/stippled-gunnel/": {
      "en-US": "/dex/stippled-gunnel/",
      "de-DE": "/de-DE/dex/punktierter-butterfisch/"
    },
    "/dex/qualle/": {
      "en-US": "/dex/jellyfish/",
      "de-DE": "/de-DE/dex/qualle/"
    },
    "/dex/jellyfish/": {
      "en-US": "/dex/jellyfish/",
      "de-DE": "/de-DE/dex/qualle/"
    },
    "/dex/quappe/": {
      "en-US": "/dex/burbot/",
      "de-DE": "/de-DE/dex/quappe/"
    },
    "/dex/burbot/": {
      "en-US": "/dex/burbot/",
      "de-DE": "/de-DE/dex/quappe/"
    },
    "/dex/quastenflosser/": {
      "en-US": "/dex/coelacanth/",
      "de-DE": "/de-DE/dex/quastenflosser/"
    },
    "/dex/coelacanth/": {
      "en-US": "/dex/coelacanth/",
      "de-DE": "/de-DE/dex/quastenflosser/"
    },
    "/dex/ranchu/": {
      "en-US": "/dex/ranchu/",
      "de-DE": "/de-DE/dex/ranchu/"
    },
    "/dex/rauhgarnele/": {
      "en-US": "/dex/southern-rough-shrimp/",
      "de-DE": "/de-DE/dex/rauhgarnele/"
    },
    "/dex/southern-rough-shrimp/": {
      "en-US": "/dex/southern-rough-shrimp/",
      "de-DE": "/de-DE/dex/rauhgarnele/"
    },
    "/dex/regenbogenblueten-muenze-65540/": {
      "en-US": "/dex/rainbow-petal-coin-65540/",
      "de-DE": "/de-DE/dex/regenbogenblueten-muenze-65540/"
    },
    "/dex/rainbow-petal-coin-65540/": {
      "en-US": "/dex/rainbow-petal-coin-65540/",
      "de-DE": "/de-DE/dex/regenbogenblueten-muenze-65540/"
    },
    "/dex/regenbogenfisch/": {
      "en-US": "/dex/rainbowfish/",
      "de-DE": "/de-DE/dex/regenbogenfisch/"
    },
    "/dex/rainbowfish/": {
      "en-US": "/dex/rainbowfish/",
      "de-DE": "/de-DE/dex/regenbogenfisch/"
    },
    "/dex/regenbogenfischgraeten-muenze-65541/": {
      "en-US": "/dex/rainbow-fish-bone-coin-65541/",
      "de-DE": "/de-DE/dex/regenbogenfischgraeten-muenze-65541/"
    },
    "/dex/rainbow-fish-bone-coin-65541/": {
      "en-US": "/dex/rainbow-fish-bone-coin-65541/",
      "de-DE": "/de-DE/dex/regenbogenfischgraeten-muenze-65541/"
    },
    "/dex/regenbogensardine/": {
      "en-US": "/dex/rainbow-sardine/",
      "de-DE": "/de-DE/dex/regenbogensardine/"
    },
    "/dex/rainbow-sardine/": {
      "en-US": "/dex/rainbow-sardine/",
      "de-DE": "/de-DE/dex/regenbogensardine/"
    },
    "/dex/reliktkristallsplitter-der-vorzeitlichen-40218/": {
      "en-US": "/dex/ancient-relic-crystal-shard-40218/",
      "de-DE": "/de-DE/dex/reliktkristallsplitter-der-vorzeitlichen-40218/"
    },
    "/dex/ancient-relic-crystal-shard-40218/": {
      "en-US": "/dex/ancient-relic-crystal-shard-40218/",
      "de-DE": "/de-DE/dex/reliktkristallsplitter-der-vorzeitlichen-40218/"
    },
    "/dex/requiemhai/": {
      "en-US": "/dex/requiem-shark/",
      "de-DE": "/de-DE/dex/requiemhai/"
    },
    "/dex/requiem-shark/": {
      "en-US": "/dex/requiem-shark/",
      "de-DE": "/de-DE/dex/requiemhai/"
    },
    "/dex/riesenbitterling/": {
      "en-US": "/dex/giant-bitterling/",
      "de-DE": "/de-DE/dex/riesenbitterling/"
    },
    "/dex/giant-bitterling/": {
      "en-US": "/dex/giant-bitterling/",
      "de-DE": "/de-DE/dex/riesenbitterling/"
    },
    "/dex/riesenhai/": {
      "en-US": "/dex/basking-shark/",
      "de-DE": "/de-DE/dex/riesenhai/"
    },
    "/dex/basking-shark/": {
      "en-US": "/dex/basking-shark/",
      "de-DE": "/de-DE/dex/riesenhai/"
    },
    "/dex/riesenkalmar/": {
      "en-US": "/dex/giant-squid/",
      "de-DE": "/de-DE/dex/riesenkalmar/"
    },
    "/dex/giant-squid/": {
      "en-US": "/dex/giant-squid/",
      "de-DE": "/de-DE/dex/riesenkalmar/"
    },
    "/dex/riesenkraken/": {
      "en-US": "/dex/giant-octopus/",
      "de-DE": "/de-DE/dex/riesenkraken/"
    },
    "/dex/giant-octopus/": {
      "en-US": "/dex/giant-octopus/",
      "de-DE": "/de-DE/dex/riesenkraken/"
    },
    "/dex/riesenzackenbarsch/": {
      "en-US": "/dex/giant-grouper/",
      "de-DE": "/de-DE/dex/riesenzackenbarsch/"
    },
    "/dex/giant-grouper/": {
      "en-US": "/dex/giant-grouper/",
      "de-DE": "/de-DE/dex/riesenzackenbarsch/"
    },
    "/dex/riesiger-mantarochen/": {
      "en-US": "/dex/manta-ray/",
      "de-DE": "/de-DE/dex/riesiger-mantarochen/"
    },
    "/dex/manta-ray/": {
      "en-US": "/dex/manta-ray/",
      "de-DE": "/de-DE/dex/riesiger-mantarochen/"
    },
    "/dex/riesiger-riemenfisch/": {
      "en-US": "/dex/giant-oarfish/",
      "de-DE": "/de-DE/dex/riesiger-riemenfisch/"
    },
    "/dex/giant-oarfish/": {
      "en-US": "/dex/giant-oarfish/",
      "de-DE": "/de-DE/dex/riesiger-riemenfisch/"
    },
    "/dex/riesiges-fischskelett-24836/": {
      "en-US": "/dex/giant-fish-bone-24836/",
      "de-DE": "/de-DE/dex/riesiges-fischskelett-24836/"
    },
    "/dex/giant-fish-bone-24836/": {
      "en-US": "/dex/giant-fish-bone-24836/",
      "de-DE": "/de-DE/dex/riesiges-fischskelett-24836/"
    },
    "/dex/riffbarsch/": {
      "en-US": "/dex/blacktip-chromis/",
      "de-DE": "/de-DE/dex/riffbarsch/"
    },
    "/dex/blacktip-chromis/": {
      "en-US": "/dex/blacktip-chromis/",
      "de-DE": "/de-DE/dex/riffbarsch/"
    },
    "/dex/rochen/": {
      "en-US": "/dex/ray/",
      "de-DE": "/de-DE/dex/rochen/"
    },
    "/dex/ray/": {
      "en-US": "/dex/ray/",
      "de-DE": "/de-DE/dex/rochen/"
    },
    "/dex/rosiger-bitterling/": {
      "en-US": "/dex/rosy-bitterling/",
      "de-DE": "/de-DE/dex/rosiger-bitterling/"
    },
    "/dex/rosy-bitterling/": {
      "en-US": "/dex/rosy-bitterling/",
      "de-DE": "/de-DE/dex/rosiger-bitterling/"
    },
    "/dex/rotbarsch/": {
      "en-US": "/dex/rosefish/",
      "de-DE": "/de-DE/dex/rotbarsch/"
    },
    "/dex/rosefish/": {
      "en-US": "/dex/rosefish/",
      "de-DE": "/de-DE/dex/rotbarsch/"
    },
    "/dex/rotbrustlippfisch/": {
      "en-US": "/dex/redbreasted-wrasse/",
      "de-DE": "/de-DE/dex/rotbrustlippfisch/"
    },
    "/dex/redbreasted-wrasse/": {
      "en-US": "/dex/redbreasted-wrasse/",
      "de-DE": "/de-DE/dex/rotbrustlippfisch/"
    },
    "/dex/rote-meerbrasse/": {
      "en-US": "/dex/red-seabream/",
      "de-DE": "/de-DE/dex/rote-meerbrasse/"
    },
    "/dex/red-seabream/": {
      "en-US": "/dex/red-seabream/",
      "de-DE": "/de-DE/dex/rote-meerbrasse/"
    },
    "/dex/rote-schneekrabbe/": {
      "en-US": "/dex/red-snow-crab/",
      "de-DE": "/de-DE/dex/rote-schneekrabbe/"
    },
    "/dex/red-snow-crab/": {
      "en-US": "/dex/red-snow-crab/",
      "de-DE": "/de-DE/dex/rote-schneekrabbe/"
    },
    "/dex/roter-handfisch/": {
      "en-US": "/dex/red-handfish/",
      "de-DE": "/de-DE/dex/roter-handfisch/"
    },
    "/dex/red-handfish/": {
      "en-US": "/dex/red-handfish/",
      "de-DE": "/de-DE/dex/roter-handfisch/"
    },
    "/dex/rundhering/": {
      "en-US": "/dex/round-herring/",
      "de-DE": "/de-DE/dex/rundhering/"
    },
    "/dex/round-herring/": {
      "en-US": "/dex/round-herring/",
      "de-DE": "/de-DE/dex/rundhering/"
    },
    "/dex/rundschwanzmakropode/": {
      "en-US": "/dex/roundtail-paradisefish/",
      "de-DE": "/de-DE/dex/rundschwanzmakropode/"
    },
    "/dex/roundtail-paradisefish/": {
      "en-US": "/dex/roundtail-paradisefish/",
      "de-DE": "/de-DE/dex/rundschwanzmakropode/"
    },
    "/dex/sackmaul-aal/": {
      "en-US": "/dex/pelican-eel/",
      "de-DE": "/de-DE/dex/sackmaul-aal/"
    },
    "/dex/pelican-eel/": {
      "en-US": "/dex/pelican-eel/",
      "de-DE": "/de-DE/dex/sackmaul-aal/"
    },
    "/dex/saegehai/": {
      "en-US": "/dex/saw-shark/",
      "de-DE": "/de-DE/dex/saegehai/"
    },
    "/dex/saw-shark/": {
      "en-US": "/dex/saw-shark/",
      "de-DE": "/de-DE/dex/saegehai/"
    },
    "/dex/saibling/": {
      "en-US": "/dex/charr/",
      "de-DE": "/de-DE/dex/saibling/"
    },
    "/dex/charr/": {
      "en-US": "/dex/charr/",
      "de-DE": "/de-DE/dex/saibling/"
    },
    "/dex/salpe/": {
      "en-US": "/dex/salp/",
      "de-DE": "/de-DE/dex/salpe/"
    },
    "/dex/salp/": {
      "en-US": "/dex/salp/",
      "de-DE": "/de-DE/dex/salpe/"
    },
    "/dex/sandaal/": {
      "en-US": "/dex/sandeel/",
      "de-DE": "/de-DE/dex/sandaal/"
    },
    "/dex/sandeel/": {
      "en-US": "/dex/sandeel/",
      "de-DE": "/de-DE/dex/sandaal/"
    },
    "/dex/sandfisch/": {
      "en-US": "/dex/sandfish/",
      "de-DE": "/de-DE/dex/sandfisch/"
    },
    "/dex/sandfish/": {
      "en-US": "/dex/sandfish/",
      "de-DE": "/de-DE/dex/sandfisch/"
    },
    "/dex/sardine/": {
      "en-US": "/dex/sardine/",
      "de-DE": "/de-DE/dex/sardine/"
    },
    "/dex/saugmaulwels/": {
      "en-US": "/dex/common-pleco/",
      "de-DE": "/de-DE/dex/saugmaulwels/"
    },
    "/dex/common-pleco/": {
      "en-US": "/dex/common-pleco/",
      "de-DE": "/de-DE/dex/saugmaulwels/"
    },
    "/dex/schachbrett-junker/": {
      "en-US": "/dex/checkerboard-wrasse/",
      "de-DE": "/de-DE/dex/schachbrett-junker/"
    },
    "/dex/checkerboard-wrasse/": {
      "en-US": "/dex/checkerboard-wrasse/",
      "de-DE": "/de-DE/dex/schachbrett-junker/"
    },
    "/dex/scherbe-einer-zerbrochenen-flasche-42349/": {
      "en-US": "/dex/broken-bottle-fragment-42349/",
      "de-DE": "/de-DE/dex/scherbe-einer-zerbrochenen-flasche-42349/"
    },
    "/dex/broken-bottle-fragment-42349/": {
      "en-US": "/dex/broken-bottle-fragment-42349/",
      "de-DE": "/de-DE/dex/scherbe-einer-zerbrochenen-flasche-42349/"
    },
    "/dex/schlammfisch/": {
      "en-US": "/dex/mudfish/",
      "de-DE": "/de-DE/dex/schlammfisch/"
    },
    "/dex/mudfish/": {
      "en-US": "/dex/mudfish/",
      "de-DE": "/de-DE/dex/schlammfisch/"
    },
    "/dex/schlammspringer/": {
      "en-US": "/dex/mudskipper/",
      "de-DE": "/de-DE/dex/schlammspringer/"
    },
    "/dex/mudskipper/": {
      "en-US": "/dex/mudskipper/",
      "de-DE": "/de-DE/dex/schlammspringer/"
    },
    "/dex/schlangenkopffisch/": {
      "en-US": "/dex/snakehead/",
      "de-DE": "/de-DE/dex/schlangenkopffisch/"
    },
    "/dex/snakehead/": {
      "en-US": "/dex/snakehead/",
      "de-DE": "/de-DE/dex/schlangenkopffisch/"
    },
    "/dex/schnee-koenigsmakrele/": {
      "en-US": "/dex/striped-bonito/",
      "de-DE": "/de-DE/dex/schnee-koenigsmakrele/"
    },
    "/dex/striped-bonito/": {
      "en-US": "/dex/striped-bonito/",
      "de-DE": "/de-DE/dex/schnee-koenigsmakrele/"
    },
    "/dex/schuppen-brandungsbarsch/": {
      "en-US": "/dex/ransonnets-surfperch/",
      "de-DE": "/de-DE/dex/schuppen-brandungsbarsch/"
    },
    "/dex/ransonnets-surfperch/": {
      "en-US": "/dex/ransonnets-surfperch/",
      "de-DE": "/de-DE/dex/schuppen-brandungsbarsch/"
    },
    "/dex/schwanzstreifensalmler/": {
      "en-US": "/dex/silver-prochilodus/",
      "de-DE": "/de-DE/dex/schwanzstreifensalmler/"
    },
    "/dex/silver-prochilodus/": {
      "en-US": "/dex/silver-prochilodus/",
      "de-DE": "/de-DE/dex/schwanzstreifensalmler/"
    },
    "/dex/schwarm-elritze/": {
      "en-US": "/dex/common-minnow/",
      "de-DE": "/de-DE/dex/schwarm-elritze/"
    },
    "/dex/common-minnow/": {
      "en-US": "/dex/common-minnow/",
      "de-DE": "/de-DE/dex/schwarm-elritze/"
    },
    "/dex/schwarzaugen-krabbe/": {
      "en-US": "/dex/black-eye-crab/",
      "de-DE": "/de-DE/dex/schwarzaugen-krabbe/"
    },
    "/dex/black-eye-crab/": {
      "en-US": "/dex/black-eye-crab/",
      "de-DE": "/de-DE/dex/schwarzaugen-krabbe/"
    },
    "/dex/schwarzer-gruendling/": {
      "en-US": "/dex/black-shiner/",
      "de-DE": "/de-DE/dex/schwarzer-gruendling/"
    },
    "/dex/black-shiner/": {
      "en-US": "/dex/black-shiner/",
      "de-DE": "/de-DE/dex/schwarzer-gruendling/"
    },
    "/dex/schwarzer-lippfisch/": {
      "en-US": "/dex/black-porgy/",
      "de-DE": "/de-DE/dex/schwarzer-lippfisch/"
    },
    "/dex/black-porgy/": {
      "en-US": "/dex/black-porgy/",
      "de-DE": "/de-DE/dex/schwarzer-lippfisch/"
    },
    "/dex/schwarzer-marlin/": {
      "en-US": "/dex/black-marlin/",
      "de-DE": "/de-DE/dex/schwarzer-marlin/"
    },
    "/dex/black-marlin/": {
      "en-US": "/dex/black-marlin/",
      "de-DE": "/de-DE/dex/schwarzer-marlin/"
    },
    "/dex/schwarzer-plattfisch/": {
      "en-US": "/dex/black-halibut/",
      "de-DE": "/de-DE/dex/schwarzer-plattfisch/"
    },
    "/dex/black-halibut/": {
      "en-US": "/dex/black-halibut/",
      "de-DE": "/de-DE/dex/schwarzer-plattfisch/"
    },
    "/dex/schwarzer-riesenkalmar/": {
      "en-US": "/dex/giant-black-squid/",
      "de-DE": "/de-DE/dex/schwarzer-riesenkalmar/"
    },
    "/dex/giant-black-squid/": {
      "en-US": "/dex/giant-black-squid/",
      "de-DE": "/de-DE/dex/schwarzer-riesenkalmar/"
    },
    "/dex/schwarzer-teufelsrochen/": {
      "en-US": "/dex/polka-dot-stingray/",
      "de-DE": "/de-DE/dex/schwarzer-teufelsrochen/"
    },
    "/dex/polka-dot-stingray/": {
      "en-US": "/dex/polka-dot-stingray/",
      "de-DE": "/de-DE/dex/schwarzer-teufelsrochen/"
    },
    "/dex/schwarzes-blatt-von-quturan-45017/": {
      "en-US": "/dex/quturans-black-leaf-45017/",
      "de-DE": "/de-DE/dex/schwarzes-blatt-von-quturan-45017/"
    },
    "/dex/quturans-black-leaf-45017/": {
      "en-US": "/dex/quturans-black-leaf-45017/",
      "de-DE": "/de-DE/dex/schwarzes-blatt-von-quturan-45017/"
    },
    "/dex/schwarzflossen-beilfisch/": {
      "en-US": "/dex/blackfin-sweeper/",
      "de-DE": "/de-DE/dex/schwarzflossen-beilfisch/"
    },
    "/dex/blackfin-sweeper/": {
      "en-US": "/dex/blackfin-sweeper/",
      "de-DE": "/de-DE/dex/schwarzflossen-beilfisch/"
    },
    "/dex/schwertfisch/": {
      "en-US": "/dex/swordfish/",
      "de-DE": "/de-DE/dex/schwertfisch/"
    },
    "/dex/swordfish/": {
      "en-US": "/dex/swordfish/",
      "de-DE": "/de-DE/dex/schwertfisch/"
    },
    "/dex/schwertwal/": {
      "en-US": "/dex/killer-whale/",
      "de-DE": "/de-DE/dex/schwertwal/"
    },
    "/dex/killer-whale/": {
      "en-US": "/dex/killer-whale/",
      "de-DE": "/de-DE/dex/schwertwal/"
    },
    "/dex/seelachs/": {
      "en-US": "/dex/pollack/",
      "de-DE": "/de-DE/dex/seelachs/"
    },
    "/dex/pollack/": {
      "en-US": "/dex/pollack/",
      "de-DE": "/de-DE/dex/seelachs/"
    },
    "/dex/seepferdchen/": {
      "en-US": "/dex/seahorse/",
      "de-DE": "/de-DE/dex/seepferdchen/"
    },
    "/dex/seahorse/": {
      "en-US": "/dex/seahorse/",
      "de-DE": "/de-DE/dex/seepferdchen/"
    },
    "/dex/seeschwein/": {
      "en-US": "/dex/sea-pig/",
      "de-DE": "/de-DE/dex/seeschwein/"
    },
    "/dex/sea-pig/": {
      "en-US": "/dex/sea-pig/",
      "de-DE": "/de-DE/dex/seeschwein/"
    },
    "/dex/seestern/": {
      "en-US": "/dex/starfish/",
      "de-DE": "/de-DE/dex/seestern/"
    },
    "/dex/starfish/": {
      "en-US": "/dex/starfish/",
      "de-DE": "/de-DE/dex/seestern/"
    },
    "/dex/seezunge/": {
      "en-US": "/dex/tongue-sole/",
      "de-DE": "/de-DE/dex/seezunge/"
    },
    "/dex/tongue-sole/": {
      "en-US": "/dex/tongue-sole/",
      "de-DE": "/de-DE/dex/seezunge/"
    },
    "/dex/segelfisch/": {
      "en-US": "/dex/sailfish/",
      "de-DE": "/de-DE/dex/segelfisch/"
    },
    "/dex/sailfish/": {
      "en-US": "/dex/sailfish/",
      "de-DE": "/de-DE/dex/segelfisch/"
    },
    "/dex/sensenfisch/": {
      "en-US": "/dex/ribbonfish/",
      "de-DE": "/de-DE/dex/sensenfisch/"
    },
    "/dex/ribbonfish/": {
      "en-US": "/dex/ribbonfish/",
      "de-DE": "/de-DE/dex/sensenfisch/"
    },
    "/dex/silber-strumpfbandfisch/": {
      "en-US": "/dex/silver-beltfish/",
      "de-DE": "/de-DE/dex/silber-strumpfbandfisch/"
    },
    "/dex/silver-beltfish/": {
      "en-US": "/dex/silver-beltfish/",
      "de-DE": "/de-DE/dex/silber-strumpfbandfisch/"
    },
    "/dex/silberkarpfen/": {
      "en-US": "/dex/silver-carp/",
      "de-DE": "/de-DE/dex/silberkarpfen/"
    },
    "/dex/silver-carp/": {
      "en-US": "/dex/silver-carp/",
      "de-DE": "/de-DE/dex/silberkarpfen/"
    },
    "/dex/silberner-schluessel-44165/": {
      "en-US": "/dex/silver-key-44165/",
      "de-DE": "/de-DE/dex/silberner-schluessel-44165/"
    },
    "/dex/silver-key-44165/": {
      "en-US": "/dex/silver-key-44165/",
      "de-DE": "/de-DE/dex/silberner-schluessel-44165/"
    },
    "/dex/silberpampel/": {
      "en-US": "/dex/dollarfish/",
      "de-DE": "/de-DE/dex/silberpampel/"
    },
    "/dex/dollarfish/": {
      "en-US": "/dex/dollarfish/",
      "de-DE": "/de-DE/dex/silberpampel/"
    },
    "/dex/skorpionfisch/": {
      "en-US": "/dex/scorpion-fish/",
      "de-DE": "/de-DE/dex/skorpionfisch/"
    },
    "/dex/scorpion-fish/": {
      "en-US": "/dex/scorpion-fish/",
      "de-DE": "/de-DE/dex/skorpionfisch/"
    },
    "/dex/soho-bitterling/": {
      "en-US": "/dex/soho-bitterling/",
      "de-DE": "/de-DE/dex/soho-bitterling/"
    },
    "/dex/speerfisch/": {
      "en-US": "/dex/marlin/",
      "de-DE": "/de-DE/dex/speerfisch/"
    },
    "/dex/marlin/": {
      "en-US": "/dex/marlin/",
      "de-DE": "/de-DE/dex/speerfisch/"
    },
    "/dex/spitzschaedel-elritze/": {
      "en-US": "/dex/bleeker/",
      "de-DE": "/de-DE/dex/spitzschaedel-elritze/"
    },
    "/dex/bleeker/": {
      "en-US": "/dex/bleeker/",
      "de-DE": "/de-DE/dex/spitzschaedel-elritze/"
    },
    "/dex/sprenzling/": {
      "en-US": "/dex/yalu-grayling/",
      "de-DE": "/de-DE/dex/sprenzling/"
    },
    "/dex/yalu-grayling/": {
      "en-US": "/dex/yalu-grayling/",
      "de-DE": "/de-DE/dex/sprenzling/"
    },
    "/dex/stachelbitterling/": {
      "en-US": "/dex/spined-bittering/",
      "de-DE": "/de-DE/dex/stachelbitterling/"
    },
    "/dex/spined-bittering/": {
      "en-US": "/dex/spined-bittering/",
      "de-DE": "/de-DE/dex/stachelbitterling/"
    },
    "/dex/stachelkopf/": {
      "en-US": "/dex/rockfish/",
      "de-DE": "/de-DE/dex/stachelkopf/"
    },
    "/dex/rockfish/": {
      "en-US": "/dex/rockfish/",
      "de-DE": "/de-DE/dex/stachelkopf/"
    },
    "/dex/stachelmakrele/": {
      "en-US": "/dex/amberjack/",
      "de-DE": "/de-DE/dex/stachelmakrele/"
    },
    "/dex/amberjack/": {
      "en-US": "/dex/amberjack/",
      "de-DE": "/de-DE/dex/stachelmakrele/"
    },
    "/dex/steinbarsch/": {
      "en-US": "/dex/rock-hind/",
      "de-DE": "/de-DE/dex/steinbarsch/"
    },
    "/dex/rock-hind/": {
      "en-US": "/dex/rock-hind/",
      "de-DE": "/de-DE/dex/steinbarsch/"
    },
    "/dex/steinbeisser/": {
      "en-US": "/dex/spined-loach/",
      "de-DE": "/de-DE/dex/steinbeisser/"
    },
    "/dex/spined-loach/": {
      "en-US": "/dex/spined-loach/",
      "de-DE": "/de-DE/dex/steinbeisser/"
    },
    "/dex/steinschnapper/": {
      "en-US": "/dex/golden-thread/",
      "de-DE": "/de-DE/dex/steinschnapper/"
    },
    "/dex/golden-thread/": {
      "en-US": "/dex/golden-thread/",
      "de-DE": "/de-DE/dex/steinschnapper/"
    },
    "/dex/stichling/": {
      "en-US": "/dex/stickleback/",
      "de-DE": "/de-DE/dex/stichling/"
    },
    "/dex/stickleback/": {
      "en-US": "/dex/stickleback/",
      "de-DE": "/de-DE/dex/stichling/"
    },
    "/dex/stinte/": {
      "en-US": "/dex/smelt/",
      "de-DE": "/de-DE/dex/stinte/"
    },
    "/dex/smelt/": {
      "en-US": "/dex/smelt/",
      "de-DE": "/de-DE/dex/stinte/"
    },
    "/dex/stoer/": {
      "en-US": "/dex/sturgeon/",
      "de-DE": "/de-DE/dex/stoer/"
    },
    "/dex/sturgeon/": {
      "en-US": "/dex/sturgeon/",
      "de-DE": "/de-DE/dex/stoer/"
    },
    "/dex/strumpfbandfisch/": {
      "en-US": "/dex/beltfish/",
      "de-DE": "/de-DE/dex/strumpfbandfisch/"
    },
    "/dex/beltfish/": {
      "en-US": "/dex/beltfish/",
      "de-DE": "/de-DE/dex/strumpfbandfisch/"
    },
    "/dex/swiri/": {
      "en-US": "/dex/swiri/",
      "de-DE": "/de-DE/dex/swiri/"
    },
    "/dex/tannenzapfenfisch/": {
      "en-US": "/dex/pinecone-fish/",
      "de-DE": "/de-DE/dex/tannenzapfenfisch/"
    },
    "/dex/pinecone-fish/": {
      "en-US": "/dex/pinecone-fish/",
      "de-DE": "/de-DE/dex/tannenzapfenfisch/"
    },
    "/dex/teufelsfisch/": {
      "en-US": "/dex/devil-stinger/",
      "de-DE": "/de-DE/dex/teufelsfisch/"
    },
    "/dex/devil-stinger/": {
      "en-US": "/dex/devil-stinger/",
      "de-DE": "/de-DE/dex/teufelsfisch/"
    },
    "/dex/thunfisch/": {
      "en-US": "/dex/tuna/",
      "de-DE": "/de-DE/dex/thunfisch/"
    },
    "/dex/tuna/": {
      "en-US": "/dex/tuna/",
      "de-DE": "/de-DE/dex/thunfisch/"
    },
    "/dex/tiefsee-scheibenbauch/": {
      "en-US": "/dex/deep-sea-snailfish/",
      "de-DE": "/de-DE/dex/tiefsee-scheibenbauch/"
    },
    "/dex/deep-sea-snailfish/": {
      "en-US": "/dex/deep-sea-snailfish/",
      "de-DE": "/de-DE/dex/tiefsee-scheibenbauch/"
    },
    "/dex/tigerfisch/": {
      "en-US": "/dex/goliath-tigerfish/",
      "de-DE": "/de-DE/dex/tigerfisch/"
    },
    "/dex/goliath-tigerfish/": {
      "en-US": "/dex/goliath-tigerfish/",
      "de-DE": "/de-DE/dex/tigerfisch/"
    },
    "/dex/tigerhai/": {
      "en-US": "/dex/tiger-shark/",
      "de-DE": "/de-DE/dex/tigerhai/"
    },
    "/dex/tiger-shark/": {
      "en-US": "/dex/tiger-shark/",
      "de-DE": "/de-DE/dex/tigerhai/"
    },
    "/dex/tintenfisch/": {
      "en-US": "/dex/cuttlefish/",
      "de-DE": "/de-DE/dex/tintenfisch/"
    },
    "/dex/cuttlefish/": {
      "en-US": "/dex/cuttlefish/",
      "de-DE": "/de-DE/dex/tintenfisch/"
    },
    "/dex/torpedobarsch/": {
      "en-US": "/dex/tilefish/",
      "de-DE": "/de-DE/dex/torpedobarsch/"
    },
    "/dex/tilefish/": {
      "en-US": "/dex/tilefish/",
      "de-DE": "/de-DE/dex/torpedobarsch/"
    },
    "/dex/traene-des-ozeans-5821/": {
      "en-US": "/dex/tear-of-the-ocean-5821/",
      "de-DE": "/de-DE/dex/traene-des-ozeans-5821/"
    },
    "/dex/tear-of-the-ocean-5821/": {
      "en-US": "/dex/tear-of-the-ocean-5821/",
      "de-DE": "/de-DE/dex/traene-des-ozeans-5821/"
    },
    "/dex/umberfisch/": {
      "en-US": "/dex/croaker/",
      "de-DE": "/de-DE/dex/umberfisch/"
    },
    "/dex/croaker/": {
      "en-US": "/dex/croaker/",
      "de-DE": "/de-DE/dex/umberfisch/"
    },
    "/dex/vergoldeter-schluessel-44164/": {
      "en-US": "/dex/gold-key-44164/",
      "de-DE": "/de-DE/dex/vergoldeter-schluessel-44164/"
    },
    "/dex/gold-key-44164/": {
      "en-US": "/dex/gold-key-44164/",
      "de-DE": "/de-DE/dex/vergoldeter-schluessel-44164/"
    },
    "/dex/walhai/": {
      "en-US": "/dex/whale-shark/",
      "de-DE": "/de-DE/dex/walhai/"
    },
    "/dex/whale-shark/": {
      "en-US": "/dex/whale-shark/",
      "de-DE": "/de-DE/dex/walhai/"
    },
    "/dex/wasserschildkroete/": {
      "en-US": "/dex/terrapin/",
      "de-DE": "/de-DE/dex/wasserschildkroete/"
    },
    "/dex/terrapin/": {
      "en-US": "/dex/terrapin/",
      "de-DE": "/de-DE/dex/wasserschildkroete/"
    },
    "/dex/weisser-hai/": {
      "en-US": "/dex/great-white-shark/",
      "de-DE": "/de-DE/dex/weisser-hai/"
    },
    "/dex/great-white-shark/": {
      "en-US": "/dex/great-white-shark/",
      "de-DE": "/de-DE/dex/weisser-hai/"
    },
    "/dex/weisser-zackenbarsch/": {
      "en-US": "/dex/white-grouper/",
      "de-DE": "/de-DE/dex/weisser-zackenbarsch/"
    },
    "/dex/white-grouper/": {
      "en-US": "/dex/white-grouper/",
      "de-DE": "/de-DE/dex/weisser-zackenbarsch/"
    },
    "/dex/weissflossenmakrele/": {
      "en-US": "/dex/whitefin-trevally/",
      "de-DE": "/de-DE/dex/weissflossenmakrele/"
    },
    "/dex/whitefin-trevally/": {
      "en-US": "/dex/whitefin-trevally/",
      "de-DE": "/de-DE/dex/weissflossenmakrele/"
    },
    "/dex/weisskarausche/": {
      "en-US": "/dex/white-crucian-carp/",
      "de-DE": "/de-DE/dex/weisskarausche/"
    },
    "/dex/white-crucian-carp/": {
      "en-US": "/dex/white-crucian-carp/",
      "de-DE": "/de-DE/dex/weisskarausche/"
    },
    "/dex/weisstintenfisch/": {
      "en-US": "/dex/bigfin-reef-squid/",
      "de-DE": "/de-DE/dex/weisstintenfisch/"
    },
    "/dex/bigfin-reef-squid/": {
      "en-US": "/dex/bigfin-reef-squid/",
      "de-DE": "/de-DE/dex/weisstintenfisch/"
    },
    "/dex/weisswal/": {
      "en-US": "/dex/beluga-whale/",
      "de-DE": "/de-DE/dex/weisswal/"
    },
    "/dex/beluga-whale/": {
      "en-US": "/dex/beluga-whale/",
      "de-DE": "/de-DE/dex/weisswal/"
    },
    "/dex/wels/": {
      "en-US": "/dex/catfish/",
      "de-DE": "/de-DE/dex/wels/"
    },
    "/dex/catfish/": {
      "en-US": "/dex/catfish/",
      "de-DE": "/de-DE/dex/wels/"
    },
    "/dex/wittling/": {
      "en-US": "/dex/whiting/",
      "de-DE": "/de-DE/dex/wittling/"
    },
    "/dex/whiting/": {
      "en-US": "/dex/whiting/",
      "de-DE": "/de-DE/dex/wittling/"
    },
    "/dex/wolfsbarsch/": {
      "en-US": "/dex/sea-bass/",
      "de-DE": "/de-DE/dex/wolfsbarsch/"
    },
    "/dex/sea-bass/": {
      "en-US": "/dex/sea-bass/",
      "de-DE": "/de-DE/dex/wolfsbarsch/"
    },
    "/dex/zackenbarsch/": {
      "en-US": "/dex/grouper/",
      "de-DE": "/de-DE/dex/zackenbarsch/"
    },
    "/dex/grouper/": {
      "en-US": "/dex/grouper/",
      "de-DE": "/de-DE/dex/zackenbarsch/"
    },
    "/dex/zahn-schlaefergrundel/": {
      "en-US": "/dex/dark-sleeper/",
      "de-DE": "/de-DE/dex/zahn-schlaefergrundel/"
    },
    "/dex/dark-sleeper/": {
      "en-US": "/dex/dark-sleeper/",
      "de-DE": "/de-DE/dex/zahn-schlaefergrundel/"
    },
    "/dex/zitterwels/": {
      "en-US": "/dex/electric-catfish/",
      "de-DE": "/de-DE/dex/zitterwels/"
    },
    "/dex/electric-catfish/": {
      "en-US": "/dex/electric-catfish/",
      "de-DE": "/de-DE/dex/zitterwels/"
    },
    "/dex/zuegeldelfin/": {
      "en-US": "/dex/black-spotted-dolphin/",
      "de-DE": "/de-DE/dex/zuegeldelfin/"
    },
    "/dex/black-spotted-dolphin/": {
      "en-US": "/dex/black-spotted-dolphin/",
      "de-DE": "/de-DE/dex/zuegeldelfin/"
    },
    "/dex/zwergengruendling/": {
      "en-US": "/dex/dwarf-gudgeon/",
      "de-DE": "/de-DE/dex/zwergengruendling/"
    },
    "/dex/dwarf-gudgeon/": {
      "en-US": "/dex/dwarf-gudgeon/",
      "de-DE": "/de-DE/dex/zwergengruendling/"
    },
    "/dex/zwergstichling/": {
      "en-US": "/dex/short-ninespine-stickleback/",
      "de-DE": "/de-DE/dex/zwergstichling/"
    },
    "/dex/short-ninespine-stickleback/": {
      "en-US": "/dex/short-ninespine-stickleback/",
      "de-DE": "/de-DE/dex/zwergstichling/"
    },
    "/dex/zwergwal/": {
      "en-US": "/dex/minke-whale/",
      "de-DE": "/de-DE/dex/zwergwal/"
    },
    "/dex/minke-whale/": {
      "en-US": "/dex/minke-whale/",
      "de-DE": "/de-DE/dex/zwergwal/"
    },
    "/dex/zwergwels/": {
      "en-US": "/dex/ussurian-bullhead/",
      "de-DE": "/de-DE/dex/zwergwels/"
    },
    "/dex/ussurian-bullhead/": {
      "en-US": "/dex/ussurian-bullhead/",
      "de-DE": "/de-DE/dex/zwergwels/"
    },
    "/guides/3x-tfr-quest/versions/initial/": {
      "en-US": "/guides/3x-tfr-quest/",
      "de-DE": "/de-DE/guides/3x-tfr-quest/"
    },
    "/guides/experience/versions/initial/": {
      "en-US": "/guides/experience/",
      "de-DE": "/de-DE/guides/experience/"
    },
    "/guides/money/versions/initial/": {
      "en-US": "/guides/money/",
      "de-DE": "/de-DE/guides/money/"
    },
    "/guides/groups/versions/initial/": {
      "en-US": "/guides/groups/",
      "de-DE": "/de-DE/guides/groups/"
    },
    "/guides/where-am-i-fishing/versions/initial/": {
      "en-US": "/guides/where-am-i-fishing/",
      "de-DE": "/de-DE/guides/where-am-i-fishing/"
    },
    "/guides/zones/versions/initial/": {
      "en-US": "/guides/zones/",
      "de-DE": "/de-DE/guides/zones/"
    },
    "/guides/mystical/versions/initial/": {
      "en-US": "/guides/mystical/",
      "de-DE": "/de-DE/guides/mystical/"
    },
    "/guides/drr/versions/initial/": {
      "en-US": "/guides/drr/",
      "de-DE": "/de-DE/guides/drr/"
    },
    "/community/versions/initial/": {
      "en-US": "/community/",
      "de-DE": "/de-DE/community/"
    },
    "/glossary/versions/initial/": {
      "en-US": "/glossary/"
    }
  }
});
})();
